/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
	'/api/healthz': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['AppController_health']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/test-cache': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['AppController_testCache']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/test-cache/{key}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['AppController_testGetCache']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/auth/login': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Admin login */
		post: operations['AuthController_login']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/auth/login-operator': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Operator login */
		post: operations['AuthController_loginOperator']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/auth/login-admin': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['AuthController_loginAdmin']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current admin profile */
		get: operations['AdminController_getMe']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/update-me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update current admin profile */
		patch: operations['AdminController_updateMe']
		trace?: never
	}
	'/api/admin/admins/get-operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator by ID */
		get: operations['AdminController_findOperator']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/get-operators': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all operators */
		get: operations['AdminController_getOperators']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/create-operators': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new operator */
		post: operations['AdminController_createOperator']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/update-operators/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update operator */
		patch: operations['AdminController_updateOperator']
		trace?: never
	}
	'/api/admin/admins/delete-operators/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete operator */
		delete: operations['AdminController_deleteOperator']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admins/operator-login-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator login history */
		get: operations['AdminController_getLoginHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current operator profile */
		get: operations['OperatorController_getMe']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/update-me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update current operator profile */
		patch: operations['OperatorController_updateMe']
		trace?: never
	}
	'/api/admin/operators/get-operators': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all operators */
		get: operations['OperatorController_getOperators']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/get-operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator by ID */
		get: operations['OperatorController_getOperatorById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/create-operator': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new operator */
		post: operations['OperatorController_createOperator']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/update-operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update operator */
		patch: operations['OperatorController_updateOperator']
		trace?: never
	}
	'/api/admin/operators/delete-operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete operator */
		delete: operations['OperatorController_removeOperator']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/login-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator login history */
		get: operations['OperatorController_getLoginHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/event-log': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator event log */
		get: operations['OperatorController_getEventLog']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/generate-totp/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Generate TOTP secret and QR code */
		post: operations['OperatorController_generateTotp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/enable-totp/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Enable TOTP for operator */
		post: operations['OperatorController_enableTotp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/disable-totp/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Disable TOTP for operator */
		post: operations['OperatorController_disableTotp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/reset-totp/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Reset TOTP for operator */
		post: operations['OperatorController_resetTotp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/me/fcm-token': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Register FCM token for current operator */
		post: operations['OperatorController_registerFCMToken']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/me/fcm-token/{token}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete FCM token for current operator */
		delete: operations['OperatorController_deleteFCMToken']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/me/fcm-tokens': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all FCM tokens for current operator */
		get: operations['OperatorController_getFCMTokens']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/create-partner': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new partner */
		post: operations['PartnerController_createPartner']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/get-partners': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all partners */
		get: operations['PartnerController_getPartners']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/get-partner/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get partner by ID */
		get: operations['PartnerController_getPartnerById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/update-partner/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update partner */
		patch: operations['PartnerController_updatePartner']
		trace?: never
	}
	'/api/admin/operators/partners/{id}/players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get players under a partner with deposit/withdraw summaries
		 * @description Returns paginated list of players referred by this partner with their deposit and withdraw summaries. Players are filtered by createdAt >= startDate. Transactions are aggregated within the date range. Use /players/summary endpoint to get the overall totals.
		 */
		get: operations['PartnerController_getPartnerPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/players/summary': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get summary totals for all players under a partner
		 * @description Returns summary totals (deposit/withdraw) for ALL players matching the filter criteria. This endpoint is separate from pagination to avoid recalculating summary on every page change.
		 */
		get: operations['PartnerController_getPartnerPlayersSummary']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/players/export-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Export partner players data as CSV (multiple date ranges)
		 * @description Exports partner players data. Returns CSV for single range, ZIP for multiple ranges.
		 */
		post: operations['PartnerController_exportPartnerPlayersCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/add-credit': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Add credit to partner player account
		 * @description Adds credit to the main wallet of the player who created/owns this partner account.
		 */
		post: operations['PartnerController_addCredit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/payment-records': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get payment records for a partner
		 * @description Returns paginated list of payment records for the partner.
		 */
		get: operations['PartnerController_getPaymentRecords']
		put?: never
		/**
		 * Create a payment record for a partner
		 * @description Records a payment made to the partner with auto-calculated player snapshot data. Use this to track commission payments.
		 */
		post: operations['PartnerController_createPaymentRecord']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/payment-records/{recordId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get a single payment record by ID
		 * @description Returns full payment record with snapshot data.
		 */
		get: operations['PartnerController_getPaymentRecordById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/toggle-active': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/**
		 * Toggle partner active status
		 * @description Activate or deactivate a partner. When deactivated: partner remains visible in admin with "Inactive" badge, client-side dashboard is hidden, referral link is blocked, and commissions stop.
		 */
		patch: operations['PartnerController_togglePartnerActive']
		trace?: never
	}
	'/api/admin/operators/partners/{id}/analytics/daily-transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get daily transaction chart data for a partner (admin)
		 * @description Returns daily deposit/bonus/withdraw totals for the last N days.
		 */
		get: operations['PartnerController_getAdminAnalyticsDailyTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}/analytics/invitation-summary': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get invitation summary for a partner (admin)
		 * @description Returns daily signups chart and invitation summary stats.
		 */
		get: operations['PartnerController_getAdminAnalyticsInvitationSummary']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/partners/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/**
		 * Delete partner (soft delete)
		 * @description Permanently delete a partner (soft delete). Partner is hidden from all admin lists, client-side treated as regular player, referral link is blocked, commissions permanently stopped. Existing referred players keep their link for historical tracking. The player can become a new partner with a fresh start.
		 */
		delete: operations['PartnerController_deletePartner']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/create-channel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new channel */
		post: operations['ChannelController_createChannel']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/get-channels': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all channels */
		get: operations['ChannelController_getChannels']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/get-channel/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get channel by ID */
		get: operations['ChannelController_getChannelById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/update-channel/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['ChannelController_updateChannel']
		trace?: never
	}
	'/api/admin/operators/channels/delete-channel/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete: operations['ChannelController_deleteChannel']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/{id}/transaction-cumulative': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get channel transaction cumulative data within a date range */
		get: operations['ChannelController_getChannelTransactionCumulative']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/{id}/cohort-analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get cohort analytics for a single channel (all-time + day buckets) */
		get: operations['ChannelController_getChannelCohortAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/channels/{id}/players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get paginated player list for a channel with cohort analytics */
		get: operations['ChannelController_getChannelPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/user-groups/create-user-group': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new user group */
		post: operations['UserGroupController_createUserGroup']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/user-groups/get-user-groups': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all user groups */
		get: operations['UserGroupController_getUserGroups']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/user-groups/get-user-group/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['UserGroupController_getUserGroupById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/user-groups/update-user-group/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['UserGroupController_updateUserGroup']
		trace?: never
	}
	'/api/admin/operators/user-groups/delete-user-group/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete: operations['UserGroupController_deleteUserGroup']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/user-groups/permissions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all available permissions */
		get: operations['UserGroupController_getAllPermissions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/create-player': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new player */
		post: operations['PlayerController_createPlayer']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/toggle-demo-account': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Toggle demo account status (admin) */
		post: operations['PlayerController_toggleDemoAccount']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/get-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all players */
		get: operations['PlayerController_getPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/get-players-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export all players as CSV */
		post: operations['PlayerController_exportPlayersCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/get-player/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player by ID */
		get: operations['PlayerController_getPlayerById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/get-player-full-phone/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player full phone number (logged) */
		get: operations['PlayerController_getPlayerFullPhone']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/update-player/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update player */
		patch: operations['PlayerController_updatePlayer']
		trace?: never
	}
	'/api/admin/operators/players/delete-player/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete player */
		delete: operations['PlayerController_deletePlayer']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/login-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player login history */
		get: operations['PlayerController_getLoginHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/banned-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get banned players */
		get: operations['PlayerController_getBannedPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/inactive-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get inactive players */
		get: operations['PlayerController_getInactivePlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/clear-lockout': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Clear player login lockout */
		post: operations['PlayerController_clearPlayerLockout']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/clear-turnover-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player clear turnover history */
		get: operations['PlayerController_getPlayerClearTurnoverHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/clear-turnover-history-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export player clear turnover history as CSV */
		post: operations['PlayerController_exportPlayerClearTurnoverHistoryCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player transactions */
		get: operations['PlayerController_getPlayerTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/transactions-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export player transactions as CSV */
		post: operations['PlayerController_exportPlayerTransactionsCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/playlog/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player play log */
		get: operations['PlayerController_getPlayerPlaylog']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/playlog-csv/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export player play log as CSV */
		post: operations['PlayerController_exportPlayerPlaylogCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/playlog-reinit/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Re-initialize a game session from playlog */
		post: operations['PlayerController_reinitPlaylog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/referred/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get referred players */
		get: operations['PlayerController_getReferredPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/referred-csv/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export referred players as CSV */
		post: operations['PlayerController_exportReferredPlayersCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/cumulative/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player cumulative data */
		get: operations['PlayerController_getPlayerCumulative']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/commission/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player commission cashback (per game type, current month) */
		get: operations['PlayerController_getPlayerCommission']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/return-loss/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player return loss config and current period calculation */
		get: operations['PlayerController_getPlayerReturnLoss']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/diamond-history/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get paginated diamond earning history for a player */
		get: operations['PlayerController_getPlayerDiamondHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/active-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get active players */
		get: operations['PlayerController_getActivePlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-deposit-promotion': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with deposit promotions */
		get: operations['PlayerController_getPlayersWithDepositPromotion']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-deposit-promotion-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export players with deposit promotions as CSV */
		post: operations['PlayerController_exportPlayersWithDepositPromotionCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-deposits': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with deposits */
		get: operations['PlayerController_getPlayersWithDeposits']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-deposits-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export players with deposits as CSV */
		post: operations['PlayerController_exportPlayersWithDepositsCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-deposits-without-promotion': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with deposits without promotion */
		get: operations['PlayerController_getPlayersWithDepositsWithoutPromotion']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/activity-log': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get player activity log */
		post: operations['PlayerController_getPlayerActivityLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/activity-log-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export player activity log as CSV */
		post: operations['PlayerController_exportPlayerActivityLogCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/clear-turnover': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Clear player turnover */
		post: operations['PlayerController_clearPlayerTurnover']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/update-main-wallet-balance': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update main wallet balance */
		patch: operations['PlayerController_updateMainWalletBalance']
		trace?: never
	}
	'/api/admin/operators/players/clear-main-wallet-turnover': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Clear main wallet turnover conditions */
		post: operations['PlayerController_clearMainWalletTurnover']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-withdraws': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with withdrawals */
		get: operations['PlayerController_getPlayersWithWithdraws']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-lucky-wheel-receive': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with lucky wheel receive */
		get: operations['PlayerController_getPlayersWithLuckyWheelReceive']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-return-loss-receive': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with return loss receive */
		get: operations['PlayerController_getPlayersWithReturnLossReceive']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/players-with-daily-check-in-receive': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players with daily check-in receive */
		get: operations['PlayerController_getPlayersWithDailyCheckInReceive']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/player-data-list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player data list with financial summary */
		get: operations['PlayerController_getPlayerDataList']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/player-data-list-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export player data list as CSV */
		post: operations['PlayerController_exportPlayerDataListCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/registered-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get registered players in date range */
		get: operations['PlayerController_getRegisteredPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/players/provider-stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player provider statistics for date range
		 * @description Get aggregated play statistics by provider for a player within a date range
		 */
		get: operations['PlayerController_getPlayerProviderStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/login': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_login']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/login-line': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_loginWithLine']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/check-phone': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_checkPhone']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/check-bank': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_checkBank']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/register': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_registerPlayer']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/register-demo': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_registerDemoAccount']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/check-channel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_checkChannel']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/update-demo-to-real': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_updateDemoToReal']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/send-login-sms-otp': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_sendLoginSmsOtp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/verify-login-sms-otp': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_verifyLoginSmsOtp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/forgot-password': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_forgotPassword']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/auth/reset-password': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PlayerAuthController_resetPassword']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/thaibulk/send-sms': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['ThaibulkController_sendSms']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/thaibulk/send-otp': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['ThaibulkController_sendSmsOtp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/thaibulk/verify-otp': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['ThaibulkController_verifySmsOtp']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/line/send-message': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['LineController_sendMessage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/line/profile/{userId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['LineController_getUserProfile']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/line/webhook': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['LineController_handleWebhook']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get list of chat rooms */
		get: operations['ChatController_getChatRooms']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/unread-count': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get total unread message count
		 * @description Get the total count of unread messages across all active chat rooms. Excludes closed and banned rooms.
		 */
		get: operations['ChatController_getUnreadCount']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/closed': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get closed chat rooms
		 * @description Get list of chat rooms that have been closed (users who unfollowed)
		 */
		get: operations['ChatController_getClosedRooms']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/banned': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get banned chat rooms
		 * @description Get list of rooms that have been marked as spam
		 */
		get: operations['ChatController_getBannedRooms']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get chat room details */
		get: operations['ChatController_getChatRoom']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/messages': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get messages for a chat room */
		get: operations['ChatController_getChatMessages']
		put?: never
		/** Send a message to a chat room */
		post: operations['ChatController_sendMessage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/messages/multiple': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Send multiple messages to a chat room in one request */
		post: operations['ChatController_sendMultipleMessages']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/read': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Mark messages as read
		 * @description Mark all incoming messages as read up to messageId (or all if not provided)
		 */
		post: operations['ChatController_markAsRead']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/search': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Search chat messages
		 * @description Search messages across all rooms or within a specific room by text content
		 */
		get: operations['ChatController_searchMessages']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/pin': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Pin or unpin a chat room
		 * @description Pinned rooms appear at the top of the chat list
		 */
		post: operations['ChatController_pinRoom']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/ban': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Ban or unban a chat room (mark as spam)
		 * @description Banned rooms are hidden from the main list and the user cannot send messages
		 */
		post: operations['ChatController_banRoom']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Update chat room status
		 * @description Change chat room status to INBOX, FOLLOW_UP, or RESOLVED. When a new message arrives and status is null or RESOLVED, it automatically changes to INBOX.
		 */
		post: operations['ChatController_updateRoomStatus']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{roomId}/messages/{messageId}/pin': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Pin or unpin a message
		 * @description Pinned messages appear at the top of the chat room
		 */
		post: operations['ChatController_pinMessage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/pinned-messages': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get pinned messages for a room
		 * @description Get all pinned messages in a chat room
		 */
		get: operations['ChatController_getPinnedMessages']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/claim': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Claim/pick up a chat room */
		post: operations['ChatController_claimRoom']
		/** Release a chat room */
		delete: operations['ChatController_releaseRoom']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/assign': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Assign a chat room to another operator
		 * @description Assign the chat room to a specific operator by operator ID
		 */
		post: operations['ChatController_assignRoom']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/tags': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all customer tags */
		get: operations['ChatController_getTags']
		put?: never
		/** Create a customer tag */
		post: operations['ChatController_createTag']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/tags/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Update a customer tag */
		put: operations['ChatController_updateTag']
		post?: never
		/** Delete a customer tag */
		delete: operations['ChatController_deleteTag']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/tags': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Add tags to a chat room */
		post: operations['ChatController_addTagsToRoom']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{roomId}/tags/{tagId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Remove a tag from a chat room */
		delete: operations['ChatController_removeTagFromRoom']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/player': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Link a player to a chat room
		 * @description Link a player to the chat room by player ID, phone number, or username. Precedence: playerId, then phone, then username. This allows operators to associate a LINE chat with a registered player account.
		 */
		post: operations['ChatController_linkPlayerToRoom']
		/**
		 * Unlink a player from a chat room
		 * @description Remove the player association from the chat room.
		 */
		delete: operations['ChatController_unlinkPlayerFromRoom']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/connect-line': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Connect player's LINE ID with chat room's LINE user
		 * @description Updates the linked player's lineId field with the LINE user ID from this chat room. This ensures the player record is connected to the correct LINE account.
		 */
		post: operations['ChatController_connectLine']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/player-stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player stats for chat room
		 * @description Get player statistics including last deposit/withdraw status, game play stats, wallet balances, and last transfer. This endpoint is designed for polling to show real-time player activity in the chat notes panel.
		 */
		get: operations['ChatController_getPlayerChatStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/rooms/{id}/notes': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all notes for a chat room */
		get: operations['ChatController_getChatNotes']
		put?: never
		/** Create a new note for a chat room */
		post: operations['ChatController_createChatNote']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/notes/{noteId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Update a chat note */
		put: operations['ChatController_updateChatNote']
		post?: never
		/** Delete a chat note */
		delete: operations['ChatController_deleteChatNote']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/quick-responses': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all quick responses (system-wide) */
		get: operations['ChatController_getQuickResponses']
		put?: never
		/** Create a quick response */
		post: operations['ChatController_createQuickResponse']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/quick-responses/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Update a quick response */
		put: operations['ChatController_updateQuickResponse']
		post?: never
		/** Delete a quick response */
		delete: operations['ChatController_deleteQuickResponse']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/settings': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get chat settings (greeting & auto-reply) */
		get: operations['ChatController_getSettings']
		/** Update chat settings */
		put: operations['ChatController_updateSettings']
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/quota': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get LINE quota usage */
		get: operations['ChatController_getQuota']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get chat analytics */
		get: operations['ChatController_getAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/media/upload-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Generate presigned URL for media upload
		 * @description Generate a presigned URL for uploading media files (image, video, audio, file) to use in chat messages. The client should upload the file directly to the presignedUrl using PUT method, then use the fileUrl in the message.
		 */
		post: operations['ChatController_generateMediaUploadUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/broadcast': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Broadcast messages to all active chat rooms
		 * @description Send multiple messages to all active chat rooms (not banned, not closed). Supports all message types: TEXT, STICKER, IMAGE, VIDEO, AUDIO, LOCATION, FLEX. Creates a log entry for the broadcast action.
		 */
		post: operations['ChatController_broadcastMessages']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Subscribe to real-time chat events via SSE
		 * @description
		 *     Connect to this endpoint to receive real-time chat updates via Server-Sent Events (SSE).
		 *
		 *     **Event Types:**
		 *     - `chat:new_message` - New message received or sent
		 *     - `chat:room_updated` - Room data changed
		 *     - `chat:room_list_changed` - Lightweight room list update for pagination
		 *     - `chat:tag_updated` - Tags added/removed from room
		 *     - `chat:assignee_updated` - Operator assigned/unassigned
		 *     - `chat:message_read` - Messages marked as read
		 *     - `ping` - Keepalive ping every 25 seconds (includes connectionCount)
		 *
		 *     **Event Format:**
		 *     Each event is wrapped in an envelope with:
		 *     - `id` - Monotonic event ID for deduplication
		 *     - `event` - Event type name
		 *     - `ts` - ISO timestamp
		 *     - `data` - Event-specific payload
		 *
		 *     **Ping Event Data:**
		 *     The ping event includes `connectionCount` which tracks the number of active SSE sessions (not unique operators).
		 *
		 *     **Connection:**
		 *     ```javascript
		 *     // Browser EventSource with token in query string
		 *     const eventSource = new EventSource('/admin/chat/events?token=<jwt-token>');
		 *
		 *     eventSource.addEventListener('chat:new_message', (e) => {
		 *       const envelope = JSON.parse(e.data);
		 *       console.log('New message:', envelope.data);
		 *     });
		 *
		 *     eventSource.addEventListener('ping', (e) => {
		 *       const envelope = JSON.parse(e.data);
		 *       console.log('Active connections:', envelope.data.connectionCount);
		 *     });
		 *
		 *     eventSource.onerror = (e) => {
		 *       // Handle reconnection
		 *     };
		 *     ```
		 *
		 *     **Reconnection Strategy:**
		 *     On reconnect, fetch the current state via REST endpoints:
		 *     - GET /admin/chat/rooms - Room list
		 *     - GET /admin/chat/rooms/:id/messages - Messages for active room
		 *
		 */
		get: operations['ChatSseController_stream']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/subscriptions/{roomId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Subscribe to a specific chat room
		 * @description Subscribe to receive events for a specific chat room. Currently all events are sent to all connected operators. This endpoint is reserved for future filtering implementation.
		 */
		post: operations['ChatSseController_subscribeToRoom']
		/**
		 * Unsubscribe from a specific chat room
		 * @description Unsubscribe from a specific chat room. Currently all events are sent to all connected operators. This endpoint is reserved for future filtering implementation.
		 */
		delete: operations['ChatSseController_unsubscribeFromRoom']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/ai-draft/setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get AI system setting (context + tools + per-case prompts) */
		get: operations['ChatAiDraftController_getSetting']
		/** Update AI system setting (context + tools) */
		put: operations['ChatAiDraftController_updateSetting']
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/ai-draft/setting/cases': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update per-classifier-case prompts (partial — only listed cases are modified) */
		patch: operations['ChatAiDraftController_updatePromptCases']
		trace?: never
	}
	'/api/admin/chat/ai-draft/room/{roomId}/latest': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get latest pending AI draft for a chat room */
		get: operations['ChatAiDraftController_getLatestDraft']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/ai-draft/room/{roomId}/admin-tasks': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get pending admin tasks for a chat room (unchecked todos) */
		get: operations['ChatAiDraftController_getRoomAdminTasks']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/chat/ai-draft/admin-task/{taskId}/done': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Mark an admin task as done */
		patch: operations['ChatAiDraftController_markAdminTaskDone']
		trace?: never
	}
	'/api/admin/chat/ai-draft/admin-task/{taskId}/dismiss': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Dismiss an admin task (no longer needed) */
		patch: operations['ChatAiDraftController_dismissAdminTask']
		trace?: never
	}
	'/api/admin/chat/ai-draft/admin-task/{taskId}/reopen': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Reopen a done/dismissed admin task */
		patch: operations['ChatAiDraftController_reopenAdminTask']
		trace?: never
	}
	'/api/admin/chat/ai-draft/{draftId}/use': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Mark AI draft as used (sent as-is) */
		patch: operations['ChatAiDraftController_markUsed']
		trace?: never
	}
	'/api/admin/chat/ai-draft/{draftId}/edit': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Mark AI draft as edited before sending */
		patch: operations['ChatAiDraftController_markEdited']
		trace?: never
	}
	'/api/admin/chat/ai-draft/{draftId}/ignore': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Mark AI draft as ignored (admin answered without using it) */
		patch: operations['ChatAiDraftController_markIgnored']
		trace?: never
	}
	'/api/admin/chat/ai-draft/room/{roomId}/ai-mode': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update per-chat AI answer mode (ASSIS|AUTO|OFF) */
		patch: operations['ChatAiDraftController_updateChatAiMode']
		trace?: never
	}
	'/api/deposits': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create a new deposit request */
		post: operations['DepositController_createDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/pending-transaction': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get pending deposit transactions */
		get: operations['DepositController_getPendingDepositTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/{id}/confirm': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Confirm a deposit transaction */
		patch: operations['DepositController_confirmDeposit']
		trace?: never
	}
	'/api/deposits/{id}/cancel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Cancel a deposit transaction */
		patch: operations['DepositController_cancelDeposit']
		trace?: never
	}
	'/api/deposits/deposit-info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get minimum deposit amount and available promotions */
		get: operations['DepositController_getDepositInfo']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/available-channels': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available deposit channels for the current player */
		get: operations['DepositController_getAvailableChannels']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/available-amounts': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available P2P deposit amounts for a channel */
		get: operations['DepositController_getAvailableAmounts']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Check if deposit is currently available */
		get: operations['DepositController_getDepositStatus']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/slip-presign': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get a presigned URL to upload a slip image directly to R2 */
		post: operations['DepositController_getSlipPresignUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/upload-slip': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Submit the R2 URL of an uploaded slip for an SMS_AUTO deposit */
		post: operations['DepositController_uploadSlip']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/verify-slip/upload': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Submit the R2 URL of an uploaded slip for a VERIFY_SLIP deposit */
		post: operations['DepositController_uploadVerifySlip']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/autosslip/upload': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Submit the R2 URL of an uploaded slip for an AUTOSSLIP deposit */
		post: operations['DepositController_uploadAutosslip']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/qr-proxy': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Proxy a QR code image to avoid CORS issues on mobile */
		get: operations['DepositController_proxyQrImage']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/{transactionId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Track a specific deposit transaction by ID */
		get: operations['DepositController_getDepositTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/claim/{token}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Claim zero-deposit promotion via token (instant credit) */
		get: operations['DepositController_claimPromotion']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/deposits/claim-test/{token}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** TEST ONLY - Claim without hash validation */
		get: operations['DepositController_claimPromotionTest']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/balance': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player active wallet balance */
		get: operations['WalletController_getBalance']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/balance/{walletType}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player wallet balance by type */
		get: operations['WalletController_getBalanceByType']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/transfer-to-main': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Transfer player promotion wallet to main wallet */
		post: operations['WalletController_transferToMain']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/clear-turnover': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Clear player promotion wallet */
		post: operations['WalletController_clearPromotionWallet']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/easy-clear-turnover': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Easy clear player promotion wallet if balance is below threshold */
		post: operations['WalletController_easyClearTurnover']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/transfer-to-active': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Transfer from a wallet to the active wallet (promotion or main) */
		post: operations['WalletController_transferToActiveWallet']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/wallet/transfer-history/{walletId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get wallet transfer history */
		get: operations['WalletController_getTransferHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get presets from external API */
		get: operations['DepositPromotionController_getPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all deposit promotions */
		get: operations['DepositPromotionController_findAll']
		put?: never
		/** Create deposit promotion */
		post: operations['DepositPromotionController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/broke-notification': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player-facing deposit promotions for broke notification selection
		 * @description Returns active deposit promotions where isForPlayer is true
		 */
		get: operations['DepositPromotionController_getPromotionsForBrokeNotification']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/promotion-presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get hardcoded deposit promotion preset templates */
		get: operations['DepositPromotionController_getDepositPromotionPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/promotion-presets/{id}/apply': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Apply a deposit promotion preset (creates a new promotion) */
		post: operations['DepositPromotionController_applyDepositPromotionPreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit promotion by ID */
		get: operations['DepositPromotionController_findById']
		put?: never
		post?: never
		/** Delete deposit promotion */
		delete: operations['DepositPromotionController_delete']
		options?: never
		head?: never
		/** Update deposit promotion */
		patch: operations['DepositPromotionController_update']
		trace?: never
	}
	'/api/admin/deposit-promotions/selector/names': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get promotion names for selector */
		get: operations['DepositPromotionController_getPromotionNamesForSelector']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/selector/names/channel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get promotion names for selector */
		get: operations['DepositPromotionController_getPromotionNamesForSelectorChannel']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/deposit-promotions/selector/names/coupon': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get promotion names for selector */
		get: operations['DepositPromotionController_getPromotionNamesForSelectorCoupon']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/notifications': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['NotificationController_createNotification']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/conversion/conversion': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Track conversion event
		 * @description Used when users complete conversion event
		 */
		post: operations['ConversionController_trackConversion']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/lucky-wheel/image-presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get lucky wheel image presets */
		get: operations['LuckyWheelController_getImagePresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/lucky-wheel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get lucky wheel setting by ID */
		get: operations['LuckyWheelController_findOnce']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update lucky wheel setting */
		patch: operations['LuckyWheelController_update']
		trace?: never
	}
	'/api/admin/lucky-wheel/test': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Test spin wheel */
		post: operations['LuckyWheelController_testSpinWheel']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/available-channels': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available channels (QR, Transfer, True Money) for this agent */
		get: operations['PaymentGatewayController_getAvailableChannels']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/channel-counts': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get count of bank accounts per channel for tab badges */
		get: operations['PaymentGatewayController_getChannelCounts']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all payment gateways */
		get: operations['PaymentGatewayController_getPaymentGateways']
		/** Update a payment gateway */
		put: operations['PaymentGatewayController_updatePaymentGateway']
		post: operations['PaymentGatewayController_createPaymentGateway']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/provider': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all payment gateway providers */
		get: operations['PaymentGatewayController_getPaymentGatewayProvider']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/constraints': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get payment gateway constraints configuration
		 * @description Returns min/max deposit constraints per provider for frontend validation
		 */
		get: operations['PaymentGatewayController_getPaymentGatewayConstraints']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/maintenances': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get active payment gateway maintenances */
		get: operations['PaymentGatewayController_getMaintenances']
		put?: never
		/** Create payment gateway maintenance */
		post: operations['PaymentGatewayController_createMaintenance']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/maintenances/all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all payment gateway maintenances (including future) */
		get: operations['PaymentGatewayController_getMaintenancesAll']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/maintenances/{id}/reject': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Reject (end) a maintenance */
		post: operations['PaymentGatewayController_rejectMaintenance']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get payment gateway analytics
		 * @description Returns deposit and withdrawal analytics per payment gateway filtered by method=PAYMENT_GATEWAY. Includes total amount, count, and average processing time derived from created_at to updated_at.
		 */
		get: operations['PaymentGatewayController_getPaymentGatewayAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get a payment gateway by ID */
		get: operations['PaymentGatewayController_getPaymentGateway']
		put?: never
		post?: never
		/** Delete a payment gateway */
		delete: operations['PaymentGatewayController_deletePaymentGateway']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/payment-gateway/sync': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['PaymentGatewayController_syncPaymentGateways']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/telegram-notify': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get telegram notify settings */
		get: operations['TelegramNotifyController_getTelegramNotifySetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update telegram notify settings */
		patch: operations['TelegramNotifyController_updateTelegramNotifySetting']
		trace?: never
	}
	'/api/admin/player-tags': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get all player tags
		 * @description Get all tags with player counts for analytics. Optional search filter by tag name.
		 */
		get: operations['PlayerTagController_getAllTags']
		put?: never
		/**
		 * Create a player tag
		 * @description Create a new tag for player segmentation. Set minDepositAmount for auto-tagging.
		 */
		post: operations['PlayerTagController_createTag']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/player-tags/statistics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get tag statistics
		 * @description Get overview of tag usage and top tags
		 */
		get: operations['PlayerTagController_getTagStatistics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/player-tags/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player tag by ID
		 * @description Get a single tag by its ID with player count
		 */
		get: operations['PlayerTagController_getTagById']
		put?: never
		post?: never
		/** Delete a player tag */
		delete: operations['PlayerTagController_deleteTag']
		options?: never
		head?: never
		/** Update a player tag */
		patch: operations['PlayerTagController_updateTag']
		trace?: never
	}
	'/api/admin/player-tags/players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get players filtered by tag
		 * @description Get paginated list of players with their tags. Filter by tag ID or search by phone/email.
		 */
		get: operations['PlayerTagController_getPlayersByTags']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/player-tags/assign': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually assign tags to players
		 * @description Assign one or more tags to multiple players
		 */
		post: operations['PlayerTagController_assignTagsToPlayers']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/player-tags/remove': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Remove tags from players
		 * @description Remove one or more tags from multiple players
		 */
		post: operations['PlayerTagController_removeTagsFromPlayers']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/player-tags/recheck-all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually recheck and assign tags for all players
		 * @description Runs the auto-tag assignment for all players based on current tag rules. Use this for manual reconciliation if needed.
		 */
		post: operations['PlayerTagController_recheckAllPlayers']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/track': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Track a single event */
		post: operations['TrackingController_trackSingle']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/track/batch': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Track a batch of events */
		post: operations['TrackingController_trackBatch']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/commission': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player commission details */
		get: operations['PlayerCommissionController_getCommissionByPlayerId']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/commission-cashback': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all commission cashback promotions */
		get: operations['CommissionCashbackController_findAll']
		put?: never
		/** Create commission cashback promotion */
		post: operations['CommissionCashbackController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/commission-cashback/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get commission cashback promotion by ID */
		get: operations['CommissionCashbackController_findById']
		put?: never
		post?: never
		/** Delete commission cashback promotion */
		delete: operations['CommissionCashbackController_delete']
		options?: never
		head?: never
		/** Update commission cashback promotion */
		patch: operations['CommissionCashbackController_update']
		trace?: never
	}
	'/api/admin/commission-cashback/selector/names': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get commission cashback names for selector */
		get: operations['CommissionCashbackController_getCommissionCashbackNamesForSelector']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/daily-check-in/get-check-in-data': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get daily check-in data */
		get: operations['PlayerDailyCheckInController_getCheckInData']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/daily-check-in/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get daily check-in by id */
		get: operations['PlayerDailyCheckInController_getDailyCheckInById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/daily-check-in/check-in': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Player check-in */
		post: operations['PlayerDailyCheckInController_checkIn']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/daily-check-in': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all daily check-in settings */
		get: operations['DailyCheckInController_findAll']
		put?: never
		/** Create daily check-in setting */
		post: operations['DailyCheckInController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/daily-check-in/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get daily check-in setting by ID */
		get: operations['DailyCheckInController_findById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update daily check-in setting */
		patch: operations['DailyCheckInController_update']
		trace?: never
	}
	'/api/admin/daily-check-in/selector/names': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get daily check-in names for selector */
		get: operations['DailyCheckInController_getDailyCheckInNamesForSelector']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/init-session': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Initialize a game session */
		post: operations['GameController_initSession']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/game-list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get game list */
		post: operations['GameController_getGameList']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/provider-list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game provider list */
		get: operations['GameController_getGameProviderList']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/providers-by-game-type': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game providers filtered by game type */
		get: operations['GameController_getProvidersByGameType']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/recent-games': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get recent games */
		get: operations['GameController_getRecentGames']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/game-type-list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game type list */
		get: operations['GameController_getPlayerGameTypeList']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/game/dynamic-section-list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get dynamic section list */
		get: operations['GameController_getDynamicSectionList']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all ranks information */
		get: operations['RankController_getRankInfo']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks/promote-condition': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Promote rank */
		get: operations['RankController_promoteRank']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks/experience': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get rank experience */
		get: operations['RankController_getRankExperience']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks/experience-rate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get rank experience rate */
		get: operations['RankController_getRankExperienceRate']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks/pending-free-spins': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get unclaimed free spins from rank-up rewards */
		get: operations['RankController_getPendingFreeSpins']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/ranks/claim-free-spin/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Claim a pending free spin and launch the game */
		post: operations['RankController_claimFreeSpin']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/login-announcements': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all login announcements */
		get: operations['SettingsController_getLoginAnnouncements']
		put?: never
		/** Create a new login announcement */
		post: operations['SettingsController_createLoginAnnouncement']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/login-announcements/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get login announcement by ID */
		get: operations['SettingsController_getLoginAnnouncementById']
		put?: never
		post?: never
		/** Delete a login announcement */
		delete: operations['SettingsController_deleteLoginAnnouncement']
		options?: never
		head?: never
		/** Update a login announcement */
		patch: operations['SettingsController_updateLoginAnnouncement']
		trace?: never
	}
	'/api/admin/settings/general': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get general setting */
		get: operations['SettingsController_getGeneralSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update general setting */
		patch: operations['SettingsController_updateGeneralSetting']
		trace?: never
	}
	'/api/admin/settings/theme-presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available theme presets */
		get: operations['SettingsController_getThemePresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/apply-theme-preset': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Apply a theme preset (uploads CSS + updates mode) */
		post: operations['SettingsController_applyThemePreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/game-type': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all game type settings */
		get: operations['SettingsController_getGameTypeSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/game-type/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update a game type setting */
		patch: operations['SettingsController_updateGameTypeSetting']
		trace?: never
	}
	'/api/admin/settings/dynamic-sections': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all dynamic sections */
		get: operations['SettingsController_getDynamicSections']
		put?: never
		/** Create a new dynamic section */
		post: operations['SettingsController_createDynamicSection']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/dynamic-sections/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get a dynamic section by id */
		get: operations['SettingsController_getDynamicSectionById']
		put?: never
		post?: never
		/** Delete a dynamic section */
		delete: operations['SettingsController_deleteDynamicSection']
		options?: never
		head?: never
		/** Update a dynamic section */
		patch: operations['SettingsController_updateDynamicSection']
		trace?: never
	}
	'/api/admin/settings/dynamic-sections/sections/{dynamicPageSectionId}/order': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update dynamic section order within a page */
		patch: operations['SettingsController_updateDynamicSectionOrder']
		trace?: never
	}
	'/api/admin/settings/dynamic-pages': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all dynamic pages */
		get: operations['SettingsController_getDynamicPages']
		put?: never
		/** Create a new dynamic page */
		post: operations['SettingsController_createDynamicPage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/dynamic-pages/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get a dynamic page by id */
		get: operations['SettingsController_getDynamicPageById']
		put?: never
		post?: never
		/** Delete a dynamic page */
		delete: operations['SettingsController_deleteDynamicPage']
		options?: never
		head?: never
		/** Update a dynamic page */
		patch: operations['SettingsController_updateDynamicPage']
		trace?: never
	}
	'/api/admin/settings/dynamic-pages/{pageId}/sections/{sectionId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Add a section to a dynamic page */
		post: operations['SettingsController_addSectionToPage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/dynamic-pages/sections/{dynamicPageSectionId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Remove a section from a dynamic page */
		delete: operations['SettingsController_removeSectionFromPage']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/dynamic-page-presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all dynamic page presets */
		get: operations['SettingsController_getDynamicPagePresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/dynamic-page-presets/{id}/duplicate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Duplicate a dynamic page preset into a new page */
		post: operations['SettingsController_duplicateDynamicPagePreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/main-wallet': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get main wallet setting */
		get: operations['SettingsController_getMainWalletSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update main wallet setting */
		patch: operations['SettingsController_updateMainWalletSetting']
		trace?: never
	}
	'/api/admin/settings/transaction/deposit/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit transaction status and schedules */
		get: operations['SettingsController_getDepositStatus']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/transaction/deposit/schedules': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all deposit schedules */
		get: operations['SettingsController_getDepositSchedules']
		put?: never
		/** Create a new deposit schedule */
		post: operations['SettingsController_createDepositSchedule']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/transaction/deposit/schedules/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit schedule by ID */
		get: operations['SettingsController_getDepositScheduleById']
		put?: never
		post?: never
		/** Delete a deposit schedule */
		delete: operations['SettingsController_deleteDepositSchedule']
		options?: never
		head?: never
		/** Update a deposit schedule */
		patch: operations['SettingsController_updateDepositSchedule']
		trace?: never
	}
	'/api/admin/settings/transaction/deposit/temporary-disable': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Temporarily disable deposits */
		post: operations['SettingsController_setDepositTemporaryDisable']
		/** Clear temporary deposit disable */
		delete: operations['SettingsController_clearDepositTemporaryDisable']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/transaction/withdraw/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get withdraw transaction status and schedules */
		get: operations['SettingsController_getWithdrawStatus']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/transaction/withdraw/schedules': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all withdraw schedules */
		get: operations['SettingsController_getWithdrawSchedules']
		put?: never
		/** Create a new withdraw schedule */
		post: operations['SettingsController_createWithdrawSchedule']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/settings/transaction/withdraw/schedules/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get withdraw schedule by ID */
		get: operations['SettingsController_getWithdrawScheduleById']
		put?: never
		post?: never
		/** Delete a withdraw schedule */
		delete: operations['SettingsController_deleteWithdrawSchedule']
		options?: never
		head?: never
		/** Update a withdraw schedule */
		patch: operations['SettingsController_updateWithdrawSchedule']
		trace?: never
	}
	'/api/admin/settings/transaction/withdraw/temporary-disable': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Temporarily disable withdrawals */
		post: operations['SettingsController_setWithdrawTemporaryDisable']
		/** Clear temporary withdraw disable */
		delete: operations['SettingsController_clearWithdrawTemporaryDisable']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/click/{referralCode}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Handle new referral link click */
		post: operations['InviteFriendAnalyticsController_handleNewReferralLinkClick']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/cumulative': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player invite friend analytics cumulative data
		 * @description Retrieves cumulative analytics data for player invite friend program within a specified date range
		 */
		get: operations['InviteFriendAnalyticsController_getPlayerInviteFriendAnalyticsCumulative']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/tiers': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get invite friend tiers */
		get: operations['InviteFriendAnalyticsController_getInviteFriendTiers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/wallet-transfer-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get invite friend wallet transfer history */
		get: operations['InviteFriendAnalyticsController_getInviteFriendWalletTransferHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/return-loss/calculate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Calculate real-time invite friend return loss rewards
		 * @description Shows pending return loss commission from referred friends (not yet rewarded by cron job)
		 */
		get: operations['InviteFriendAnalyticsController_calculateInviteFriendReturnLoss']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/return-loss/info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get invite friend return loss settings and information */
		get: operations['InviteFriendAnalyticsController_getInviteFriendReturnLossInfo']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/invite-friend-analytics/tier-counts': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player count for each invite friend tier
		 * @description Returns the number of players at each tier level (tier 1 = direct referrals, tier 2 = referrals of tier 1, etc.)
		 */
		get: operations['InviteFriendAnalyticsController_getInviteFriendTierCounts']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/click/{referralCode}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Handle new referral link click */
		post: operations['PartnerAnalyticsController_handleNewReferralLinkClick']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/cumulative': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get latest partner analytics cumulative data */
		get: operations['PartnerAnalyticsController_getPartnerAnalyticsCumulative']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/referred-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get players referred by a specific partner */
		get: operations['PartnerAnalyticsController_getReferredPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/monthly-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get monthly player data with transactions for a partner
		 * @description Returns all invited players with their deposit, bonus, withdraw, and loss amounts for the specified month. Partner share is calculated only for past complete months.
		 */
		get: operations['PartnerAnalyticsController_getMonthlyPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/daily-transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get daily transaction data for chart
		 * @description Returns daily deposit, bonus, and withdraw totals for the last N days (default 7). Used for rendering line charts.
		 */
		get: operations['PartnerAnalyticsController_getDailyTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/partner-analytics/invitation-summary': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get invitation summary with daily signups chart
		 * @description Returns daily signup counts for the last N days (default 7), plus summary metrics including total signups, deposited players count, and deposit totals.
		 */
		get: operations['PartnerAnalyticsController_getInvitationSummary']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/lucky-wheel/info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get wheel info by rank */
		get: operations['PlayerLuckyWheelController_getWheelInfoByRank']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/lucky-wheel/spin': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Spin wheel */
		post: operations['PlayerLuckyWheelController_spinWheel']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/return-loss/calculate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Calculate return loss for current player */
		get: operations['ReturnLossController_calculate']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/return-loss/info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get return loss info by id */
		get: operations['ReturnLossController_info']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all transactions for the player */
		get: operations['TransactionController_getTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/play-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player play history */
		get: operations['PlayHistoryController_getPlayHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/play-history/sessions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get play history grouped by promotion sessions */
		get: operations['PlayHistoryController_getPlayHistorySessions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/play-history/reinit-session': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Re-initialize a game session from play history */
		post: operations['PlayHistoryController_reinitSession']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/ranks/experience-setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get rank experience setting */
		get: operations['RankController_getRankExperienceSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update rank experience setting */
		patch: operations['RankController_updateRankExperienceSetting']
		trace?: never
	}
	'/api/admin/operators/ranks': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all ranks */
		get: operations['RankController_getRanks']
		put?: never
		/** Create new rank */
		post: operations['RankController_createRank']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/ranks/names': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all rank names for selector */
		get: operations['RankController_getRankNames']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/ranks/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get rank by ID */
		get: operations['RankController_getRankById']
		put?: never
		post?: never
		/** Delete rank */
		delete: operations['RankController_deleteRank']
		options?: never
		head?: never
		/** Update rank */
		patch: operations['RankController_updateRank']
		trace?: never
	}
	'/api/admin/operators/ranks/{id}/order': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Update rank order */
		put: operations['RankController_updateRankOrder']
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/operators/ranks/{id}/rank-up-rewards': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Replace all rank-up reward lines for a rank */
		put: operations['RankController_updateRankUpRewards']
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/return-loss': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all return loss promotions */
		get: operations['ReturnLossController_findAll']
		put?: never
		/** Create return loss promotion */
		post: operations['ReturnLossController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/return-loss/selector/names': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get return loss names for selector */
		get: operations['ReturnLossController_getReturnLossNamesForSelector']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/return-loss/daily-player-return-loss': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get daily player return loss data */
		get: operations['ReturnLossController_getDailyPlayerReturnLoss']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/return-loss/history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get return loss history */
		get: operations['ReturnLossController_getReturnLossHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/return-loss/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get return loss promotion by ID */
		get: operations['ReturnLossController_findById']
		put?: never
		post?: never
		/** Delete return loss promotion */
		delete: operations['ReturnLossController_delete']
		options?: never
		head?: never
		/** Update return loss promotion */
		patch: operations['ReturnLossController_update']
		trace?: never
	}
	'/api/admin/carousel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all carousels */
		get: operations['CarouselController_getAllCarousels']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/carousel/items': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create carousel item */
		post: operations['CarouselController_createItem']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/carousel/items/{itemId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete carousel item */
		delete: operations['CarouselController_deleteItem']
		options?: never
		head?: never
		/** Update carousel item */
		patch: operations['CarouselController_updateItem']
		trace?: never
	}
	'/api/admin/analytics/channels': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get channel analytics data */
		get: operations['AnalyticsController_getChannelAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/overall/cumulative': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get overall analytics cumulative slice (transaction cumulative LAG delta) */
		get: operations['AnalyticsController_getOverallAnalyticsCumulative']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/overall/aggregate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get overall analytics aggregate slice (wallets, fees, distinct counts) */
		get: operations['AnalyticsController_getOverallAnalyticsAggregate']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/overall': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get overall analytics data (merged) */
		get: operations['AnalyticsController_getOverallAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/overall-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export overall analytics data as CSV */
		post: operations['AnalyticsController_exportOverallAnalyticsCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/deposit-withdraw-graph': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit vs withdraw graph data */
		get: operations['AnalyticsController_getDepositWithdrawGraph']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/player-deposit-withdraw-graph': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player-specific deposit vs withdraw graph data */
		get: operations['AnalyticsController_getPlayerDepositWithdrawGraph']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/transaction-summary': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get transaction summary data */
		get: operations['AnalyticsController_getTransactionSummary']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/transaction-summary-csv': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Export transaction summary data as CSV */
		post: operations['AnalyticsController_exportTransactionSummaryCsv']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/promotions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get promotion analytics data */
		get: operations['AnalyticsController_getPromotionAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/promotions/detail': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get promotion detail analytics per player */
		get: operations['AnalyticsController_getPromotionDetail']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/retention/ttfb': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get Time to First Bet (TTFB) distribution */
		get: operations['AnalyticsController_getTTFBDistribution']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/retention/ttfd': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get Time to First Deposit (TTFD) distribution */
		get: operations['AnalyticsController_getTTFDDistribution']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/retention/cohort': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get cohort retention heatmap */
		get: operations['AnalyticsController_getCohortRetention']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/retention/stickiness': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get stickiness trend (DAU/MAU) */
		get: operations['AnalyticsController_getStickinessTrend']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/retention/lifecycle': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player lifecycle analysis */
		get: operations['AnalyticsController_getPlayerLifecycle']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/playlogs': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player play logs with filters */
		get: operations['AnalyticsController_getPlayLogs']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/online-users': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get currently active online users count */
		get: operations['AnalyticsController_getOnlineUsersStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/line/analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get comprehensive LINE messaging analytics
		 * @description Returns quota, consumption, and message statistics (push, multicast, broadcast, reply, PNP) for a specific date
		 */
		get: operations['AnalyticsController_getLineAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/active-users': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get active users metrics over time
		 * @description Returns active user count in 30-minute intervals. Users are considered active if they had wallet activity (e.g., wallet balance polling from frontend). Supports optional comparison with another period.
		 */
		get: operations['AnalyticsController_getActiveUsersMetrics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/active-users/summary': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get active users summary statistics
		 * @description Returns summary statistics including hourly pattern (24 points) and day of week pattern (7 points). Supports optional comparison with another period.
		 */
		get: operations['AnalyticsController_getActiveUsersSummary']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/player-game-stats/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player game playing statistics
		 * @description Returns aggregated statistics showing which games a player plays most, including bet amounts, turnover, profit/loss, and play counts. Can be filtered by date range, specific game, or provider.
		 */
		get: operations['AnalyticsController_getPlayerGameStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/analytics/all-players-game-stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get all players game statistics with pagination
		 * @description Returns aggregated statistics for all players showing which games they play, with filtering, sorting, and pagination. Useful for admin dashboard and analytics.
		 */
		get: operations['AnalyticsController_getAllPlayersGameStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game list */
		get: operations['GameController_getGameListForAdmin']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/provider/list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game provider list */
		get: operations['GameController_getGameProviderListForAdmin']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/update/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update game */
		patch: operations['GameController_updateGame']
		trace?: never
	}
	'/api/admin/game/type/list': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game type list */
		get: operations['GameController_getGameTypeList']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/type/update/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update game type */
		patch: operations['GameController_updateGameType']
		trace?: never
	}
	'/api/admin/game/sync': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Sync games */
		post: operations['GameController_syncGames']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/provider/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update game provider */
		patch: operations['GameController_updateGameProvider']
		trace?: never
	}
	'/api/admin/game/provider-game-type/update/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update game provider game type (banner, active status) */
		patch: operations['GameController_updateGameProviderGameType']
		trace?: never
	}
	'/api/admin/game/providers-by-game-type': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get game providers filtered by game type (Admin - includes inactive) */
		get: operations['GameController_getAdminProvidersByGameType']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/provider/batch-set-preset': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Batch set default RTP preset for providers */
		post: operations['GameController_batchSetProviderPreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/game/batch-set-preset': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Batch set default RTP preset for all games under providers */
		post: operations['GameController_batchSetGamePreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/check-balance': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Check player balance */
		post: operations['ExternalCallbackController_checkBalance']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/update-balance': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Update player balance from game provider */
		post: operations['ExternalCallbackController_updateBalance']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/get-general-setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get general settings for external integration */
		post: operations['ExternalCallbackController_getGeneralSetting']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/update-general-setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Update general settings for external integration */
		post: operations['ExternalCallbackController_updateGeneralSetting']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/get-billing-details': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get billing details breakdown for a billing month */
		post: operations['ExternalCallbackController_getBillingDetails']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/get-crypto-invoices': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Get crypto invoices with filters
		 * @description List all crypto invoices with optional filters: status (PENDING/COMPLETED/CANCELED/EXPIRED), invoiceType (MONTHLY_FEE/COMPANY_COMMISSION), billingMonth, or search by txId
		 */
		post: operations['ExternalCallbackController_getCryptoInvoices']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/get-promotions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Get all promotions with charge rate information
		 * @description Returns list of promotions with their charge rates. Supports search and filtering. If chargeRate is null, the provider default rate will be used.
		 */
		post: operations['ExternalCallbackController_getPromotions']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/update-promotion-charge-rate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Update promotion charge rate
		 * @description Update the charge rate for a specific promotion. Set to null to use provider default rate.
		 */
		post: operations['ExternalCallbackController_updatePromotionChargeRate']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/create-monthly-fee-invoice': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually create monthly platform fee invoice
		 * @description Create a monthly platform fee invoice for a specific billing month. This endpoint allows manual invoice creation outside of the automated cron schedule.
		 */
		post: operations['ExternalCallbackController_createMonthlyFeeInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/create-company-commission-invoice': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually create company commission invoice
		 * @description Create a company commission invoice for a specific billing month. This endpoint allows manual invoice creation outside of the automated cron schedule.
		 */
		post: operations['ExternalCallbackController_createCompanyCommissionInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/update-crypto-invoice-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Update crypto invoice status and settings
		 * @description Update crypto invoice status (PENDING, COMPLETED, CANCELED, EXPIRED) and/or allowGrace setting. Can update status, txHash, and allowGrace independently or together.
		 */
		post: operations['ExternalCallbackController_updateCryptoInvoiceStatus']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/external/create-manual-invoice': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Create manual crypto invoice
		 * @description Create a manual crypto invoice with custom amount and note. Manual invoices are typically for ad-hoc charges outside of regular billing cycles.
		 */
		post: operations['ExternalCallbackController_createManualInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/check-overdue': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Check if there are overdue invoices (for warning) */
		get: operations['CryptoDepositController_checkOverdueInvoices']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all crypto invoices */
		get: operations['CryptoDepositController_getCryptoInvoices']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/billing-details': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get billing details breakdown for a billing month */
		get: operations['CryptoDepositController_getBillingDetails']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get crypto invoice by ID */
		get: operations['CryptoDepositController_getCryptoInvoiceById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/create-manual': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create manual crypto invoice with note */
		post: operations['CryptoDepositController_createManualInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/create-prepayment': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Create prepayment invoice for a specific billing month
		 * @description Creates a prepayment invoice that counts toward monthly company commission. Use this for mid-month prepayments.
		 */
		post: operations['CryptoDepositController_createPrepaymentInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/generate-payment': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Generate payment for invoice */
		post: operations['CryptoDepositController_generatePayment']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/crypto-invoices/confirm': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Confirm crypto payment */
		post: operations['CryptoDepositController_payCryptoInvoice']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/tournaments/presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available tournament presets */
		get: operations['TournamentController_getPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/tournaments/from-preset': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create tournament from preset template */
		post: operations['TournamentController_createTournamentFromPreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/tournaments': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get tournaments with pagination and filters */
		get: operations['TournamentController_getTournaments']
		put?: never
		/** Create a new tournament */
		post: operations['TournamentController_createTournament']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/tournaments/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get tournament by ID */
		get: operations['TournamentController_getTournamentById']
		put?: never
		post?: never
		/** Delete tournament (soft delete) */
		delete: operations['TournamentController_deleteTournament']
		options?: never
		head?: never
		/** Update tournament */
		patch: operations['TournamentController_updateTournament']
		trace?: never
	}
	'/api/admin/tournaments/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update tournament status */
		patch: operations['TournamentController_updateTournamentStatus']
		trace?: never
	}
	'/api/admin/tournaments/{id}/players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get tournament players with leaderboard */
		get: operations['TournamentController_getTournamentPlayers']
		put?: never
		/** Manually add player to tournament */
		post: operations['TournamentController_manualJoinTournament']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/tournaments/{id}/finalize': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Finalize tournament and distribute prizes */
		post: operations['TournamentController_finalizeTournament']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/create-bank-account': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new bank account */
		post: operations['BankAccountController_createBankAccount']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/get-bank-account': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all bank accounts */
		get: operations['BankAccountController_getBankAccounts']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/get-bank-account/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get bank account by ID */
		get: operations['BankAccountController_getBankAccountById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/update-bank-account/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update bank account */
		patch: operations['BankAccountController_updateBankAccount']
		trace?: never
	}
	'/api/admin/bank-accounts/delete-bank-account/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete bank account */
		delete: operations['BankAccountController_deleteBankAccount']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/providers': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get bank providers */
		get: operations['BankAccountController_getAdminBankProviders']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-accounts/create-withdraw-transaction': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create withdraw transaction */
		post: operations['BankAccountController_createWithdrawTransaction']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit transactions */
		get: operations['BankTransactionController_getDepositTransactions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/operator': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator deposit transactions */
		get: operations['BankTransactionController_getOperatorDepositTransactions']
		put?: never
		/** Create a operator deposit transaction to payment gateway */
		post: operations['BankTransactionController_createOperatorDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator deposit transaction by ID */
		get: operations['BankTransactionController_getOperatorDepositTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get withdrawal transactions */
		get: operations['BankTransactionController_getWithdrawalTransactions']
		put?: never
		/** Create a withdrawal transaction (auto or manual) */
		post: operations['BankTransactionController_createWithdraw']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/operator': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator deposit transactions */
		get: operations['BankTransactionController_getOperatorWithdrawalTransactions']
		put?: never
		/** Create a operator withdrawal transaction to payment gateway */
		post: operations['BankTransactionController_createOperatorWithdrawal']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/operator/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get operator deposit transaction by ID */
		get: operations['BankTransactionController_getOperatorWithdrawalTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/truemoney': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get TrueMoney deposit transactions analytics */
		get: operations['BankTransactionController_getTrueMoneyDeposits']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get deposit transaction by ID */
		get: operations['BankTransactionController_getDepositTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get withdrawal transaction by ID */
		get: operations['BankTransactionController_getWithdrawalTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/{id}/force-complete': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Force complete a deposit transaction */
		patch: operations['BankTransactionController_forceCompleteDeposit']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/manual': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Create a manual bank withdrawal transaction */
		patch: operations['BankTransactionController_manualBankWithdraw']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/force-complete': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Force complete a withdrawal transaction */
		patch: operations['BankTransactionController_forceCompleteWithdraw']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/approve': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Approve a pending withdrawal (execute bank transactions) */
		patch: operations['BankTransactionController_approveWithdraw']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/retry': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Retry a pending withdrawal (execute bank transactions) */
		patch: operations['BankTransactionController_retryWithdraw']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/cancel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Cancel a withdrawal transaction */
		patch: operations['BankTransactionController_cancelWithdrawBank']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/refund': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Refund a failed or expired withdrawal transaction */
		patch: operations['BankTransactionController_refundWithdraw']
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/manual': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create a manual deposit transaction */
		post: operations['BankTransactionController_createManualDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/manual': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create a manual withdrawal transaction */
		post: operations['BankTransactionController_createManualWithdraw']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/{id}/cancel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Cancel a deposit transaction */
		patch: operations['BankTransactionController_forceCancelDeposit']
		trace?: never
	}
	'/api/admin/bank-transactions/true-wallet-logs': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get True Wallet transaction logs */
		get: operations['BankTransactionController_getTrueWalletTransactionLogs']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/search-players': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Search players by phone or account for SMS rematch */
		get: operations['BankTransactionController_searchPlayersForRematch']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/players/{playerId}/turnover-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Check player main wallet turnover status */
		get: operations['BankTransactionController_checkPlayerTurnover']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get SMS Auto transaction logs */
		get: operations['BankTransactionController_getSmsAutoTransactionLogs']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/search-users': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Search users for SMS rematch by account number */
		get: operations['BankTransactionController_searchUsersForRematch']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/{id}/rematch': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Rematch an unmatched SMS log to a deposit */
		post: operations['BankTransactionController_rematchSmsAutoLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/{id}/cancel': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Cancel an unmatched SMS log */
		post: operations['BankTransactionController_cancelSmsAutoLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/**
		 * Set SMS auto log PROCESSING/UNMATCHED status
		 * @description Toggles an SMS auto log between UNMATCHED and PROCESSING. Rejects REMATCHED/CANCELLED target statuses and any other transition.
		 */
		patch: operations['BankTransactionController_updateSmsAutoLogStatus']
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/{id}/deposits': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Create a deposit for SMS auto log rematch
		 * @description Auto-creates a deposit transaction (CREATED status) for the given player.
		 */
		post: operations['BankTransactionController_createSmsAutoLogDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/sms-auto-logs/{id}/complete-rematch': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Complete rematch — force-completes deposit and links SMS
		 * @description Force-completes a deposit (existing or auto-created) and links the SMS log to it. If depositTransactionId is provided, uses that deposit. Otherwise auto-creates a new deposit for the player.
		 */
		post: operations['BankTransactionController_completeRematchSmsAutoLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/statistics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get deposit and withdraw statistics by transaction method
		 * @description Returns total amounts and counts for deposits and withdraws separated by bank, payment gateway, true money, SMS auto, and manual methods. Manual deposits exclude free credit type.
		 */
		get: operations['BankTransactionController_getTransactionStatistics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/**
		 * Update deposit transaction status
		 * @description Update deposit transaction status by txId
		 */
		patch: operations['BankTransactionController_updateDepositStatus']
		trace?: never
	}
	'/api/admin/bank-transactions/withdrawals/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/**
		 * Update withdrawal transaction status
		 * @description Update withdrawal transaction status by txId
		 */
		patch: operations['BankTransactionController_updateWithdrawStatus']
		trace?: never
	}
	'/api/admin/bank-transactions/deposits/operator/{id}/upload-slip': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Upload slip for an operator deposit transaction */
		post: operations['BankTransactionController_uploadOperatorDepositSlip']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/withdraws': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create a new withdraw request */
		post: operations['WithdrawController_createWithdraw']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/withdraws/track-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Track withdraw status */
		get: operations['WithdrawController_getPendingWithdrawTransaction']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/withdraws/info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get withdrawal information and limits */
		get: operations['WithdrawController_getWithdrawInfo']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/withdraws/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Check if withdrawal is currently available */
		get: operations['WithdrawController_getWithdrawStatus']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/withdraws/{transactionId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Track a specific withdraw transaction by ID */
		get: operations['WithdrawController_getWithdrawTransactionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/blacklist': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get blacklists */
		get: operations['BlacklistController_getBlacklists']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/blacklist/report': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Report a blacklist */
		post: operations['BlacklistController_reportBlacklist']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/blacklist/report/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Remove a blacklist */
		delete: operations['BlacklistController_removeBlacklist']
		options?: never
		head?: never
		/** Report a blacklist */
		patch: operations['BlacklistController_updateBlacklist']
		trace?: never
	}
	'/api/admin/announcements/create-announcement': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new announcement */
		post: operations['AnnouncementController_createAnnouncement']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/announcements/get-announcement': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all announcements */
		get: operations['AnnouncementController_getAnnouncements']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/announcements/get-announcement/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get announcement by ID */
		get: operations['AnnouncementController_getAnnouncementById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/announcements/update-announcement/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update announcement */
		patch: operations['AnnouncementController_updateAnnouncement']
		trace?: never
	}
	'/api/admin/announcements/delete-announcement/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete announcement */
		delete: operations['AnnouncementController_deleteAnnouncement']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/slide-announcements': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get slide announcement */
		get: operations['SlideAnnouncementController_getSlideAnnouncement']
		put?: never
		/** Create slide announcement */
		post: operations['SlideAnnouncementController_createSlideAnnouncement']
		/** Delete slide announcement */
		delete: operations['SlideAnnouncementController_deleteSlideAnnouncement']
		options?: never
		head?: never
		/** Update slide announcement */
		patch: operations['SlideAnnouncementController_updateSlideAnnouncement']
		trace?: never
	}
	'/api/admin/minimum-withdraw': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get minimum withdraw setting */
		get: operations['MinimumWithdrawController_get']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update minimum withdraw setting */
		patch: operations['MinimumWithdrawController_update']
		trace?: never
	}
	'/api/admin/invite-friend/setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get invite friend setting by ID */
		get: operations['InviteFriendController_getSettings']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update invite friend setting */
		patch: operations['InviteFriendController_update']
		trace?: never
	}
	'/api/admin/invite-friend/commission-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get invite friend commission history */
		get: operations['InviteFriendController_getCommissionHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/invite-friend/tier-counts/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get player count for each invite friend tier
		 * @description Returns the number of players at each tier level (tier 1 = direct referrals, tier 2 = referrals of tier 1, etc.)
		 */
		get: operations['InviteFriendController_getInviteFriendTierCounts']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/invite-friend/referred-players/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get players referred by a player with commission data
		 * @description Returns list of referred players with detailed commission earnings breakdown. Supports date range filtering to answer "how much did X earn from Y during this period?". Use commissionForPlayer query parameter to view commissions from the perspective of a different player (e.g., tree head).
		 */
		get: operations['InviteFriendController_getPlayerReferredPlayers']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/profile-page-banners': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all profile page banners */
		get: operations['ProfilePageBannerController_getAllProfilePageBanners']
		put?: never
		/** Create a new profile page banner */
		post: operations['ProfilePageBannerController_createProfilePageBanner']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/profile-page-banners/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get profile page banner by ID */
		get: operations['ProfilePageBannerController_getProfilePageBannerById']
		put?: never
		post?: never
		/** Delete a profile page banner */
		delete: operations['ProfilePageBannerController_deleteProfilePageBanner']
		options?: never
		head?: never
		/** Update a profile page banner */
		patch: operations['ProfilePageBannerController_updateProfilePageBanner']
		trace?: never
	}
	'/api/admin/coupons/batches': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all coupon batches with pagination and filters */
		get: operations['CouponController_getCouponBatches']
		put?: never
		/** Create a new coupon batch with generated coupons */
		post: operations['CouponController_createCouponBatch']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/coupons/batches/{batchId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete a coupon batch and all associated coupons */
		delete: operations['CouponController_deleteBatch']
		options?: never
		head?: never
		/** Update coupon batch details */
		patch: operations['CouponController_updateCouponBatch']
		trace?: never
	}
	'/api/admin/coupons/batches/{batchId}/generate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Generate additional coupons (MULTIPLE type) or increase quota (SINGLE type)
		 * @description For MULTIPLE type batches: generates new coupon codes. For SINGLE type batches: increases the usage quota.
		 */
		post: operations['CouponController_generateAdditionalCoupons']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/coupons/coupons': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all coupons with pagination and filters */
		get: operations['CouponController_getCoupons']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/coupons/stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get coupon system statistics */
		get: operations['CouponController_getCouponStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/coupons/broke-notification': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get SINGLE type coupons for broke notification selection
		 * @description Returns active SINGLE type coupons with code and id only
		 */
		get: operations['CouponController_getCouponsForBrokeNotification']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/coupons/coupons/{couponId}/usage-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get usage history for a SINGLE type coupon */
		get: operations['CouponController_getCouponUsageHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/items/presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get shop item presets */
		get: operations['ShopController_getShopItemPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/items/presets/{presetId}/apply': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Apply shop item preset (create item from preset) */
		post: operations['ShopController_applyShopItemPreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/items': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get shop items with pagination and filters */
		get: operations['ShopController_getShopItems']
		put?: never
		/** Create a new shop item */
		post: operations['ShopController_createShopItem']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/items/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get shop item by ID */
		get: operations['ShopController_getShopItemById']
		put?: never
		post?: never
		/** Delete shop item (soft delete) */
		delete: operations['ShopController_deleteShopItem']
		options?: never
		head?: never
		/** Update shop item */
		patch: operations['ShopController_updateShopItem']
		trace?: never
	}
	'/api/admin/shop/purchases': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get shop purchases with pagination and filters */
		get: operations['ShopController_getShopPurchases']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/purchases/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get purchase by ID */
		get: operations['ShopController_getPurchaseById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/shop/purchases/{id}/process': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Process purchase (approve/reject, especially for ITEM type) */
		patch: operations['ShopController_processPurchase']
		trace?: never
	}
	'/api/admin/events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all events */
		get: operations['EventController_getAllEvents']
		put?: never
		/** Create event */
		post: operations['EventController_createEvent']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/events/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get event by ID */
		get: operations['EventController_getEventById']
		put?: never
		post?: never
		/** Delete event */
		delete: operations['EventController_deleteEvent']
		options?: never
		head?: never
		/** Update event */
		patch: operations['EventController_updateEvent']
		trace?: never
	}
	'/api/admin/turnover-events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all turnover events with filters */
		get: operations['TurnoverEventController_getTurnoverEvents']
		put?: never
		/** Create a new turnover event */
		post: operations['TurnoverEventController_createTurnoverEvent']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/turnover-events/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get turnover event by ID */
		get: operations['TurnoverEventController_getTurnoverEventById']
		put?: never
		post?: never
		/** Delete turnover event (soft delete) */
		delete: operations['TurnoverEventController_deleteTurnoverEvent']
		options?: never
		head?: never
		/** Update turnover event */
		patch: operations['TurnoverEventController_updateTurnoverEvent']
		trace?: never
	}
	'/api/admin/turnover-events/{id}/status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update turnover event status */
		patch: operations['TurnoverEventController_updateTurnoverEventStatus']
		trace?: never
	}
	'/api/admin/turnover-events/{id}/claims': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all player claims for event */
		get: operations['TurnoverEventController_getEventClaims']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/providers': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get SMS providers */
		get: operations['MessageController_getSmsProviders']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/providers/{providerId}/senders': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get SMS provider senders */
		get: operations['MessageController_getSmsProviderSenders']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/transaction-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get message transaction history */
		post: operations['MessageController_getMessageTransactionHistory']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/conditions/single': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all conditions (single) */
		get: operations['MessageController_getConditions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/conditions/auto': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all conditions (auto) */
		get: operations['MessageController_getConditionsAuto']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/group-player-by-condition': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Group player by condition using enum values */
		post: operations['MessageController_groupPlayerByCondition']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/auto-message-all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all auto messages */
		get: operations['MessageController_getAllAutoMessages']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/auto-message-by-id/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get auto message */
		get: operations['MessageController_getAutoMessage']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/auto-message-update/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		/** Update auto message */
		put: operations['MessageController_updateAutoMessage']
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/auto-message-delete/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete auto message (soft delete) */
		delete: operations['MessageController_removeAutoMessage']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/create-message': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new message */
		post: operations['MessageController_createMessageTransaction']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/create-auto-message': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create new auto message */
		post: operations['MessageController_createAutoMessageTransaction']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/channel-transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get SMS or LINE transactions by channel with pagination and filters */
		post: operations['MessageController_getChannelTransactions']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get messaging analytics and conversion rates */
		get: operations['MessageController_getMessagingAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/flex-analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get flex message analytics (latest record per flex message) */
		get: operations['MessageController_getFlexMessageAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/flex-analytics/{hotGameFlexMessageId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get flex message analytics for a specific flex message */
		get: operations['MessageController_getFlexMessageAnalyticsDetail']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/flex-analytics/recalculate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Trigger full recalculation of flex message analytics */
		post: operations['MessageController_recalculateFlexMessageAnalytics']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/build-promotion-flex': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Build promotion flex message for chat sending */
		post: operations['MessageController_buildPromotionFlex']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/promotion-flex-analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get promotion flex message analytics
		 * @description Get analytics for all promotion flex messages sent
		 */
		get: operations['MessageController_getPromotionFlexAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/message/promotion-flex-analytics/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get promotion flex analytics for specific message
		 * @description Get detailed analytics for a specific promotion flex message
		 */
		get: operations['MessageController_getPromotionFlexAnalyticsDetail']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/interval-message': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all interval messages */
		get: operations['IntervalMessageController_findAll']
		put?: never
		/** Create interval message */
		post: operations['IntervalMessageController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/interval-message/interval-conditions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available interval conditions */
		get: operations['IntervalMessageController_getIntervalConditions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/interval-message/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get interval message by ID */
		get: operations['IntervalMessageController_findOne']
		put?: never
		post?: never
		/** Delete interval message (soft delete) */
		delete: operations['IntervalMessageController_remove']
		options?: never
		head?: never
		/** Update interval message */
		patch: operations['IntervalMessageController_update']
		trace?: never
	}
	'/api/admin/broke-notifications': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all broke notifications */
		get: operations['AdminBrokeNotificationController_getAllNotifications']
		put?: never
		/** Create a new broke notification */
		post: operations['AdminBrokeNotificationController_createNotification']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-notifications/stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get notification view statistics */
		get: operations['AdminBrokeNotificationController_getNotificationStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-notifications/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get broke notification by ID */
		get: operations['AdminBrokeNotificationController_getNotificationById']
		put?: never
		post?: never
		/** Delete a broke notification */
		delete: operations['AdminBrokeNotificationController_deleteNotification']
		options?: never
		head?: never
		/** Update a broke notification */
		patch: operations['AdminBrokeNotificationController_updateNotification']
		trace?: never
	}
	'/api/admin/broke-flex-messages/campaigns': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get all broke flex message campaigns
		 * @description List all broke flex message campaigns with filtering
		 */
		get: operations['BrokeFlexMessageController_getCampaigns']
		put?: never
		/**
		 * Create broke flex message campaign
		 * @description Create a multi-stage progressive campaign for players with depleted balance
		 */
		post: operations['BrokeFlexMessageController_createCampaign']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/campaigns/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get broke flex message campaign by ID
		 * @description Get detailed campaign with all stages and items
		 */
		get: operations['BrokeFlexMessageController_getCampaign']
		/**
		 * Update broke flex message campaign
		 * @description Update campaign settings, stages, and items
		 */
		put: operations['BrokeFlexMessageController_updateCampaign']
		post?: never
		/**
		 * Delete broke flex message campaign
		 * @description Soft delete a campaign (sets isDeleted=true, isActive=false)
		 */
		delete: operations['BrokeFlexMessageController_deleteCampaign']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/campaigns/{id}/preview/{stageId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Preview flex message for a campaign stage
		 * @description Generate and send a preview of the flex message to admin chat for testing
		 */
		post: operations['BrokeFlexMessageController_previewCampaignStage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get available campaign presets
		 * @description List all available preset templates with their configurations
		 */
		get: operations['BrokeFlexMessageController_getPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/campaigns/from-preset': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Create campaign from preset
		 * @description Quick create a campaign using a preset template (creates Stage 1 only)
		 */
		post: operations['BrokeFlexMessageController_createFromPreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/campaigns/{id}/add-stage': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Add a new stage to existing campaign
		 * @description Add Stage 2, 3, 4, etc. to an existing campaign with simple configuration
		 */
		post: operations['BrokeFlexMessageController_addStage']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/analytics': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get analytics overview for all broke flex campaigns
		 * @description Get analytics summary for all campaigns with recipient counts, open rates, and conversions
		 */
		get: operations['BrokeFlexMessageController_getAllAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/broke-flex-messages/analytics/{campaignId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get detailed analytics for a specific broke flex campaign
		 * @description Get detailed analytics including opens, plays, conversions, and breakdowns by wallet/game/balance
		 */
		get: operations['BrokeFlexMessageController_getAnalytics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/domains/attach-domain': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Attach domain to Cloudflare Worker */
		post: operations['DomainController_attachDomain']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/domains/detach-domain': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Detach domain from Cloudflare Worker */
		post: operations['DomainController_detachDomain']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/domains': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get domains by agent name */
		get: operations['DomainController_getDomains']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/domains/invalidate-cache': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Invalidate cache */
		post: operations['DomainController_invalidateCache']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/hot-game-flex-message': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all hot game settings */
		get: operations['HotGameFlexMessageController_findAll']
		put?: never
		/** Create hot game setting */
		post: operations['HotGameFlexMessageController_create']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/hot-game-flex-message/presets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all flex message presets */
		get: operations['HotGameFlexMessageController_getPresets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/hot-game-flex-message/presets/{id}/duplicate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Duplicate a flex message preset into a new record */
		post: operations['HotGameFlexMessageController_duplicatePreset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/hot-game-flex-message/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get hot game setting by ID */
		get: operations['HotGameFlexMessageController_findOne']
		put?: never
		post?: never
		/** Disable hot game setting */
		delete: operations['HotGameFlexMessageController_delete']
		options?: never
		head?: never
		/** Update hot game setting */
		patch: operations['HotGameFlexMessageController_update']
		trace?: never
	}
	'/api/admin/session/kick-all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Kick all players out of their sessions */
		post: operations['SessionController_kickAll']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/session/kick/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Kick a specific player out of their session */
		post: operations['SessionController_kickPlayer']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/session/reinit/{playerId}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Reinitialize a specific player session with new settings */
		post: operations['SessionController_reinitPlayer']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/session/reinit-all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Reinitialize all active game sessions with new settings */
		post: operations['SessionController_reinitAll']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/metrics/indicator-service-container': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get ECS service CPU and memory metrics */
		get: operations['MetricsController_getEcsServiceCpuMem']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/metrics/indicator-service-task': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get task-specific CPU and memory time-series metrics */
		get: operations['MetricsController_getTaskMetrics']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-stickers/packages': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all sticker packages */
		get: operations['LineStickerController_getAllPackages']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-stickers/packages/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get a sticker package by ID */
		get: operations['LineStickerController_getPackageById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-stickers/packages/{packageId}/stickers': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all stickers for a package */
		get: operations['LineStickerController_getStickersForPackage']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-message-log': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get LINE auto message logs with pagination and filters */
		get: operations['LineMessageLogController_getLineMessageLogs']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-message-log/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get a specific LINE auto message log by ID */
		get: operations['LineMessageLogController_getLineMessageLogById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-message-log/{id}/messages': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get messages for a specific LINE auto message log */
		get: operations['LineMessageLogController_getLineMessageLogMessages']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/line-message-log/{id}/grouped': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get grouped messages for a specific LINE auto message log (unique messages with chat room summary) */
		get: operations['LineMessageLogController_getLineMessageLogGrouped']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/admin-assets': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get admin asset configuration */
		get: operations['AdminAssetsController_getAdminAssets']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update admin asset configuration */
		patch: operations['AdminAssetsController_updateAdminAssets']
		trace?: never
	}
	'/api/admin/otp-provider': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['OtpProviderController_getAllProviders']
		put?: never
		post: operations['OtpProviderController_createProvider']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/otp-provider/active': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['OtpProviderController_getActiveProvider']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/otp-provider/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get: operations['OtpProviderController_getProviderById']
		put: operations['OtpProviderController_updateProvider']
		post?: never
		delete: operations['OtpProviderController_deleteProvider']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/quota/purchase': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Purchase quota from super server */
		post: operations['AdminQuotaController_purchaseQuota']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/quota/current': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current agent quota information */
		get: operations['AdminQuotaController_getCurrentQuota']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/quota/history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get quota purchase history */
		get: operations['AdminQuotaController_getPurchaseHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/agent/buy-my-quota/crypto': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Create crypto quota purchase request */
		post: operations['AgentQuotaCryptoController_buyQuotaCrypto']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/agent/buy-my-quota/crypto-confirm': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Confirm crypto quota payment with transaction hash */
		post: operations['AgentQuotaCryptoController_confirmQuotaCrypto']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-carousel-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getCarouselUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-promotion-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getPromotionUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-rank-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getRankBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-rank-frame-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getRankFrameUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-return-loss-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getReturnLossUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-commission-cashback-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getCommissionCashbackUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-game-page-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getGamePageBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-announcement-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getAnnouncementBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-broke-notification-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getBrokeNotificationUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-profile-page-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getProfilePageBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-game-image-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getGameImageUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-provider-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getProviderBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-provider-logo-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getProviderLogoUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-lucky-wheel-image-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getLuckyWheelImageUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-lucky-wheel-arrow-image-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getLuckyWheelArrowImageUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-shop-item-image-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getShopItemImageUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-event-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getEventBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-event-logo-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['FileController_getEventLogoUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-tournament-banner-upload-file-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get presigned URL for uploading tournament banner image */
		post: operations['FileController_getTournamentBannerUploadFileUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/invalidate-image-cache': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Invalidate image server cache for a specific image URL */
		post: operations['FileController_invalidateImageCache']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/upload-logo': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Upload logo directly and invalidate both image server and R2 caches */
		post: operations['FileController_uploadLogo']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/upload-favicon': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Upload favicon directly, generate all sizes, and invalidate both image server and R2 caches */
		post: operations['FileController_uploadFavicon']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-withdraw-sound-upload-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get presigned URL for uploading withdraw notification sound (mp3) */
		post: operations['FileController_getWithdrawSoundUploadUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/upload-custom-css': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Upload custom CSS from string content and invalidate both image server and R2 caches */
		post: operations['FileController_uploadCustomCss']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/admin/file/get-slip-presign-url': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get presigned URL for uploading a deposit slip image to R2 */
		post: operations['FileController_getSlipPresignUrl']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/bank/callback/bulk-update-transactions': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['TransactionController_bulkUpdateTransactions']
		trace?: never
	}
	'/api/bank/callback/update-transfer-transaction': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['TransactionController_updateTransferTransaction']
		trace?: never
	}
	'/api/bank/callback/bulk-update-bank-health-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['TransactionController_bulkUpdateBankHealthStatus']
		trace?: never
	}
	'/api/bank/callback/bulk-notify-true-wallet-transaction-log': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['TransactionController_bulkNotifyTrueWalletTransactionLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/bank/callback/bulk-notify-sms-auto-transaction-log': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['TransactionController_bulkNotifySMSAutoTransactionLog']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/bank/callback/mark-sms-auto-match-failed': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch: operations['TransactionController_markSmsAutoMatchFailed']
		trace?: never
	}
	'/api/bank/callback/maintenance-notify': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['TransactionController_maintenanceNotify']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/bank/callback/maintenance-started': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['TransactionController_maintenanceStarted']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/bank/callback/maintenance-ended': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post: operations['TransactionController_maintenanceEnded']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/general-setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get general settings for player */
		get: operations['PlayerPageController_getGeneralSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/carousel-items': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get carousel items */
		get: operations['PlayerPageController_getCarouselItems']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/manifest.json': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get PWA manifest.json */
		get: operations['PlayerPageController_getManifest']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current player profile */
		get: operations['PlayerController_getMe']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/me/password': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Update current player password */
		patch: operations['PlayerController_updatePassword']
		trace?: never
	}
	'/api/player/me/fcm-token': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Register FCM token for push notifications */
		post: operations['PlayerController_registerFCMToken']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/me/fcm-token/{token}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Unregister FCM token(s) */
		delete: operations['PlayerController_unregisterFCMToken']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/me/popup-display': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current player display status */
		get: operations['PlayerController_getPopupDisplay']
		put?: never
		/** Update player rank display status */
		post: operations['PlayerController_updatePopupDisplay']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/me/connect-lineid': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		/** Connect or update LINE ID */
		patch: operations['PlayerController_connectLineId']
		trace?: never
	}
	'/api/player/me/diamond-history': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get current player diamond earning history */
		get: operations['PlayerController_getDiamondHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player notifications */
		get: operations['PlayerNotificationController_getNotifications']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications/{id}/read': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Mark notification as read */
		post: operations['PlayerNotificationController_markAsRead']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications/read-all': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Mark all notifications as read */
		post: operations['PlayerNotificationController_markAllAsRead']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications/unread-count': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get unread notifications count */
		get: operations['PlayerNotificationController_getUnreadCount']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		post?: never
		/** Delete notification */
		delete: operations['PlayerNotificationController_deleteNotification']
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/notifications/events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get all player events
		 * @description Get aggregated information about all player events including lucky wheel quota, daily check-in status, return loss, and commission
		 */
		get: operations['PlayerNotificationController_getPlayerEvents']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/promotions/applicable': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get list of promotions applicable for the current player */
		get: operations['PromotionController_getApplicablePromotions']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/promotions/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get promotion details by ID
		 * @description Get detailed information about a specific promotion. Works for both regular and hidden promotions (isCoupon=true) when accessed directly.
		 */
		get: operations['PromotionController_getPromotionById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/bank/providers': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get bank providers */
		get: operations['BankController_getPlayerBankProviders']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/bank/me': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Add bank account for player who skipped at registration */
		post: operations['BankController_addPlayerBank']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/profile-page-banners': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all profile page banners */
		get: operations['PlayerProfilePageBannerController_getAllProfilePageBanners']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/profile-page-banners/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get profile page banner by ID */
		get: operations['PlayerProfilePageBannerController_getProfilePageBannerById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/login-announcement': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player login announcement */
		get: operations['PlayerLoginAnnouncementController_getPlayerLoginAnnouncement']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/slide-announcement': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player slide announcement */
		get: operations['PlayerSlideAnnouncementController_getPlayerSlideAnnouncement']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/partner/partner-info': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get partner info */
		get: operations['PartnerController_getPartnerInfo']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/partner/payment-records': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Get payment records for the partner
		 * @description Returns paginated list of payment records for the authenticated partner. Only shows summary data, not individual player details.
		 */
		get: operations['PlayerPartnerController_getPaymentRecords']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/coupons/redeem': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Redeem a coupon code */
		post: operations['CouponController_redeemCoupon']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/shop/items': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available diamond shop items */
		get: operations['ShopController_getPlayerShopItems']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/shop/items/{id}/purchase': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Purchase shop item with diamonds */
		post: operations['ShopController_purchaseShopItem']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/shop/purchases': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get player diamond purchase history */
		get: operations['ShopController_getPlayerPurchaseHistory']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get active events for players */
		get: operations['EventController_getActiveEvents']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/broke-notification/check': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/**
		 * Check for broke notification when player balance < 1
		 * @description Returns the first eligible notification. Frontend should only call when balance drops below 1.
		 */
		get: operations['BrokeNotificationController_checkBrokeNotification']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/turnover-events': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get all active turnover events with player progress */
		get: operations['PlayerTurnoverEventController_getTurnoverEvents']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/turnover-events/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get turnover event by ID with player progress */
		get: operations['PlayerTurnoverEventController_getTurnoverEventById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/turnover-events/{id}/claim': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Claim turnover event reward */
		post: operations['PlayerTurnoverEventController_claimReward']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/tournaments': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get available tournaments */
		get: operations['PlayerTournamentController_getTournaments']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/tournaments/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get tournament details */
		get: operations['PlayerTournamentController_getTournamentById']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/tournaments/{id}/join': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Join tournament */
		post: operations['PlayerTournamentController_joinTournament']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/tournaments/{id}/leaderboard': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get tournament leaderboard */
		get: operations['PlayerTournamentController_getTournamentLeaderboard']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/player/tournaments/{id}/my-stats': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get my tournament statistics */
		get: operations['PlayerTournamentController_getPlayerTournamentStats']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/return-loss/backfill': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill daily return loss histories for a specific date
		 * @description Recomputes daily histories for a past date. This does not calculate or pay rewards.
		 */
		post: operations['CronJobController_backfillReturnLoss']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/return-loss/backfill-range': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill daily return loss histories for a date range
		 * @description Recomputes daily histories for each date in the inclusive range. This does not calculate or pay rewards.
		 */
		post: operations['CronJobController_backfillReturnLossRange']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/return-loss/backfill-payout': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill return loss payout for a completed interval
		 * @description Pays a missed completed interval after daily history runs have been successfully backfilled. Weekly periodEndDate should be Saturday; monthly should be the last day of the month.
		 */
		post: operations['CronJobController_backfillReturnLossPayout']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/invite-friend-return-loss/backfill-payout': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill invite-friend return loss payout for a completed interval
		 * @description Pays missed invite-friend return loss for a completed interval after daily history runs have been successfully backfilled.
		 */
		post: operations['CronJobController_backfillInviteFriendReturnLossPayout']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/message-analytics/backfill': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill message analytics for existing campaigns
		 * @description Initialize and calculate analytics for campaigns sent after the specified start date. If no date provided, starts from 2024-01-01.
		 */
		post: operations['CronJobController_backfillMessageAnalytics']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/message-analytics/calculate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually trigger message analytics calculation
		 * @description Run the daily message analytics calculation job manually for testing.
		 */
		post: operations['CronJobController_calculateMessageAnalytics']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/broke-flex-analytics/backfill': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Backfill broke flex analytics for existing campaigns
		 * @description Initialize and calculate analytics for all broke flex campaigns that have been sent.
		 */
		post: operations['CronJobController_backfillBrokeFlexAnalytics']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/broke-flex-analytics/calculate': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually trigger broke flex analytics calculation
		 * @description Run the daily broke flex analytics calculation job manually for testing.
		 */
		post: operations['CronJobController_calculateBrokeFlexAnalytics']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/cron-job/demo-reset/run': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/**
		 * Manually trigger demo database reset
		 * @description Wipes all user data and reseeds to a clean state for the current project. Recreates the demo player (0000000000 / 0000) and resets CSS, logo, and favicon.
		 */
		post: operations['CronJobController_runDemoReset']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/register': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Register a new player */
		post: operations['PoliExternalCallbackController_register']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/update-player/{id}': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Update player */
		post: operations['PoliExternalCallbackController_updatePlayer']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/get-bank-provider': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get bank provider */
		post: operations['PoliExternalCallbackController_getBankProvider']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/check-balance': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Check player balance */
		post: operations['PoliExternalCallbackController_checkBalance']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/init-session': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Initialize player session */
		post: operations['PoliExternalCallbackController_initSession']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/get-general-setting': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		/** Get general settings */
		get: operations['PoliExternalCallbackController_getGeneralSetting']
		put?: never
		post?: never
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/deposit': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Initiate a deposit */
		post: operations['PoliExternalCallbackController_deposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/get-deposit-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get deposit status */
		post: operations['PoliExternalCallbackController_getDepositStatus']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/cancel-deposit': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Cancel a deposit */
		post: operations['PoliExternalCallbackController_cancelDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/withdraw': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Initiate a withdrawal */
		post: operations['PoliExternalCallbackController_withdraw']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/get-withdraw-status': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Get withdrawal status */
		post: operations['PoliExternalCallbackController_getWithdrawStatus']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/cancel-withdraw': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Cancel a withdrawal */
		post: operations['PoliExternalCallbackController_cancelWithdraw']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
	'/api/poli/callback/manual-complete-deposit': {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		get?: never
		put?: never
		/** Manually complete a deposit transaction */
		post: operations['PoliExternalCallbackController_manualCompleteDeposit']
		delete?: never
		options?: never
		head?: never
		patch?: never
		trace?: never
	}
}
export type webhooks = Record<string, never>
export interface components {
	schemas: {
		LoginDto: {
			/** @default operatorA */
			username: string
			/** @default password */
			password: string
			totpCode?: string
		}
		/** @enum {string} */
		SubType: SubType
		LoginResponse: {
			accessToken: string
			role: components['schemas']['SubType']
			totpSecret?: string
		}
		AdminResponse: {
			id: string
			username: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateAdminDto: {
			password?: string
			username?: string
		}
		/**
		 * @description Array of all available permissions
		 * @enum {string}
		 */
		OperatorGroupPermission: OperatorGroupPermission
		OperatorGroupModel: {
			id: string
			name: string
			writePermission: components['schemas']['OperatorGroupPermission'][]
			readPermission: components['schemas']['OperatorGroupPermission'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetOperatorResponse: {
			id: string
			username: string
			phone?: string
			userGroup: components['schemas']['OperatorGroupModel']
			isActive: boolean
			totpEnabled: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetOperatorsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['GetOperatorResponse'][]
		}
		CreateOperatorDto: {
			username: string
			password: string
			userGroupId: string
			phone?: string
		}
		UpdateOperatorDto: {
			username?: string
			password?: string
			phone?: string
			userGroupId?: string
			isActive?: boolean
		}
		OperatorLoginHistoryModel: {
			id: string
			operatorId: string
			ipAddress: string
			userAgent: string
			browser: string
			device: string
			os: string
			/** Format: date-time */
			createdAt: string
			operator: {
				username?: string
			}
		}
		GetOperatorLoginHistoriesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['OperatorLoginHistoryModel'][]
		}
		UpdateMeOperatorDto: {
			username?: string
			password?: string
			phone?: string
		}
		/** @enum {string} */
		OperatorEventHistoryStatus: OperatorEventHistoryStatus
		/** @enum {string} */
		OperatorLogEvent: OperatorLogEvent
		/** @enum {string} */
		TagEvent: TagEvent
		OperatorEventLogModel: {
			id: string
			operatorId: string
			operatorName: string
			eventName: components['schemas']['OperatorLogEvent']
			tagEvent?: components['schemas']['TagEvent']
			ipAddress?: Record<string, never> | null
			status: components['schemas']['OperatorEventHistoryStatus']
			description: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetOperatorEventLogsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['OperatorEventLogModel'][]
		}
		GetTotpSecretResponse: {
			qrCode: string
			/** @description Current TOTP code for testing purposes */
			totpCode: string
			/** @description TOTP secret for testing purposes */
			secret: string
		}
		EnableTotpDto: {
			totpCode: string
		}
		DisableTotpDto: {
			totpCode: string
		}
		ResetTotpDto: {
			password: string
		}
		RegisterFCMTokenDto: {
			/** @description Firebase Cloud Messaging token */
			token: string
			/** @description Unique device identifier */
			deviceId?: string
			/** @description Platform (iOS, Android, Web) */
			platform?: string
			/** @description Device information */
			deviceInfo?: string
		}
		FCMTokenResponse: {
			id: string
			token: string
			deviceId?: string
			platform?: string
			deviceInfo?: string
			isActive: boolean
			/** Format: date-time */
			lastUsedAt: string
			/** Format: date-time */
			createdAt: string
		}
		RegisterFCMTokenResponse: {
			/** @description Whether the token was newly created or updated */
			created: boolean
			fcmToken: components['schemas']['FCMTokenResponse']
		}
		PartnerRewardModel: {
			ratio: number
			maxCreditAmount?: number
		}
		CreatePartnerDto: {
			createdByPlayerId: string
			nickname: string
			percentage: number
			rewards: {
				[key: string]: components['schemas']['PartnerRewardModel']
			}
		}
		GetPartnerResponse: {
			id: string
			nickname: string
			percentage: number
			rewards: {
				[key: string]: components['schemas']['PartnerRewardModel']
			}
			referralCode: string
			createdByPlayerId: string
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** Format: date-time */
			lastPaymentDate?: string
		}
		PartnerModel: {
			id: string
			nickname: string
			percentage: number
			rewards: {
				[key: string]: components['schemas']['PartnerRewardModel']
			}
			referralCode: string
			createdByPlayerId: string
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** Format: date-time */
			lastPaymentDate?: string
		}
		GetPartnersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PartnerModel'][]
		}
		UpdatePartnerDto: {
			nickname?: string
			percentage?: number
			rewards?: {
				[key: string]: components['schemas']['PartnerRewardModel']
			}
			isActive?: boolean
			isDeleted?: boolean
		}
		AdminPartnerPlayerSummaryModel: {
			id: string
			phone: string
			/** Format: date-time */
			createdAt: string
			isBanned: boolean
			/** @description Sum of SUCCESS deposits WITH promotion in date range */
			depositWithBonus: number
			/** @description Sum of SUCCESS deposits WITHOUT promotion in date range */
			depositWithoutBonus: number
			/** @description Total deposits (depositWithBonus + depositWithoutBonus) */
			totalDeposit: number
			/** @description Sum of COMPLETED withdraws in date range */
			totalWithdraw: number
			/** @description Profit (transferIn - transferOut - bonus from play logs and deposit bonus) */
			profit: number
			/** @description Partner's share of the profit (profit * percentage) */
			partnerShare: number
			/** @description Sum of transfer_in from successful play logs in range (แทงเสีย — system receives) */
			transferIn: number
			/** @description Sum of transfer_out from successful play logs in range (แทงได้ — system pays) */
			transferOut: number
			/** @description Sum of bonus_amount from deposit promotion history for completed deposits in range */
			bonus: number
		}
		AdminGetPartnerPlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminPartnerPlayerSummaryModel'][]
		}
		AdminPartnerPlayersSummaryTotals: {
			/** @description Grand total of all players depositWithBonus */
			summaryDepositWithBonus: number
			/** @description Grand total of all players depositWithoutBonus */
			summaryDepositWithoutBonus: number
			/** @description Grand total of all players totalDeposit */
			summaryTotalDeposit: number
			/** @description Grand total of all players totalWithdraw */
			summaryTotalWithdraw: number
			/** @description Grand total profit (summaryTransferIn - summaryTransferOut - summaryBonus) */
			summaryProfit: number
			/** @description Grand total of partner's share */
			summaryPartnerShare: number
			/** @description Grand total of transferIn (play log sum_in, แทงเสีย) */
			summaryTransferIn: number
			/** @description Grand total of transferOut (play log sum_out, แทงได้) */
			summaryTransferOut: number
			/** @description Grand total of bonus (deposit promotion bonus_amount sum) */
			summaryBonus: number
		}
		AdminGetPartnerPlayersSummaryResponse: {
			/** @description Total number of players matching the filter */
			totalPlayers: number
			summary: components['schemas']['AdminPartnerPlayersSummaryTotals']
		}
		DateRangeDto: {
			/**
			 * @description Start date (YYYY-MM-DD)
			 * @example 2024-01-01
			 */
			startDate: string
			/**
			 * @description End date (YYYY-MM-DD)
			 * @example 2024-01-31
			 */
			endDate: string
			/**
			 * @description Label for this date range (used in filename)
			 * @example January_2024
			 */
			label?: string
		}
		AdminExportPartnerPlayersCsvDto: {
			/** @description Array of date ranges to export */
			ranges: components['schemas']['DateRangeDto'][]
			/** @description Search by phone number (applies to all ranges) */
			phone?: string
			/** @description Custom column name mappings */
			columnMappings?: {
				[key: string]: string
			}
		}
		AddPartnerCreditDto: {
			/**
			 * @description Amount of credit to add to partner player
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Note/reason for adding credit
			 * @example Commission payment for January
			 */
			note?: string
		}
		AddPartnerCreditResponse: {
			/** @description Success message */
			message: string
			/** @description New balance after adding credit */
			newBalance: number
			/** @description Amount added */
			amountAdded: number
			/** @description Player ID who received the credit */
			playerId: string
		}
		CreatePartnerPaymentRecordDto: {
			/**
			 * @description Start date of the payment period (YYYY-MM-DD)
			 * @example 2024-01-01
			 */
			startDate: string
			/**
			 * @description End date of the payment period (YYYY-MM-DD)
			 * @example 2024-01-31
			 */
			endDate: string
			/**
			 * @description Amount paid to partner
			 * @example 10000
			 */
			amount: number
			/**
			 * @description Note/reason for the payment
			 * @example January 2024 commission payment
			 */
			note?: string
		}
		PaymentRecordPlayerSnapshotModel: {
			playerId: string
			phone: string
			/** Format: date-time */
			createdAt: string
			depositAmount: number
			depositBonusAmount: number
			totalWithdraw: number
			totalLoss: number
			partnerShare: number
		}
		PaymentRecordSummarySnapshotModel: {
			playerCount: number
			totalDepositAmount: number
			totalDepositBonusAmount: number
			totalWithdraw: number
			totalLoss: number
			totalPartnerShare: number
		}
		PaymentRecordSnapshotModel: {
			players: components['schemas']['PaymentRecordPlayerSnapshotModel'][]
			summary: components['schemas']['PaymentRecordSummarySnapshotModel']
		}
		CreatePartnerPaymentRecordResponse: {
			id: string
			partnerId: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			amount: number
			note?: string
			snapshotData: components['schemas']['PaymentRecordSnapshotModel']
			createdById: string
			createdByUsername?: string
			/** Format: date-time */
			createdAt: string
		}
		PartnerPaymentRecordModel: {
			id: string
			partnerId: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			amount: number
			note?: string
			snapshotData: components['schemas']['PaymentRecordSnapshotModel']
			createdById: string
			createdByUsername?: string
			/** Format: date-time */
			createdAt: string
		}
		GetPartnerPaymentRecordsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PartnerPaymentRecordModel'][]
		}
		TogglePartnerActiveDto: {
			/**
			 * @description Whether the partner should be active
			 * @example true
			 */
			isActive: boolean
		}
		TogglePartnerActiveResponse: {
			/** @description Success message */
			message: string
			/** @description Partner ID */
			partnerId: string
			/** @description New active status */
			isActive: boolean
		}
		DailyTransactionDataModel: {
			date: string
			/** @description Actual money deposited */
			depositAmount: number
			/** @description Bonus credit added */
			depositBonusAmount: number
			totalWithdraw: number
		}
		GetDailyTransactionsResponse: {
			data: components['schemas']['DailyTransactionDataModel'][]
		}
		DailySignupDataModel: {
			date: string
			count: number
		}
		InvitationSummaryModel: {
			/** @description Total signups in the period */
			totalSignups: number
			/** @description Total players who have deposited */
			totalDepositedPlayers: number
			/** @description Total deposit amount in the period */
			totalDepositAmount: number
			/** @description Total deposit bonus amount in the period */
			totalDepositBonusAmount: number
		}
		GetInvitationSummaryResponse: {
			dailySignups: components['schemas']['DailySignupDataModel'][]
			summary: components['schemas']['InvitationSummaryModel']
		}
		DeletePartnerResponse: {
			/** @description Success message */
			message: string
			/** @description Partner ID */
			partnerId: string
		}
		CreateChannelDto: {
			name: string
			isActive: boolean
			cost?: number
			promotionId?: string
			/** @description Whether this channel is for guest users */
			isGuest?: boolean
			/** @description Optional note for the channel */
			note?: string
		}
		ChannelPromotionModel: {
			id: string
			name: string
		}
		GetChannelResponse: {
			id: string
			name: string
			link: string
			cost: number
			isActive: boolean
			promotionId?: string
			promotion?: components['schemas']['ChannelPromotionModel']
			isGuest: boolean
			/** @description Optional note for the channel */
			note?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ChannelListModel: {
			id: string
			name: string
			link: string
			cost: number
			isActive: boolean
			playerCount: number
			promotionId?: string
			promotion?: components['schemas']['ChannelPromotionModel']
			isGuest: boolean
			/** @description Optional note for the channel */
			note?: string
			/** Format: date-time */
			createdAt: string
		}
		GetChannelsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['ChannelListModel'][]
		}
		UpdateChannelDto: {
			name?: string
			isActive?: boolean
			cost?: number
			promotionId?: string
			/** @description Whether this channel is for guest users */
			isGuest?: boolean
			/** @description Optional note for the channel */
			note?: string
		}
		ChannelTransactionCumulativeGameTypeResponse: {
			totalLossAmount: number
			totalReturnLossAmount: number
			totalBetAmount: number
			totalTurnoverAmount: number
			totalTransferIn: number
			totalTransferOut: number
			totalSettleAmount: number
		}
		ChannelTransactionCumulativeTotalResponse: {
			totalDepositTime: number
			totalDepositAmount: number
			totalDepositBonusAmount: number
			totalReturnLossBonusReward: number
			totalLuckyWheelQuotaReward: number
			totalLuckyWheelBonusReward: number
			totalWithdrawTime: number
			totalWithdrawAmount: number
			totalLossAmount: number
			totalReturnLossAmount: number
			totalBetAmount: number
			totalTurnoverAmount: number
			totalTransferIn: number
			totalTransferOut: number
			totalSettleAmount: number
			totalTurnoverCashback: number
			totalPlayerCountWithDeposit: number
			totalPlayerCount: number
			totalActivePlayerCount: number
			totalProfit: number
			/** @description Number of players who registered within the query period (all players if no date range) */
			newPlayerCount: number
			/** @description Number of new players who made at least one deposit within the query period */
			newPlayerDepositCount: number
			/** @description Number of new players who had a deposit or play log within the query period */
			newActivePlayerCount: number
			/** @description Sum of all completed deposits by new players within the query period */
			newPlayerTotalDepositAmount: number
			/** @description Number of channel players whose very first deposit ever occurred within the query period */
			firstDepositCount: number
		}
		ChannelTransactionCumulativeResponse: {
			channelId: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			totalCumulative: components['schemas']['ChannelTransactionCumulativeTotalResponse']
			gameTypeCumulative: {
				[
					key: string
				]: components['schemas']['ChannelTransactionCumulativeGameTypeResponse']
			}
		}
		ChannelCohortPeriodAnalytics: {
			/** @description Day after activation (-1 = all-time) */
			dayAfterActivation: number
			totalDepositAmount: number
			totalDepositAmountAvg: number
			totalWithdrawAmount: number
			totalWithdrawAmountAvg: number
			totalDepositTime: number
			totalDepositTimeAvg: number
			totalWithdrawTime: number
			totalWithdrawTimeAvg: number
			totalPlayerCount: number
			totalActivePlayerCount: number
			totalProfit: number
			totalProfitAvg: number
			costPerPlayer?: number
			costPerActivePlayer?: number
			costMinusProfit?: number
		}
		ChannelCohortAnalyticsResponse: {
			/** @description Channel ID */
			id: string
			/** @description Channel name */
			name: string
			/** @description Channel cost */
			cost?: number
			/** @description Analytics data for different time periods (all-time + day cohorts) */
			analytics: components['schemas']['ChannelCohortPeriodAnalytics'][]
		}
		ChannelPlayerItemResponse: {
			id: string
			phone: string
			username?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			firstDepositAt?: string
			totalDepositAmount: number
			totalDepositTime: number
			totalWithdrawAmount: number
			totalWithdrawTime: number
			totalTurnoverAmount: number
			profit: number
			avgDepositAmount: number
		}
		ChannelPlayerAveragesResponse: {
			avgTotalDepositAmount: number
			avgTotalWithdrawAmount: number
			avgTotalTurnoverAmount: number
			avgProfit: number
			avgDepositPerPlayer: number
			depositRate: number
		}
		ChannelPlayerListResponse: {
			data: components['schemas']['ChannelPlayerItemResponse'][]
			total: number
			skip: number
			take: number
			averages: components['schemas']['ChannelPlayerAveragesResponse']
		}
		CreateUserGroupDto: {
			name: string
			writePermission: components['schemas']['OperatorGroupPermission'][]
			readPermission: components['schemas']['OperatorGroupPermission'][]
		}
		GetUserGroupResponse: {
			id: string
			name: string
			writePermission: components['schemas']['OperatorGroupPermission'][]
			readPermission: components['schemas']['OperatorGroupPermission'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UserGroupListResponse: {
			id: string
			name: string
			operatorCount?: number
		}
		GetUserGroupsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['UserGroupListResponse'][]
		}
		UpdateUserGroupDto: {
			name?: string
			writePermission?: components['schemas']['OperatorGroupPermission'][]
			readPermission?: components['schemas']['OperatorGroupPermission'][]
		}
		GetAllPermissionsResponse: {
			data: components['schemas']['OperatorGroupPermission'][]
		}
		CreatePlayerDto: {
			password: string
			phone: string
			email?: string
			channelId?: string
			bankProvider: string
			accountName: string
			accountNumber: string
			referrerId?: string
		}
		ChannelModel: {
			id: string
			name: string
			link: string
			isActive: boolean
			isGuest: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		BankModel: {
			id: string
			bankProvider: string
			accountName: string
			accountNumber: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		PartnerAccountModel: {
			id: string
			nickname: string
			percentage: number
			isActive: boolean
		}
		ReferringPartnerModel: {
			id: string
			nickname: string
		}
		AdminRankUpRewardResponse: {
			id: string
			/** @enum {string} */
			type: AdminRankUpRewardResponseType
			amount: number
			luckyWheelSettingId?: string
			gameId?: string
			betAmount?: number
			presetId?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		RankModel: {
			id: string
			name: string
			rankProtectionDeposit: number
			rankProtectionTurnover: number
			bannerUrl?: string
			limitWithdrawCredit: number
			limitWithdrawFrequency: number
			commissionCashbackId?: string
			returnLossId?: string
			dailyCheckInSettingId?: string
			maxExperiencePoints: number
			description?: string
			allowRepeatRankUpRewards: boolean
			rankUpRewards?: components['schemas']['AdminRankUpRewardResponse'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		/** @enum {string} */
		WalletType: WalletType
		WalletModel: {
			id: string
			playerId: string
			isDeleted: boolean
			type: components['schemas']['WalletType']
			balance: number
			turnoverAmount?: number
			promotionId?: string
			promotion?: string | null
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		TagModel: {
			id: string
			name: string
			color: string
		}
		PlayerGameStatisticsSummaryModel: {
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalTurnover: number
			totalProfit: number
			totalPlayCount: number
			/** Format: date-time */
			firstPlayAt?: string
			/** Format: date-time */
			lastPlayAt?: string
		}
		PlayerProviderStatsModel: {
			provider: string
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalTurnover: number
			totalProfit: number
			totalPlayCount: number
			/** Format: date-time */
			firstPlayAt?: string
			/** Format: date-time */
			lastPlayAt?: string
		}
		PlayerGameTypeStatsModel: {
			/** @enum {string} */
			gameType: PlayerGameTypeStatsModelGameType
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalTurnover: number
			totalProfit: number
			totalPlayCount: number
			/** Format: date-time */
			firstPlayAt?: string
			/** Format: date-time */
			lastPlayAt?: string
		}
		PlayerGameStatsModel: {
			gameId: string
			gameName: string
			/** @enum {string} */
			gameType: PlayerGameStatsModelGameType
			provider: string
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalTurnover: number
			totalProfit: number
			totalPlayCount: number
			/** Format: date-time */
			firstPlayAt?: string
			/** Format: date-time */
			lastPlayAt?: string
		}
		PlayerGameStatisticsModel: {
			summary: components['schemas']['PlayerGameStatisticsSummaryModel']
			/** @description Top 5 providers by turnover */
			topProviders: components['schemas']['PlayerProviderStatsModel'][]
			/** @description All providers */
			allProviders: components['schemas']['PlayerProviderStatsModel'][]
			/** @description All game types played */
			gameTypes: components['schemas']['PlayerGameTypeStatsModel'][]
			/** @description Top 20 games by turnover */
			topGames: components['schemas']['PlayerGameStatsModel'][]
		}
		GetPlayerResponse: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isNewUser: boolean
			isFirstDeposit: boolean
			isBanned: boolean
			banReason?: string
			/** Format: date-time */
			bannedAt?: string
			referralCode: string
			diamondAmount: number
			color?: string
			note?: string
			referrerId?: string
			partnerId?: string
			rankId?: string
			bypassLine: boolean
			isAgentDemoAccount: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			channel?: components['schemas']['ChannelModel']
			bank: components['schemas']['BankModel']
			isPartner: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			rank?: components['schemas']['RankModel']
			wallets: components['schemas']['WalletModel'][]
			/** Format: date-time */
			lastLoginAt?: string
			lastLoginIp?: string
			/** Format: date-time */
			lastPlayAt?: string
			/** Format: date-time */
			lastOnline?: string
			currentWalletId?: string
			presetId?: string
			tags: components['schemas']['TagModel'][]
			gameStatistics?: components['schemas']['PlayerGameStatisticsModel']
		}
		CreateDemoAccountDto: {
			/** @description Player ID to toggle */
			playerId: string
		}
		/** @enum {string} */
		SortOrder: SortOrder
		LoginHistoryModel: {
			/** Format: date-time */
			createdAt: string
			ipAddress: string
			browser: string
			device: string
			os: string
		}
		PlayerListModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
		}
		GetPlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerListModel'][]
		}
		GetPlayersCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			search?: string
			ipAddress?: string
			isBanned?: boolean
			referringPartnerId?: string
			rankId?: string
			/** @description Filter by channel name */
			channelName?: string
			orderByCreatedAt?: components['schemas']['SortOrder']
			sortByMainWalletBalance?: components['schemas']['SortOrder']
			sortByPromotionWalletBalance?: components['schemas']['SortOrder']
			/**
			 * @description Filename for CSV export (without extension)
			 * @example players
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Player ID",
			 *       "phone": "Phone Number",
			 *       "bank.accountName": "Account Name",
			 *       "bank.accountNumber": "Account Number",
			 *       "mainWallet.balance": "Main Wallet Balance",
			 *       "promotionWallet.balance": "Promotion Wallet Balance",
			 *       "channel.name": "Channel Name",
			 *       "rank.name": "Rank Name",
			 *       "createdAt": "Registration Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		/**
		 * @description Messaging platform (LINE, FACEBOOK, etc.)
		 * @enum {string}
		 */
		ChatPlatform: ChatPlatform
		PlayerChatRoomModel: {
			id: string
			platform: components['schemas']['ChatPlatform']
		}
		GetPlayerByIdWithEventRewardsModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isNewUser: boolean
			isFirstDeposit: boolean
			isBanned: boolean
			banReason?: string
			/** Format: date-time */
			bannedAt?: string
			referralCode: string
			diamondAmount: number
			color?: string
			note?: string
			referrerId?: string
			partnerId?: string
			rankId?: string
			bypassLine: boolean
			isAgentDemoAccount: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			channel?: components['schemas']['ChannelModel']
			bank: components['schemas']['BankModel']
			isPartner: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			rank?: components['schemas']['RankModel']
			wallets: components['schemas']['WalletModel'][]
			/** Format: date-time */
			lastLoginAt?: string
			lastLoginIp?: string
			/** Format: date-time */
			lastPlayAt?: string
			/** Format: date-time */
			lastOnline?: string
			currentWalletId?: string
			presetId?: string
			tags: components['schemas']['TagModel'][]
			gameStatistics?: components['schemas']['PlayerGameStatisticsModel']
			/** @description Total amount received from lucky wheel events */
			totalLuckyWheelRewards: number
			/** @description Total amount received from daily check-in events */
			totalDailyCheckInRewards: number
			/** @description Total amount received from return loss events */
			totalReturnLossRewards: number
			/** @description Total amount received from all events */
			totalEventRewards: number
			/** @description Chat rooms linked to this player */
			chatRooms?: components['schemas']['PlayerChatRoomModel'][]
		}
		GetPlayerFullPhoneResponse: {
			phone: string
		}
		UpdatePlayerDto: {
			password?: string
			phone?: string
			email?: string
			isBanned?: boolean
			banReason?: string
			channelId?: string
			bankProvider?: string
			accountName?: string
			accountNumber?: string
			presetId?: string
			diamondAmount?: number
			color?: string
			note?: string
			bypassLine?: boolean
		}
		PlayerLoginHistoryModel: {
			id: string
			ipAddress: string
			userAgent: string
			browser: string
			device: string
			os: string
			/** Format: date-time */
			createdAt: string
		}
		GetPlayerLoginHistoriesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerLoginHistoryModel'][]
		}
		BannedPlayerModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			banReason?: string
			/** Format: date-time */
			bannedAt?: string
			color?: string
			note?: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
			/** Format: date-time */
			createdAt: string
		}
		GetBannedPlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['BannedPlayerModel'][]
		}
		InactivePlayerModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			color?: string
			note?: string
			lastLogin: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			createdAt: string
			totalDepositAmount: number
			totalDepositTime: number
			totalWithdrawAmount: number
			totalWithdrawTime: number
			/** Format: date-time */
			lastDepositAt: string
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
		}
		GetInactivePlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['InactivePlayerModel'][]
		}
		ClearPlayerLockoutDto: {
			phone: string
		}
		PlayerClearTurnoverHistoryModel: {
			id: string
			amount: number
			/** Format: date-time */
			createdAt: string
		}
		GetPlayerClearTurnoverHistoryResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerClearTurnoverHistoryModel'][]
		}
		GetPlayerClearTurnoverHistoryCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			playerId: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example clear_turnover_history
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "History ID",
			 *       "amount": "Amount",
			 *       "clearedAt": "Cleared Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		/**
		 * @description Transaction type
		 * @enum {string}
		 */
		TransactionType: TransactionType
		/** @enum {string} */
		DepositStatus: DepositStatus
		/**
		 * @description Processor
		 * @enum {string}
		 */
		TransactionProcessor: TransactionProcessor
		DepositTransactionPromotionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/** @example DEPOSIT */
			type: components['schemas']['TransactionType']
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Transaction amount
			 * @example 1000.5
			 */
			amount: number
			/** @example COMPLETED */
			status: components['schemas']['DepositStatus']
			/** @example AUTO */
			processor: components['schemas']['TransactionProcessor']
			/**
			 * @description Bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankId: string | null
			/**
			 * Format: date-time
			 * @description Transaction creation date
			 * @example 2024-03-14T12:00:00Z
			 */
			createdAt: string | null
			/**
			 * Format: date-time
			 * @description Transaction last update date
			 * @example 2024-03-14T12:00:00Z
			 */
			updatedAt: string | null
			/**
			 * @description Promotion name if applicable
			 * @example First Deposit Bonus
			 */
			promotionName: Record<string, never> | null
			/**
			 * @description Bonus amount from promotion if applicable
			 * @default 0
			 * @example 100
			 */
			bonusAmount: number
		}
		PaginatedTransactionResponseWithPromotion: {
			/** @description Array of transactions */
			data: components['schemas']['DepositTransactionPromotionResponse'][]
			/**
			 * @description Total number of records
			 * @example 10
			 */
			total: number
			/**
			 * @description Number of records to take
			 * @example 10
			 */
			take: number
			/**
			 * @description Number of records to skip
			 * @example 0
			 */
			skip: number
		}
		GetPlayerTransactionsCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example player_transactions
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Transaction ID",
			 *       "amount": "Amount",
			 *       "type": "Type",
			 *       "createdAt": "Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		/** @enum {string} */
		PlayerPlayLogStatus: PlayerPlayLogStatus
		ProviderModel: {
			/** @description Provider ID */
			id: string
			/** @description Provider name */
			name: string
			/** @description Provider display name */
			displayName?: string | null
			/** @description Provider logo URL */
			logoUrl: string
			/** @description Provider active status */
			isActive: boolean
			/** @description Provider popular status */
			isPopular: boolean
			/** @description Provider order */
			order: number
			/**
			 * Format: date-time
			 * @description Created date
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 */
			updatedAt: string
		}
		AdminGameModel: {
			/** @description Game ID */
			id: string
			/** @description Game name */
			name: string
			/** @description Game provider */
			provider: components['schemas']['ProviderModel']
		}
		PlayerPlaylogModel: {
			/** @description Provider transaction ID */
			providerTransactionId: string
			/** @description Transaction ID */
			transactionId: string
			/** @description Player ID */
			playerId: string
			/** @description Agent ID */
			agentId: string
			/** @description Provider name */
			provider: string
			/** @description Game ID */
			gameId?: string | null
			status?: components['schemas']['PlayerPlayLogStatus']
			/** @description Game name */
			gameName?: string | null
			/** @description Wallet ID */
			walletId: string
			/** @description Transfer in amount */
			transferIn?: number | null
			/** @description Transfer out amount */
			transferOut?: number | null
			/** @description Bet amount */
			betAmount?: number | null
			/** @description Settle amount */
			settleAmount?: number | null
			/** @description Turnover amount */
			turnOver?: number | null
			/** @description Additional information */
			info: string
			/** @description Balance before transaction */
			balanceBefore: number
			/** @description Balance after transaction */
			balanceAfter: number
			/**
			 * Format: date-time
			 * @description Created date
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 */
			updatedAt: string
			/** @description Game information */
			game?: components['schemas']['AdminGameModel'] | null
			/** @description Session ID */
			sessionId?: string
			/** @description Turnover after transaction */
			turnoverAfter?: number | null
			/** @description Wallet type */
			walletType?: string | null
			/** @description Bank transaction ID */
			promotionSessionId?: string | null
			/** @description Init session log ID */
			initSessionLogId?: string | null
		}
		GetPlayerPlaylogResponse: {
			total: number
			take: number
			skip: number
			/** @description Array of player play logs */
			data: components['schemas']['PlayerPlaylogModel'][]
		}
		GetPlayerPlaylogCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			sessionId?: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example player_playlog
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Log ID",
			 *       "gameId": "Game ID",
			 *       "betAmount": "Bet Amount",
			 *       "winAmount": "Win Amount"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		AdminReinitPlaylogDto: {
			/** @description Init session log ID to re-initialize */
			initSessionLogId: string
		}
		ReferredPlayerModel: {
			/** @description Player ID */
			id: string
			/** @description Short user ID */
			username?: string
			/** @description Masked phone number */
			phone: string
			/** @description Email address */
			email: string | null
			/** @description Whether player is banned */
			isBanned: boolean
			/**
			 * Format: date-time
			 * @description Creation date
			 */
			createdAt: string
			/** @description Referral code */
			referralCode: string
			/** @description Channel information */
			channel: components['schemas']['ChannelModel'] | null
			/** @description Rank information */
			rank: components['schemas']['RankModel'] | null
			/**
			 * Format: date-time
			 * @description Last login information
			 */
			lastLoginAt: string | null
			tags: components['schemas']['TagModel'][]
		}
		AdminGetReferredPlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['ReferralPlayerCommissionData'][]
		}
		GetReferredPlayersCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			phone?: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/** @description Optional player ID to calculate commissions for (useful for viewing referral tree from head perspective) */
			commissionForPlayer?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example referred_players
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Player ID",
			 *       "phone": "Phone Number",
			 *       "createdAt": "Registration Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		/**
		 * @description Game types applicable for this promotion
		 * @enum {string}
		 */
		GameType: GameType
		GameTypeTransactionCumulativeModel: {
			gameType: components['schemas']['GameType']
			/** @description Total loss amount */
			totalLossAmount: number
			/** @description Total bet amount */
			totalBetAmount: number
			/** @description Total turnover amount */
			totalTurnoverAmount: number
			/** @description Total transfer in amount */
			totalTransferIn: number
			/** @description Total transfer out amount */
			totalTransferOut: number
			/** @description Total settle amount */
			totalSettleAmount: number
		}
		GetPlayerCumulativeResponse: {
			/** @description Player ID */
			playerId: string
			/** @description Total deposit time */
			totalDepositTime: number
			totalUnverifiedDepositAmount: number
			/** @description Total deposit amount */
			totalDepositAmount: number
			/** @description Total deposit bonus amount */
			totalDepositBonusAmount: number
			/** @description Total return loss bonus reward */
			totalReturnLossBonusReward: number
			/** @description Total lucky wheel quota reward */
			totalLuckyWheelQuotaReward: number
			/** @description Total lucky wheel bonus reward */
			totalLuckyWheelBonusReward: number
			/** @description Total withdraw time */
			totalWithdrawTime: number
			/** @description Total withdraw amount */
			totalWithdrawAmount: number
			/** @description Total loss amount */
			totalLossAmount: number
			/** @description Total bet amount */
			totalBetAmount: number
			/** @description Total turnover amount */
			totalTurnoverAmount: number
			/** @description Total transfer in amount */
			totalTransferIn: number
			/** @description Total transfer out amount */
			totalTransferOut: number
			/** @description Total settle amount */
			totalSettleAmount: number
			/** @description Total turnover cashback */
			totalTurnoverCashback: number
			/**
			 * Format: date-time
			 * @description Date of the cumulative data
			 */
			date: string
			/** @description Game type specific cumulative data */
			gameTypeTransactionCumulative: components['schemas']['GameTypeTransactionCumulativeModel'][]
		}
		AdminPlayerCommissionResponse: {
			/** @description Credit ratio configuration for each game type */
			creditRatio: {
				[key: string]: {
					creditRatio?: number
					maxCreditAmount?: number | null
				}
			}
			/** @description Total commission amount for the current month */
			totalAmount: number
			/** @description Commission amounts for each game type this month */
			gameTypeAmounts: {
				[key: string]: number
			}
			/** @description Number of turnover rounds required */
			turnoverRound: number
			/** @description Whether the commission is active */
			isActive: boolean
			/** @description Commission multiplier (e.g., 2.0 for 2x). Null if no multiplier configured. */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date of multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date of multiplier period
			 */
			multiplierEndDate?: string
			/** @description Whether the multiplier is currently active */
			isMultiplierActive: boolean
		}
		ReturnLossCreditRatioModel: {
			creditRatio: number
			maxCreditAmount?: number
		}
		/** @enum {string} */
		CalculateInterval: CalculateInterval
		WalletConditionPoolPresetConfigResponse: {
			id: string
			walletConditionId: string
			name: string
			description: string
			rewardSize: number
			savingSize: number
			rewardRatio: number
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		WalletConditionPresetConfigResponse: {
			id: string
			walletConditionId: string
			turnoverThreshold?: number
			presetId?: string
			presetNumber?: number
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		WalletConditionResponse: {
			id: string
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			turnoverRound?: number
			usePool: boolean
			gameTypes: components['schemas']['GameType'][]
			whitelistGameProviders: string[]
			presetId?: string
			presetNumber?: number
			poolPresetConfigs: components['schemas']['WalletConditionPoolPresetConfigResponse'][]
			presetConfigs: components['schemas']['WalletConditionPresetConfigResponse'][]
			/** @description Use PGHard provider */
			pgHard: boolean
			/** @description Use JokerHardV2 provider */
			jokerHard: boolean
			/** @description Use JiliHardV2 provider */
			jiliHard: boolean
			/** @description Use HARDV2_PP provider */
			ppHard: boolean
			/** @description Use HARDV2_NOLIMITCITY provider */
			nlcHard: boolean
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ReturnLossResponse: {
			id: string
			name: string
			minimumLossAmount: number
			shortDescription?: string
			description?: string
			isActive: boolean
			turnoverRound: number
			creditRatio: {
				[key: string]: components['schemas']['ReturnLossCreditRatioModel']
			}
			calculateInterval: components['schemas']['CalculateInterval']
			/** Format: date-time */
			nextCalculateAt: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			walletCondition?: components['schemas']['WalletConditionResponse']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ReturnLossResponseDto: {
			canReceiveReturnLoss: boolean
			totalReturnLossAmount: number
			returnAmount?: number
			totalReturnLossByGameType: {
				[key: string]: number
			}
			returnAmountByGameType?: {
				[key: string]: number
			}
			creditRatio?: {
				[key: string]: {
					creditRatio?: number
					maxCreditAmount?: number
				}
			}
		}
		AdminPlayerReturnLossResponse: {
			info: components['schemas']['ReturnLossResponse']
			calculation: components['schemas']['ReturnLossResponseDto']
		}
		/** @enum {string} */
		PlayerDiamondHistoryType: PlayerDiamondHistoryType
		DiamondTransactionResponse: {
			id: string
			playerId: string
			amount: number
			type: components['schemas']['PlayerDiamondHistoryType']
			/** Format: date-time */
			createdAt: string
		}
		AdminPlayerDiamondHistoryResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DiamondTransactionResponse'][]
		}
		ActivePlayerModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
			/** @description Total bet amount within date range */
			totalBetAmount: number
			/** @description Total deposit amount within date range */
			totalDepositAmount: number
			/** @description Number of deposits within date range */
			totalDepositTime: number
			/** @description Total turnover amount within date range */
			totalTurnoverAmount: number
			/** @description Total withdraw amount within date range */
			totalWithdrawAmount: number
			/** @description Number of withdraws within date range */
			totalWithdrawTime: number
		}
		GetActivePlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['ActivePlayerModel'][]
		}
		PromotionalDepositModel: {
			amount: number
			promotionName: string
			/** Format: date-time */
			createdAt: string
		}
		PlayerWithDepositPromotionModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
			/** @description Promotional deposits */
			promotionalDeposits: components['schemas']['PromotionalDepositModel'][]
			/** @description Total promotional deposit amount */
			totalPromotionalDepositAmount: number
			/** @description Total bonus amount from promotional deposits */
			totalBonusAmount: number
		}
		GetPlayersWithDepositPromotionResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithDepositPromotionModel'][]
		}
		GetPlayersWithDepositPromotionCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			phone?: string
			ipAddress?: string
			/** @description Filter by channel name */
			channelName?: string
			isBanned?: boolean
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example players_with_deposit_promotion
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Player ID",
			 *       "phone": "Phone Number",
			 *       "bank.accountName": "Account Holder Name",
			 *       "mainWallet.balance": "Wallet Balance"
			 *     }
			 */
			columnMappings?: Record<string, never>
		}
		DepositModel: {
			amount: number
			/** Format: date-time */
			createdAt: string
		}
		PlayerWithDepositsModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
			/** @description All deposits */
			deposits: components['schemas']['DepositModel'][]
			/** @description Total deposit amount */
			totalDepositAmount: number
			/** @description Number of deposits */
			totalDepositTime: number
			/** @description Total bonus amount from deposits */
			totalBonusAmount: number
		}
		GetPlayersWithDepositsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithDepositsModel'][]
		}
		GetPlayersWithDepositsCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			phone?: string
			ipAddress?: string
			/** @description Filter by channel name */
			channelName?: string
			isBanned?: boolean
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			depositAmountSort?: components['schemas']['SortOrder']
			depositTimeSort?: components['schemas']['SortOrder']
			/** @description Exclude deposits with amount 0 (free credits) */
			excludeFreeCredit?: boolean
			/**
			 * @description Filename for CSV export (without extension)
			 * @example players_with_deposits
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Player ID",
			 *       "phone": "Phone Number",
			 *       "bank.accountName": "Account Name",
			 *       "bank.accountNumber": "Account Number",
			 *       "depositAmount": "Deposit Amount",
			 *       "depositTime": "Deposit Count",
			 *       "lastDepositAt": "Last Deposit Date",
			 *       "channel.name": "Channel Name",
			 *       "createdAt": "Registration Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		DepositWithoutPromotionModel: {
			amount: number
			/** Format: date-time */
			createdAt: string
		}
		PlayerWithDepositsWithoutPromotionModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
			/** @description Deposits without promotion */
			depositsWithoutPromotion: components['schemas']['DepositWithoutPromotionModel'][]
			/** @description Total deposit amount without promotion */
			totalDepositAmountWithoutPromotion: number
			/** @description Number of deposits without promotion */
			totalDepositTimeWithoutPromotion: number
		}
		GetPlayersWithDepositsWithoutPromotionResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithDepositsWithoutPromotionModel'][]
		}
		/**
		 * @description Filter by activity log types
		 * @enum {string}
		 */
		PlayerActivityLogType: PlayerActivityLogType
		GetPlayerActivityLogBodyDto: {
			types?: components['schemas']['PlayerActivityLogType'][]
		}
		PlayerActivityLogModel: {
			id: string
			playerId: string
			type: components['schemas']['PlayerActivityLogType']
			message: string | null
			note: string | null
			/** Format: date-time */
			createdAt: string
		}
		GetPlayerActivityLogResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerActivityLogModel'][]
		}
		GetPlayerActivityLogCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			playerId?: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			types?: components['schemas']['PlayerActivityLogType'][]
			/**
			 * @description Filename for CSV export (without extension)
			 * @example player_activity_log
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "id": "Log ID",
			 *       "type": "Activity Type",
			 *       "description": "Description",
			 *       "createdAt": "Date"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		ClearPlayerTurnoverDto: {
			playerId: string
			note?: string
		}
		ClearPlayerTurnoverResponse: {
			data: components['schemas']['WalletModel']
		}
		UpdateMainWalletDto: {
			playerId: string
			amount: number
			note?: string
		}
		UpdateMainWalletResponse: {
			data: components['schemas']['WalletModel']
		}
		WithdrawModel: {
			amount: number
			status: string
			/** Format: date-time */
			createdAt: string
		}
		PlayerWithWithdrawsModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			isPartner?: boolean
			partnerAccount?: components['schemas']['PartnerAccountModel']
			referringPartner?: components['schemas']['ReferringPartnerModel']
			mainWallet: {
				balance?: number
			}
			promotionWallet: {
				balance?: number
				turnover?: number
				promotionId?: string | null
			} | null
			bank: components['schemas']['BankModel']
			referralCode: string
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			presetId?: string
			color?: string
			note?: string
			tags: components['schemas']['TagModel'][]
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			bypassLine: boolean
			isAgentDemoAccount?: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt?: string
			/** @description All withdraws */
			withdraws: components['schemas']['WithdrawModel'][]
			/** @description Total withdraw amount */
			totalWithdrawAmount: number
			/** @description Number of withdraws */
			totalWithdrawTime: number
		}
		GetPlayersWithWithdrawsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithWithdrawsModel'][]
		}
		PlayerWithLuckyWheelReceiveModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			color?: string
			note?: string
			/** @description Total lucky wheel reward amount */
			totalLuckyWheelAmount: number
			/** @description Number of lucky wheel rewards */
			totalLuckyWheelTime: number
			lastLogin: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
		}
		GetPlayersWithLuckyWheelReceiveResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithLuckyWheelReceiveModel'][]
		}
		PlayerWithReturnLossReceiveModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			color?: string
			note?: string
			/** @description Total return loss reward amount */
			totalReturnLossAmount: number
			/** @description Number of return loss rewards */
			totalReturnLossTime: number
			lastLogin: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
		}
		GetPlayersWithReturnLossReceiveResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithReturnLossReceiveModel'][]
		}
		PlayerWithDailyCheckInReceiveModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			color?: string
			note?: string
			/** @description Total daily check-in reward amount */
			totalDailyCheckInAmount: number
			/** @description Number of daily check-in rewards */
			totalDailyCheckInTime: number
			lastLogin: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
		}
		GetPlayersWithDailyCheckInReceiveResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithDailyCheckInReceiveModel'][]
		}
		SimplePlayerDataModel: {
			/** @description Player ID */
			id: string
			/** @description Short user ID */
			username?: string
			/** @description Masked phone number */
			phone: string
			/** @description Player email */
			email: Record<string, never> | null
			/** @description Whether player is banned */
			isBanned: boolean
			color?: string
			note?: string
			/** @description Total deposit amount */
			totalDepositAmount: number
			/** @description Total withdraw amount */
			totalWithdrawAmount: number
			/** @description Total profit (totalDepositAmount - totalWithdrawAmount) */
			totalProfit: number
			/** @description Total win/loss (transferIn - transferOut) */
			totalWinloss: number
			lastLogin: components['schemas']['LoginHistoryModel']
			/** Format: date-time */
			lastOnline?: string
			tags: components['schemas']['TagModel'][]
		}
		GetPlayerDataListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['SimplePlayerDataModel'][]
		}
		GetPlayerDataListCsvDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			phone?: string
			ipAddress?: string
			/** @description Filter by channel name */
			channelName?: string
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			totalDepositAmountSort?: components['schemas']['SortOrder']
			totalWithdrawAmountSort?: components['schemas']['SortOrder']
			totalProfitSort?: components['schemas']['SortOrder']
			totalWinlossSort?: components['schemas']['SortOrder']
			/**
			 * @description Filename for CSV export (without extension)
			 * @example player_data_list
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "phone": "เบอร์โทรศัพท์",
			 *       "username": "ชื่อผู้ใช้",
			 *       "totalDepositAmount": "ยอดฝากทั้งหมด (บาท)",
			 *       "totalWithdrawAmount": "ยอดถอนทั้งหมด (บาท)",
			 *       "totalProfit": "กำไรทั้งหมด (บาท)",
			 *       "totalWinloss": "W/L (บาท)",
			 *       "lastOnline": "ใช้งานล่าสุด"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		RegisteredPlayerModel: {
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			email?: string
			isBanned: boolean
			/** Format: date-time */
			createdAt: string
			referralCode?: string
			presetId?: string
			color?: string
			note?: string
			mainWallet: Record<string, never>
			bank?: components['schemas']['BankModel']
			channel?: components['schemas']['ChannelModel']
			rank?: components['schemas']['RankModel']
			lastLogin?: components['schemas']['LoginHistoryModel']
			/** @description Total deposit amount */
			totalDepositAmount: number
		}
		GetRegisteredPlayersResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['RegisteredPlayerModel'][]
		}
		ProviderStatsResponse: {
			/**
			 * @description Provider name
			 * @example pghard
			 */
			provider: string
			/**
			 * @description Total amount transferred in
			 * @example 50000
			 */
			totalTransferIn: number
			/**
			 * @description Total amount transferred out
			 * @example 48000
			 */
			totalTransferOut: number
			/**
			 * @description Total bet amount
			 * @example 120000
			 */
			totalBetAmount: number
			/**
			 * @description Total settle amount
			 * @example 118000
			 */
			totalSettleAmount: number
			/**
			 * @description Total turnover
			 * @example 120000
			 */
			totalTurnover: number
			/**
			 * @description Total profit (transferOut - transferIn)
			 * @example -2000
			 */
			totalProfit: number
			/**
			 * @description Total play count
			 * @example 150
			 */
			totalPlayCount: number
			/**
			 * @description First play timestamp
			 * @example 2025-01-01T10:00:00Z
			 */
			firstPlayAt: Record<string, never> | null
			/**
			 * @description Last play timestamp
			 * @example 2025-01-31T22:00:00Z
			 */
			lastPlayAt: Record<string, never> | null
		}
		GetPlayerProviderStatsResponse: {
			/**
			 * @description Success status
			 * @example true
			 */
			success: boolean
			/**
			 * @description Player ID
			 * @example player-uuid
			 */
			playerId: string
			/**
			 * @description Start date (defaults to 2000-01-01 if not provided)
			 * @example 2025-01-01
			 */
			startDate: string
			/**
			 * @description End date (defaults to today if not provided)
			 * @example 2025-01-31
			 */
			endDate: string
			/** @description Provider stats (aggregated by provider or daily records) */
			data: components['schemas']['ProviderStatsResponse'][]
		}
		PlayerLoginDto: {
			/**
			 * @description Player phone
			 * @example 0811111111
			 */
			phone: string
			/**
			 * @description Player password
			 * @example 1234
			 */
			password: string
		}
		PlayerLoginResponseDto: {
			accessToken: string
			/** Format: date-time */
			expiredAt: string
		}
		LineLoginDto: {
			/**
			 * @description LINE access token from LIFF SDK
			 * @example eyJhbGciOiJIUzI1NiIsInR5cCI...
			 */
			accessToken: string
		}
		CheckBankExistsDto: {
			/** @description Bank provider code */
			bankProvider: string
			/** @description Bank account number */
			accountNumber: string
			/** @description Account holder name */
			accountName?: string
		}
		CustomDataDto: {
			/** @description Page type identifier */
			pageType?: string
			/** @description Cross-domain session ID */
			sessionId?: string
			/** @description UTM source parameter */
			utmSource?: string
			/** @description UTM medium parameter */
			utmMedium?: string
			/** @description UTM content parameter */
			utmContent?: string
			/** @description UTM campaign parameter */
			utmCampaign?: string
			/** @description Promotion ID applied */
			promotionId?: string
			/** @description Promotion name applied */
			promotionName?: string
			/** @description Promotion type applied */
			promotionType?: string
			/** @description Promotion ratio applied */
			bonusRatio?: number
			/** @description Bonus amount received */
			bonusAmount?: number
			/** @description Total credit received */
			totalCredit?: number
			/** @description Transaction ID */
			transactionId?: string
			/** @description Time spent on page in seconds */
			timeOnPage?: number
			/** @description Element that was clicked */
			clickedElement?: string
			/** @description Type of interaction performed */
			interactionType?: string
			/** @description Original landing page URL */
			originalLandingPage?: string
			/** @description Whether user came from landing page */
			cameFromLanding?: boolean
			/** @description List of landing page interactions */
			landingPageInteractions?: string[]
			/** @description Type of lead generated */
			leadType?: string
			/** @description Time to complete registration step in seconds */
			timeToComplete?: number
			/** @description Number of validation attempts */
			validationAttempts?: number
			/** @description Channel name user came from */
			fromChannelName?: string
			/** @description Bank provider selected */
			bankProvider?: string
			/** @description Total registration time in seconds */
			totalRegistrationTime?: number
			/** @description Time spent on step 1 in seconds */
			step1Time?: number
			/** @description Time spent on step 2 in seconds */
			step2Time?: number
			/** @description List of available promotions */
			availablePromotions?: string[]
			/** @description Time spent on deposit page in seconds */
			timeOnDepositPage?: number
			/** @description Selected promotion ID */
			selectedPromotionId?: string
			/** @description Selected promotion name */
			selectedPromotionName?: string
			/** @description Expiration time in seconds */
			expiredTime?: number
			/** @description Total value of the event */
			value?: number
			/** @description Currency code (e.g., THB, USD) */
			currency?: string
			/** @description Product SKUs/IDs */
			contentIds?: string[]
			/** @description Detailed product information */
			contents?: string[]
			/** @description Content type (product or product_group) */
			contentType?: string
			/** @description Number of items */
			numItems?: number
			/** @description Predicted lifetime value */
			predictedLtv?: number
			/** @description Order/transaction ID */
			orderId?: string
			/** @description Search query string */
			searchString?: string
		}
		RegisterPlayerDto: {
			fbp?: string
			fbc?: string
			userAgent?: string
			/**
			 * @description หน้าที่ event เกิด ไม่ต้องใส่ query string
			 * @example https://example.com/landing-page
			 */
			eventSourceUrl?: string
			/**
			 * @description URL ที่ผู้ใช้มาจากไหน
			 * @example https://facebook.com
			 */
			referrerUrl?: string
			/** @description Custom event data */
			customData?: components['schemas']['CustomDataDto']
			/** @description Phone number (10 digits) */
			phone: string
			bankProvider: string
			accountName: string
			accountNumber: string
			/** @description 4-digit PIN number */
			password: string
			/** @description Referral code from another player */
			referralCode?: string
			/** @description Channel link code */
			channelCode?: string
			/** @description Validate code */
			validateCode?: string
			/** @description Line ID */
			lineId?: string
			/** @description Is demo account */
			isDemoAccount?: boolean
			/** @description Skip adding bank at registration */
			isSkipBank?: boolean
		}
		PlayerBankResponseDto: {
			id: string
			bankProvider: string
			accountName: string
			accountNumber: string
		}
		WalletResponseDto: {
			id: string
			type: components['schemas']['WalletType']
			balance: number
		}
		PlayerRegisterResponseDto: {
			id: string
			phone: string
			isNewUser: boolean
			isFirstDeposit: boolean
			isBanned: boolean
			bank: components['schemas']['PlayerBankResponseDto']
			wallets: components['schemas']['WalletResponseDto'][]
			currentWalletId?: string | null
		}
		UpdateDemoToRealDto: {
			/** @description Demo player ID */
			playerId: string
			/** @description Real phone number (10 digits) */
			phone: string
			/** @description Real bank provider */
			bankProvider: string
			/** @description Real account name */
			accountName: string
			/** @description Real account number */
			accountNumber: string
			/** @description 4-digit PIN number */
			password: string
			/** @description Validate code for OTP */
			validateCode?: string
		}
		SendSmsOtpDto: {
			/**
			 * @description The phone number to send the OTP to
			 * @example 0812345678
			 */
			phone: string
		}
		SendLoginSmsOtpResponseDto: {
			refNo: string
			token: string
			skipOtp: boolean
		}
		VerifySmsOtpDto: {
			/**
			 * @description Token from Request OTP response
			 * @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...
			 */
			token: string
			/**
			 * @description The OTP pin received via SMS
			 * @example 123456
			 */
			pin: string
			/**
			 * @description The phone number (msisdn) for cache key
			 * @example 0812345678
			 */
			phone: string
		}
		VerifyLoginSmsOtpResponseDto: {
			allowRegister: boolean
			validateCode?: string
		}
		ForgotPasswordDto: {
			/** @description Phone number */
			phone: string
		}
		ResetPasswordDto: {
			/** @description Token */
			token: string
			/** @description New password */
			password: string
		}
		SendSmsDto: {
			/** @description The phone number to send the SMS to */
			phone: string
			/** @description The message to send */
			message: string
			/**
			 * @description The force to send the SMS
			 * @default standard
			 * @enum {string}
			 */
			force: SendSmsDtoForce
		}
		SendSmsOtpResponse: {
			/** @example success */
			status: string
			/** @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9... */
			token: string
			/** @example ABCD12 */
			refno: string
		}
		VerifySmsOtpResponse: {
			/** @example success */
			status: string
			/** @example OTP verified successfully */
			message: string
		}
		SendLineMessageDto: Record<string, never>
		/** @enum {string} */
		ChatRoomStatus: ChatRoomStatus
		/** @enum {string} */
		ChatResponseType: ChatResponseType
		CustomerTagResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			name: string
			color: string
			/** @description Minimum deposit amount for auto-tagging (null if not set) */
			minDepositAmount?: Record<string, never>
			/** @description Net profit threshold for house (deposit - withdraw) */
			depositGtWithdraw?: Record<string, never>
			/** Format: date-time */
			createdAt: string
		}
		PlayerResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			username?: string
			/** @description Masked phone number */
			phone: string
			lineId?: string
			tags: components['schemas']['CustomerTagResponse'][]
		}
		OperatorResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			username: string
		}
		/** @enum {string} */
		ChatMessageDirection: ChatMessageDirection
		/** @enum {string} */
		ChatMessageType: ChatMessageType
		ReplyToMessageResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			messageType: components['schemas']['ChatMessageType']
			text?: string
			imagePreviewUrl?: string
			stickerPackageId?: string
			stickerId?: string
			direction: components['schemas']['ChatMessageDirection']
			sentByOperator?: components['schemas']['OperatorResponse']
		}
		PlayerLinkResponse: {
			/** @description Player ID for navigation link */
			playerId: string
			/** @description Player username displayed as link text */
			username: string
		}
		ChatMessageResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			/** @description Client-generated ID for optimistic updates (matches the clientId sent in request) */
			clientId?: string
			chatRoomId: string
			direction: components['schemas']['ChatMessageDirection']
			messageType: components['schemas']['ChatMessageType']
			replyToMessage?: components['schemas']['ReplyToMessageResponse']
			isPinned: boolean
			/** Format: date-time */
			pinnedAt?: string
			pinnedBy?: components['schemas']['OperatorResponse']
			text?: string
			stickerPackageId?: string
			stickerId?: string
			imageOriginalUrl?: string
			imagePreviewUrl?: string
			videoOriginalUrl?: string
			videoPreviewUrl?: string
			videoDuration?: number
			audioOriginalUrl?: string
			audioDuration?: number
			fileName?: string
			fileSize?: number
			fileUrl?: string
			locationTitle?: string
			locationAddress?: string
			locationLatitude?: number
			locationLongitude?: number
			flexAltText?: string
			flexContents?: Record<string, never>
			templateAltText?: string
			templateContent?: Record<string, never>
			/** @description LINE message ID (from LINE API) */
			lineMessageId?: string
			sentByOperator?: components['schemas']['OperatorResponse']
			/** @description Whether reply token was used (FREE) or push message (PAID) */
			usedReplyToken: boolean
			isRead: boolean
			/** Format: date-time */
			readAt?: string
			readByOperator?: components['schemas']['OperatorResponse']
			/** @description Player links found by matching phone numbers in message text */
			playerLinks?: components['schemas']['PlayerLinkResponse'][]
			/** Format: date-time */
			createdAt: string
		}
		/** @enum {string} */
		AiAnswerMode: AiAnswerMode
		ChatRoomResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			platform: components['schemas']['ChatPlatform']
			/** @description LINE user ID (only for LINE platform) */
			lineUserId?: string
			/** @description LINE display name (only for LINE platform) */
			lineDisplayName?: string
			/** @description LINE profile picture URL (only for LINE platform) */
			linePictureUrl?: string
			/** @description LINE status message (only for LINE platform) */
			lineStatusMessage?: string
			player?: components['schemas']['PlayerResponse']
			status: components['schemas']['ChatRoomStatus']
			/** Format: date-time */
			lastMessageAt?: string
			unreadCount: number
			isPinned: boolean
			/** Format: date-time */
			pinnedAt?: string
			pinnedBy?: components['schemas']['OperatorResponse']
			isBanned: boolean
			/** Format: date-time */
			bannedAt?: string
			bannedBy?: components['schemas']['OperatorResponse']
			banReason?: string
			assignedOperator?: components['schemas']['OperatorResponse']
			/** Format: date-time */
			assignedAt?: string
			tags: components['schemas']['CustomerTagResponse'][]
			lastMessage?: components['schemas']['ChatMessageResponse']
			pinnedMessages?: components['schemas']['ChatMessageResponse'][]
			aiAnswerMode: components['schemas']['AiAnswerMode']
			/** @description Number of pending admin tasks for this room */
			adminTaskCount?: number
			/** Format: date-time */
			createdAt: string
		}
		CursorPaginationMeta: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			hasMore: boolean
			nextCursor?: string
			prevCursor?: string
		}
		ChatRoomListResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			items: components['schemas']['ChatRoomResponse'][]
			pagination: components['schemas']['CursorPaginationMeta']
		}
		UnreadCountResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			/** @description Total unread message count across all active rooms */
			unreadCount: number
			/** @description Total pending admin task (notify) count across all active rooms */
			adminTaskCount: number
		}
		ChatMessageListResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			items: components['schemas']['ChatMessageResponse'][]
			pagination: components['schemas']['CursorPaginationMeta']
		}
		SendChatMessageDto: {
			/**
			 * @description Client-generated ID for optimistic updates. Frontend can use this to match the pending message with the confirmed message from SSE.
			 * @example client-uuid-123
			 */
			clientId?: string
			messageType: components['schemas']['ChatMessageType']
			/** @description ID of the message to reply to (quote reply). The replied message will be shown as a quote. */
			replyToMessageId?: string
			/** @description Text content (for TEXT messages) */
			text?: string
			/** @description LINE sticker package ID (for STICKER messages) */
			stickerPackageId?: string
			/** @description LINE sticker ID (for STICKER messages) */
			stickerId?: string
			/** @description Original image URL (for IMAGE messages) */
			imageOriginalUrl?: string
			/** @description Preview image URL (for IMAGE messages) */
			imagePreviewUrl?: string
			/** @description Original video URL (for VIDEO messages) */
			videoOriginalUrl?: string
			/** @description Preview image URL (for VIDEO messages) */
			videoPreviewUrl?: string
			/** @description Video duration in milliseconds (for VIDEO messages) */
			videoDuration?: number
			/** @description Audio URL (for AUDIO messages) */
			audioOriginalUrl?: string
			/** @description Audio duration in milliseconds (for AUDIO messages) */
			audioDuration?: number
			/** @description Location title (for LOCATION messages) */
			locationTitle?: string
			/** @description Address (for LOCATION messages) */
			locationAddress?: string
			/** @description Latitude (for LOCATION messages) */
			locationLatitude?: number
			/** @description Longitude (for LOCATION messages) */
			locationLongitude?: number
			/** @description Alt text (for FLEX messages) */
			flexAltText?: string
			/** @description Flex message contents JSON (for FLEX messages) */
			flexContents?: Record<string, never>
			/** @description Alt text (for TEMPLATE messages) */
			templateAltText?: string
			/** @description Template content JSON (for TEMPLATE messages) */
			templateContent?: Record<string, never>
		}
		SendMessageResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			success: boolean
			data?: components['schemas']['ChatMessageResponse']
			/** @description Whether reply token was used (FREE) or push message (PAID) */
			usedReplyToken: boolean
		}
		ChatMessageContentDto: {
			/**
			 * @description Client-generated ID for optimistic updates. Frontend can use this to match the pending message with the confirmed message from SSE.
			 * @example client-uuid-123
			 */
			clientId?: string
			messageType: components['schemas']['ChatMessageType']
			/**
			 * @description Display order (0 = first)
			 * @default 0
			 */
			order: number
			/** @description Text content (for TEXT type) */
			text?: string
			/** @description LINE sticker package ID (for STICKER type) */
			stickerPackageId?: string
			/** @description LINE sticker ID (for STICKER type) */
			stickerId?: string
			/** @description Image URL (for IMAGE type) */
			imageUrl?: string
			/** @description Video URL (for VIDEO type) */
			videoUrl?: string
			/** @description Video preview image URL (for VIDEO type) */
			videoPreviewUrl?: string
			/** @description Audio URL (for AUDIO type) */
			audioUrl?: string
			/** @description Audio duration in milliseconds (for AUDIO type) */
			audioDuration?: number
			/** @description File URL (for FILE type) */
			fileUrl?: string
			/** @description File name (for FILE type) */
			fileName?: string
			/** @description Location title (for LOCATION type) */
			locationTitle?: string
			/** @description Location address (for LOCATION type) */
			locationAddress?: string
			/** @description Latitude (for LOCATION type) */
			locationLatitude?: number
			/** @description Longitude (for LOCATION type) */
			locationLongitude?: number
			/** @description Alt text (for FLEX type) */
			flexAltText?: string
			/** @description Flex message contents JSON (for FLEX type) */
			flexContents?: Record<string, never>
			/** @description Template content JSON (for TEMPLATE type) */
			templateContent?: Record<string, never>
		}
		SendMultipleMessagesDto: {
			/** @description ID of the message to reply to (quote reply). Only applies to the first message. */
			replyToMessageId?: string
			/** @description Messages to send (supports multiple messages of any type) */
			messages: components['schemas']['ChatMessageContentDto'][]
		}
		SendMultipleMessagesResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			success: boolean
			data: components['schemas']['ChatMessageResponse'][]
			/** @description Whether reply token was used (FREE) or push message (PAID) */
			usedReplyToken: boolean
		}
		MarkAsReadDto: {
			/** @description Message ID to mark as read up to (inclusive). If not provided, marks all messages as read. */
			messageId?: string
		}
		SearchChatMessageResult: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			message: components['schemas']['ChatMessageResponse']
			/** @description Room info for context */
			room: Record<string, never>
		}
		SearchChatMessagesResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			items: components['schemas']['SearchChatMessageResult'][]
			pagination: components['schemas']['CursorPaginationMeta']
			/** @description Total number of matching messages */
			totalCount: number
		}
		PinChatRoomDto: {
			/**
			 * @description Whether to pin (true) or unpin (false) the chat room
			 * @default true
			 */
			isPinned: boolean
		}
		BanChatRoomDto: {
			/**
			 * @description Whether to ban (true) or unban (false) the user
			 * @default true
			 */
			isBanned: boolean
			/** @description Reason for banning the user */
			reason?: string
		}
		UpdateChatRoomStatusDto: {
			status: components['schemas']['ChatRoomStatus']
		}
		PinMessageDto: {
			/**
			 * @description Whether to pin (true) or unpin (false) the message
			 * @default true
			 */
			isPinned: boolean
		}
		AssignChatRoomDto: {
			/** @description Operator ID to assign the chat room to */
			operatorId: string
		}
		CreateCustomerTagDto: {
			/** @description Tag name */
			name: string
			/**
			 * @description Tag color (hex)
			 * @default #6B7280
			 */
			color: string
			/**
			 * @description Minimum deposit amount for auto-tagging. If set, players with total deposits >= this amount will automatically receive this tag.
			 * @example 50000
			 */
			minDepositAmount?: number
			/**
			 * @description Net profit threshold for house. Auto-tag players where (totalDeposit - totalWithdraw) >= this amount. Example: 5000 means house profit of 5000+
			 * @example 5000
			 */
			depositGtWithdraw?: number
		}
		UpdateCustomerTagDto: {
			/** @description Tag name */
			name?: string
			/** @description Tag color (hex) */
			color?: string
			/**
			 * @description Minimum deposit amount for auto-tagging. Set to null to disable auto-tagging.
			 * @example 50000
			 */
			minDepositAmount?: number
			/**
			 * @description Net profit threshold for house. Auto-tag when (deposit - withdraw) >= this amount. Set to null to disable.
			 * @example 5000
			 */
			depositGtWithdraw?: number
		}
		SuccessResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			success: boolean
			message?: string
		}
		AddTagsToRoomDto: {
			/** @description Tag IDs to add */
			tagIds: string[]
		}
		LinkPlayerToRoomDto: {
			/** @description Player ID to link to the chat room */
			playerId?: string
			/** @description Player phone number to search and link */
			phone?: string
			/** @description Player username to search and link (exact match) */
			username?: string
		}
		LastTransactionResponse: {
			id: string
			txId: string
			amount: number
			status: string
			/** @description Whether withdraw needs approval */
			needsApproval?: boolean
			/** Format: date-time */
			createdAt: string
		}
		GamePlayStats: {
			/** @description Total play count today */
			playCountToday: number
			/** @description Total turnover today */
			turnoverToday: number
			/**
			 * Format: date-time
			 * @description Last play time
			 */
			lastPlayAt?: string
			/** @description Last game name */
			lastGameName?: string
			/** @description Last provider name */
			lastProviderName?: string
		}
		PlayLogSummaryStats: {
			/** @description Total transfer out (win) */
			transferOut: number
			/** @description Total transfer in (loss) */
			transferIn: number
			/** @description Profit (transferOut - transferIn) */
			profit: number
		}
		LastWalletTransfer: {
			id: string
			amount: number
			fromWalletType: string
			toWalletType: string
			/** Format: date-time */
			createdAt: string
		}
		WalletBalanceInfo: {
			type: string
			balance: number
			promotionName?: string
		}
		PlayerChatStatsResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			/** @description Player ID */
			playerId: string
			/** @description Last deposit transaction */
			lastDeposit?: components['schemas']['LastTransactionResponse']
			/** @description Last withdraw transaction */
			lastWithdraw?: components['schemas']['LastTransactionResponse']
			/** @description Game play statistics */
			gamePlayStats: components['schemas']['GamePlayStats']
			/** @description Play log summary statistics */
			playLogSummary: components['schemas']['PlayLogSummaryStats']
			/** @description Last wallet transfer */
			lastWalletTransfer?: components['schemas']['LastWalletTransfer']
			/** @description Wallet balances */
			walletBalances: components['schemas']['WalletBalanceInfo'][]
			/**
			 * Format: date-time
			 * @description Last online time (from last game session)
			 */
			lastOnline?: string
			/** @description Whether the player is a new user */
			isNewUser: boolean
		}
		ChatNoteResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			chatRoomId: string
			title: string
			content: string
			lastUpdatedBy?: components['schemas']['OperatorResponse']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ChatNoteListResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			items: components['schemas']['ChatNoteResponse'][]
		}
		CreateChatNoteDto: {
			/** @description Note title */
			title: string
			/** @description Note content */
			content: string
		}
		UpdateChatNoteDto: {
			/** @description Note title */
			title?: string
			/** @description Note content */
			content?: string
		}
		MessageContentResponse: {
			id: string
			order: number
			messageType: components['schemas']['ChatMessageType']
			text?: string
			stickerPackageId?: string
			stickerId?: string
			imageUrl?: string
			videoUrl?: string
			videoPreviewUrl?: string
			audioUrl?: string
			audioDuration?: number
			fileUrl?: string
			fileName?: string
			locationTitle?: string
			locationAddress?: string
			locationLatitude?: number
			locationLongitude?: number
			flexAltText?: string
			flexContents?: Record<string, never>
		}
		QuickResponseResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			name: string
			order: number
			createdById?: string
			createdByUsername?: string
			messages: components['schemas']['MessageContentResponse'][]
			/** Format: date-time */
			createdAt: string
		}
		CreateQuickResponseDto: {
			/** @description Quick response name */
			name: string
			/**
			 * @description Display order
			 * @default 0
			 */
			order: number
			/** @description Messages (supports multiple messages of any type) */
			messages: components['schemas']['ChatMessageContentDto'][]
		}
		UpdateQuickResponseDto: {
			/** @description Quick response name */
			name?: string
			/** @description Display order */
			order?: number
			/** @description Messages (supports multiple messages of any type) */
			messages?: components['schemas']['ChatMessageContentDto'][]
		}
		ChatAutoReplyRuleResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			id: string
			keywords: string[]
			priority: number
			isActive: boolean
			messages: components['schemas']['MessageContentResponse'][]
		}
		ChatSettingsResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			greetingEnabled: boolean
			greetingMessages: components['schemas']['MessageContentResponse'][]
			autoReplyEnabled: boolean
			autoReplyRules: components['schemas']['ChatAutoReplyRuleResponse'][]
		}
		ChatAutoReplyRuleDto: {
			/** @description Keywords to match */
			keywords: string[]
			/**
			 * @description Priority (lower = higher priority)
			 * @default 0
			 */
			priority: number
			/**
			 * @description Is rule active
			 * @default true
			 */
			isActive: boolean
			/** @description Response messages (supports multiple messages of any type) */
			messages: components['schemas']['ChatMessageContentDto'][]
		}
		UpdateChatSettingsDto: {
			/** @description Enable greeting message */
			greetingEnabled?: boolean
			/** @description Greeting messages (supports multiple messages of any type) */
			greetingMessages?: components['schemas']['ChatMessageContentDto'][]
			/** @description Enable auto-reply */
			autoReplyEnabled?: boolean
			/** @description Auto-reply rules */
			autoReplyRules?: components['schemas']['ChatAutoReplyRuleDto'][]
		}
		ChatQuotaResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			quotaType: string
			quotaValue: number
			totalUsage: number
			remaining: number
		}
		ChatAnalyticsResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			totalRooms: number
			unreadRooms: number
			activeRooms: number
			replyTokenUsage: number
			pushMessageUsage: number
			quota: components['schemas']['ChatQuotaResponse']
		}
		GenerateChatMediaUploadUrlDto: {
			/**
			 * @description Media type to upload
			 * @enum {string}
			 */
			mediaType: GenerateChatMediaUploadUrlDtoMediaType
			/**
			 * @description File extension (e.g., jpg, png, mp4, mp3)
			 * @example jpg
			 */
			fileExtension: string
		}
		ChatMediaUploadUrlResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			/** @description Presigned URL for uploading the file */
			presignedUrl: string
			/** @description Public URL of the file after upload */
			fileUrl: string
		}
		BroadcastMessagesDto: {
			/** @description Messages to broadcast (supports multiple messages of any type) */
			messages: components['schemas']['ChatMessageContentDto'][]
		}
		BroadcastResponse: {
			type?: components['schemas']['ChatResponseType']
			responseName?: string
			success: boolean
			/** @description Total number of chat rooms targeted */
			totalRooms: number
			/** @description Number of rooms successfully sent to */
			successCount: number
			/** @description Number of rooms that failed */
			failedCount: number
			/** @description Number of rooms skipped (no LINE user ID) */
			skippedCount: number
		}
		ChatNewMessageSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/** @description The new message */
			message: components['schemas']['ChatMessageResponse']
		}
		ChatNewMessageSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatNewMessageSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatNewMessageSsePayload']
		}
		ChatRoomUpdatedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/** @description Updated room data */
			room: components['schemas']['ChatRoomResponse']
		}
		ChatRoomUpdatedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatRoomUpdatedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatRoomUpdatedSsePayload']
		}
		ChatRoomListChangedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description LINE display name
			 * @example John Doe
			 */
			lineDisplayName?: string
			/** @description LINE profile picture URL */
			linePictureUrl?: string
			/**
			 * @description Number of unread messages
			 * @example 5
			 */
			unreadCount: number
			/**
			 * @description ISO timestamp of last message
			 * @example 2024-01-01T12:00:00.000Z
			 */
			lastMessageAt: string
			/**
			 * @description Whether room needs attention (unread + no assignee)
			 * @example true
			 */
			needsAttention: boolean
			/**
			 * @description Whether room has an assigned operator
			 * @example false
			 */
			hasAssignee: boolean
			/**
			 * @description Assigned operator ID
			 * @example op123
			 */
			assignedOperatorId?: string
			/**
			 * @description Preview of last message (first 50 chars or type label)
			 * @example Hello, I need help with...
			 */
			lastMessagePreview?: string
			/**
			 * @description Type of the last message
			 * @example TEXT
			 * @enum {string}
			 */
			lastMessageType: ChatRoomListChangedSsePayloadLastMessageType
			/**
			 * @description Direction of the last message
			 * @example INCOMING
			 * @enum {string}
			 */
			lastMessageDirection: ChatRoomListChangedSsePayloadLastMessageDirection
			/**
			 * @description Reason for the room list change
			 * @example new_message
			 * @enum {string}
			 */
			reason: ChatRoomListChangedSsePayloadReason
		}
		ChatRoomListChangedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatRoomListChangedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatRoomListChangedSsePayload']
		}
		ChatTagUpdatedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/** @description Current tags on the room */
			tags: components['schemas']['CustomerTagResponse'][]
			/**
			 * @description Action performed
			 * @example added
			 * @enum {string}
			 */
			action: ChatTagUpdatedSsePayloadAction
			/**
			 * @description Tag ID that was added or removed
			 * @example tag123
			 */
			tagId: string
		}
		ChatTagUpdatedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatTagUpdatedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatTagUpdatedSsePayload']
		}
		ChatAssigneeUpdatedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description Assigned operator ID (null if released)
			 * @example op123
			 */
			assignedOperatorId?: string | null
			/**
			 * @description Assigned operator username (null if released)
			 * @example admin_user
			 */
			assignedOperatorName?: string | null
		}
		ChatAssigneeUpdatedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatAssigneeUpdatedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatAssigneeUpdatedSsePayload']
		}
		ChatMessageReadSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description IDs of messages that were marked as read
			 * @example [
			 *       "msg1",
			 *       "msg2",
			 *       "msg3"
			 *     ]
			 */
			messageIds: string[]
			/**
			 * @description Operator ID who read the messages
			 * @example op123
			 */
			readByOperatorId: string
			/**
			 * @description Operator username who read the messages
			 * @example admin_user
			 */
			readByOperatorName: string
			/**
			 * @description ISO timestamp when messages were read
			 * @example 2024-01-01T12:00:00.000Z
			 */
			readAt: string
		}
		ChatMessageReadSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatMessageReadSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatMessageReadSsePayload']
		}
		ChatMessageConfirmedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description Client-generated ID that was sent with the message
			 * @example client-uuid-123
			 */
			clientId: string
			/**
			 * @description Server-generated message ID
			 * @example msg-server-id
			 */
			messageId: string
			/** @description The confirmed message */
			message: components['schemas']['ChatMessageResponse']
		}
		ChatMessageConfirmedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatMessageConfirmedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatMessageConfirmedSsePayload']
		}
		ChatMessagePinnedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description Message ID that was pinned/unpinned
			 * @example msg123
			 */
			messageId: string
			/**
			 * @description Whether the message is now pinned
			 * @example true
			 */
			isPinned: boolean
			/** @description Operator who pinned/unpinned */
			operatorId?: string
			/** @description Operator username */
			operatorName?: string
		}
		ChatMessagePinnedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatMessagePinnedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatMessagePinnedSsePayload']
		}
		ChatRoomPinnedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description Whether the room is now pinned
			 * @example true
			 */
			isPinned: boolean
			/** @description Operator who pinned/unpinned */
			operatorId?: string
			/** @description Operator username */
			operatorName?: string
		}
		ChatRoomPinnedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatRoomPinnedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatRoomPinnedSsePayload']
		}
		ChatRoomBannedSsePayload: {
			/**
			 * @description Chat room ID
			 * @example clxyz123abc
			 */
			roomId: string
			/**
			 * @description Whether the room is now banned
			 * @example true
			 */
			isBanned: boolean
			/** @description Ban reason */
			reason?: string
			/** @description Operator who banned/unbanned */
			operatorId?: string
			/** @description Operator username */
			operatorName?: string
		}
		ChatRoomBannedSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatRoomBannedSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatRoomBannedSsePayload']
		}
		ChatPingSsePayload: {
			/**
			 * @description Number of active SSE connections (sessions)
			 * @example 5
			 */
			connectionCount: number
		}
		ChatPingSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatPingSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatPingSsePayload']
		}
		ChatBroadcastSentSsePayload: {
			/**
			 * @description Whether this is a broadcast to all rooms. If true, roomIds will be empty and frontend should refresh if viewing any room.
			 * @example true
			 */
			isAllRooms: boolean
			/**
			 * @description List of room IDs that received messages. Empty if isAllRooms is true.
			 * @example [
			 *       "room1",
			 *       "room2",
			 *       "room3"
			 *     ]
			 */
			roomIds: string[]
			/** @description The message that was sent */
			message: components['schemas']['ChatMessageResponse']
			/**
			 * @description Number of rooms targeted
			 * @example 100
			 */
			totalRooms: number
			/**
			 * @description Operator ID who sent the broadcast
			 * @example op123
			 */
			operatorId: string
			/**
			 * @description Operator username who sent the broadcast
			 * @example admin_user
			 */
			operatorName?: string
			/**
			 * @description ISO timestamp when broadcast was sent
			 * @example 2024-01-01T12:00:00.000Z
			 */
			sentAt: string
		}
		ChatBroadcastSentSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: ChatBroadcastSentSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['ChatBroadcastSentSsePayload']
		}
		WithdrawPendingSsePayload: {
			/**
			 * @description Transaction ID
			 * @example TX-240101-abc123
			 */
			txId: string
			/**
			 * @description Withdrawal amount
			 * @example 5000
			 */
			amount: number
			/**
			 * @description Masked player phone number
			 * @example 081****678
			 */
			playerPhone: string
			/**
			 * @description Bank provider name
			 * @example KBANK
			 */
			bankProvider: string
			/**
			 * @description Created timestamp
			 * @example 2024-01-01T12:00:00.000Z
			 */
			createdAt: string
		}
		WithdrawPendingSseEvent: {
			/**
			 * @description Monotonic event ID for deduplication and replay
			 * @example 1704067200000-abc123
			 */
			id: string
			/**
			 * @description Event type name
			 * @example chat:new_message
			 * @enum {string}
			 */
			event: WithdrawPendingSseEventEvent
			/**
			 * @description ISO timestamp when the event was created
			 * @example 2024-01-01T12:00:00.000Z
			 */
			ts: string
			/** @description Event payload data */
			data: components['schemas']['WithdrawPendingSsePayload']
		}
		ChatAiDraftSsePayload: {
			/** @description Draft ID from AiAdminDraft table */
			draftId: string
			/** @description Chat room ID */
			roomId: string
			/** @description Chat message ID this draft responds to */
			messageId: string
			/** @description AI-generated draft text (Thai) */
			draftText?: string
			/**
			 * @description Draft action type
			 * @enum {string}
			 */
			action: ChatAiDraftSsePayloadAction
			/** @description Classified intent */
			intent: string
			/** @description Classification confidence (0.00-1.00) */
			confidence: number
			/** @description Suggested admin follow-up actions */
			adminActions: string[]
		}
		/** @enum {string} */
		AiPromptCaseKey: AiPromptCaseKey
		AiPromptCaseResponse: {
			caseKey: components['schemas']['AiPromptCaseKey']
			replyPrompt: string
			adminPrompt: string
			enabled: boolean
		}
		AiSettingFullResponse: {
			systemContext: string
			toolsEnabled: Record<string, never>
			aiEnabled: boolean
			promptCases: components['schemas']['AiPromptCaseResponse'][]
		}
		UpdateAiSettingDto: {
			/** @description System context for AI agent prompt */
			systemContext: string
			/**
			 * @description Tool enable/disable map
			 * @example {
			 *       "get_player_profile": true,
			 *       "get_deposit_history": false
			 *     }
			 */
			toolsEnabled?: Record<string, never>
			/**
			 * @description Enable AI globally for all chats
			 * @example true
			 */
			aiEnabled?: boolean
		}
		AiPromptCaseUpdateItemDto: {
			caseKey: components['schemas']['AiPromptCaseKey']
			/** @description Prompt fed to user reply executor */
			replyPrompt?: string
			/** @description Prompt fed to admin action executor */
			adminPrompt?: string
			/** @description Whether this case is enabled */
			enabled?: boolean
		}
		UpdateAiPromptCasesDto: {
			/** @description Partial list of case updates. Cases not in this list are untouched. */
			cases: components['schemas']['AiPromptCaseUpdateItemDto'][]
		}
		AiDraftResponse: {
			draftId: string
			roomId: string
			messageId: string
			draftText?: string
			action: string
			intent: string
			confidence: number
			adminActions: string[]
		}
		AdminTaskResponse: {
			id: string
			draftId: string
			chatRoomId: string
			text: string
			/** @enum {string} */
			status: AdminTaskResponseStatus
			actedByOperatorId?: string | null
			actedAt?: string | null
			createdAt: string
		}
		UpdateAiDraftBody: {
			/** @description Final text sent to player (if edited) */
			finalText?: string
		}
		UpdateChatAiModeDto: {
			aiAnswerMode: components['schemas']['AiAnswerMode']
		}
		ChatAiModeResponse: {
			roomId: string
			aiAnswerMode: components['schemas']['AiAnswerMode']
		}
		CreateDepositDto: {
			fbp?: string
			fbc?: string
			userAgent?: string
			/**
			 * @description หน้าที่ event เกิด ไม่ต้องใส่ query string
			 * @example https://example.com/landing-page
			 */
			eventSourceUrl?: string
			/**
			 * @description URL ที่ผู้ใช้มาจากไหน
			 * @example https://facebook.com
			 */
			referrerUrl?: string
			/** @description Custom event data */
			customData?: components['schemas']['CustomDataDto']
			/**
			 * @description The amount of the deposit
			 * @example 100
			 */
			amount: number
			promotionId?: string
			/**
			 * @description Deposit channel selected by the player
			 * @example QR
			 * @enum {string}
			 */
			channel?: CreateDepositDtoChannel
			/** @description P2P choice token (from deposit-choice-list) */
			choiceToken?: string
		}
		/** @enum {string} */
		TransactionMethod: TransactionMethod
		/**
		 * @description Bank validation method
		 * @enum {string}
		 */
		ValidateMethod: ValidateMethod
		BankResponse: {
			/** @description Bank ID */
			id: string
			/** @description Bank account name */
			accountName: string
			/** @description Bank account number */
			accountNumber: string
			/** @description Bank provider */
			bankProvider: string
			/**
			 * Format: date-time
			 * @description Created date
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 */
			updatedAt: string
		}
		/**
		 * @description Type of manual deposit (REGULAR = actual deposit, FREE_CREDIT = admin giveaway)
		 * @enum {string}
		 */
		ManualDepositType: ManualDepositType
		DepositTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174001
			 */
			playerId: string
			/**
			 * @description Amount
			 * @example 100.5
			 */
			amount: number
			/** @example PENDING */
			status: components['schemas']['DepositStatus']
			/** @example BANK */
			method: components['schemas']['TransactionMethod']
			/** @example TRANSFER */
			bankValidateMethod?: components['schemas']['ValidateMethod']
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2023-01-01T12:00:00Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2023-01-01T12:30:00Z
			 */
			updatedAt: string
			/**
			 * @description Timestamp information
			 * @example {
			 *       "CREATED": "2023-01-01T12:00:00Z"
			 *     }
			 */
			timestamp: {
				[key: string]: string
			}
			/**
			 * @description Promotion ID
			 * @example 123e4567-e89b-12d3-a456-426614174002
			 */
			promotionId?: string
			/**
			 * @description Player bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174003
			 */
			playerBankId: string
			processor: components['schemas']['TransactionProcessor']
			/**
			 * @description Bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174004
			 */
			bankId?: string
			/** @description QR code URL */
			qrCodeUrl?: string
			/** @description Account number */
			accountNumber?: string
			/** @description Account name */
			accountName?: string
			/** @description Account provider name */
			accountProviderName?: string
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174005
			 */
			paymentGatewayId?: string
			/**
			 * Format: date-time
			 * @description Expired at
			 * @example 2023-01-01T12:00:00Z
			 */
			expiredAt: string
			/** @description Bank information */
			bank?: components['schemas']['BankResponse']
			manualDepositType?: components['schemas']['ManualDepositType']
			/** @description Whether this deposit requires slip upload verification */
			verifySlip?: boolean
			/** @description Whether SMS_AUTO bank has slip upload enabled (show after 1 min) */
			enableUploadSlip?: boolean
			/** @description Whether the player can upload a slip right now (server-computed from createdAt + delay) */
			canUploadSlip?: boolean
			/** @description Whether the channel was changed due to fallback */
			channelChanged?: boolean
			/** @description The actual channel used for this deposit */
			channel?: string
		}
		/**
		 * @description Credit type of the promotion
		 * @enum {string}
		 */
		CreditType: CreditType
		whitelistGameProvider: {
			id: string
			name: string
			displayName?: Record<string, never>
		}
		PromotionResponse: {
			/**
			 * @description Promotion ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Promotion name
			 * @example Welcome Bonus
			 */
			name: string
			/**
			 * @description Promotion banner URL
			 * @example https://example.com/banner.jpg
			 */
			banner?: string
			/**
			 * @description Short description of the promotion
			 * @example Get 100% bonus on your first deposit
			 */
			shortDescription?: string
			/**
			 * @description Detailed description of the promotion
			 * @example Get a 100% bonus up to 1000 on your first deposit. Minimum deposit 100.
			 */
			description?: string
			/** @example FIXED */
			creditType: components['schemas']['CreditType']
			/**
			 * @description Credit amount (for FIXED credit type)
			 * @example 100
			 */
			creditAmount?: number
			/**
			 * @description Credit ratio (for RATIO credit type)
			 * @example 0.5
			 */
			creditRatio?: number
			/**
			 * @description Maximum credit amount
			 * @example 1000
			 */
			maxCreditAmount?: number
			/**
			 * @description Fixed deposit amount required for this promotion
			 * @example 500
			 */
			fixedDepositAmount?: number
			/**
			 * @description Minimum deposit amount
			 * @example 100
			 */
			minimumDeposit?: number
			/** @example [
			 *       "SLOT",
			 *       "CASINO"
			 *     ] */
			gameTypes: components['schemas']['GameType'][]
			/**
			 * @description Turnover requirement multiplier
			 * @example 5
			 */
			turnoverRound?: number
			/**
			 * @description Minimum withdrawal credit
			 * @example 100
			 */
			minimumWithdrawCredit?: number
			/**
			 * @description Maximum withdrawal credit
			 * @example 10000
			 */
			maximumWithdrawCredit?: number
			/**
			 * @description Maximum current credit before deposit
			 * @example 5
			 */
			maximumCurrentCredit?: number
			/**
			 * @description Maximum withdrawal as multiple of deposit amount
			 * @example 5
			 */
			maximumWithdrawMultiplierOfDeposit?: number
			/**
			 * @description Minimum rank order required
			 * @example 1
			 */
			minimumRankOrder?: number
			/** @description Game providers applicable for this promotion */
			whitelistGameProviders: components['schemas']['whitelistGameProvider'][]
			/**
			 * @description Maximum number of times a player can claim this promotion
			 * @example 1
			 */
			perPlayerQuota?: number
			/**
			 * @description Maximum number of times the system can claim this promotion
			 * @example 1
			 */
			limitQuota?: number
			/**
			 * @description Maximum number of times a player can claim this promotion per day
			 * @example 1
			 */
			limitQuotaPerDay?: number
			/**
			 * @description Maximum number of times a player can claim this promotion per month
			 * @example 1
			 */
			limitQuotaPerMonth?: number
			/**
			 * @description Maximum number of times a player can claim this promotion per day
			 * @example 1
			 */
			limitQuotaPerDayPerPlayer?: number
			/**
			 * Format: date-time
			 * @description Promotion start date
			 * @example 2023-01-01T00:00:00Z
			 */
			startDate?: string
			/**
			 * Format: date-time
			 * @description Promotion end date
			 * @example 2023-12-31T23:59:59Z
			 */
			endDate?: string
			/**
			 * @description Whether the player is eligible to claim this promotion
			 * @example true
			 */
			isEligible: boolean
			/**
			 * @description Reason why the player cannot claim this promotion (if not eligible)
			 * @example Insufficient rank level
			 */
			ineligibilityReason?: string
			/**
			 * @description Expire at
			 * @example 2023-01-01T00:00:00Z
			 */
			rankExperiencePoint?: number
			/**
			 * @description Whether this promotion requires the player to connect LINE
			 * @example false
			 */
			requireConnectLine: boolean
			/**
			 * @description Whether this is an exclusive promotion for specific player groups. If true, this promotion is specially for you!
			 * @example true
			 */
			isExclusive?: boolean
			/**
			 * @description Fixed diamond amount the player will receive upon completing this promotion deposit
			 * @example 50
			 */
			diamondAmount?: number
		}
		MinimumDepositResponse: {
			/**
			 * @description Minimum deposit amount
			 * @example 100
			 */
			minimumDepositAmount: number
			/** @description Available promotions */
			promotionList: components['schemas']['PromotionResponse'][]
		}
		AmountConstraintDto: {
			/**
			 * @description Amount step gap (null = no step constraint)
			 * @example 50
			 */
			step?: number
			/**
			 * @description Minimum deposit amount for this channel
			 * @example 100
			 */
			minAmount?: number
			/**
			 * @description Maximum deposit amount for this channel
			 * @example 50000
			 */
			maxAmount?: number
			/**
			 * @description P2P suggestion threshold percentage (null = no limit)
			 * @example 50
			 */
			threshold?: number
		}
		AvailableChannelItem: {
			/**
			 * @description Channel identifier
			 * @example QR
			 */
			name: string
			/**
			 * @description Display label for the channel
			 * @example QR Code
			 */
			label: string
			/**
			 * @description Short description of the channel
			 * @example ฝากเงินผ่าน QR Code
			 */
			description: string
			/**
			 * @description Whether this channel is currently available
			 * @example true
			 */
			available: boolean
			/** @description P2P amount constraints (only present for P2P channels) */
			amountConstraint?: components['schemas']['AmountConstraintDto']
		}
		AvailableChannelsResponse: {
			/** @description List of deposit channels visible to this player */
			channels: components['schemas']['AvailableChannelItem'][]
			/**
			 * @description When set, the player has no channel choice and must use this channel (e.g. TRUE_MONEY for True Wallet users)
			 * @example TRUE_MONEY
			 */
			forceChannel?: string
		}
		TransactionAvailabilityResponse: {
			/** @description Whether the transaction type is available */
			isAvailable: boolean
			/**
			 * @description Reason for unavailability
			 * @enum {string}
			 */
			reason?: TransactionAvailabilityResponseReason
			/** @description When the service will be available again (ISO datetime) */
			availableAt?: string
		}
		GetSlipPresignDto: {
			/**
			 * @description File extension of the slip image (e.g. jpg, png)
			 * @example jpg
			 */
			fileExtension?: string
		}
		SlipPresignResponse: {
			/** @description Presigned PUT URL to upload the slip image directly to R2 */
			presignedUrl: string
			/** @description Final public URL of the slip image after upload */
			fileUrl: string
		}
		UploadSlipDto: {
			/**
			 * @description Public R2 URL of the slip image uploaded via presigned URL
			 * @example https://image.example.com/project/slips/uuid.jpg
			 */
			imageUrl: string
		}
		UploadSlipResponse: {
			/** @description Whether the slip upload request was accepted */
			success: boolean
			/** @description Response message */
			message: string
			status?: components['schemas']['DepositStatus']
		}
		WalletConditionsResponse: {
			/**
			 * @description Turnover amount needed to fulfill the promotion condition
			 * @example 1000
			 */
			turnoverAmount?: number
			/**
			 * @description Initial turnover amount required for the promotion
			 * @example 2000
			 */
			initialTurnover?: number
			/**
			 * @description Current turnover amount completed by the user
			 * @example 1500
			 */
			currentTurnover?: number
			/**
			 * @description Promotion ID
			 * @example 123e4567-e89b-12d3-a456-426614174002
			 */
			promotionId?: string
			/** @example [
			 *       "SLOT"
			 *     ] */
			gameTypes?: components['schemas']['GameType'][]
			/**
			 * @description Minimum withdraw credit
			 * @example 100
			 */
			minimumWithdrawCredit?: number
			/**
			 * @description Maximum withdraw credit
			 * @example 1000
			 */
			maximumWithdrawCredit?: number
			/**
			 * @description Provider names
			 * @example [
			 *       "Provider 1",
			 *       "Provider 2"
			 *     ]
			 */
			providerNames?: string[]
		}
		WalletBasicResponse: {
			/**
			 * @description Wallet ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/** @example MAIN */
			type: components['schemas']['WalletType']
			/**
			 * @description Wallet balance
			 * @example 500.5
			 */
			balance: number
		}
		PlayerWalletConditionResponse: {
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			turnoverRound?: number
			gameTypes: components['schemas']['GameType'][]
			whitelistGameProviders: string[]
		}
		WalletBalanceResponse: {
			/**
			 * @description Wallet ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/** @example PROMOTION */
			type: components['schemas']['WalletType']
			/**
			 * @description Wallet balance
			 * @example 500.5
			 */
			balance: number
			/**
			 * @description Minimum withdraw credit
			 * @example 100
			 */
			minimumWithdrawCredit?: number
			/**
			 * @description Maximum withdraw credit
			 * @example 1000
			 */
			maximumWithdrawCredit?: number
			/**
			 * @description If the wallet is in withdraw condition
			 * @example false
			 */
			inWithdrawCondition?: boolean
			/**
			 * @description Promotion name (only for promotion wallets)
			 * @example Welcome Bonus 100%
			 */
			promotionName?: string
			/** @description Wallet conditions (only for promotion wallets) */
			conditions?: components['schemas']['WalletConditionsResponse']
			/** @description Main wallet information (only for promotion wallets) */
			mainWallet?: components['schemas']['WalletBasicResponse']
			/** @description Wallet condition for this wallet type */
			walletCondition?: components['schemas']['PlayerWalletConditionResponse']
			/**
			 * @description Previous main wallet credit that was moved to promotion wallet during deposit
			 * @example 150
			 */
			previousMainCredit?: number
		}
		WalletTransferResponse: {
			/**
			 * @description Amount transferred from promotion to main wallet
			 * @example 500
			 */
			transferredAmount: number
			/**
			 * @description Previous promotion wallet balance before transfer
			 * @example 500
			 */
			previousPromotionBalance: number
			/** @description Wallet conditions that were active before transfer */
			conditions?: components['schemas']['WalletConditionsResponse']
			/** @description Main wallet information after transfer */
			mainWallet: components['schemas']['WalletBasicResponse']
			/** @description Whether promotion wallet conditions were auto-cleared due to low balance */
			wasAutoCleared?: boolean
		}
		ClearTurnoverWalletDto: {
			password: string
		}
		ClearTurnoverWalletResponse: {
			/**
			 * @description Wallet ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/** @example PROMOTION */
			type: components['schemas']['WalletType']
			/**
			 * @description Wallet balance after clearing
			 * @example 0
			 */
			balance: number
			/**
			 * @description Turnover amount after clearing
			 * @example 0
			 */
			turnoverAmount: number
			/**
			 * @description Withdraw condition status after clearing
			 * @example false
			 */
			inWithdrawCondition: boolean
			/**
			 * @description Promotion ID after clearing (null)
			 * @example null
			 */
			promotionId?: string
		}
		TransferToActiveWalletDto: {
			fromWalletId: string
		}
		PresetInfo: {
			/**
			 * @description Unique identifier for the preset
			 * @example preset-123
			 */
			id: string
			/**
			 * @description RTP value for normal gameplay
			 * @example 96.5
			 */
			rtpNormal: number
			/**
			 * @description RTP value for buy feature gameplay
			 * @example 97
			 */
			rtpBuyFeature: number
			/**
			 * @description Additional notes about the preset
			 * @example High volatility preset
			 */
			note: string
			/** @description Payoff settings configuration */
			payoffSetting: Record<string, never>
			/**
			 * @description Creation timestamp
			 * @example 2025-07-24T01:33:11.780Z
			 */
			createdAt: string
			/**
			 * @description Last update timestamp
			 * @example 2025-07-24T01:33:11.780Z
			 */
			updatedAt: string
		}
		GetPresetsResponse: {
			/** @description Array of preset configurations */
			presets: components['schemas']['PresetInfo'][]
		}
		CreatePoolPresetConfigDto: {
			name?: string
			description?: string
			rewardSize: number
			savingSize?: number
			rewardRatio: number
		}
		NewUserConstraintModel: {
			/** @enum {string} */
			constraintType: NewUserConstraintModelConstraintType
			/** @example true */
			isNewUser: boolean
		}
		FirstDepositConstraintModel: {
			/** @enum {string} */
			constraintType: FirstDepositConstraintModelConstraintType
			/** @example true */
			isFirstDeposit: boolean
		}
		FirstTimeOfDayConstraintModel: {
			/** @enum {string} */
			constraintType: FirstTimeOfDayConstraintModelConstraintType
			/** @example true */
			isFirstTimeOfDay: boolean
		}
		/** @enum {string} */
		ComparisonOperator: ComparisonOperator
		DepositAmountConstraintModel: {
			/** @enum {string} */
			constraintType: DepositAmountConstraintModelConstraintType
			/** @example GREATER_THAN */
			operator: components['schemas']['ComparisonOperator']
			/** @example 100 */
			amount: number
		}
		DayOfWeekConstraintModel: {
			/** @enum {string} */
			constraintType: DayOfWeekConstraintModelConstraintType
			/** @example [
			 *       "MONDAY",
			 *       "FRIDAY"
			 *     ] */
			days: unknown[][]
		}
		/** @enum {string} */
		DepositHistoryPeriod: DepositHistoryPeriod
		DepositHistoryAmountConstraintModel: {
			/** @enum {string} */
			constraintType: DepositHistoryAmountConstraintModelConstraintType
			/** @example TODAY */
			period: components['schemas']['DepositHistoryPeriod']
			/** @example GREATER_THAN_OR_EQUAL */
			operator: components['schemas']['ComparisonOperator']
			/** @example 500 */
			amount: number
		}
		CreateDepositPromotionPresetConfigDto: {
			/** @enum {string} */
			thresholdType?: CreateDepositPromotionPresetConfigDtoThresholdType
			turnoverThreshold?: number
			turnoverMultiplier?: number
			presetId: string
			presetNumber?: number
			order?: number
		}
		CreateDepositPromotionDto: {
			name: string
			banner?: string
			shortDescription?: string
			description?: string
			order?: number
			isActive: boolean
			creditType: components['schemas']['CreditType']
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			fixedDepositAmount?: number
			/** @description Maximum current credit balance allowed to accept promotion (เครดิตคงเหลือสูงสุดก่อนรับโปร) */
			maximumCurrentCredit?: number
			rankExperiencePoint?: number
			/** @description Fixed diamond amount awarded to the player when this promotion deposit completes */
			diamondAmount?: number
			gameTypes: components['schemas']['GameType'][]
			turnoverRound: number
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			/** @description Maximum withdrawal as multiple of deposit (ถอนสูงสุดเป็นกี่เท่าของการฝาก) */
			maximumWithdrawMultiplierOfDeposit?: number
			limitQuota?: number
			minimumRankOrder?: number
			limitQuotaPerDay?: number
			limitQuotaPerDayPerPlayer?: number
			limitQuotaPerMonth?: number
			claimConstraint: (
				| components['schemas']['NewUserConstraintModel']
				| components['schemas']['FirstDepositConstraintModel']
				| components['schemas']['FirstTimeOfDayConstraintModel']
				| components['schemas']['DepositAmountConstraintModel']
				| components['schemas']['DayOfWeekConstraintModel']
				| components['schemas']['DepositHistoryAmountConstraintModel']
			)[]
			whitelistGameProviderIds?: string[]
			perPlayerQuota?: number
			presetId?: string
			presetNumber?: number
			isForPlayer?: boolean
			isForGuestOnly?: boolean
			/** @description Hidden promotion - not shown in player lists but can be claimed through special campaigns (broke-flex, etc.) */
			isHiddenPromotion?: boolean
			isCoupon?: boolean
			requireConnectedLine?: boolean
			/** @description Allowed customer tag IDs. If specified, only players with at least one of these tags can claim this promotion. Leave empty to allow everyone. */
			allowedTagIds?: string[]
			/** @description Allow instant claim mode - enables shared claim link for zero-deposit promotion */
			allowInstantClaim?: boolean
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			usePool?: boolean
			poolPresetConfigs?: components['schemas']['CreatePoolPresetConfigDto']
			presetConfigs?: components['schemas']['CreateDepositPromotionPresetConfigDto'][]
			/** @description Use PGHard provider (default: true) */
			pgHard?: boolean
			/** @description Use JokerHard provider (default: false, not ready yet) */
			jokerHard?: boolean
			/** @description Use JiliHard provider (default: false, not ready yet) */
			jiliHard?: boolean
			/** @description Use HARDV2_PP provider (default: false) */
			ppHard?: boolean
			/** @description Use HARDV2_NOLIMITCITY provider (default: false) */
			nlcHard?: boolean
		}
		PoolPresetConfigModel: {
			name: string
			description: string
			rewardSize: number
			savingSize: number
			rewardRatio: number
		}
		DepositPromotionPresetConfigModel: {
			/** @enum {string} */
			thresholdType?: DepositPromotionPresetConfigModelThresholdType
			turnoverThreshold?: number
			turnoverMultiplier?: number
			presetId: string
			presetNumber?: number
			order?: number
		}
		DepositPromotionResponse: {
			id: string
			order: number
			banner?: string
			name: string
			shortDescription?: string
			description?: string
			minimumRankOrder?: number
			isActive: boolean
			creditType: components['schemas']['CreditType']
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			fixedDepositAmount?: number
			/** @description Maximum current credit balance allowed to accept promotion (เครดิตคงเหลือสูงสุดก่อนรับโปร) */
			maximumCurrentCredit?: number
			gameTypes: components['schemas']['GameType'][]
			turnoverRound?: number
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			limitQuota?: number
			limitQuotaPerDay?: number
			limitQuotaPerDayPerPlayer?: number
			limitQuotaPerMonth?: number
			perPlayerQuota?: number
			claimConstraint: (
				| components['schemas']['NewUserConstraintModel']
				| components['schemas']['FirstDepositConstraintModel']
				| components['schemas']['FirstTimeOfDayConstraintModel']
				| components['schemas']['DepositAmountConstraintModel']
				| components['schemas']['DayOfWeekConstraintModel']
				| components['schemas']['DepositHistoryAmountConstraintModel']
			)[]
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			whitelistGameProviders?: components['schemas']['whitelistGameProvider'][]
			presetId?: string
			presetNumber?: number
			isForPlayer?: boolean
			usePool?: boolean
			poolPresetConfigs?: components['schemas']['PoolPresetConfigModel'][]
			presetConfigs?: components['schemas']['DepositPromotionPresetConfigModel'][]
			isForGuestOnly?: boolean
			isCoupon?: boolean
			requireConnectedLine?: boolean
			/** @description Allowed customer tag IDs. If not empty, only players with at least one of these tags can claim. */
			allowedTagIds?: string[]
			/** @description Allow instant claim mode - enables shared claim link for zero-deposit promotion */
			allowInstantClaim?: boolean
			rankExperiencePoint?: number
			/** @description Fixed diamond amount awarded to the player when this promotion deposit completes */
			diamondAmount?: number
			/** @description Use PGHard provider (default: true) */
			pgHard: boolean
			/** @description Use JokerHard provider (default: true) */
			jokerHard: boolean
			/** @description Use JiliHard provider (default: true) */
			jiliHard: boolean
			/** @description Use HARDV2_PP provider (default: false) */
			ppHard: boolean
			/** @description Use HARDV2_NOLIMITCITY provider (default: false) */
			nlcHard: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DepositPromotionsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DepositPromotionResponse'][]
		}
		DepositPromotionForBrokeNotificationModel: {
			id: string
			name: string
		}
		GetDepositPromotionsForBrokeNotificationResponse: {
			data: components['schemas']['DepositPromotionForBrokeNotificationModel'][]
		}
		DepositPromotionPresetDataModel: {
			creditType: string
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			turnoverRound: number
			gameTypes: string[]
			whitelistGameProviderNames: string[]
			maximumCurrentCredit?: number
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			perPlayerQuota?: number
			limitQuotaPerDayPerPlayer?: number
			pgHard: boolean
			presetConfigs: components['schemas']['DepositPromotionPresetConfigModel'][]
			claimConstraint: Record<string, never>[]
		}
		DepositPromotionPresetModel: {
			id: string
			name: string
			description: string
			data: components['schemas']['DepositPromotionPresetDataModel']
		}
		DepositPromotionPresetListResponse: {
			data: components['schemas']['DepositPromotionPresetModel'][]
		}
		ApplyDepositPromotionPresetDto: {
			/** @description Name for the new promotion */
			name: string
		}
		DepositPromotionModel: {
			id: string
			order: number
			banner?: string
			name: string
			shortDescription?: string
			description?: string
			minimumRankOrder?: number
			isActive: boolean
			creditType: components['schemas']['CreditType']
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			fixedDepositAmount?: number
			/** @description Maximum current credit balance allowed to accept promotion (เครดิตคงเหลือสูงสุดก่อนรับโปร) */
			maximumCurrentCredit?: number
			gameTypes: components['schemas']['GameType'][]
			turnoverRound?: number
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			limitQuota?: number
			limitQuotaPerDay?: number
			limitQuotaPerDayPerPlayer?: number
			limitQuotaPerMonth?: number
			perPlayerQuota?: number
			claimConstraint: (
				| components['schemas']['NewUserConstraintModel']
				| components['schemas']['FirstDepositConstraintModel']
				| components['schemas']['FirstTimeOfDayConstraintModel']
				| components['schemas']['DepositAmountConstraintModel']
				| components['schemas']['DayOfWeekConstraintModel']
				| components['schemas']['DepositHistoryAmountConstraintModel']
			)[]
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			whitelistGameProviders?: components['schemas']['whitelistGameProvider'][]
			presetId?: string
			presetNumber?: number
			isForPlayer?: boolean
			usePool?: boolean
			poolPresetConfigs?: components['schemas']['PoolPresetConfigModel'][]
			presetConfigs?: components['schemas']['DepositPromotionPresetConfigModel'][]
			isForGuestOnly?: boolean
			isCoupon?: boolean
			requireConnectedLine?: boolean
			/** @description Allowed customer tag IDs. If not empty, only players with at least one of these tags can claim. */
			allowedTagIds?: string[]
			/** @description Allow instant claim mode - enables shared claim link for zero-deposit promotion */
			allowInstantClaim?: boolean
			rankExperiencePoint?: number
			/** @description Fixed diamond amount awarded to the player when this promotion deposit completes */
			diamondAmount?: number
			/** @description Use PGHard provider (default: true) */
			pgHard: boolean
			/** @description Use JokerHard provider (default: true) */
			jokerHard: boolean
			/** @description Use JiliHard provider (default: true) */
			jiliHard: boolean
			/** @description Use HARDV2_PP provider (default: false) */
			ppHard: boolean
			/** @description Use HARDV2_NOLIMITCITY provider (default: false) */
			nlcHard: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ApplyDepositPromotionPresetResponse: {
			success: boolean
			data: components['schemas']['DepositPromotionModel']
		}
		UpdateDepositPromotionDto: {
			name?: string
			banner?: string
			shortDescription?: string
			description?: string
			order?: number
			isActive?: boolean
			creditType?: components['schemas']['CreditType']
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			fixedDepositAmount?: number
			/** @description Maximum current credit balance allowed to accept promotion (เครดิตคงเหลือสูงสุดก่อนรับโปร) */
			maximumCurrentCredit?: number
			rankExperiencePoint?: number
			/** @description Fixed diamond amount awarded to the player when this promotion deposit completes */
			diamondAmount?: number
			gameTypes?: components['schemas']['GameType'][]
			turnoverRound?: number
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			/** @description Maximum withdrawal as multiple of deposit (ถอนสูงสุดเป็นกี่เท่าของการฝาก) */
			maximumWithdrawMultiplierOfDeposit?: number
			limitQuota?: number
			minimumRankOrder?: number
			limitQuotaPerDay?: number
			limitQuotaPerDayPerPlayer?: number
			limitQuotaPerMonth?: number
			claimConstraint?: (
				| components['schemas']['NewUserConstraintModel']
				| components['schemas']['FirstDepositConstraintModel']
				| components['schemas']['FirstTimeOfDayConstraintModel']
				| components['schemas']['DepositAmountConstraintModel']
				| components['schemas']['DayOfWeekConstraintModel']
				| components['schemas']['DepositHistoryAmountConstraintModel']
			)[]
			whitelistGameProviderIds?: string[]
			perPlayerQuota?: number
			presetId?: string
			presetNumber?: number
			isForPlayer?: boolean
			isForGuestOnly?: boolean
			/** @description Hidden promotion - not shown in player lists but can be claimed through special campaigns (broke-flex, etc.) */
			isHiddenPromotion?: boolean
			isCoupon?: boolean
			requireConnectedLine?: boolean
			/** @description Allowed customer tag IDs. If specified, only players with at least one of these tags can claim this promotion. Leave empty to allow everyone. */
			allowedTagIds?: string[]
			/** @description Allow instant claim mode - enables shared claim link for zero-deposit promotion */
			allowInstantClaim?: boolean
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			usePool?: boolean
			poolPresetConfigs?: components['schemas']['CreatePoolPresetConfigDto']
			presetConfigs?: components['schemas']['CreateDepositPromotionPresetConfigDto'][]
			/** @description Use PGHard provider (default: true) */
			pgHard?: boolean
			/** @description Use JokerHard provider (default: false, not ready yet) */
			jokerHard?: boolean
			/** @description Use JiliHard provider (default: false, not ready yet) */
			jiliHard?: boolean
			/** @description Use HARDV2_PP provider (default: false) */
			ppHard?: boolean
			/** @description Use HARDV2_NOLIMITCITY provider (default: false) */
			nlcHard?: boolean
		}
		PromotionSelectorResponse: {
			id: string
			name: string
		}
		PromotionSelectorListResponse: {
			data: components['schemas']['PromotionSelectorResponse'][]
		}
		CreateNotificationDto: {
			/**
			 * @description The list of players to send the notification to
			 * @example [
			 *       "1",
			 *       "2",
			 *       "3"
			 *     ]
			 */
			playerIds?: string[]
			/**
			 * @description The title of the notification
			 * @example System Maintenance
			 */
			title: string
			/**
			 * @description The content of the notification
			 * @example The system will be under maintenance from 2:00 AM to 4:00 AM
			 */
			content: string
			/**
			 * @description URL of the notification image
			 * @example https://example.com/images/notification.jpg
			 */
			imageUrl?: string
			/**
			 * Format: date-time
			 * @description When the notification should start being shown
			 * @example 2025-03-20T00:00:00Z
			 */
			startAt: string
			/**
			 * Format: date-time
			 * @description When the notification should stop being shown
			 * @example 2025-03-25T00:00:00Z
			 */
			endAt?: string
			/**
			 * @description Whether the notification is active
			 * @default true
			 */
			isActive: boolean
		}
		/**
		 * @description Facebook Standard Event name
		 * @enum {string}
		 */
		FacebookStandardEvents: FacebookStandardEvents
		/**
		 * @description Customer segmentation
		 * @enum {string}
		 */
		CustomerSegmentation: CustomerSegmentation
		CreateConversionDto: {
			eventName: components['schemas']['FacebookStandardEvents']
			/** @description Unique event ID for deduplication */
			eventId?: string
			/** @description Unix timestamp in seconds */
			eventTime?: number
			/** @description User email address */
			userEmail?: string
			/** @description User phone number */
			userPhone?: string
			/** @description User first name */
			firstName?: string
			/** @description User last name */
			lastName?: string
			/** @description User city */
			city?: string
			/** @description User state/province */
			state?: string
			/** @description User zip/postal code */
			zipCode?: string
			/** @description Country code (ISO 3166-1 alpha-2, e.g., TH, US) */
			country?: string
			/** @description Date of birth in YYYYMMDD format */
			dateOfBirth?: string
			/** @description Gender (f for female, m for male) */
			gender?: string
			/** @description External user ID from your system */
			externalId?: string
			/** @description Client user ID */
			clientUserId?: string
			/** @description Subscription ID */
			subscriptionId?: string
			/** @description Lead ID from CRM */
			leadId?: string
			/** @description Facebook browser ID (_fbp cookie) */
			fbp?: string
			/** @description Facebook click ID (_fbc cookie or fbclid URL param) */
			fbc?: string
			/** @description URL where the event occurred */
			eventSourceUrl?: string
			/** @description User agent string */
			userAgent?: string
			/** @description Client IP address */
			clientIpAddress?: string
			/** @description HTTP referrer URL */
			referrerUrl?: string
			/** @description Action source (website, app, etc.) */
			actionSource?: string
			/** @description User opted out of tracking */
			optOut?: boolean
			/** @description Data processing options for CCPA compliance */
			dataProcessingOptions?: string[]
			/** @description Data processing options country (1 for USA, 0 for other) */
			dataProcessingOptionsCountry?: number
			/** @description Data processing options state (1000 for California) */
			dataProcessingOptionsState?: number
			customerSegmentation?: components['schemas']['CustomerSegmentation']
			/** @description Custom event data */
			customData?: components['schemas']['CustomDataDto']
		}
		/** @enum {string} */
		LuckyWheelPresetType: LuckyWheelPresetType
		AdminLuckyWheelImagePresetResponse: {
			id: string
			name: string
			url: string
			type: components['schemas']['LuckyWheelPresetType']
		}
		AdminLuckyWheelImagePresetsResponse: {
			presets: components['schemas']['AdminLuckyWheelImagePresetResponse'][]
		}
		/** @enum {string} */
		LuckyWheelConstraintType: LuckyWheelConstraintType
		LuckyWheelConstraintModel: {
			id: string
			constraintType: components['schemas']['LuckyWheelConstraintType']
			amount: number
			luckyWheelSettingId: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		/**
		 * @description The type of the wheel
		 * @enum {string}
		 */
		LuckyWheelRewardType: LuckyWheelRewardType
		SettingModel: {
			id: string
			title: string
			probability: number
			type: components['schemas']['LuckyWheelRewardType']
			amount: number
			color: string
			presetId?: string
			gameId?: string
			betAmount?: number
		}
		LuckyWheelSettingResponse: {
			id: string
			claimConstraint: components['schemas']['LuckyWheelConstraintModel'][]
			wheelSetting: components['schemas']['SettingModel'][]
			wheelUrl?: string
			arrowWheelUrl?: string
			showImageOnWheel: boolean
			isActive: boolean
			/** Format: date-time */
			expiredIn: string
			turnoverRound: number
			walletCondition?: components['schemas']['WalletConditionResponse']
			/** @default false */
			requireConnectedLine: boolean
			presetId?: string
			gameId?: string
			betAmount?: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		WalletConditionPoolPresetConfigModel: {
			name: string
			description: string
			rewardSize: number
			savingSize: number
			rewardRatio: number
			order?: number
		}
		WalletConditionPresetConfigModel: {
			/** @enum {string} */
			thresholdType?: WalletConditionPresetConfigModelThresholdType
			turnoverThreshold?: number
			turnoverMultiplier?: number
			presetId?: string
			presetNumber?: number
			order?: number
		}
		CreateWalletConditionDto: {
			minimumWithdrawCredit?: number
			maximumWithdrawCredit?: number
			turnoverRound?: number
			usePool?: boolean
			gameTypes?: components['schemas']['GameType'][]
			whitelistGameProviders?: string[]
			presetId?: string
			presetNumber?: number
			/** @description Use PGHard provider (default: true) */
			pgHard?: boolean
			/** @description Use JokerHard provider (default: false, not ready yet) */
			jokerHard?: boolean
			/** @description Use JiliHard provider (default: false, not ready yet) */
			jiliHard?: boolean
			/** @description Use HARDV2_PP provider (default: false) */
			ppHard?: boolean
			/** @description Use HARDV2_NOLIMITCITY provider (default: false) */
			nlcHard?: boolean
			poolPresetConfigs?: components['schemas']['WalletConditionPoolPresetConfigModel'][]
			presetConfigs?: components['schemas']['WalletConditionPresetConfigModel'][]
		}
		UpdateLuckyWheelSettingDto: {
			isActive?: boolean
			/** Format: date-time */
			expiredIn?: string
			turnoverRound?: number
			claimConstraint?: components['schemas']['LuckyWheelConstraintModel'][]
			wheelSetting?: components['schemas']['SettingModel'][]
			clearQuota?: boolean
			wheelUrl?: string
			arrowWheelUrl?: string
			showImageOnWheel?: boolean
			walletCondition?: components['schemas']['CreateWalletConditionDto']
			requireConnectedLine?: boolean
		}
		LuckyWheelModel: {
			/**
			 * @description The color of the wheel
			 * @example #000000
			 */
			color: string
			/**
			 * @description The title of the wheel
			 * @example 1000
			 */
			title: string
			/**
			 * @description The amount of the wheel
			 * @example 1000
			 */
			amount: number
			/** @example CREDIT */
			type: components['schemas']['LuckyWheelRewardType']
			/** @description Game ID for FREE_SPIN reward type */
			gameId?: string
			/** @description Preset ID for FREE_SPIN reward type */
			presetId?: string
			/** @description Bet amount for FREE_SPIN reward type */
			betAmount?: number
		}
		LuckyWheelSpinResponse: {
			/** @description The lucky wheel spin result of the player */
			luckyWheelSpinResult: components['schemas']['LuckyWheelModel']
			/** @description Free spin game URL (only for FREE_SPIN rewards) */
			freeSpinUrl?: string
		}
		ActiveWithdrawBankSummaryResponse: {
			displayName: string
			bankProviderName: string
		}
		PaymentGatewayChannelCountsResponse: {
			qr: number
			transfer: number
			trueMoney: number
			withdrawBank: number
			p2p: number
			/** @description Payment gateway marked as withdrawal account for QR/Transfer (WITHDRAW_BANK), if any */
			activeWithdrawBank?:
				| components['schemas']['ActiveWithdrawBankSummaryResponse']
				| null
		}
		PaymentGatewayResponse: {
			id: string
			displayName: string
			bankProviderName: string
			order: number
			paymentGatewayId: string
			paymentGatewaySecretKey: string
			paymentGatewayPrivateKey: string
			paymentGatewayClientId: string
			paymentGatewayApiKey: string
			paymentGatewayAccountNumber?: string
			paymentGatewayAccountName?: string
			paymentGatewayProviderName?: string
			balance: number
			senderName: string
			deviceId: string
			pin: string
			privateKey: string
			isValidated: boolean
			isActive?: boolean
			isWithdrawalAccount?: boolean
			isChannelQr?: boolean
			isChannelTransfer?: boolean
			isChannelTrueMoney?: boolean
			isChannelCrypto?: boolean
			isChannelP2P?: boolean
			isActiveQr?: boolean
			isActiveTransfer?: boolean
			isActiveTrueMoney?: boolean
			isActiveCrypto?: boolean
			isActiveP2P?: boolean
			isWithdrawalAccountQrTransfer?: boolean
			isWithdrawalAccountTrueMoney?: boolean
			isWithdrawalAccountCrypto?: boolean
			isWithdrawalAccountP2P?: boolean
			minDepositAmount?: number
			maxDepositAmount?: number
			/** Format: date-time */
			maintenanceDepositStartAt?: string | null
			/** Format: date-time */
			maintenanceDepositEndAt?: string | null
			/** Format: date-time */
			maintenanceWithdrawStartAt?: string | null
			/** Format: date-time */
			maintenanceWithdrawEndAt?: string | null
			/** @description Enable slip upload for SMS_AUTO accounts */
			enableUploadSlip?: boolean
			/** @description Seconds after deposit creation before slip upload is allowed */
			uploadSlipDelaySeconds?: number
			/** @description Whether this payment gateway is a P2P provider */
			isP2p?: boolean
			/** @description P2P amount step gap */
			p2pStep?: number | null
			/** @description P2P suggestion threshold percentage */
			p2pThreshold?: number | null
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		PaginatedPaymentGatewayResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PaymentGatewayResponse'][]
		}
		PaymentGatewayProviderModel: {
			id: string
			name: string
			imageUrl: string
			createdAt: string
			updatedAt: string
		}
		PaymentGatewayConstraintsResponse: {
			/**
			 * @description Global maximum deposit amount (applies to all gateways)
			 * @example 50000
			 */
			globalMaxDeposit: number
			/**
			 * @description Minimum deposit amounts per provider
			 * @example {
			 *       "GOALPAY": 50,
			 *       "WELLPAY": 50,
			 *       "TRUE_WALLET": 50,
			 *       "DEFAULT": 50
			 *     }
			 */
			providerMinDeposits: {
				[key: string]: number
			}
			/**
			 * @description Default minimum deposit for unknown providers
			 * @example 50
			 */
			defaultMinDeposit: number
		}
		ProviderMaintenanceItemResponse: {
			id: string
			bankProviderId: string
			bankProviderName: string
			/** @enum {string} */
			type: ProviderMaintenanceItemResponseType
			/** Format: date-time */
			startAt: string
			endAt?: Record<string, never> | null
			isRejected: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ProviderMaintenanceListResponse: {
			data: components['schemas']['ProviderMaintenanceItemResponse'][]
		}
		MaintenanceTimeRangeRequest: {
			/** @description Start time (ISO 8601) */
			startAt: string
			/** @description End time (ISO 8601). Omit for indefinite */
			endAt?: string
		}
		CreateMaintenanceRequest: {
			/** @description Payment provider name (e.g. SCB, FLASHPAY) */
			bankProviderName: string
			depositMaintenance?: components['schemas']['MaintenanceTimeRangeRequest']
			withdrawMaintenance?: components['schemas']['MaintenanceTimeRangeRequest']
		}
		CreateMaintenanceResponse: {
			deposit?: Record<string, never>
			withdraw?: Record<string, never>
		}
		PaymentGatewayTransactionStats: {
			/** @description Total amount of successful transactions */
			totalAmount: number
			/** @description Total number of successful transactions */
			totalCount: number
			/** @description Total number of all transactions (any status) */
			totalAllCount: number
			/** @description Total number of failed/canceled/expired transactions */
			failedCount: number
			/** @description Success rate as a percentage (0-100) */
			successRate: number
			/** @description Failure rate as a percentage (0-100) */
			failRate: number
			/** @description Average amount per successful transaction */
			avgAmount: number
			/** @description Maximum single transaction amount */
			maxAmount: number
			/** @description Minimum single transaction amount (successful only) */
			minAmount: number
			/** @description Average processing time in seconds (created_at to updated_at), successful only */
			avgProcessingTimeSec: number
			/** @description Median processing time in seconds */
			medianProcessingTimeSec: number
			/** @description Total fee amount collected */
			totalFeeAmount: number
		}
		PaymentGatewayHourlyBucket: {
			/** @description Hour of day (0-23) */
			hour: number
			/** @description Number of successful transactions in this hour */
			count: number
			/** @description Total amount in this hour */
			amount: number
		}
		PaymentGatewayAnalyticsItem: {
			/** @description Payment gateway ID */
			id: string
			/** @description Display name */
			displayName: string
			/** @description Provider name */
			bankProviderName: string
			deposit: components['schemas']['PaymentGatewayTransactionStats']
			withdrawal: components['schemas']['PaymentGatewayTransactionStats']
			/** @description Deposit volume by hour of day (0-23) */
			depositHourlyDistribution: components['schemas']['PaymentGatewayHourlyBucket'][]
			/** @description Withdrawal volume by hour of day (0-23) */
			withdrawalHourlyDistribution: components['schemas']['PaymentGatewayHourlyBucket'][]
		}
		PaymentGatewayAnalyticsResponse: {
			data: components['schemas']['PaymentGatewayAnalyticsItem'][]
			/** @description Start date used for the query */
			startDate: string
			/** @description End date used for the query */
			endDate: string
		}
		CreatePaymentGatewayRequest: {
			bankProviderName: string
			displayName: string
			paymentGatewayId: string
			paymentGatewaySecretKey: string
			paymentGatewayPrivateKey: string
			paymentGatewayClientId: string
			paymentGatewayApiKey: string
			paymentGatewayAccountNumber?: string
			paymentGatewayAccountName?: string
			paymentGatewayProviderName?: string
			channels?: CreatePaymentGatewayRequestChannels[]
			senderName?: string
			deviceId?: string
			pin?: string
			minDepositAmount?: number
			maxDepositAmount?: number
			/** @description Enable slip upload for SMS_AUTO accounts */
			enableUploadSlip?: boolean
			/** @description P2P amount step gap (e.g. 50 = amounts must be multiples of 50) */
			p2pStep?: number
			/** @description Whether this payment gateway is a P2P provider */
			isP2p?: boolean
			/** @description P2P suggestion threshold % (e.g. 50 = suggest up to 50% above entered) */
			p2pThreshold?: number
			/** @description Delay in seconds before slip upload is allowed (SMS_AUTO etc.) */
			uploadSlipDelaySeconds?: number
		}
		UpdatePaymentGatewayRequest: {
			bankProviderName?: string
			displayName?: string
			paymentGatewayId?: string
			paymentGatewaySecretKey?: string
			paymentGatewayPrivateKey?: string
			paymentGatewayClientId?: string
			paymentGatewayApiKey?: string
			paymentGatewayAccountNumber?: string
			paymentGatewayAccountName?: string
			paymentGatewayProviderName?: string
			channels?: UpdatePaymentGatewayRequestChannels[]
			senderName?: string
			deviceId?: string
			pin?: string
			minDepositAmount?: number
			maxDepositAmount?: number
			/** @description Enable slip upload for SMS_AUTO accounts */
			enableUploadSlip?: boolean
			/** @description P2P amount step gap (e.g. 50 = amounts must be multiples of 50) */
			p2pStep?: number
			/** @description Whether this payment gateway is a P2P provider */
			isP2p?: boolean
			/** @description P2P suggestion threshold % (e.g. 50 = suggest up to 50% above entered) */
			p2pThreshold?: number
			/** @description Delay in seconds before slip upload is allowed (SMS_AUTO etc.) */
			uploadSlipDelaySeconds?: number
			id: string
			/** @description Single channel key for reorder / per-channel toggles (QR, TRANSFER, …) */
			channel?: string
			isActive?: boolean
			isWithdrawalAccount?: boolean
			isDeleted?: boolean
			/** @description Display order / reorder value */
			order?: number
		}
		TelegramNotifySettingResponse: {
			/** @description Setting ID */
			id: string
			/** @description Master toggle for telegram notifications */
			isEnabled: boolean
			/** @description Telegram chat/channel ID for regular notifications */
			chatId: Record<string, never> | null
			/** @description Telegram chat/channel ID for high priority notifications */
			highPriorityChatId: Record<string, never> | null
			/** @description Enable analytics cron notifications */
			enableAnalyticsCron: boolean
			/** @description Enable withdraw approval notifications */
			enableWithdrawApproval: boolean
			/** @description Enable deposit complete notifications */
			enableDepositComplete: boolean
			/** @description Enable withdraw complete notifications */
			enableWithdrawComplete: boolean
			/** @description Enable deposit failed notifications */
			enableDepositFailed: boolean
			/** @description Enable withdraw failed notifications */
			enableWithdrawFailed: boolean
			/** @description Enable big win notifications */
			enableBigWin: boolean
			/** @description Enable TrueMoney no match notifications */
			enableTrueMoneyNoMatch: boolean
			/** @description Enable crypto invoice notifications */
			enableCryptoInvoice: boolean
			/** @description Enable transaction expired notifications */
			enableTransactionExpired: boolean
			/** @description Big win threshold amount */
			bigWinThreshold: number
			/**
			 * Format: date-time
			 * @description Created at timestamp
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated at timestamp
			 */
			updatedAt: string
		}
		UpdateTelegramNotifySettingDto: {
			/** @description Telegram chat/channel ID for regular notifications */
			chatId?: string
			/** @description Telegram chat/channel ID for high priority notifications */
			highPriorityChatId?: string
			/** @description Enable analytics cron notifications */
			enableAnalyticsCron?: boolean
			/** @description Enable withdraw approval notifications */
			enableWithdrawApproval?: boolean
			/** @description Enable deposit complete notifications */
			enableDepositComplete?: boolean
			/** @description Enable withdraw complete notifications */
			enableWithdrawComplete?: boolean
			/** @description Enable deposit failed notifications */
			enableDepositFailed?: boolean
			/** @description Enable withdraw failed notifications */
			enableWithdrawFailed?: boolean
			/** @description Enable big win notifications */
			enableBigWin?: boolean
			/** @description Enable TrueMoney no match notifications */
			enableTrueMoneyNoMatch?: boolean
			/** @description Enable crypto invoice notifications */
			enableCryptoInvoice?: boolean
			/** @description Enable transaction expired notifications */
			enableTransactionExpired?: boolean
			/** @description Enable new user registration notifications */
			enableNewUserRegister?: boolean
			/** @description Big win threshold amount */
			bigWinThreshold?: number
		}
		PlayerTagResponse: {
			id: string
			name: string
			color: string
			/** @description Minimum deposit amount for auto-tagging (null if manual tag) */
			minDepositAmount?: number | null
			/** @description Net profit threshold for house (deposit - withdraw) */
			depositGtWithdraw?: number | null
			/** @description Preset ID for PGHARD provider (overrides game/promotion preset) */
			presetId?: string | null
			/** @description Preset number (RTP) for non-PGHARD providers (overrides game/promotion preset) */
			presetNumber?: number | null
			/** @description Number of players with this tag */
			playerCount: number
			/** Format: date-time */
			createdAt: string
		}
		TagStatisticsResponse: {
			totalTags: number
			totalAutoTags: number
			totalManualTags: number
			totalPlayersWithTags: number
			topTags: components['schemas']['PlayerTagResponse'][]
		}
		CreatePlayerTagDto: {
			/**
			 * @description Tag name
			 * @example VIP 50K+
			 */
			name: string
			/**
			 * @description Tag color (hex)
			 * @default #6B7280
			 * @example #FFD700
			 */
			color: string
			/**
			 * @description Minimum deposit amount for auto-tagging. If set, players with total deposits >= this amount will automatically receive this tag.
			 * @example 50000
			 */
			minDepositAmount?: number
			/**
			 * @description Net profit threshold for house. Auto-tag players where (totalDeposit - totalWithdraw) >= this amount. Example: 5000 means house profit of 5000+
			 * @example 5000
			 */
			depositGtWithdraw?: number | null
			/**
			 * @description Preset ID for PGHARD provider. When set, all players with this tag will use this preset for PGHARD games. This overrides game/promotion presets.
			 * @example preset-id-123
			 */
			presetId?: string | null
			/**
			 * @description Preset number (RTP) for non-PGHARD providers. When set, all players with this tag will use this preset number for games. This overrides game/promotion presets.
			 * @example 95
			 */
			presetNumber?: number | null
		}
		UpdatePlayerTagDto: {
			/** @description Tag name */
			name?: string
			/** @description Tag color (hex) */
			color?: string
			/**
			 * @description Minimum deposit amount for auto-tagging. Set to null to disable auto-tagging.
			 * @example 50000
			 */
			minDepositAmount?: number | null
			/**
			 * @description Net profit threshold for house. Auto-tag when (deposit - withdraw) >= this amount. Set to null to disable.
			 * @example 5000
			 */
			depositGtWithdraw?: number | null
			/**
			 * @description Preset ID for PGHARD provider. Set to null to remove preset override.
			 * @example preset-id-123
			 */
			presetId?: string | null
			/**
			 * @description Preset number (RTP) for non-PGHARD providers. Set to null to remove preset override.
			 * @example 95
			 */
			presetNumber?: number | null
		}
		PlayerWithTagsModel: {
			id: string
			phone: string
			/** @description Total deposit amount (all time) */
			totalDepositAmount: number
			/** @description Player tags */
			tags: components['schemas']['PlayerTagResponse'][]
		}
		GetPlayersByTagResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerWithTagsModel'][]
		}
		AssignTagsToPlayersDto: {
			/** @description Player IDs */
			playerIds: string[]
			/** @description Tag IDs to assign */
			tagIds: string[]
		}
		RemoveTagsFromPlayersDto: {
			/** @description Player IDs */
			playerIds: string[]
			/** @description Tag IDs to remove */
			tagIds: string[]
		}
		TrackSingleDto: {
			/** @description Event name (e.g., page_view, deposit_created) */
			event_name: string
			/**
			 * @default client
			 * @enum {string}
			 */
			event_source: TrackSingleDtoEvent_source
			/** @description Unique event ID (UUID v4) */
			event_id: string
			/** @description ISO 8601 timestamp */
			occurred_at: string
			/** @description Site identifier */
			site_id: string
			/** @description Environment */
			environment?: string
			/** @description Authenticated user ID */
			user_id?: string
			/** @description Anonymous session-based ID */
			anonymous_id: string
			/** @description Session ID */
			session_id: string
			/** @description User agent string */
			user_agent?: string
			/** @enum {string} */
			device_type?: TrackSingleDtoDevice_type
			is_line_client?: boolean
			utm_source?: string
			utm_medium?: string
			utm_campaign?: string
			utm_content?: string
			utm_term?: string
			referral_code?: string
			channel_code?: string
			landing_page?: string
			referrer?: string
			/** @description Event-specific properties */
			properties?: Record<string, never>
		}
		TrackingResponse: {
			ok: boolean
			count?: number
		}
		TrackingEventDto: {
			/** @description Event name (e.g., page_view, deposit_created) */
			event_name: string
			/**
			 * @default client
			 * @enum {string}
			 */
			event_source: TrackingEventDtoEvent_source
			/** @description Unique event ID (UUID v4) */
			event_id: string
			/** @description ISO 8601 timestamp */
			occurred_at: string
			/** @description Site identifier */
			site_id: string
			/** @description Environment */
			environment?: string
			/** @description Authenticated user ID */
			user_id?: string
			/** @description Anonymous session-based ID */
			anonymous_id: string
			/** @description Session ID */
			session_id: string
			/** @description User agent string */
			user_agent?: string
			/** @enum {string} */
			device_type?: TrackingEventDtoDevice_type
			is_line_client?: boolean
			utm_source?: string
			utm_medium?: string
			utm_campaign?: string
			utm_content?: string
			utm_term?: string
			referral_code?: string
			channel_code?: string
			landing_page?: string
			referrer?: string
			/** @description Event-specific properties */
			properties?: Record<string, never>
		}
		TrackBatchDto: {
			events: components['schemas']['TrackingEventDto'][]
		}
		PlayerCommissionResponse: {
			/** @description Credit ratio configuration for each game type */
			creditRatio: {
				[key: string]: {
					creditRatio?: number
					maxCreditAmount?: number | null
				}
			}
			/** @description Total commission amount for the current month */
			totalAmount: number
			/** @description Commission amounts for each game type this month */
			gameTypeAmounts: {
				[key: string]: number
			}
			/** @description Number of turnover rounds required */
			turnoverRound: number
			/** @description Whether the commission is active */
			isActive: boolean
			/** @description Commission multiplier (e.g., 2.0 for 2x). Null if no multiplier configured. */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date of multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date of multiplier period
			 */
			multiplierEndDate?: string
			/** @description Whether the multiplier is currently active */
			isMultiplierActive: boolean
		}
		CreateCommissionCashbackDto: {
			name: string
			banner?: string
			shortDescription?: string
			description?: string
			isActive: boolean
			turnoverRound: number
			creditRatio: {
				[
					key: string
				]: components['schemas']['CommissionCashbackCreditRatioModel']
			}
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Commission multiplier (e.g., 2.0 for 2x, 1.5 for 1.5x). Applies to all game types.
			 * @example 2
			 */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date for multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date for multiplier period
			 */
			multiplierEndDate?: string
			rankIds?: string[]
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		CommissionCashbackCreditRatioModel: {
			creditRatio: number
			maxCreditAmount?: number
		}
		CommissionCashbackResponse: {
			id: string
			banner?: string
			name: string
			shortDescription?: string
			description?: string
			isActive: boolean
			turnoverRound: number
			creditRatio: {
				[
					key: string
				]: components['schemas']['CommissionCashbackCreditRatioModel']
			}
			totalAmount?: number
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			walletCondition?: components['schemas']['WalletConditionResponse']
			/** @description Commission multiplier for all game types (e.g., 2.0 for 2x) */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date for multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date for multiplier period
			 */
			multiplierEndDate?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CommissionCashbackResponseWithoutWalletCondition: {
			id: string
			banner?: string
			name: string
			shortDescription?: string
			description?: string
			isActive: boolean
			turnoverRound: number
			creditRatio: {
				[
					key: string
				]: components['schemas']['CommissionCashbackCreditRatioModel']
			}
			totalAmount?: number
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/** @description Commission multiplier for all game types (e.g., 2.0 for 2x) */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date for multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date for multiplier period
			 */
			multiplierEndDate?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CommissionCashbacksResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['CommissionCashbackResponseWithoutWalletCondition'][]
		}
		UpdateCommissionCashbackDto: {
			name?: string
			banner?: string
			shortDescription?: string
			description?: string
			isActive?: boolean
			turnoverRound?: number
			gameTypes?: components['schemas']['GameType'][]
			creditRatio?: {
				[
					key: string
				]: components['schemas']['CommissionCashbackCreditRatioModel']
			}
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/**
			 * @description Commission multiplier (e.g., 2.0 for 2x, 1.5 for 1.5x). Applies to all game types.
			 * @example 2
			 */
			multiplier?: number
			/**
			 * Format: date-time
			 * @description Start date for multiplier period
			 */
			multiplierStartDate?: string
			/**
			 * Format: date-time
			 * @description End date for multiplier period
			 */
			multiplierEndDate?: string
			rankIds?: string[]
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		CommissionCashbackSelectorResponse: {
			id: string
			name: string
		}
		CommissionCashbackSelectorListResponse: {
			data: components['schemas']['CommissionCashbackSelectorResponse'][]
		}
		/** @enum {string} */
		CheckInRewardType: CheckInRewardType
		CheckInSettingModel: {
			id: string
			dailyCheckInSettingId: string
			day: number
			rewardType: components['schemas']['CheckInRewardType']
			amount: number
			minimumTurnoverAmount: number
			minimumDepositAmount: number
			gameId?: string | null
			presetId?: string | null
			betAmount?: number | null
			isCheckedIn?: boolean | null
		}
		DailyCheckInResponse: {
			day: number
			missingDeposit: number
			missingTurnover: number
			/** @description Whether the daily check-in is active */
			isActive: boolean
			/** @description Whether LINE connection is required for daily check-in */
			requireConnectedLine: boolean
			/** @description Whether the player needs to connect LINE to check in */
			requiresLineConnection: boolean
			/** Format: date-time */
			endDate: string
			checkInSetting: components['schemas']['CheckInSettingModel'][]
		}
		CheckInDto: {
			/** @description URL to return to after free spin game session */
			hrefBackUrl?: string
			/** @description Whether to launch in desktop mode */
			isDesktop?: boolean
		}
		CheckInResponse: {
			id: string
			playerId: string
			isDeleted: boolean
			type: components['schemas']['WalletType']
			balance: number
			turnoverAmount?: number
			promotionId?: string
			promotion?: string | null
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** @description Free spin URL if reward type is FREE_SPIN */
			freeSpinUrl?: string
		}
		CreateDailyCheckInSettingDto: {
			rankIds?: string[]
			name: string
			isActive: boolean
			/** @description จำนวนวันเช็คอิน (1-25) */
			days: number
			checkInSetting?: components['schemas']['CheckInSettingModel'][]
			turnoverRound: number
			walletCondition?: components['schemas']['CreateWalletConditionDto']
			requireConnectedLine?: boolean
		}
		DailyCheckInSettingResponse: {
			id: string
			days: number
			name: string
			checkInSetting: components['schemas']['CheckInSettingModel'][]
			isActive: boolean
			turnoverRound: number
			walletCondition?: components['schemas']['WalletConditionResponse']
			/** @default false */
			requireConnectedLine: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DailyCheckInSettingResponseWithoutWalletCondition: {
			id: string
			days: number
			name: string
			checkInSetting: components['schemas']['CheckInSettingModel'][]
			isActive: boolean
			turnoverRound: number
			/** @default false */
			requireConnectedLine: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DailyCheckInSettingsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DailyCheckInSettingResponseWithoutWalletCondition'][]
		}
		UpdateDailyCheckInSettingDto: {
			name?: string
			rankId?: string
			isActive?: boolean
			/** @description จำนวนวันเช็คอิน (1-25) */
			days?: number
			checkInSetting?: components['schemas']['CheckInSettingModel'][]
			turnoverRound?: number
			walletCondition?: components['schemas']['CreateWalletConditionDto']
			requireConnectedLine?: boolean
		}
		DailyCheckInSelectorResponse: {
			id: string
			name: string
		}
		DailyCheckInSelectorListResponse: {
			data: components['schemas']['DailyCheckInSelectorResponse'][]
		}
		LaunchGameDto: {
			/** @description Game ID */
			gameId: string
			/** @description Whether to launch in desktop mode */
			isDesktop: boolean
			clientIp?: string
			/** @description URL to return to after game session */
			hrefBackUrl: string
			/** @description Winning probability preset ID (direct preset) */
			presetId?: string
			/** @description Winning probability preset number (direct preset) */
			presetNumber?: number
			/** @description Message reference ID (from hot game flex message, used to lookup preset securely) */
			messageRef?: string
			/** @description Message item ID (for randomized hot game items, used to lookup preset config at init time) */
			messageId?: string
			/** @description Client session ID for tracking (from frontend analytics) */
			sessionId?: string
		}
		/** @enum {string} */
		InitType: InitType
		/**
		 * @description The CSS of the game session
		 * @enum {string}
		 */
		GameRenderType: GameRenderType
		InitGameSessionResponse: {
			/**
			 * @description The URL of the game session
			 * @example https://example.com/game
			 */
			url: string
			initType: components['schemas']['InitType']
			/**
			 * @description The HTML of the game session
			 * @example game-1
			 */
			html: string
			/** @example game-1 */
			type: components['schemas']['GameRenderType']
		}
		GetGameListDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			type?: components['schemas']['GameType']
			providerId?: string
			providerIds?: string[]
			isPopular?: boolean
			isNew?: boolean
			name?: string
			displayName?: string
			allowOnly?: boolean
			/**
			 * @description Include hard provider games (PGHARD, JILIHARD, JOKERHARD)
			 * @default true
			 */
			includeHardProviders: boolean
		}
		PlayerGameModel: {
			id: string
			name: string
			displayName?: string
			code: string
			imageUrl: string
			type: components['schemas']['GameType']
			isActive: boolean
			isPopular: boolean
			isNew: boolean
			tag?: string
			order?: number
			providerId?: string
			providerName?: string
			providerBannerGameUrl?: string
			isAllowed: boolean
			/** @description Whether this game is eligible for player active tournament */
			isEligibleForTournament?: boolean
		}
		GameListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['GameModel'][]
			providers?: components['schemas']['GameProviderModel'][]
		}
		PlayerGameProviderModel: {
			id: string
			name: string
			displayName?: string
			logoUrl: string
			isActive: boolean
			order: number
			providerBannerGameUrl?: string
			isNew: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** @description Whether this provider is eligible for player active tournament */
			isEligibleForTournament?: boolean
		}
		PlayerGameProviderListResponse: {
			data: components['schemas']['PlayerGameProviderModel'][]
		}
		GameProviderWithBannerModel: {
			id: string
			providerId: string
			name: string
			displayName?: string
			logoUrl: string
			isActive: boolean
			order: number
			providerBannerGameUrl?: string
			isNew: boolean
			isPopular: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			defaultPreset?: string
			defaultPresetNumber?: number
			/** @description Provider-specific banner for the requested game type */
			bannerUrl: string
			/** @description Whether this provider is eligible for player active tournament */
			isEligibleForTournament?: boolean
		}
		GameProviderWithBannerListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['GameProviderWithBannerModel'][]
		}
		GameTypeModel: {
			id: string
			name: string
			isActive: boolean
			bannerUrl: string
			title: string
			subtitle: string
			order: number
		}
		GameTypeListResponse: {
			data: components['schemas']['GameTypeModel'][]
		}
		/** @enum {string} */
		DynamicSectionType: DynamicSectionType
		GameInfo: {
			id: string
			name: string
			code: string
			type: string
			thumbnailUrl: string
			flagUrl: string
		}
		OperatorRoundResultInfo: {
			id: string
			poyType: string
			poyDisplayNumber: string
			poyNumber: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		OperatorRoundWithGameAndResults: {
			id: string
			gameId: string
			status: string
			/** Format: date-time */
			endDate: string
			game: components['schemas']['GameInfo']
			operatorRoundResults: components['schemas']['OperatorRoundResultInfo'][]
			/** @description Map of PoyType to winning number */
			result: {
				[key: string]: string
			}
		}
		GetPoyResultAllGameResponse: {
			thaiGovernment?: components['schemas']['OperatorRoundWithGameAndResults']
			government: components['schemas']['OperatorRoundWithGameAndResults'][]
			bank: components['schemas']['OperatorRoundWithGameAndResults'][]
			stock: components['schemas']['OperatorRoundWithGameAndResults'][]
			yeekee: components['schemas']['OperatorRoundWithGameAndResults'][]
		}
		PlayerLottoAnnouncementSectionModel: {
			id: string
			gameId: string
			game: components['schemas']['PlayerGameModel']
			data: components['schemas']['GetPoyResultAllGameResponse']
		}
		PlayerGameListSectionModel: {
			id: string
			title: string
			link?: string
			data: components['schemas']['GameListResponse']
		}
		LeaderboardItemModel: {
			rank: number
			/** @description Masked phone number (e.g., 082XXXX624) */
			phone: string
			/** @description Game display name */
			gameName: string
			/** @description Game image URL */
			gameImage: string
			/** @description Game ID */
			gameId: Record<string, never> | null
			/** @description Winning amount based on transferOut */
			amount: number
			/** @description Whether the game is allowed for the player based on promotion constraints */
			isAllowed: boolean
		}
		PlayerLeaderboardSectionModel: {
			id: string
			title: string
			leaderboardType: string
			limit: number
			uiType: string
			data: components['schemas']['LeaderboardItemModel'][]
		}
		PlayerGameSuggestionSectionModel: {
			id: string
			title: string
			limit: number
			/** @description Suggested games with full game details including images */
			games: components['schemas']['PlayerGameModel'][]
		}
		PlayerDynamicSectionModel: {
			id: string
			type: components['schemas']['DynamicSectionType']
			lottoAnnouncementSection?: components['schemas']['PlayerLottoAnnouncementSectionModel']
			gameListSection?: components['schemas']['PlayerGameListSectionModel']
			leaderboardSection?: components['schemas']['PlayerLeaderboardSectionModel']
			gameSuggestionSection?: components['schemas']['PlayerGameSuggestionSectionModel']
		}
		PlayerDynamicSectionListResponse: {
			data: components['schemas']['PlayerDynamicSectionModel'][]
		}
		CommissionCashbackInfo: {
			id: string
			name: string
			shortDescription?: string | null
			/** @description Commission cashback percentage by game type */
			creditRatio: Record<string, never>
			/** @description Game types eligible for commission cashback */
			gameTypes: string[]
			/** @description Turnover round requirement */
			turnoverRound: number
		}
		DailyCheckInSettingInfo: {
			id: string
			name: string
			days: number
			turnoverRound: number
		}
		ReturnLossInfo: {
			id: string
			name: string
			shortDescription?: string | null
			/** @description Return loss percentage by game type */
			creditRatio: Record<string, never>
			/** @description Game types eligible for return loss */
			gameTypes: string[]
			/** @description Turnover round requirement */
			turnoverRound: number
			/** @description Minimum loss amount required */
			minimumLossAmount: number
		}
		RankInfoResponse: {
			id: string
			name: string
			order: number
			rankProtectionDeposit: number
			rankProtectionTurnover: number
			limitWithdrawCredit: number
			limitWithdrawFrequency: number
			maxExperiencePoints: number
			frameUrl: string
			commissionCashback?: components['schemas']['CommissionCashbackInfo']
			dailyCheckInSetting?: components['schemas']['DailyCheckInSettingInfo']
			returnLoss?: components['schemas']['ReturnLossInfo']
			description?: string
			isCurrentRank: boolean
		}
		CurrentRankInfo: {
			name: string
			bannerUrl?: string | null
			frameUrl?: string | null
		}
		ProtectionRankInfo: {
			depositRemaining: number
			turnoverRemaining: number
			rankProtectedDepositAmount: number
			rankProtectedTurnoverAmount: number
		}
		NextRankInfo: {
			name: string
			banner?: string | null
			frame?: string | null
			remainingDeposit: number
			remainingTurnover: number
			deposit: number
			turnover: number
		}
		PromoteRankResponse: {
			currentRank: components['schemas']['CurrentRankInfo']
			currentDeposit: number
			currentTurnover: number
			protectionRank: components['schemas']['ProtectionRankInfo']
			nextRank?: components['schemas']['NextRankInfo'] | null
		}
		RankExperienceResponse: {
			rank: components['schemas']['RankInfoResponse']
			experiencePoints: number
			maxExperiencePoints: number
			totalTurnover: number
			totalDeposit: number
			totalWithdraw: number
			totalWin: number
			totalLose: number
		}
		RankExperienceRateResponse: {
			depositPoint: number
			turnoverPoint: number
			withdrawPoint: number
			promotionTurnoverPoint: number
		}
		PendingFreeSpinResponse: {
			id: string
			rankName: string
			gameId: string
			gameName: string
			betAmount: number
			presetId?: string
			/** Format: date-time */
			createdAt: string
		}
		ClaimFreeSpinDto: {
			/** @description URL to return to after game session */
			hrefBackUrl: string
			/** @description Whether to launch in desktop mode */
			isDesktop?: boolean
		}
		ClaimFreeSpinResponse: {
			url: string
		}
		LoginAnnouncementModel: {
			id: string
			title: string
			content: string
			image: string
			isActive: boolean
			order: number
			link?: string
			linkText?: string
			targetPaths: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		LoginAnnouncementResponse: {
			data: components['schemas']['LoginAnnouncementModel'][]
		}
		CreateLoginAnnouncementDto: {
			title: string
			content?: string
			image?: string
			isActive: boolean
			link?: string
			linkText?: string
			order?: number
			targetPaths?: string[]
		}
		UpdateLoginAnnouncementDto: {
			title?: string
			content?: string
			image?: string
			isActive?: boolean
			link?: string
			linkText?: string
			order?: number
			targetPaths?: string[]
		}
		AdminMinimumWithdrawSettingModel: {
			id: string
			minimumWithdrawForWalletType: string[]
		}
		/** @enum {string} */
		CarouselItemSize: CarouselItemSize
		GeneralSettingModel: {
			id: string
			isOtpEnabled: boolean
			isRegisterEnabled: boolean
			isSkipBankEnabled: boolean
			displayAllPromotion: boolean
			initType: components['schemas']['InitType']
			minimumDepositAmount: number
			minimumWithdrawalAmount: number
			minimumEasyClearTurnover: number
			manualApprovalWithdrawThreshold: number
			/**
			 * @description Withdrawal multiplier for approval (e.g., 2x means if last deposit is 100, withdrawing >= 200 requires approval). Set to 0 to disable.
			 * @example 2
			 */
			manualApprovalWithdrawMultiplier: number
			minimumWithdrawSetting: components['schemas']['AdminMinimumWithdrawSettingModel']
			lineUrl: string
			telegramUrl: string
			uniqueBankName: boolean
			carouselItemSize: components['schemas']['CarouselItemSize']
			/**
			 * @description Quick deposit button amounts
			 * @example [
			 *       10,
			 *       20,
			 *       50,
			 *       100,
			 *       500
			 *     ]
			 */
			quickDepositButtons: number[]
			/**
			 * @description Hidden bank provider codes that will not be shown to players (e.g., bank codes with leading zeros)
			 * @example [
			 *       "025",
			 *       "006",
			 *       "000"
			 *     ]
			 */
			hiddenBankProviderCodes: string[]
			hideClearTurnoverButton: boolean
			/** @description Skip payment gateway and use fallback bank for deposits (default: false) */
			useFallbackBank: boolean
			/** @description When enabled, player sees deposit channel choice (QR, Transfer, etc.) on deposit (default: false) */
			enableDepositChannelChoice: boolean
			/**
			 * @description Channel fallback priority order (e.g. ["QR","TRANSFER","P2P"]). Default: ["QR","TRANSFER","P2P"].
			 * @example [
			 *       "QR",
			 *       "TRANSFER",
			 *       "P2P"
			 *     ]
			 */
			channelPriority: string[]
			/** @description When true = ถอนออโต้ (auto withdraw bank). When false = ถอนแมนวล (manual withdraw). Default: true. */
			useAutoWithdrawBank: boolean
			/** @description Use PGHard for main wallet (default: true) */
			mainWalletPgHard: boolean
			/** @description Use JokerHard for main wallet (default: false) */
			mainWalletJokerHard: boolean
			/** @description Use JiliHard for main wallet (default: false) */
			mainWalletJiliHard: boolean
			/** @description Use HARDV2_PP for main wallet (default: false) */
			mainWalletPpHard: boolean
			/** @description Use HARDV2_NOLIMITCITY for main wallet (default: false) */
			mainWalletNlcHard: boolean
			/** @description Default to PGHard for guests/no context (default: true) */
			defaultPgHard: boolean
			/** @description Default to JokerHard for guests/no context (default: false) */
			defaultJokerHard: boolean
			/** @description Default to JiliHard for guests/no context (default: false) */
			defaultJiliHard: boolean
			/** @description Default to HARDV2_PP for guests/no context (default: false) */
			defaultPpHard: boolean
			/** @description Default to HARDV2_NOLIMITCITY for guests/no context (default: false) */
			defaultNlcHard: boolean
			/** @description Client domain for channel links */
			clientDomain: string
			/** @description Send LINE flex message to users when deposit completes (default: true) */
			sendDepositLineFlexMessage: boolean
			/** @description Send LINE flex message to users when withdraw completes (default: true) */
			sendWithdrawLineFlexMessage: boolean
			/** @description Monthly platform fee (USD) */
			monthlyPlatformFee: number
			/**
			 * @description Days of grace period for crypto invoice payment (0 = no blocking/unlimited time, >0 = days of grace before blocking)
			 * @example 3
			 */
			cryptoInvoiceGraceDays: number
			/** @description Enable phone number masking in admin panel (default: true) */
			enableMaskPhone: boolean
			/** @description Theme mode: dark or light */
			themeMode: string
			/** @description Active theme preset ID */
			themePreset?: string
			/** @description Show gradient drop shadow effects in player frontend (default: true) */
			showDropShadow: boolean
			/**
			 * @description Custom Google Fonts family name (e.g., "Kanit", "Noto Sans Thai"). Null means use default font.
			 * @example Kanit
			 */
			fontFamily?: string
			/**
			 * @description Computed Google Fonts CSS URL from fontFamily. Null if no custom font set.
			 * @example https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;600;700&display=swap
			 */
			fontUrl?: string
			/** @description Maximum login attempts before 1-hour lockout (0 = disabled, no limit, default: 5) */
			maxLoginAttempts: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateGeneralSettingDto: {
			initType?: components['schemas']['InitType']
			isOtpEnabled?: boolean
			isRegisterEnabled?: boolean
			/** @description When true, players may skip adding a bank account at registration */
			isSkipBankEnabled?: boolean
			displayAllPromotion?: boolean
			minimumDepositAmount?: number
			minimumWithdrawalAmount?: number
			minimumEasyClearTurnover?: number
			manualApprovalWithdrawThreshold?: number
			/**
			 * @description Withdrawal multiplier for approval (e.g., 2x means if last deposit is 100, withdrawing >= 200 requires approval). Set to 0 to disable.
			 * @example 2
			 */
			manualApprovalWithdrawMultiplier?: number
			minimumTransferAmount?: number
			lineUrl?: string
			telegramUrl?: string
			uniqueBankName?: boolean
			carouselItemSize?: components['schemas']['CarouselItemSize']
			/**
			 * @description Quick deposit button amounts (e.g., [10, 20, 50, 100, 500])
			 * @example [
			 *       10,
			 *       20,
			 *       50,
			 *       100,
			 *       500
			 *     ]
			 */
			quickDepositButtons?: number[]
			/**
			 * @description Hidden bank provider codes that will not be shown to players (e.g., bank codes with leading zeros)
			 * @example [
			 *       "025",
			 *       "006",
			 *       "000"
			 *     ]
			 */
			hiddenBankProviderCodes?: string[]
			/** @description Skip payment gateway and use fallback bank for deposits */
			useFallbackBank?: boolean
			/** @description When enabled, player sees deposit channel choice (QR, Transfer, etc.) on deposit */
			enableDepositChannelChoice?: boolean
			/**
			 * @description Channel fallback priority order
			 * @example [
			 *       "QR",
			 *       "TRANSFER",
			 *       "P2P"
			 *     ]
			 */
			channelPriority?: string[]
			/** @description When true = ถอนออโต้ (use auto withdraw bank). When false = ถอนแมนวล (manual withdraw). */
			useAutoWithdrawBank?: boolean
			hideClearTurnoverButton?: boolean
			/** @description Use PGHard for main wallet (default: true) */
			mainWalletPgHard?: boolean
			/** @description Use JokerHard for main wallet (default: false, not ready yet) */
			mainWalletJokerHard?: boolean
			/** @description Use JiliHard for main wallet (default: false, not ready yet) */
			mainWalletJiliHard?: boolean
			/** @description Use HARDV2_PP for main wallet (default: false) */
			mainWalletPpHard?: boolean
			/** @description Use HARDV2_NOLIMITCITY for main wallet (default: false) */
			mainWalletNlcHard?: boolean
			/** @description Default to PGHard for guests/no context (default: true) */
			defaultPgHard?: boolean
			/** @description Default to JokerHard for guests/no context (default: false, not ready yet) */
			defaultJokerHard?: boolean
			/** @description Default to JiliHard for guests/no context (default: false, not ready yet) */
			defaultJiliHard?: boolean
			/** @description Default to HARDV2_PP for guests/no context (default: false) */
			defaultPpHard?: boolean
			/** @description Default to HARDV2_NOLIMITCITY for guests/no context (default: false) */
			defaultNlcHard?: boolean
			/** @description Client domain for channel links */
			clientDomain?: string
			/** @description Send LINE flex message to users when deposit completes (default: true) */
			sendDepositLineFlexMessage?: boolean
			/** @description Send LINE flex message to users when withdraw completes (default: true) */
			sendWithdrawLineFlexMessage?: boolean
			/** @description Enable phone number masking in admin panel */
			enableMaskPhone?: boolean
			/**
			 * @description Days of grace period for crypto invoice payment (0 = no blocking/unlimited time, >0 = days of grace before blocking)
			 * @example 3
			 */
			cryptoInvoiceGraceDays?: number
			/** @description Theme mode: dark or light */
			themeMode?: string
			/** @description Active theme preset ID (null for custom CSS) */
			themePreset?: string
			/**
			 * @description Custom Google Fonts family name (e.g., "Kanit", "Noto Sans Thai"). Leave empty or null for default font.
			 * @example Kanit
			 */
			fontFamily?: string | null
			/** @description Show gradient drop shadow effects in player frontend (default: true) */
			showDropShadow?: boolean
			/**
			 * @description Maximum login attempts before 1-hour lockout (0 = disabled, no limit)
			 * @example 5
			 */
			maxLoginAttempts?: number
		}
		ThemePresetModel: {
			id: string
			name: string
			/** @description dark or light */
			themeMode: string
			thumbnailUrl: string
		}
		ThemePresetListResponse: {
			data: components['schemas']['ThemePresetModel'][]
		}
		ApplyThemePresetDto: {
			/** @description Theme preset ID to apply */
			presetId: string
		}
		GameTypeSettingModel: {
			id: string
			type: components['schemas']['GameType']
			order: number
			imageUrl: string
			gameCount: number
			isActive: boolean
			description: string
		}
		GameTypeSettingResponse: {
			data: components['schemas']['GameTypeSettingModel'][]
		}
		UpdateGameTypeSettingDto: {
			imageUrl?: string
			gameCount?: number
			order?: number
			description?: string
			isActive?: boolean
		}
		/** @enum {string} */
		GameListSectionType: GameListSectionType
		GameProviderModel: {
			id: string
			name: string
			displayName?: string
			logoUrl: string
			isActive: boolean
			order: number
			providerBannerGameUrl?: string
			isNew: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			gameTypes?: components['schemas']['GameProviderGameTypeModel'][]
			defaultPreset?: string
			defaultPresetNumber?: number
		}
		GameListSectionModel: {
			id: string
			title: string
			link?: string
			gameType?: components['schemas']['GameType']
			gameListType: components['schemas']['GameListSectionType']
			gameIds: string[]
			filterProviders?: components['schemas']['GameProviderModel'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DynamicSectionGameModel: {
			id: string
			name: string
			displayName?: string
			imageUrl: string
			type: components['schemas']['GameType']
		}
		LottoAnnouncementSectionModel: {
			id: string
			gameId: string
			game: components['schemas']['DynamicSectionGameModel']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		/** @enum {string} */
		LeaderboardSectionType: LeaderboardSectionType
		LeaderboardDataModel: {
			rank: number
			/** @description Masked phone number (e.g., 082XXXX624) */
			phone: string
			/** @description Game display name */
			gameName: string
			/** @description Game image URL */
			gameImage: string
			/** @description Game ID */
			gameId: Record<string, never> | null
			/** @description Amount (win/deposit/withdrawal) */
			amount: number
			/** @description Whether the game is allowed for the player based on promotion constraints */
			isAllowed: boolean
		}
		/** @enum {string} */
		LeaderboardUIType: LeaderboardUIType
		LeaderboardSectionModel: {
			id: string
			title: string
			leaderboardType: components['schemas']['LeaderboardSectionType']
			limit: number
			data?: components['schemas']['LeaderboardDataModel'][]
			uiType: components['schemas']['LeaderboardUIType']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GameSuggestionSectionModel: {
			id: string
			title: string
			limit: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		FootballMatchesSectionModel: {
			id: string
			title: string
			gameId: string | null
			showLive: boolean
			showUpcoming: boolean
			showFinished: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DynamicSectionModel: {
			id: string
			name: string
			type: components['schemas']['DynamicSectionType']
			gameListSection?: components['schemas']['GameListSectionModel']
			lottoAnnouncementSection?: components['schemas']['LottoAnnouncementSectionModel']
			leaderboardSection?: components['schemas']['LeaderboardSectionModel']
			gameSuggestionSection?: components['schemas']['GameSuggestionSectionModel']
			footballMatchesSection?: components['schemas']['FootballMatchesSectionModel']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DynamicSectionResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DynamicSectionModel'][]
		}
		CreateGameListSectionDto: {
			title: string
			link?: string
			gameType?: components['schemas']['GameType']
			gameListType: components['schemas']['GameListSectionType']
			filterProviderIds?: string[]
			gameIds?: string[]
		}
		CreateLottoAnnouncementSectionDto: Record<string, never>
		CreateLeaderboardSectionDto: {
			title: string
			leaderboardType: components['schemas']['LeaderboardSectionType']
			/** @default 5 */
			limit: number
			uiType?: components['schemas']['LeaderboardUIType']
		}
		CreateGameSuggestionSectionDto: {
			title: string
			/** @default 10 */
			limit: number
		}
		CreateFootballMatchesSectionDto: {
			title: string
			gameId?: string
			/** @default true */
			showLive?: boolean
			/** @default true */
			showUpcoming?: boolean
			/** @default false */
			showFinished?: boolean
		}
		CreateDynamicSectionDto: {
			name: string
			type: components['schemas']['DynamicSectionType']
			gameListSection?: components['schemas']['CreateGameListSectionDto']
			lottoAnnouncementSection?: components['schemas']['CreateLottoAnnouncementSectionDto']
			leaderboardSection?: components['schemas']['CreateLeaderboardSectionDto']
			gameSuggestionSection?: components['schemas']['CreateGameSuggestionSectionDto']
			footballMatchesSection?: components['schemas']['CreateFootballMatchesSectionDto']
		}
		UpdateDynamicSectionDto: {
			name?: string
			type?: components['schemas']['DynamicSectionType']
			gameListSection?: components['schemas']['CreateGameListSectionDto']
			lottoAnnouncementSection?: components['schemas']['CreateLottoAnnouncementSectionDto']
			leaderboardSection?: components['schemas']['CreateLeaderboardSectionDto']
			gameSuggestionSection?: components['schemas']['CreateGameSuggestionSectionDto']
			footballMatchesSection?: components['schemas']['CreateFootballMatchesSectionDto']
		}
		UpdateDynamicSectionOrderDto: {
			order: number
		}
		DynamicPageListModel: {
			id: string
			name: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DynamicPageResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DynamicPageListModel'][]
		}
		DynamicPageSectionModel: {
			id: string
			dynamicPageId?: Record<string, never>
			dynamicSectionId?: Record<string, never>
			dynamicSection?: components['schemas']['DynamicSectionModel']
			isActive: boolean
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		DynamicPageModel: {
			id: string
			name: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			dynamicPageSections?: components['schemas']['DynamicPageSectionModel'][]
			total: number
			take: number
			skip: number
		}
		CreateDynamicPageDto: {
			name: string
			isActive?: boolean
		}
		UpdateDynamicPageDto: {
			name?: string
			isActive?: boolean
		}
		DynamicPagePresetSectionModel: {
			name: string
			type: components['schemas']['DynamicSectionType']
			order: number
		}
		DynamicPagePresetModel: {
			id: string
			name: string
			thumbnailUrl?: string
			sections: components['schemas']['DynamicPagePresetSectionModel'][]
		}
		DynamicPagePresetListResponse: {
			data: components['schemas']['DynamicPagePresetModel'][]
		}
		MainWalletSettingResponse: {
			/** @description Main wallet setting ID */
			id: string
			/** @description Is condition enabled */
			isConditionEnabled: boolean
			/** @description Wallet condition ID */
			walletConditionId?: Record<string, never>
			/** @description Allow event transfers */
			allowEventTransfer?: boolean
			/**
			 * @description Auto clear turnover balance threshold
			 * @default 1
			 */
			autoClearTurnBalanceThreshold: number
			/** @description Wallet condition details */
			walletCondition?: Record<string, never>
		}
		UpdateMainWalletSettingDto: {
			/**
			 * @description Enable or disable main wallet conditions
			 * @example true
			 */
			isConditionEnabled?: boolean
			/**
			 * @description Wallet condition ID to apply to main wallet (deprecated, use walletCondition instead)
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			walletConditionId?: string
			/**
			 * @description Allow event wallet transfers when main wallet has conditions
			 * @example false
			 */
			allowEventTransfer?: boolean
			/** @description Wallet condition to create or update */
			walletCondition?: components['schemas']['CreateWalletConditionDto']
			/**
			 * @description Auto clear turnover balance threshold
			 * @example 1000
			 */
			autoClearTurnBalanceThreshold?: number
		}
		TemporaryDisableInfo: {
			/** @description Whether temporary disable is active */
			isActive: boolean
			/** @description When the temporary disable expires (ISO datetime) */
			expiresAt?: string
		}
		TransactionScheduleResponse: {
			/** @description Schedule ID */
			id: string
			/**
			 * @description Start time of inactive period (HH:mm format)
			 * @example 01:00
			 */
			inactiveStartAt: string
			/**
			 * @description End time of inactive period (HH:mm format)
			 * @example 02:00
			 */
			inactiveEndAt: string
			/** @description Whether the schedule is active */
			isActive: boolean
			/**
			 * Format: date-time
			 * @description Created date
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 */
			updatedAt: string
		}
		TransactionTypeStatusResponse: {
			/** @description Whether transactions are currently disabled */
			isDisabled: boolean
			/** @description Temporary disable information */
			temporaryDisable: components['schemas']['TemporaryDisableInfo']
			/** @description All schedules for this transaction type */
			schedules: components['schemas']['TransactionScheduleResponse'][]
			/** @description Currently active schedule if any */
			currentActiveSchedule?: components['schemas']['TransactionScheduleResponse']
		}
		TransactionScheduleListResponse: {
			/** @description List of schedules */
			data: components['schemas']['TransactionScheduleResponse'][]
		}
		CreateTransactionScheduleDto: {
			/**
			 * @description Start time of inactive period (HH:mm format in UTC)
			 * @example 01:00
			 */
			inactiveStartAt: string
			/**
			 * @description End time of inactive period (HH:mm format in UTC)
			 * @example 02:00
			 */
			inactiveEndAt: string
			/**
			 * @description Whether the schedule is active
			 * @example true
			 */
			isActive?: boolean
		}
		UpdateTransactionScheduleDto: {
			/**
			 * @description Start time of inactive period (HH:mm format in UTC)
			 * @example 01:00
			 */
			inactiveStartAt?: string
			/**
			 * @description End time of inactive period (HH:mm format in UTC)
			 * @example 02:00
			 */
			inactiveEndAt?: string
			/**
			 * @description Whether the schedule is active
			 * @example true
			 */
			isActive?: boolean
		}
		SetTemporaryDisableDto: {
			/**
			 * @description Duration in minutes to disable transactions
			 * @example 60
			 */
			durationMinutes: number
		}
		SetTemporaryDisableResponse: {
			/** @description Whether the operation was successful */
			success: boolean
			/** @description When the temporary disable expires (ISO datetime) */
			expiresAt: string
		}
		ClearTemporaryDisableResponse: {
			/** @description Whether the operation was successful */
			success: boolean
		}
		InviteFriendGameTypeTransactionCumulative: {
			gameType: components['schemas']['GameType']
			income: number
		}
		InviteFriendReturnLossGameTypeTransactionCumulative: {
			gameType: components['schemas']['GameType']
			income: number
		}
		GetInviteFriendAnalyticsCumulativeResponse: {
			totalClickCount: number
			totalSignupCount: number
			totalActiveCount: number
			totalTurnoverCommission: number
			totalSignupCommission: number
			totalFirstDepositCommission: number
			totalReturnLossCommission: number
			totalDepositCommission: number
			inviteFriendGameTypeTransactionCumulatives: components['schemas']['InviteFriendGameTypeTransactionCumulative'][]
			inviteFriendReturnLossGameTypeTransactionCumulatives: components['schemas']['InviteFriendReturnLossGameTypeTransactionCumulative'][]
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate: string
		}
		InviteFriendFirstDeposit: {
			minimumAmount: number
			creditType: components['schemas']['CreditType']
			creditAmount?: number
			creditRatio?: number
			maxCreditAmount?: number
			isRequirePromotion: boolean
		}
		InviteFriendDepositCommissionConfig: {
			isEnabled: boolean
			isRequirePromotion: boolean
			minimumAmount?: number
		}
		InviteFriendTier: {
			level: number
			rewards: {
				[key: string]: components['schemas']['RewardModel']
			}
			depositCommissionRatio?: number
			depositCommissionMaxAmount?: number
		}
		GetInviteFriendTiersResponse: {
			turnoverRound: number
			durationDays: number
			firstDeposit: components['schemas']['InviteFriendFirstDeposit']
			depositCommission: components['schemas']['InviteFriendDepositCommissionConfig']
			commissionTiers: components['schemas']['InviteFriendTier'][]
		}
		WalletTransferHistoryResponse: {
			total: number
			take: number
			skip: number
		}
		InviteFriendReturnLossResponseDto: {
			canReceiveReturnLoss: boolean
			totalReturnLossAmount: number
			totalCommissionAmount: number
			totalReturnLossByGameType: {
				[key: string]: number
			}
			commissionAmountByGameType: {
				[key: string]: number
			}
		}
		InviteFriendReturnLossInfoResponse: {
			isEnabled: boolean
			minimumLossAmount?: number
			calculateInterval?: components['schemas']['CalculateInterval']
			/** Format: date-time */
			nextCalculateAt?: string
			commissionTiers: components['schemas']['InviteFriendTier'][]
		}
		InviteFriendTierCount: {
			tier: number
			count: number
		}
		GetInviteFriendTierCountsResponse: {
			tierCounts: components['schemas']['InviteFriendTierCount'][]
		}
		PartnerGameTypeTransactionCumulative: {
			gameType: components['schemas']['GameType']
			income: number
		}
		GetPartnerAnalyticsCumulativeResponse: {
			/** @description Total number of referral link clicks */
			totalClickCount: number
			/** @description Total number of signups through referral links */
			totalSignupCount: number
			/** @description Total number of active referred players */
			totalActiveCount: number
			/** @description Total commission earned from turnover */
			totalTurnoverCommission: number
			/** @description Total commission earned from profit */
			totalProfitCommission: number
			partnerGameTypeTransactionCumulatives: components['schemas']['PartnerGameTypeTransactionCumulative'][]
			/**
			 * Format: date-time
			 * @description Start date of the analytics period
			 */
			startDate?: string
			/**
			 * Format: date-time
			 * @description End date of the analytics period
			 */
			endDate: string
		}
		GetReferredPlayersResponse: {
			total: number
			take: number
			skip: number
		}
		MonthlyPlayerDataModel: {
			playerId: string
			username?: string
			phone: string
			/** Format: date-time */
			createdAt: string
			/** @description Actual money deposited by user */
			depositAmount: number
			/** @description Bonus credit added by system */
			depositBonusAmount: number
			totalWithdraw: number
			totalLoss: number
			/** @description Partner share from profit * percentage; profit = play log transferIn - transferOut - deposit bonus */
			partnerShare: number
		}
		MonthlyPlayersSummaryModel: {
			playerCount: number
			totalDepositAmount: number
			totalDepositBonusAmount: number
			totalWithdraw: number
			totalLoss: number
			totalPartnerShare: number
		}
		GetMonthlyPlayersResponse: {
			players: components['schemas']['MonthlyPlayerDataModel'][]
			summary: components['schemas']['MonthlyPlayersSummaryModel']
			/** @description Partner percentage */
			partnerPercentage: number
		}
		LuckyWheelInfo: {
			/**
			 * @description The id of the wheel
			 * @example 123
			 */
			id: string
			/**
			 * @description The wheel setting of the wheel
			 * @example []
			 */
			wheelSetting: string[]
			/**
			 * @description The is active of the wheel
			 * @example true
			 */
			isActive: boolean
			/**
			 * @description The turnover round of the wheel
			 * @example 10
			 */
			turnoverRound: number
			/** @description The wheel background image URL */
			wheelUrl?: string
			/** @description The arrow wheel image URL */
			arrowWheelUrl?: string
			/**
			 * @description Whether to show images on the wheel segments
			 * @example false
			 */
			showImageOnWheel: boolean
			/** @description The constraints for earning quota */
			constraints: components['schemas']['LuckyWheelConstraintModel'][]
			/**
			 * @description Whether LINE connection is required to spin the wheel
			 * @example false
			 */
			requireConnectedLine: boolean
		}
		LuckyWheelQuota: {
			/**
			 * @description The id of the player
			 * @example 123
			 */
			id: string
			/**
			 * @description The amount of the wheel
			 * @example 1000
			 */
			amount: number
		}
		LuckyWheelResponse: {
			/** @description The wheel setting of the wheel */
			wheelSetting: components['schemas']['LuckyWheelInfo']
			/** @description The lucky wheel quota of the player */
			luckyWheelQuota: components['schemas']['LuckyWheelQuota']
			/** @description Whether the player needs to connect LINE to spin the wheel */
			requiresLineConnection: boolean
		}
		SpinWheelDto: {
			/** @description URL to return to after game session */
			hrefBackUrl: string
			/** @description Whether to launch in desktop mode */
			isDesktop: boolean
		}
		TransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/** @example DEPOSIT */
			type: components['schemas']['TransactionType']
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Transaction amount
			 * @example 1000.5
			 */
			amount: number
			/** @example COMPLETED */
			status: components['schemas']['DepositStatus']
			/** @example AUTO */
			processor: components['schemas']['TransactionProcessor']
			/**
			 * @description Bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankId: string | null
			/**
			 * Format: date-time
			 * @description Transaction creation date
			 * @example 2024-03-14T12:00:00Z
			 */
			createdAt: string | null
			/**
			 * Format: date-time
			 * @description Transaction last update date
			 * @example 2024-03-14T12:00:00Z
			 */
			updatedAt: string | null
		}
		PaginatedTransactionResponse: {
			/** @description Array of transactions */
			data: components['schemas']['TransactionResponse'][]
			/**
			 * @description Total number of records
			 * @example 100
			 */
			total: number
			/**
			 * @description Number of records to take
			 * @example 10
			 */
			take: number
			/**
			 * @description Number of records to skip
			 * @example 0
			 */
			skip: number
		}
		PlayHistorySessionGameResponse: {
			/** @description Game ID */
			gameId: string
			/** @description Game name */
			gameName: string
			/** @description Game image URL */
			gameImage?: string
			/** @description Provider name */
			providerName: string
			/** @description Total bet amount */
			totalBet: number
			/** @description Total payout amount */
			totalPayout: number
			/** @description Number of plays */
			playCount: number
			/**
			 * Format: date-time
			 * @description Last played date
			 */
			lastPlayedAt: string
			/** @description Last init session log ID for re-init */
			initSessionLogId?: string
		}
		PlayHistorySessionResponse: {
			/** @description Promotion session ID (null for main wallet) */
			promotionSessionId?: string
			/** @description Promotion name */
			promotionName?: string
			/**
			 * Format: date-time
			 * @description Earliest play log date in this session
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Latest play log date in this session
			 */
			lastPlayedAt: string
			/** @description Games played in this session */
			games: components['schemas']['PlayHistorySessionGameResponse'][]
		}
		GetPlayHistorySessionsResponse: {
			total: number
			take: number
			skip: number
			/** @description Session groups */
			sessions: components['schemas']['PlayHistorySessionResponse'][]
		}
		ReinitSessionDto: {
			/** @description Init session log ID to re-initialize */
			initSessionLogId: string
		}
		ReinitSessionResponse: {
			/** @description Game launch URL */
			url: string
			/** @description Game launch HTML */
			html?: string
			/** @description Init type */
			initType: string
			/** @description Response type */
			type: string
		}
		RankExperienceSettingModel: {
			id: string
			depositPoint: number
			turnoverPoint: number
			winPoint: number
			losePoint: number
			withdrawPoint: number
			promotionTurnoverPoint: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CreateRankDto: {
			name: string
			bannerUrl?: string
			frameUrl?: string
			limitWithdrawCredit: number
			limitWithdrawFrequency: number
			rankProtectionDeposit: number
			rankProtectionTurnover: number
			commissionCashbackId?: string
			returnLossId?: string
			dailyCheckInSettingId?: string
			maxExperiencePoints?: number
			description?: string
			allowRepeatRankUpRewards?: boolean
		}
		GetRankResponse: {
			id: string
			name: string
			rankProtectionDeposit: number
			rankProtectionTurnover: number
			bannerUrl?: string
			limitWithdrawCredit: number
			limitWithdrawFrequency: number
			commissionCashbackId?: string
			returnLossId?: string
			dailyCheckInSettingId?: string
			maxExperiencePoints: number
			description?: string
			allowRepeatRankUpRewards: boolean
			rankUpRewards?: components['schemas']['AdminRankUpRewardResponse'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateRankExperienceSettingDto: {
			/**
			 * @description Points awarded for deposit
			 * @example 1
			 */
			depositPoint: number
			/**
			 * @description Points awarded for turnover
			 * @example 1
			 */
			turnoverPoint: number
			/**
			 * @description Points awarded for winning
			 * @example 1
			 */
			winPoint: number
			/**
			 * @description Points awarded for losing
			 * @example 1
			 */
			losePoint: number
			/**
			 * @description Points awarded for withdrawing
			 * @example 1
			 */
			withdrawPoint: number
			/**
			 * @description Points awarded for promotion turnover
			 * @example 1
			 */
			promotionTurnoverPoint: number
		}
		RankNameModel: {
			id: string
			name: string
		}
		ReturnLossModel: {
			id: string
			name: string
		}
		CommissionCashbackModel: {
			id: string
			name: string
		}
		DailyCheckInSettingModel: {
			id: string
			name: string
		}
		RankListModel: {
			id: string
			name: string
			bannerUrl?: string
			rankProtectionDeposit: number
			rankProtectionTurnover: number
			limitWithdrawCredit: number
			limitWithdrawFrequency: number
			playerCount: number
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			returnLoss?: components['schemas']['ReturnLossModel']
			commissionCashback?: components['schemas']['CommissionCashbackModel']
			dailyCheckInSetting?: components['schemas']['DailyCheckInSettingModel']
			maxExperiencePoints?: number
			description?: string
			allowRepeatRankUpRewards: boolean
		}
		GetRanksResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['RankListModel'][]
		}
		UpdateRankDto: {
			name?: string
			bannerUrl?: string
			frameUrl?: string
			limitWithdrawCredit?: number
			limitWithdrawFrequency?: number
			rankProtectionDeposit?: number
			rankProtectionTurnover?: number
			commissionCashbackId?: string
			returnLossId?: string
			dailyCheckInSettingId?: string
			maxExperiencePoints?: number
			description?: string
			allowRepeatRankUpRewards?: boolean
			dailyCheckInId?: string
		}
		UpdateRankOrderDto: {
			from: number
			to: number
		}
		DeleteRankResponse: {
			/**
			 * @description Success message
			 * @example Rank deleted successfully
			 */
			message: string
			/**
			 * @description Number of players that were moved to another rank
			 * @example 5
			 */
			playersAffected: number
			/**
			 * @description Name of the deleted rank
			 * @example Gold
			 */
			deletedRank: string
			/**
			 * @description Name of the rank where players were moved to
			 * @example Silver
			 */
			targetRank: string
		}
		AdminRankUpRewardLineDto: {
			/** @enum {string} */
			type: AdminRankUpRewardLineDtoType
			amount: number
			luckyWheelSettingId?: string
			gameId?: string
			betAmount?: number
			presetId?: string
		}
		AdminUpdateRankUpRewardsDto: {
			rewards: components['schemas']['AdminRankUpRewardLineDto'][]
		}
		CreateReturnLossDto: {
			name: string
			shortDescription?: string
			description?: string
			isActive: boolean
			minimumLossAmount: number
			turnoverRound: number
			creditRatio: {
				[key: string]: components['schemas']['ReturnLossCreditRatioModel']
			}
			calculateInterval?: components['schemas']['CalculateInterval']
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			rankIds?: string[]
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		ReturnLossesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['ReturnLossResponse'][]
		}
		ReturnLossSelectorResponse: {
			id: string
			name: string
		}
		ReturnLossSelectorListResponse: {
			data: components['schemas']['ReturnLossSelectorResponse'][]
		}
		AdminDailyPlayerReturnLossResponse: {
			id: string
			playerId: string
			totalSlotLossAmount: number
			totalCasinoLossAmount: number
			totalLottoLossAmount: number
			totalSportLossAmount: number
			totalFishingLossAmount: number
			/** Format: date-time */
			returnLossRewardedAt?: string
			/** Format: date-time */
			inviteFriendReturnLossRewardedAt?: string
			/** Format: date-time */
			date: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			playerPhone: string
		}
		AdminDailyPlayerReturnLossListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminDailyPlayerReturnLossResponse'][]
		}
		AdminReturnLossHistoryResponse: {
			id: string
			playerId: string
			isReceived: boolean
			amount: number
			totalLossByGameType: Record<string, never>
			totalLossAmount: number
			balanceBefore: number
			balanceAfter: number
			status: string
			/** Format: date-time */
			expiredAt: string
			returnLossId: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			playerPhone: string
			returnLossName: string
		}
		AdminReturnLossHistoryListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminReturnLossHistoryResponse'][]
		}
		UpdateReturnLossDto: {
			name?: string
			shortDescription?: string
			minimumLossAmount?: number
			description?: string
			isActive?: boolean
			turnoverRound?: number
			gameTypes?: components['schemas']['GameType'][]
			creditRatio?: {
				[key: string]: components['schemas']['ReturnLossCreditRatioModel']
			}
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			rankIds?: string[]
			calculateInterval?: components['schemas']['CalculateInterval']
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		CarouselItemModel: {
			id: string
			image: string
			link?: string
			order: number
		}
		GetCarouselItemsResponse: {
			data: components['schemas']['CarouselItemModel'][]
		}
		CreateCarouselItemDto: {
			image: string
			link: string
		}
		UpdateCarouselItemDto: {
			id: string
			image?: string
			link?: string
			order?: number
		}
		ChannelCumulativeAnalytics: {
			/** @description Day after activation */
			dayAfterActivation: number
			/** @description Total deposit amount */
			totalDepositAmount: number
			/** @description Average deposit amount per player */
			totalDepositAmountAvg: number
			/** @description Total withdraw amount */
			totalWithdrawAmount: number
			/** @description Average withdraw amount per player */
			totalWithdrawAmountAvg: number
			/** @description Total deposit times */
			totalDepositTime: number
			/** @description Average deposit times per player */
			totalDepositTimeAvg: number
			/** @description Total withdraw times */
			totalWithdrawTime: number
			/** @description Average withdraw times per player */
			totalWithdrawTimeAvg: number
			/** @description Total player count */
			totalPlayerCount: number
			/** @description Total profit (deposit - withdraw) */
			totalProfit: number
			/** @description Average profit per player */
			totalProfitAvg: number
			/** @description Total active player count */
			totalActivePlayerCount: number
			/** @description Cost per player */
			costPerPlayer: number
			/** @description Cost per active player */
			costPerActivePlayer: number
			/** @description Channel cost minus total profit (cost - (deposit - withdraw)) */
			costMinusProfit: number
		}
		ChannelAnalyticsResponse: {
			/** @description Channel ID */
			id: string
			/** @description Channel name */
			name: string
			/** @description Channel cost */
			cost: number
			/** @description Channel note */
			note?: string
			/**
			 * Format: date-time
			 * @description Channel activation date
			 */
			activateAt?: string
			/** @description Channel active */
			isChannelActive: boolean
			/** @description Analytics data for different time periods */
			analytics: components['schemas']['ChannelCumulativeAnalytics'][]
		}
		ChannelAnalyticsListResponse: {
			total: number
			take: number
			skip: number
			/** @description Channel analytics data */
			data: components['schemas']['ChannelAnalyticsResponse'][]
		}
		OverallAnalyticsCumulativeResponse: {
			totalDepositAmount: number
			totalWithdrawAmount: number
			totalTurnoverAmount: number
			totalSettleAmount: number
			totalLossAmount: number
			totalBetAmount: number
			totalTransferIn: number
			totalTransferOut: number
			totalFirstDepositTime: number
			totalNewPlayer: number
			totalNewPlayerWithDeposit: number
			totalNewPlayerDepositAmount: number
			totalTurnoverCashback: number
			totalDepositBonusAmount: number
			totalReturnLossBonusReward: number
			totalLuckyWheelQuotaReward: number
			totalLuckyWheelBonusReward: number
			totalDailyCheckInReward: number
			totalInviteFriendReward: number
			totalInviteFriendRewardTransfer: number
			totalLuckyWheelRewardTransfer: number
			totalDailyCheckInRewardTransfer: number
			totalReturnLossBonusRewardTransfer: number
			totalPartnerRewardTransfer: number
			totalCommissionRewardTransfer: number
			totalEventCreditTransfer: number
			totalAdminWalletAdjustment: number
			totalAdminPartnerCredit: number
			totalDepositTime: number
			totalWithdrawTime: number
		}
		OverallAnalyticsAggregateResponse: {
			/** @description Total deposit fee amount */
			totalDepositFeeAmount: number
			/** @description Total deposit amount without promotion */
			totalDepositAmountWithoutPromotion: number
			totalDepositCountWithoutPromotion: number
			totalUnverifiedDepositAmount: number
			/** @description Total promotion bonus count */
			totalPromotionBonusCount: number
			/** @description Total withdraw fee amount */
			totalWithdrawFeeAmount: number
			/** @description Total failed withdraw amount */
			totalWithdrawFailedAmount: number
			/** @description Total failed withdraw transaction count */
			totalWithdrawFailedTime: number
			/** @description Total pending withdraw amount (in-range) */
			totalWithdrawPendingAmount: number
			/** @description Total pending withdraw transaction count (in-range) */
			totalWithdrawPendingTime: number
			/** @description Total players who received lucky wheel bonus reward */
			totalPlayerReceiveLuckyWheel: number
			/** @description Total players who received daily check-in reward */
			totalPlayerReceiveDailyCheckIn: number
			/** @description Total players who received return loss bonus reward */
			totalPlayerReceiveReturnLoss: number
			/** @description Total players who received invite friend rewards */
			totalPlayerReceiveInviteFriend: number
			/** @description Total players who transferred invite friend rewards to main wallet */
			totalPlayerReceiveInviteFriendRewardTransfer: number
			/** @description Total deposit time without promotion */
			totalDepositTimeWithoutPromotion: number
			/**
			 * Format: date-time
			 * @description Start date of analytics period
			 */
			startDate: string
			/**
			 * Format: date-time
			 * @description End date of analytics period
			 */
			endDate: string
			/** @description Total credit in main wallets (ready for withdraw) */
			totalMainWalletCredit: number
			/** @description Total main wallet count */
			totalMainWalletCount: number
			/** @description Total credit in promotion wallets */
			totalPromotionWalletCredit: number
			/** @description Total promotion wallet count */
			totalPromotionWalletCount: number
			/** @description Total credit in other wallets */
			totalOtherWalletCredit: number
			/** @description Total other wallet count */
			totalOtherWalletCount: number
			/** @description Total pending withdraw amount */
			totalPendingWithdrawAmount: number
			/** @description Total pending withdraw count */
			totalPendingWithdrawCount: number
			/** @description Total play count in period */
			totalPlayCount: number
			/** @description Total deposit count in period */
			totalDepositCount: number
			/** @description Total withdraw count in period */
			totalWithdrawCount: number
			/** @description Total free credit amount (admin giveaway + coupon redemptions) */
			totalManualFreeCreditAmount: number
			/** @description Total free credit count (admin giveaway + coupon redemptions) */
			totalManualFreeCreditTime: number
			/** @description Total manual deposit amount (actual deposits) */
			totalManualDepositAmount: number
			/** @description Total manual deposit count */
			totalManualDepositTime: number
		}
		OverallAnalyticsResponse: {
			/** @description Total deposit amount */
			totalDepositAmount: number
			/** @description Total deposit fee amount */
			totalDepositFeeAmount: number
			/** @description Total deposit amount without promotion */
			totalDepositAmountWithoutPromotion: number
			totalUnverifiedDepositAmount: number
			/** @description Total promotion bonus count */
			totalPromotionBonusCount: number
			/** @description Total withdraw amount */
			totalWithdrawAmount: number
			/** @description Total withdraw fee amount */
			totalWithdrawFeeAmount: number
			/** @description Total failed withdraw amount */
			totalWithdrawFailedAmount: number
			/** @description Total failed withdraw transaction count */
			totalWithdrawFailedTime: number
			/** @description Total pending withdraw amount */
			totalWithdrawPendingAmount: number
			/** @description Total pending withdraw transaction count */
			totalWithdrawPendingTime: number
			/** @description Total turnover amount */
			totalTurnoverAmount: number
			/** @description Total settle amount */
			totalSettleAmount: number
			/** @description Total loss amount */
			totalLossAmount: number
			/** @description Total bet amount */
			totalBetAmount: number
			/** @description Total transfer in amount */
			totalTransferIn: number
			/** @description Total transfer out amount */
			totalTransferOut: number
			/** @description Total first deposit time */
			totalFirstDepositTime: number
			/** @description Total turnover cashback */
			totalTurnoverCashback: number
			/** @description Total deposit bonus amount */
			totalDepositBonusAmount: number
			/** @description Total return loss bonus reward */
			totalReturnLossBonusReward: number
			/** @description Total lucky wheel quota reward */
			totalLuckyWheelQuotaReward: number
			/** @description Total lucky wheel bonus reward */
			totalLuckyWheelBonusReward: number
			/** @description Total daily check-in reward */
			totalDailyCheckInReward: number
			/** @description Total invite friend reward */
			totalInviteFriendReward: number
			/** @description Total invite friend reward transfers to main wallet */
			totalInviteFriendRewardTransfer: number
			/** @description Total players who received lucky wheel bonus reward */
			totalPlayerReceiveLuckyWheel: number
			/** @description Total players who received daily check-in reward */
			totalPlayerReceiveDailyCheckIn: number
			/** @description Total players who received return loss bonus reward */
			totalPlayerReceiveReturnLoss: number
			/** @description Total players who received invite friend rewards */
			totalPlayerReceiveInviteFriend: number
			/** @description Total players who transferred invite friend rewards to main wallet */
			totalPlayerReceiveInviteFriendRewardTransfer: number
			/** @description Total lucky wheel reward transfers to playable wallets */
			totalLuckyWheelRewardTransfer: number
			/** @description Total daily check-in reward transfers to playable wallets */
			totalDailyCheckInRewardTransfer: number
			/** @description Total return loss reward transfers to playable wallets */
			totalReturnLossBonusRewardTransfer: number
			/** @description Total partner reward transfers to playable wallets */
			totalPartnerRewardTransfer: number
			/** @description Total commission reward transfers to playable wallets */
			totalCommissionRewardTransfer: number
			/** @description Total event credit transferred to playable wallets (sum of all event wallet transfers) */
			totalEventCreditTransfer: number
			/** @description Net admin wallet balance adjustments (positive = added, negative = reduced) */
			totalAdminWalletAdjustment: number
			/** @description Total credits added to partner wallets by admin */
			totalAdminPartnerCredit: number
			/** @description Total deposit time */
			totalDepositTime: number
			/** @description Total deposit time without promotion */
			totalDepositTimeWithoutPromotion: number
			/** @description Total withdraw time */
			totalWithdrawTime: number
			/**
			 * Format: date-time
			 * @description Start date of analytics period
			 */
			startDate: string
			/**
			 * Format: date-time
			 * @description End date of analytics period
			 */
			endDate: string
			/** @description Total credit in main wallets (ready for withdraw) */
			totalMainWalletCredit: number
			/** @description Total main wallet count */
			totalMainWalletCount: number
			/** @description Total credit in other wallets */
			totalPromotionWalletCredit: number
			/** @description Total other wallet count */
			totalPromotionWalletCount: number
			/** @description Total credit in other wallets */
			totalOtherWalletCredit: number
			/** @description Total credit in other wallets */
			totalNewPlayer: number
			/** @description Total new players who made their first deposit */
			totalNewPlayerWithDeposit: number
			/** @description Total deposit amount from new players who registered on the same day */
			totalNewPlayerDepositAmount: number
			/** @description Total other wallet count */
			totalOtherWalletCount: number
			/** @description Total pending withdraw amount */
			totalPendingWithdrawAmount: number
			/** @description Total pending withdraw count */
			totalPendingWithdrawCount: number
			/** @description Total play count in period */
			totalPlayCount: number
			/** @description Total deposit count in period */
			totalDepositCount: number
			/** @description Total withdraw count in period */
			totalWithdrawCount: number
			/** @description Total deposit count without promotion */
			totalDepositCountWithoutPromotion: number
			/** @description Total free credit amount (admin giveaway + coupon redemptions) */
			totalManualFreeCreditAmount: number
			/** @description Total free credit count (admin giveaway + coupon redemptions) */
			totalManualFreeCreditTime: number
			/** @description Total manual deposit amount (actual deposits) */
			totalManualDepositAmount: number
			/** @description Total manual deposit count */
			totalManualDepositTime: number
		}
		GetOverallAnalyticsCsvDto: {
			/**
			 * @description Start date (YYYY-MM-DD)
			 * @example 2023-01-01
			 */
			startDate?: string
			/**
			 * @description End date (YYYY-MM-DD)
			 * @example 2023-01-31
			 */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example overall_analytics
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "totalDepositAmount": "Total Deposit Amount",
			 *       "totalWithdrawAmount": "Total Withdraw Amount",
			 *       "totalPlayCount": "Total Play Count"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		DepositWithdrawGraphData: {
			/**
			 * Format: date-time
			 * @description Date
			 */
			date: string
			/** @description Deposit amount */
			deposit: number
			/** @description Withdraw amount */
			withdraw: number
		}
		GetDepositWithdrawGraphResponse: {
			/** @description Deposit and withdraw data */
			data: components['schemas']['DepositWithdrawGraphData'][]
		}
		PlayerDepositWithdrawGraphData: {
			/** @description Player ID */
			playerId: string
			/** @description Masked player phone number */
			playerPhone: string
			/** @description Player deposit and withdraw graph data */
			graphData: components['schemas']['DepositWithdrawGraphData'][]
		}
		GetPlayerDepositWithdrawGraphResponse: {
			/** @description Player-specific deposit and withdraw graph data */
			data: components['schemas']['PlayerDepositWithdrawGraphData']
		}
		ProviderSummaryResponse: {
			providerId: string
			providerName: string
			commissionRate: number
			companyRate: number
			totalTurnOver: number
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalSuccessTransaction: number
			totalCommission: number
			totalCompany: number
		}
		TransactionSummaryResponse: {
			summaryByProvider: components['schemas']['ProviderSummaryResponse'][]
			totalTurnOver: number
			totalTransferIn: number
			totalTransferOut: number
			totalBetAmount: number
			totalSettleAmount: number
			totalSuccessTransaction: number
			totalCommission: number
			totalCompany: number
		}
		GetTransactionSummaryCsvDto: {
			/**
			 * @description Start date for transaction summary
			 * @example 2025-05-31T16:34:04.148Z
			 */
			startDate?: string
			/**
			 * @description End date for transaction summary
			 * @example 2025-05-31T16:34:04.148Z
			 */
			endDate?: string
			/**
			 * @description Filename for CSV export (without extension)
			 * @example transaction_summary
			 */
			filename?: string
			/**
			 * @description Custom column name mappings (key: column path, value: display name)
			 * @example {
			 *       "providerId": "Provider ID",
			 *       "providerName": "Provider Name",
			 *       "totalTurnOver": "Total Turnover",
			 *       "totalBetAmount": "Total Bet Amount"
			 *     }
			 */
			columnMappings?: {
				[key: string]: string
			}
		}
		PromotionAnalyticsItemResponse: {
			promotionId: string
			promotionName: string
			/** @description Whether promotion is for players */
			isForPlayer: boolean
			/** @description Whether promotion is a coupon */
			isCoupon: boolean
			/** @description Whether promotion is for guest players only */
			isForGuestOnly: boolean
			/**
			 * @description Charge type: NORMAL or FREE_CREDIT
			 * @enum {string}
			 */
			chargeType: PromotionAnalyticsItemResponseChargeType
			/** @description Unique players who received this promotion */
			playerCount: number
			/** @description Total times promotion was received (can be > playerCount) */
			totalReceiveTime: number
			/** @description Sum of deposit amounts tied to this promotion */
			totalDepositAmount: number
			/** @description Sum of transfers from promotion wallet to main wallet for this promotion */
			totalTransferAmount: number
			/** @description Balance remaining after turnover requirements were met */
			balanceAfterTurnoverFinish: number
			/** @description Sum of player turnover amount at the time of finishing turnover or clearing turnover in the selected range */
			playerTurnoverAmountAfterClearTurnover: number
			/** @description Number of unique players who finished turnover in the selected range */
			playerAmountFinishTurnover: number
			/** @description Total number of times turnover was finished/completed in the selected range */
			totalTimeFinishTurnover: number
		}
		PromotionAnalyticsListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PromotionAnalyticsItemResponse'][]
		}
		PromotionDetailPlayerItemResponse: {
			/** @description Promotion name */
			promotionName: string
			/** @description Masked player phone */
			phone?: string
			/** @description Player ID */
			playerId: string
			/** @description Total times player received this promotion in range */
			totalReceiveTime: number
			/** @description Total deposit amount tied to this promotion for player */
			totalDepositAmount: number
			/** @description Total transferred amount from promotion to main for player */
			totalTransferAmount: number
			/** @description Total balance after turnover finished across finishes */
			balanceAfterTurnoverFinish: number
			/** @description Sum of turnover at time of finish or clear in range */
			playerTurnoverAmountAfterClearTurnover: number
			/** @description Total number of times this player finished turnover in the selected range */
			totalTimeFinishTurnover: number
		}
		PromotionDetailAnalyticsListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PromotionDetailPlayerItemResponse'][]
		}
		/** @enum {string} */
		BucketSize: BucketSize
		TTFBDistributionBucket: {
			bucket: string
			count: number
			percentage: number
		}
		TTFBSummaryAverageTTFB: {
			milliseconds: number
			hours: number
			days: number
		}
		TTFBSummaryMedianTTFB: {
			milliseconds: number
			hours: number
			days: number
		}
		TTFBSummary: {
			totalPlayers: number
			playersWithBet: number
			playersWithoutBet: number
			conversionRate: number
			averageTTFB: components['schemas']['TTFBSummaryAverageTTFB']
			medianTTFB: components['schemas']['TTFBSummaryMedianTTFB']
		}
		TTFBDistributionResponse: {
			distribution: components['schemas']['TTFBDistributionBucket'][]
			summary: components['schemas']['TTFBSummary']
		}
		TTFDDistributionBucket: {
			bucket: string
			count: number
			percentage: number
		}
		TTFDSummaryAverageTTFD: {
			milliseconds: number
			hours: number
			days: number
		}
		TTFDSummaryMedianTTFD: {
			milliseconds: number
			hours: number
			days: number
		}
		TTFDSummary: {
			totalPlayers: number
			playersWithDeposit: number
			playersWithoutDeposit: number
			conversionRate: number
			averageTTFD: components['schemas']['TTFDSummaryAverageTTFD']
			medianTTFD: components['schemas']['TTFDSummaryMedianTTFD']
		}
		TTFDDistributionResponse: {
			distribution: components['schemas']['TTFDDistributionBucket'][]
			summary: components['schemas']['TTFDSummary']
		}
		/** @enum {string} */
		CohortType: CohortType
		CohortRetentionData: {
			cohort: string
			cohortSize: number
			retention: {
				[key: string]: number
			}
		}
		CohortRetentionSummary: {
			totalCohorts: number
			totalPlayers: number
			averageDay0Retention: number
			averageDay1Retention: number
			averageDay7Retention: number
			averageDay30Retention: number
		}
		CohortRetentionResponse: {
			heatmap: components['schemas']['CohortRetentionData'][]
			summary: components['schemas']['CohortRetentionSummary']
		}
		StickinessTrendData: {
			period: string
			dau: number
			wau?: number
			mau: number
			stickiness: number
			dauMauRatio: number
			dauWauRatio?: number
		}
		StickinessSummary: {
			averageStickiness: number
			maxStickiness: number
			minStickiness: number
			latestDAU: number
			latestMAU: number
			growthRate: number
		}
		StickinessTrendResponse: {
			trend: components['schemas']['StickinessTrendData'][]
			summary: components['schemas']['StickinessSummary']
		}
		PlayerSegment: {
			count: number
			percentage: number
		}
		PlayerSegments: {
			new: components['schemas']['PlayerSegment']
			activated: components['schemas']['PlayerSegment']
			deposited: components['schemas']['PlayerSegment']
			retained: components['schemas']['PlayerSegment']
			churned: components['schemas']['PlayerSegment']
			reactivated: components['schemas']['PlayerSegment']
		}
		PlayerFunnel: {
			signup: number
			firstBet: number
			firstDeposit: number
			multiDeposit: number
			retained: number
		}
		PlayerAverageMetrics: {
			ltv: number
			depositsPerPlayer: number
			avgFirstDepositAmount: number
		}
		PlayerLifecycleResponse: {
			segments: components['schemas']['PlayerSegments']
			funnel: components['schemas']['PlayerFunnel']
			averageMetrics: components['schemas']['PlayerAverageMetrics']
		}
		AdminPlayLogItemResponse: {
			id: string
			playerId: string
			/** @description Masked player phone */
			playerPhone?: string
			providerTransactionId: string
			agentId: string
			transactionId: string
			provider: string
			transferIn: number
			transferOut: number
			betAmount: number
			settleAmount: number
			turnover: number
			info: string
			walletId: string
			balanceBefore: number
			balanceAfter: number
			turnoverAfter?: number
			status: components['schemas']['PlayerPlayLogStatus']
			gameId?: string
			gameName?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminPlayLogsListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminPlayLogItemResponse'][]
		}
		OnlineUsersStatsResponse: {
			/** @description Total number of currently online users */
			totalOnlineUsers: number
			/**
			 * Format: date-time
			 * @description Timestamp when the stats were retrieved
			 */
			timestamp: string
		}
		LineQuotaResponse: {
			/** @description Whether the request was successful */
			success: boolean
			/** @description Quota type (e.g., "limited", "none") */
			type: string
			/** @description Quota value */
			value: number
		}
		LineConsumptionResponse: {
			/** @description Whether the request was successful */
			success: boolean
			/** @description Total usage of LINE message quota */
			totalUsage: number
		}
		LineMessageStatisticsResponse: {
			/** @description Number of push messages sent */
			push: number
			/** @description Number of multicast messages sent */
			multicast: number
			/** @description Number of broadcast messages sent */
			broadcast: number
			/** @description Number of reply messages sent */
			reply: number
			/** @description Number of LINE notification messages sent (PNP) */
			pnp: number
		}
		LineAnalyticsResponse: {
			/** @description Whether the request was successful */
			success: boolean
			/** @description Quota information */
			quota: components['schemas']['LineQuotaResponse']
			/** @description Consumption information */
			consumption: components['schemas']['LineConsumptionResponse']
			/** @description Message statistics by type */
			messageStatistics: components['schemas']['LineMessageStatisticsResponse']
			/** @description Date for message statistics (format: yyyyMMdd) */
			date: string
		}
		ActiveUserMetricData: {
			/**
			 * Format: date-time
			 * @description Timestamp of the metric
			 */
			timestamp: string
			/** @description Number of active users */
			activeCount: number
			/** @description Period in minutes */
			period: number
		}
		ActiveUsersMetricsResponse: {
			/** @description List of active user metrics */
			data: components['schemas']['ActiveUserMetricData'][]
			/** @description Total data points returned */
			total: number
			/**
			 * Format: date-time
			 * @description Start date of the query
			 */
			startDate: string
			/**
			 * Format: date-time
			 * @description End date of the query
			 */
			endDate: string
			/** @description Aggregation interval used */
			interval: string
		}
		HourlyPatternData: {
			/** @description Hour (0-23) */
			hour: number
			/** @description Average active users for this hour */
			average: number
		}
		DayOfWeekData: {
			/** @description Day name */
			day: string
			/** @description Average active users for this day */
			average: number
		}
		ActiveUsersSummaryResponse: {
			/** @description Average active users in the period */
			averageActiveUsers: number
			/** @description Peak active users in the period */
			peakActiveUsers: number
			/**
			 * Format: date-time
			 * @description Timestamp of peak activity
			 */
			peakTimestamp: string
			/** @description Minimum active users in the period */
			minActiveUsers: number
			/** @description Total data points analyzed */
			dataPoints: number
			/** @description Hourly pattern (24 data points) */
			hourlyPattern: components['schemas']['HourlyPatternData'][]
			/** @description Day of week pattern (7 data points) */
			dayOfWeek: components['schemas']['DayOfWeekData'][]
			/**
			 * Format: date-time
			 * @description Start date of the query
			 */
			startDate: string
			/**
			 * Format: date-time
			 * @description End date of the query
			 */
			endDate: string
		}
		PlayerGameStatsItemResponse: {
			/**
			 * @description Game ID
			 * @example game-uuid
			 */
			gameId: string
			/**
			 * @description Game name
			 * @example Fortune Tiger
			 */
			gameName?: string
			/**
			 * @description Game display name
			 * @example Fortune Tiger
			 */
			gameDisplayName?: string
			/**
			 * @description Provider name
			 * @example pghard
			 */
			provider?: string
			/**
			 * @description Game type
			 * @example SLOT
			 */
			gameType?: string
			/**
			 * @description Total amount transferred in
			 * @example 50000
			 */
			totalTransferIn: number
			/**
			 * @description Total amount transferred out
			 * @example 48000
			 */
			totalTransferOut: number
			/**
			 * @description Total bet amount
			 * @example 120000
			 */
			totalBetAmount: number
			/**
			 * @description Total settle amount
			 * @example 118000
			 */
			totalSettleAmount: number
			/**
			 * @description Total turnover
			 * @example 120000
			 */
			totalTurnover: number
			/**
			 * @description Total profit (transferOut - transferIn)
			 * @example -2000
			 */
			totalProfit: number
			/**
			 * @description Total play count
			 * @example 150
			 */
			totalPlayCount: number
			/**
			 * @description First play timestamp
			 * @example 2025-01-01T10:00:00Z
			 */
			firstPlayAt?: Record<string, never>
			/**
			 * @description Last play timestamp
			 * @example 2025-01-31T22:00:00Z
			 */
			lastPlayAt?: Record<string, never>
			/**
			 * @description Player ID
			 * @example player-uuid
			 */
			playerId: string
			/**
			 * @description Player phone
			 * @example 0812345678
			 */
			playerPhone?: string
			/**
			 * @description Player name
			 * @example John Doe
			 */
			playerName?: string
		}
		AdminGetAllPlayersGameStatsResponse: {
			total: number
			take: number
			skip: number
			/** @description Player game statistics */
			data: components['schemas']['PlayerGameStatsItemResponse'][]
		}
		GameModel: {
			id: string
			name: string
			displayName?: string
			code: string
			imageUrl: string
			type: components['schemas']['GameType']
			isActive: boolean
			isPopular: boolean
			isNew: boolean
			tag?: string
			order?: number
			providerId?: string
			providerName?: string
			providerBannerGameUrl?: string
			isAllowed: boolean
			defaultPreset?: string
			defaultPresetNumber?: number
			/** @description Switch to opposite provider version (hard ↔ real) when game is launched */
			switchToOpposite?: boolean
		}
		GameAdminProviderListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['GameProviderModel'][]
		}
		UpdateGameListDto: {
			displayName?: string
			imageUrl?: string
			isActive?: boolean
			isPopular?: boolean
			isNew?: boolean
			order?: number
			defaultPreset?: string
			defaultPresetNumber?: number
			/** @description Switch to opposite provider version (hard ↔ real) when game is launched */
			switchToOpposite?: boolean
		}
		UpdateGameTypeDto: {
			isActive?: boolean
			title?: string
			subtitle?: string
			bannerUrl?: string
			order?: number
		}
		UpdateGameProviderDto: {
			name?: string
			logoUrl?: string
			isActive?: boolean
			order?: number
			displayName?: string
			providerBannerGameUrl?: string
			isNew?: boolean
			isPopular?: boolean
			defaultPreset?: string
			defaultPresetNumber?: number
		}
		GameProviderGameTypeModel: {
			id: string
			gameType: components['schemas']['GameType']
			bannerUrl: string
			isActive: boolean
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateGameProviderGameTypeDto: {
			bannerUrl?: string
			isActive?: boolean
			isNew?: boolean
			isPopular?: boolean
			order?: number
		}
		UpdateGameProviderGameTypeResponse: {
			id: string
			gameType: components['schemas']['GameType']
			bannerUrl: string
			isActive: boolean
			order: number
			isNew: boolean
			isPopular: boolean
			provider: Record<string, never>
		}
		BatchSetProviderPresetDto: {
			/** @description Provider IDs to update */
			providerIds: string[]
			/** @description RTP preset ID (for PGHARD/JOKERHARD). Set to null to clear. */
			defaultPreset?: string | null
			/** @description RTP percentage 30-99 (for HARDV2*). Set to null to clear. */
			defaultPresetNumber?: number | null
		}
		BatchSetPresetSkippedDetail: {
			providerName: string
			reason: string
		}
		BatchSetPresetResponse: {
			/** @example true */
			success: boolean
			/** @example 5 */
			updatedCount: number
			/** @example 2 */
			skippedCount: number
			skippedDetails?: components['schemas']['BatchSetPresetSkippedDetail'][]
		}
		BatchSetGamePresetDto: {
			/** @description Provider IDs whose games will be updated */
			providerIds: string[]
			/** @description RTP preset ID (for PGHARD/JOKERHARD). Set to null to clear. */
			defaultPreset?: string | null
			/** @description RTP percentage 30-99 (for HARDV2*). Set to null to clear. */
			defaultPresetNumber?: number | null
		}
		CheckBalanceRequestDto: {
			/** @example agent-id */
			agentId: string
			/** @example test-player */
			username: string
		}
		/** @enum {number} */
		StatusCode: StatusCode
		CheckBalanceResponse: {
			type: string
			balance: number
		}
		UpdateBalanceRequestDto: {
			/** @example test-player */
			username: string
			/** @example agent-id */
			agentId: string
			/** @example 1234567890 */
			providerTransactionId: string
			/** @example 1234567890 */
			transactionId: string
			/** @example 1234567890 */
			provider: string
			/** @example SLOT */
			gameName: string
			/** @example test-slot */
			gameId: string
			/** @example 100 */
			transferIn: number
			/** @example 100 */
			transferOut: number
			/** @example 100 */
			betAmount: number
			/** @example 100 */
			settleAmount: number
			/** @example 100 */
			turnOver: number
			/** @example 1234567890 */
			info: string
			/** @example test-player */
			ableNegativeBalance: boolean
			/** @example 1234567890 */
			poliTransactionGroupId: string
		}
		/** @enum {string} */
		UpdateBalanceStatus: UpdateBalanceStatus
		UpdateBalanceResponse: {
			status: components['schemas']['UpdateBalanceStatus']
			username: string
			balanceBefore: number
			balanceAfter: number
			status_code: components['schemas']['StatusCode']
		}
		ExternalGeneralSettingResponse: {
			id: string
			isOtpEnabled: boolean
			isRegisterEnabled: boolean
			displayAllPromotion: boolean
			minimumDepositAmount: number
			minimumWithdrawalAmount: number
			minimumEasyClearTurnover: number
			manualApprovalWithdrawThreshold: number
			lineUrl: string
			telegramUrl: string
			logoUrl?: Record<string, never> | null
			initType: string
			carouselItemSize: string
			quickDepositButtons: number[]
			hiddenBankProviderCodes: string[]
			hideClearTurnoverButton: boolean
			uniqueBankName: boolean
			useFallbackBank: boolean
			enableDepositChannelChoice: boolean
			mainWalletPgHard: boolean
			mainWalletJokerHard: boolean
			mainWalletJiliHard: boolean
			defaultPgHard: boolean
			defaultJokerHard: boolean
			defaultJiliHard: boolean
			clientDomain: string
			adminDomain: string
			sendDepositLineFlexMessage: boolean
			sendWithdrawLineFlexMessage: boolean
			/**
			 * @description Billing start day of month (1-31)
			 * @example 1
			 */
			billingStartDay: number
			/**
			 * @description Monthly platform fee (USD)
			 * @example 100
			 */
			monthlyPlatformFee: number
			/**
			 * @description Days of grace period for crypto invoice payment (0 = no blocking/unlimited time, >0 = days of grace before blocking)
			 * @example 3
			 */
			cryptoInvoiceGraceDays: number
			/** @description Show gradient drop shadow effects in player frontend (default: true) */
			showDropShadow: boolean
			/**
			 * @description Custom Google Fonts family name (e.g., "Kanit", "Noto Sans Thai")
			 * @example Kanit
			 */
			fontFamily?: string
		}
		UpdateExternalGeneralSettingDto: {
			/** @example agent-id */
			agentId: string
			isOtpEnabled?: boolean
			isRegisterEnabled?: boolean
			displayAllPromotion?: boolean
			minimumDepositAmount?: number
			minimumWithdrawalAmount?: number
			minimumEasyClearTurnover?: number
			manualApprovalWithdrawThreshold?: number
			lineUrl?: string
			telegramUrl?: string
			logoUrl?: string
			initType?: string
			carouselItemSize?: string
			quickDepositButtons?: number[]
			hiddenBankProviderCodes?: string[]
			hideClearTurnoverButton?: boolean
			uniqueBankName?: boolean
			useFallbackBank?: boolean
			enableDepositChannelChoice?: boolean
			mainWalletPgHard?: boolean
			mainWalletJokerHard?: boolean
			mainWalletJiliHard?: boolean
			defaultPgHard?: boolean
			defaultJokerHard?: boolean
			defaultJiliHard?: boolean
			clientDomain?: string
			sendDepositLineFlexMessage?: boolean
			sendWithdrawLineFlexMessage?: boolean
			/**
			 * @description Billing start day of month (1-31)
			 * @example 1
			 */
			billingStartDay?: number
			/**
			 * @description Monthly platform fee (USD)
			 * @example 100
			 */
			monthlyPlatformFee?: number
			/**
			 * @description Days of grace period for crypto invoice payment (0 = no blocking/unlimited time, >0 = days of grace before blocking)
			 * @example 3
			 */
			cryptoInvoiceGraceDays?: number
		}
		GetExternalBillingDetailsDto: {
			/** @example agent-id */
			agentId: string
			/**
			 * @description Billing month in YYYY-MM format
			 * @example 2025-11
			 */
			billingMonth: string
			/**
			 * @description THB to USD exchange rate (e.g., 35.5 means 1 USD = 35.5 THB). Optional - if not provided, will use stored rate from existing invoice or current rate.
			 * @example 35.5
			 */
			exchangeRate?: number
		}
		ProviderPromotionBreakdownDto: {
			/** @example promo-001 */
			promotionId: Record<string, never> | null
			/** @example Welcome Bonus 100% */
			promotionName: Record<string, never> | null
			/**
			 * @description Charge rate (0.05 = 5%). If null, uses provider companyRate
			 * @example 0.05
			 */
			chargeRate: Record<string, never> | null
			/**
			 * @description Transfer in for this provider (THB)
			 * @example 5000
			 */
			transferIn: number
			/**
			 * @description Transfer out for this provider (THB)
			 * @example 4000
			 */
			transferOut: number
			/**
			 * @description Profit for this provider (THB)
			 * @example 1000
			 */
			profit: number
			/**
			 * @description Charge for this promotion in this provider (THB)
			 * @example 50
			 */
			charge: number
		}
		ProviderBreakdownDto: {
			/** @example PG Soft */
			providerName: string
			/**
			 * @description Company rate (0.15 = 15%)
			 * @example 0.15
			 */
			companyRate: number
			/**
			 * @description Transfer in (THB)
			 * @example 13896.61
			 */
			transferIn: number
			/**
			 * @description Transfer out (THB)
			 * @example 11117.29
			 */
			transferOut: number
			/**
			 * @description Profit (THB)
			 * @example 2779.32
			 */
			profit: number
			/**
			 * @description Total charge for this provider (THB)
			 * @example 416.9
			 */
			charge: number
			/**
			 * @description Charge for non-promotion plays (THB)
			 * @example 300
			 */
			nonPromotionCharge: number
			/**
			 * @description Charge for promotion plays (THB)
			 * @example 116.9
			 */
			promotionCharge: number
			promotions: components['schemas']['ProviderPromotionBreakdownDto'][]
		}
		PromotionBreakdownDto: {
			/** @example promo-001 */
			promotionId: Record<string, never> | null
			/** @example Welcome Bonus 100% */
			promotionName: Record<string, never> | null
			/**
			 * @description Charge rate (0.05 = 5%). If null, uses provider companyRate
			 * @example 0.05
			 */
			chargeRate: Record<string, never> | null
			/**
			 * @description Total transfer in across all providers (THB)
			 * @example 13896.61
			 */
			transferIn: number
			/**
			 * @description Total transfer out across all providers (THB)
			 * @example 11117.29
			 */
			transferOut: number
			/**
			 * @description Total profit across all providers (THB)
			 * @example 2779.32
			 */
			profit: number
			/**
			 * @description Total charge for this promotion across all providers (THB)
			 * @example 138.97
			 */
			charge: number
		}
		ExternalBillingDetailsResponse: {
			/** @example 2025-11 */
			billingMonth: string
			/**
			 * @description THB to USD exchange rate used
			 * @example 35.98
			 */
			exchangeRate: number
			/**
			 * @description Total transfer in (THB)
			 * @example 1500000
			 */
			totalTransferIn: number
			/**
			 * @description Total transfer out (THB)
			 * @example 1200000
			 */
			totalTransferOut: number
			/**
			 * @description Total profit (THB)
			 * @example 300000
			 */
			totalProfit: number
			/**
			 * @description Total charge in THB
			 * @example 15000
			 */
			totalChargeThb: number
			/**
			 * @description Total charge in USD (converted from THB)
			 * @example 416.9
			 */
			totalChargeUsd: number
			providerBreakdown: components['schemas']['ProviderBreakdownDto'][]
			promotionBreakdown: components['schemas']['PromotionBreakdownDto'][]
			/**
			 * @description Total transfer in for all promotions (THB)
			 * @example 500000
			 */
			totalPromotionTransferIn: number
			/**
			 * @description Total transfer out for all promotions (THB)
			 * @example 400000
			 */
			totalPromotionTransferOut: number
			/**
			 * @description Total profit for all promotions (THB)
			 * @example 100000
			 */
			totalPromotionProfit: number
			/**
			 * @description Total charge for all promotions (THB)
			 * @example 5000
			 */
			totalPromotionCharge: number
		}
		GetExternalCryptoInvoicesDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			/** @example agent-id */
			agentId: string
			/** @enum {string} */
			status?: GetExternalCryptoInvoicesDtoStatus
			/** @enum {string} */
			invoiceType?: GetExternalCryptoInvoicesDtoInvoiceType
			/**
			 * @description Filter by billing month (YYYY-MM)
			 * @example 2025-11
			 */
			billingMonth?: string
			/** @description Search by transaction ID */
			txId?: string
		}
		/** @enum {string} */
		CryptoInvoiceStatus: CryptoInvoiceStatus
		/** @enum {string} */
		CryptoInvoiceType: CryptoInvoiceType
		ExternalCryptoInvoiceResponse: {
			id: string
			txId: string
			amount: number
			chain: string
			walletAddress: Record<string, never> | null
			txHash: Record<string, never> | null
			status: components['schemas']['CryptoInvoiceStatus']
			invoiceType: components['schemas']['CryptoInvoiceType']
			billingMonth: Record<string, never> | null
			note: Record<string, never> | null
			/** @description Whether this invoice follows grace period rules (true = follows grace period, false = no grace period blocking) */
			allowGrace: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ExternalPaginatedCryptoInvoicesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['ExternalCryptoInvoiceResponse'][]
		}
		GetPromotionsDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Search by promotion name
			 * @example Welcome
			 */
			search?: string
			/**
			 * @description Filter by active status
			 * @example true
			 */
			isActive?: boolean
			/**
			 * @description Filter by charge type
			 * @enum {string}
			 */
			chargeType?: GetPromotionsDtoChargeType
			/**
			 * @description Filter promotions with custom charge rate (true) or using default (false)
			 * @example true
			 */
			hasCustomChargeRate?: boolean
		}
		ExternalPromotionResponse: {
			/** @example promo-id-uuid */
			id: string
			/** @example Welcome Bonus */
			name: string
			/**
			 * @description Credit type
			 * @example FIXED
			 */
			creditType: string
			/**
			 * @description Credit amount (for FIXED type)
			 * @example 100
			 */
			creditAmount: Record<string, never> | null
			/**
			 * @description Credit ratio (for RATIO type)
			 * @example 0.5
			 */
			creditRatio: Record<string, never> | null
			/**
			 * @description Charge type: NORMAL or FREE_CREDIT
			 * @example NORMAL
			 */
			chargeType: string
			/**
			 * @description Custom charge rate for this promotion (0.1 = 10%). Null means using provider default.
			 * @example 0.1
			 */
			chargeRate: Record<string, never> | null
			/** @example true */
			isActive: boolean
			/** @example 1 */
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		ExternalPromotionsResponse: {
			promotions: components['schemas']['ExternalPromotionResponse'][]
		}
		UpdatePromotionChargeRateDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Promotion ID
			 * @example promo-id-uuid
			 */
			promotionId: string
			/**
			 * @description Requested charge rate (0.1 = 10%). Set to null to use provider default rate.
			 * @example 0.1
			 */
			chargeRate?: Record<string, never> | null
		}
		CreateMonthlyFeeInvoiceDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Billing month in YYYY-MM format. The invoice will be created for this billing period.
			 * @example 2025-12
			 */
			billingMonth: string
			/**
			 * @description Optional note for the invoice
			 * @example Monthly platform fee for December 2025
			 */
			note?: string
		}
		CreateCompanyCommissionInvoiceDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Billing month in YYYY-MM format. The invoice will be created for this billing period.
			 * @example 2025-12
			 */
			billingMonth: string
			/**
			 * @description Optional note for the invoice
			 * @example Company commission for December 2025
			 */
			note?: string
		}
		UpdateCryptoInvoiceStatusDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Crypto invoice ID
			 * @example invoice-id-uuid
			 */
			invoiceId: string
			/**
			 * @description New status for the invoice
			 * @example COMPLETED
			 * @enum {string}
			 */
			status: UpdateCryptoInvoiceStatusDtoStatus
			/**
			 * @description Transaction hash (optional, for COMPLETED status)
			 * @example 0x1234567890abcdef
			 */
			txHash?: string
			/**
			 * @description Whether this invoice should follow grace period rules (true = follows grace period, false = no grace period blocking)
			 * @example true
			 */
			allowGrace?: boolean
		}
		CreateManualCryptoInvoiceExternalDto: {
			/**
			 * @description Agent ID for authentication
			 * @example agent-id
			 */
			agentId: string
			/**
			 * @description Invoice amount in USD
			 * @example 100.5
			 */
			amount: number
			/**
			 * @description Note describing the invoice purpose
			 * @example Manual invoice for additional services
			 */
			note: string
			/**
			 * @description Whether this invoice should follow grace period rules
			 * @default false
			 */
			allowGrace: boolean
		}
		CryptoInvoiceResponse: {
			id: string
			txId: string
			amount: number
			chain: string
			walletAddress: Record<string, never> | null
			txHash: Record<string, never> | null
			status: components['schemas']['CryptoInvoiceStatus']
			invoiceType: components['schemas']['CryptoInvoiceType']
			billingMonth: Record<string, never> | null
			note: Record<string, never> | null
			allowGrace: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		PaginatedCryptoInvoicesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['CryptoInvoiceResponse'][]
		}
		BillingDetailsResponse: {
			/** @example 2025-11 */
			billingMonth: string
			/**
			 * @description THB to USD exchange rate used
			 * @example 35.98
			 */
			exchangeRate: number
			/**
			 * @description Monthly platform fee (THB)
			 * @example 3598
			 */
			monthlyPlatformFee: number
			/**
			 * @description Total transfer in (THB)
			 * @example 1500000
			 */
			totalTransferIn: number
			/**
			 * @description Total transfer out (THB)
			 * @example 1200000
			 */
			totalTransferOut: number
			/**
			 * @description Total profit (THB)
			 * @example 300000
			 */
			totalProfit: number
			/**
			 * @description Total charge to pay in THB
			 * @example 48598
			 */
			totalChargeThb: number
			/**
			 * @description Total charge to pay in USD
			 * @example 1350.7
			 */
			totalChargeUsd: number
			providerBreakdown: components['schemas']['ProviderBreakdownDto'][]
			promotionBreakdown: components['schemas']['PromotionBreakdownDto'][]
			/**
			 * @description Total transfer in for all promotions (THB)
			 * @example 500000
			 */
			totalPromotionTransferIn: number
			/**
			 * @description Total transfer out for all promotions (THB)
			 * @example 400000
			 */
			totalPromotionTransferOut: number
			/**
			 * @description Total profit for all promotions (THB)
			 * @example 100000
			 */
			totalPromotionProfit: number
			/**
			 * @description Total charge for all promotions (THB)
			 * @example 5000
			 */
			totalPromotionCharge: number
		}
		CreateManualCryptoInvoiceDto: {
			/**
			 * @description Invoice amount in USD
			 * @example 100.5
			 */
			amount: number
			/**
			 * @description Note describing the invoice purpose
			 * @example Manual invoice for additional services
			 */
			note: string
			/**
			 * @description Whether this invoice should follow grace period rules
			 * @default false
			 */
			allowGrace: boolean
		}
		CreatePrepaymentInvoiceDto: {
			/**
			 * @description Prepayment amount in USD
			 * @example 50
			 */
			amount: number
			/**
			 * @description Billing month in YYYY-MM format
			 * @example 2025-04
			 */
			billingMonth: string
			/**
			 * @description Note describing the prepayment
			 * @example Prepayment for April 2025 usage
			 */
			note?: string
		}
		GeneratePaymentRequestDto: {
			id: string
			chain: string
		}
		ConfirmCryptoInvoiceRequestDto: {
			id: string
			txHash: string
		}
		AdminTournamentPrizeDto: {
			/** @example 1 */
			rank: number
			/** @example 250000 */
			prizeAmount: number
		}
		AdminCreateTournamentFromPresetDto: {
			/**
			 * @description Tournament preset type
			 * @example SMALL
			 * @enum {string}
			 */
			preset: AdminCreateTournamentFromPresetDtoPreset
			/** @example March 2026 Casino Championship */
			name: string
			/** @example 2026-03-05T00:00:00.000Z */
			startDate: string
			/** @example 2026-03-30T23:59:59.999Z */
			endDate: string
			/** @description Optional: Override the default description from preset */
			description?: string
			/** @description Optional: Override the default banner image from preset */
			bannerImage?: string
			/** @description Optional: Override prize structure from preset */
			prizeOverrides?: components['schemas']['AdminTournamentPrizeDto'][]
			/** @description Optional: Override min turnover from preset */
			minTurnoverOverride?: number
			/** @description Optional: Override min deposit from preset */
			minDepositOverride?: number
			/** @description Optional: Override min bet amount from preset */
			minBetAmountOverride?: number
			/** @description Optional: Override allowed game types from preset */
			allowedGameTypesOverride?: string
			/** @description Optional: Override allowed game IDs from preset */
			allowedGameIdsOverride?: string
			/** @description Optional: Override allowed provider IDs from preset */
			allowedProviderIdsOverride?: string
		}
		AllowedGameResponse: {
			id: string
			name: string
			displayName?: string
		}
		AllowedProviderResponse: {
			id: string
			name: string
			displayName?: string
		}
		PointSystemConfigResponse: {
			/**
			 * @description Streak bonuses mapping. Key = consecutive wins, Value = bonus points
			 * @example {
			 *       "3": 1,
			 *       "5": 2,
			 *       "7": 3,
			 *       "10": 5,
			 *       "15": 10
			 *     }
			 */
			streakBonuses: {
				[key: string]: number
			}
		}
		AdminTournamentPrizeResponse: {
			id: string
			rank: number
			prizeAmount: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminTournamentResponse: {
			id: string
			name: string
			description?: string
			bannerImage?: string
			status: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			minTurnover?: string
			minDeposit?: string
			minBetAmount: string
			maxTransactionDay: number
			allowedGameTypes: string
			allowedGameIds?: string
			allowedProviderIds?: string
			allowedGames?: components['schemas']['AllowedGameResponse'][]
			allowedProviders?: components['schemas']['AllowedProviderResponse'][]
			leaderboardRefresh: number
			pointSystemConfig?: components['schemas']['PointSystemConfigResponse']
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			prizes: components['schemas']['AdminTournamentPrizeResponse'][]
			playerCount?: number
		}
		PointSystemConfigDto: {
			/**
			 * @description Streak bonuses mapping. Key = consecutive wins, Value = bonus points
			 * @example {
			 *       "3": 1,
			 *       "5": 2,
			 *       "7": 3,
			 *       "10": 5,
			 *       "15": 10
			 *     }
			 */
			streakBonuses: {
				[key: string]: number
			}
		}
		AdminCreateTournamentDto: {
			/** @example March 2026 Baccarat Championship */
			name: string
			/** @example Monthly baccarat tournament for VIP players */
			description?: string
			/**
			 * @description Banner image URL for the tournament
			 * @example https://example.com/images/tournament-banner.jpg
			 */
			bannerImage?: string
			/** @example 2026-03-05T00:00:00.000Z */
			startDate: string
			/** @example 2026-03-30T23:59:59.999Z */
			endDate: string
			/** @example 50000 */
			minTurnover?: number
			/** @example 50000 */
			minDeposit?: number
			/** @example 100 */
			minBetAmount: number
			/** @example 30 */
			maxTransactionDay: number
			/**
			 * @description Comma-separated game matching patterns (matches game type, name, code, or tag). Examples: "CASINO", "baccarat", "CASINO,SLOT", "DG"
			 * @example CASINO
			 */
			allowedGameTypes: string
			/**
			 * @description Comma-separated game IDs to allow. If specified, only these specific games will be allowed regardless of allowedGameTypes.
			 * @example game-uuid-1,game-uuid-2
			 */
			allowedGameIds?: string
			/**
			 * @description Comma-separated provider IDs to allow. If specified, only games from these providers will be allowed.
			 * @example provider-uuid-1,provider-uuid-2
			 */
			allowedProviderIds?: string
			/** @example 300 */
			leaderboardRefresh: number
			/** @description Point system config. Define streak bonuses: { "streakBonuses": { "3": 1, "5": 2 } } */
			pointSystemConfig?: components['schemas']['PointSystemConfigDto']
			prizes: components['schemas']['AdminTournamentPrizeDto'][]
		}
		AdminTournamentListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminTournamentResponse'][]
		}
		AdminUpdateTournamentDto: {
			/** @example March 2026 Baccarat Championship */
			name?: string
			/** @example Monthly baccarat tournament for VIP players */
			description?: string
			/**
			 * @description Banner image URL for the tournament
			 * @example https://example.com/images/tournament-banner.jpg
			 */
			bannerImage?: string
			/** @example 2026-03-05T00:00:00.000Z */
			startDate?: string
			/** @example 2026-03-30T23:59:59.999Z */
			endDate?: string
			/** @example 50000 */
			minTurnover?: number
			/** @example 50000 */
			minDeposit?: number
			/** @example 100 */
			minBetAmount?: number
			/** @example 30 */
			maxTransactionDay?: number
			/**
			 * @description Comma-separated game matching patterns
			 * @example CASINO
			 */
			allowedGameTypes?: string
			/**
			 * @description Comma-separated game IDs to allow. If specified, only these specific games will be allowed.
			 * @example game-uuid-1,game-uuid-2
			 */
			allowedGameIds?: string
			/**
			 * @description Comma-separated provider IDs to allow. If specified, only games from these providers will be allowed.
			 * @example provider-uuid-1,provider-uuid-2
			 */
			allowedProviderIds?: string
			/** @example 300 */
			leaderboardRefresh?: number
			/** @description Point system config */
			pointSystemConfig?: components['schemas']['PointSystemConfigDto']
			prizes?: components['schemas']['AdminTournamentPrizeDto'][]
			isActive?: boolean
		}
		AdminUpdateTournamentStatusDto: {
			/** @enum {string} */
			status: AdminUpdateTournamentStatusDtoStatus
		}
		AdminTournamentPlayerResponse: {
			id: string
			playerId: string
			playerPhone: string
			playerUsername?: string
			status: string
			totalPoints: number
			totalWins: number
			currentStreak: number
			longestStreak: number
			totalBetAmount: string
			totalTransactions: number
			qualificationTurnover?: string
			qualificationDeposit?: string
			finalRank?: number
			prizeAmount?: string
			/** Format: date-time */
			prizeClaimAt?: string
			/** Format: date-time */
			joinedAt: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminTournamentPlayerListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminTournamentPlayerResponse'][]
		}
		AdminManualJoinTournamentDto: {
			/** @example player-uuid */
			playerId: string
			/**
			 * @description Optional: Skip qualification check and force add player
			 * @default true
			 */
			bypassQualification: boolean
		}
		/** @enum {string} */
		BankAccountType: BankAccountType
		AppCredential: {
			deviceId: string
			pin: string
		}
		BankApiCredential: {
			username: string
			password: string
		}
		AutoBankAccountTransferOut: {
			maximumCredit: number
			preferTransferOutCredit: number
			isActive: boolean
		}
		AutoBankAccountTransferIn: {
			minimumCredit: number
			preferTransferInCredit: number
			isActive: boolean
		}
		CreateBankAccountDto: {
			/**
			 * @description Bank provider
			 * @example SCB
			 */
			bankProvider: string
			/**
			 * @description Account name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Account number
			 * @example 1234567890
			 */
			accountNumber: string
			/** @description Is active */
			isActive: boolean
			/** @example DEPOSIT */
			bankType: components['schemas']['BankAccountType']
			validateType: components['schemas']['ValidateMethod'][]
			/** @description App credentials */
			appCredential?: components['schemas']['AppCredential']
			/** @description Bank API credentials */
			bankApiCredential?: components['schemas']['BankApiCredential']
			/** @description Auto transfer out information */
			autoTransferOutInfo?: components['schemas']['AutoBankAccountTransferOut']
			/** @description Auto transfer in information */
			autoTransferInInfo?: components['schemas']['AutoBankAccountTransferIn']
		}
		GetBankAccountResponse: {
			id: string
			bankProvider: string
			accountName: string
			accountNumber: string
			order: number
			bankAccountType: components['schemas']['BankAccountType']
			validateMethods: components['schemas']['ValidateMethod']
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		BankAccountModel: {
			id: string
			bankProvider: string
			accountName: string
			accountNumber: string
			order: number
			bankAccountType: components['schemas']['BankAccountType']
			validateMethods: components['schemas']['ValidateMethod']
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetBankAccountsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['BankAccountModel'][]
		}
		UpdateBankAccountDto: {
			bankType?: components['schemas']['BankAccountType']
			order?: number
			validateType?: components['schemas']['ValidateMethod'][]
			/** @description App credentials */
			appCredential?: components['schemas']['AppCredential']
			/** @description Bank API credentials */
			bankApiCredential?: components['schemas']['BankApiCredential']
			/** @description Is active */
			isActive?: boolean
			/** @description Auto transfer out information */
			autoTransferOutInfo?: components['schemas']['AutoBankAccountTransferOut']
			/** @description Auto transfer in information */
			autoTransferInInfo?: components['schemas']['AutoBankAccountTransferIn']
			/** @description Is deleted */
			isDeleted?: boolean
		}
		BankProviderResponse: {
			id: string
			name: string
			code: number
			nameTH: string
			imageUrl: string
			createdAt: string
			updatedAt: string
		}
		CreateWithdrawTransactionDto: {
			/**
			 * @description Player phone number
			 * @example 0812345678
			 */
			playerPhone: string
			/**
			 * @description Transaction amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Bank account number
			 * @example 1234567890
			 */
			accountNumber?: string
			/**
			 * @description Bank account name
			 * @example John Doe
			 */
			accountName?: string
			/**
			 * @description Bank provider name
			 * @example SCB
			 */
			bankProviderName?: string
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
			/**
			 * @description Withdrawal type
			 * @example auto
			 * @enum {string}
			 */
			type: CreateWithdrawTransactionDtoType
		}
		PlayerBankResponse: {
			/**
			 * @description Player bank account name
			 * @example Player Bank Account Name
			 */
			accountName?: string
			/**
			 * @description Player bank account number
			 * @example 9876543210
			 */
			accountNumber?: string
			/**
			 * @description Player bank provider
			 * @example Player Bank Provider
			 */
			bankProvider?: string
		}
		PaymentGatewayErrorResponse: {
			/**
			 * @description Error ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			paymentGatewayId: string
			/**
			 * @description Error message
			 * @example Insufficient balance in payment gateway
			 */
			errorMessage: string
			/**
			 * @description Whether the payment gateway was under withdraw maintenance when this error occurred
			 * @example false
			 */
			isUnderMaintenance?: boolean
			/** @description Payment gateway details */
			paymentGateway: components['schemas']['PaymentGatewayResponse']
			/**
			 * Format: date-time
			 * @description Error created date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Error updated date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			updatedAt: string
		}
		AdminDepositTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Bank transaction ID
			 * @example 123e4567
			 */
			bankTxId?: string
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Amount
			 * @example 1000
			 */
			amount: number
			status: components['schemas']['DepositStatus']
			method: components['schemas']['TransactionMethod']
			bankValidateMethod?: components['schemas']['ValidateMethod']
			processor: components['schemas']['TransactionProcessor']
			/**
			 * @description Timestamp information
			 * @example {
			 *       "CREATED": "2023-01-01T12:00:00Z"
			 *     }
			 */
			timestamp: {
				[key: string]: string
			}
			/**
			 * @description Promotion ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			promotionId?: string
			/**
			 * @description Promotion name
			 * @example Promotion Name
			 */
			promotionName?: string
			/**
			 * @description Promotion fixed deposit amount
			 * @example 100
			 */
			promotionFixedDepositAmount?: number
			/**
			 * @description Player bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerBankId?: string
			/**
			 * @description Bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankId?: string
			/**
			 * Format: date-time
			 * @description Slip verification date
			 * @example 2023-01-01T00:00:00.000Z
			 */
			slipVerifyAt?: string
			/**
			 * @description Manual deposit operator ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			manualDepositOperatorId?: string
			/**
			 * Format: date-time
			 * @description Created at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			updatedAt: string
			/**
			 * Format: date-time
			 * @description Expired at
			 * @example 2023-01-01T12:00:00Z
			 */
			expiredAt: string
			/** @description Bank information */
			bank?: components['schemas']['BankResponse']
			/** @description Player bank information */
			playerBank: components['schemas']['PlayerBankResponse']
			/** @description Player information */
			player: components['schemas']['PlayerResponse']
			/**
			 * @description QR code URL
			 * @example https://example.com/qr-code.png
			 */
			qrCodeUrl?: string
			/** @description Bank information */
			bankInfo: string
			/** @description Payment gateway information */
			playerBankInfo: string
			/** @description Manual deposit operator information */
			manualDepositOperator?: components['schemas']['OperatorResponse']
			/**
			 * @description Bonus amount
			 * @example 1000
			 */
			bonusAmount: number
			/**
			 * @description Turnover amount
			 * @example 1000
			 */
			turnoverAmount: number
			/**
			 * @description Whether this deposit was created by blacklist
			 * @example false
			 */
			isBlacklist: boolean
			/**
			 * @description Note
			 * @example Manual deposit note
			 */
			note?: string
			manualDepositType?: components['schemas']['ManualDepositType']
			/** @description Payment gateway errors */
			paymentGatewayErrors?: components['schemas']['PaymentGatewayErrorResponse'][]
			/**
			 * @description Count of payment gateway errors
			 * @example {
			 *       "paymentGatewayErrors": 2
			 *     }
			 */
			_count?: Record<string, never>
			/** @description Slip image URL uploaded by customer (AUTOSSLIP/VERIFY_SLIP) */
			slipImageUrl?: string
			/** @description Reason why the slip was rejected by bank verification */
			slipRejectReason?: string
		}
		PaginatedDepositTransactionsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminDepositTransactionResponse'][]
		}
		OperatorDepositTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Human-readable transaction ID (txId)
			 * @example ODT-20240101-0001
			 */
			txId?: Record<string, never>
			/**
			 * @description Amount
			 * @example 100.5
			 */
			amount: number
			/** @example PENDING */
			status: components['schemas']['DepositStatus']
			/** @example BANK */
			method: components['schemas']['TransactionMethod']
			/** @example TRANSFER */
			bankValidateMethod?: components['schemas']['ValidateMethod']
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2023-01-01T12:00:00Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2023-01-01T12:30:00Z
			 */
			updatedAt: string
			/**
			 * @description Timestamp information
			 * @example {
			 *       "CREATED": "2023-01-01T12:00:00Z"
			 *     }
			 */
			timestamp: {
				[key: string]: string
			}
			/** @description QR code URL */
			qrCodeUrl?: string
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174005
			 */
			paymentGatewayId?: string
			/**
			 * @description Payment gateway name
			 * @example Payment Gateway Name
			 */
			paymentGatewayName?: string
			/**
			 * Format: date-time
			 * @description Expired at
			 * @example 2023-01-01T12:00:00Z
			 */
			expiredAt: string
			/** @description Bank account name */
			accountName: string
			/** @description Bank account number */
			accountNumber: string
			/** @description Bank provider */
			bankProvider: string
			/** @description Operator username who created this transaction */
			operatorUsername?: string
		}
		PaginatedOperatorDepositTransactionsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['OperatorDepositTransactionResponse'][]
		}
		/** @enum {string} */
		WithdrawStatus: WithdrawStatus
		/** @enum {string} */
		PlayerBankType: PlayerBankType
		AdminWithdrawTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Bank transaction ID
			 * @example 123e4567
			 */
			bankTxId?: string
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Amount
			 * @example 1000
			 */
			amount: number
			/** @description Amount matched in P2P */
			matchedAmount?: number
			/** @description Amount refunded in P2P */
			refundAmount?: number
			status: components['schemas']['WithdrawStatus']
			method?: components['schemas']['TransactionMethod']
			processor: components['schemas']['TransactionProcessor']
			/**
			 * @description Whether this withdrawal was approved by an admin
			 * @example false
			 */
			isApprovedByAdmin?: boolean
			/**
			 * @description Note
			 * @example Transaction cancelled due to suspicious activity
			 */
			note?: string
			/**
			 * @description Timestamp information
			 * @example {
			 *       "CREATED": "2023-01-01T12:00:00Z"
			 *     }
			 */
			timestamp: {
				[key: string]: string
			}
			/**
			 * @description Player bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerBankId?: string
			/**
			 * @description Manual withdraw operator ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			manualWithdrawOperatorId?: string
			/**
			 * Format: date-time
			 * @description Created at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			updatedAt: string
			/** @description Bank information */
			bank?: components['schemas']['BankResponse']
			/** @description Player bank information */
			playerBank?: components['schemas']['PlayerBankResponse']
			/** @description Player information */
			player: components['schemas']['PlayerResponse']
			/** @description Manual withdraw operator information */
			manualWithdrawOperator?: components['schemas']['OperatorResponse']
			/** @description Bank information */
			bankInfo: string
			/**
			 * @description Whether this withdrawal was created by blacklist
			 * @example false
			 */
			isBlacklist: boolean
			/** @description Payment gateway errors */
			paymentGatewayErrors?: components['schemas']['PaymentGatewayErrorResponse'][]
			/**
			 * @description Count of payment gateway errors
			 * @example {
			 *       "paymentGatewayErrors": 2
			 *     }
			 */
			_count?: Record<string, never>
			/**
			 * Format: date-time
			 * @description Deposit maintenance start time for this provider (if under maintenance)
			 */
			maintenanceDepositStartAt?: string | null
			/**
			 * Format: date-time
			 * @description Deposit maintenance end time for this provider (if under maintenance)
			 */
			maintenanceDepositEndAt?: string | null
			/**
			 * Format: date-time
			 * @description Withdraw maintenance start time for this provider (if under maintenance)
			 */
			maintenanceWithdrawStartAt?: string | null
			/**
			 * Format: date-time
			 * @description Withdraw maintenance end time for this provider (if under maintenance)
			 */
			maintenanceWithdrawEndAt?: string | null
		}
		PaginatedWithdrawTransactionsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminWithdrawTransactionResponse'][]
		}
		OperatorWithdrawalTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Human-readable transaction ID (txId)
			 * @example OWT-20240101-0001
			 */
			txId?: Record<string, never>
			/**
			 * @description Amount
			 * @example 100.5
			 */
			amount: number
			/** @example PENDING */
			status: components['schemas']['WithdrawStatus']
			/** @example BANK */
			method: components['schemas']['TransactionMethod']
			/** @example TRANSFER */
			bankValidateMethod?: components['schemas']['ValidateMethod']
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2023-01-01T12:00:00Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2023-01-01T12:30:00Z
			 */
			updatedAt: string
			/**
			 * @description Timestamp information
			 * @example {
			 *       "CREATED": "2023-01-01T12:00:00Z"
			 *     }
			 */
			timestamp: {
				[key: string]: string
			}
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174005
			 */
			paymentGatewayId?: string
			/**
			 * @description Payment gateway name
			 * @example Payment Gateway Name
			 */
			paymentGatewayName?: string
			/** @description Bank account name */
			accountName: string
			/** @description Bank account number */
			accountNumber: string
			/** @description Bank provider */
			bankProvider: string
			/** @description Operator username who created this transaction */
			operatorUsername?: string
		}
		TrueMoneyDepositsResponse: {
			/**
			 * @description Total TrueMoney deposit amount
			 * @example 150000.5
			 */
			totalAmount: number
			/**
			 * @description Total number of TrueMoney deposits
			 * @example 25
			 */
			totalCount: number
			/**
			 * @description Total TrueMoney deposit fee amount
			 * @example 750.25
			 */
			totalFeeAmount: number
			/**
			 * @description Average TrueMoney deposit amount
			 * @example 6000.02
			 */
			averageAmount: number
		}
		ForceCompleteDepositDto: {
			/**
			 * @description Amount to deposit
			 * @example 1000
			 */
			amount: number
			/**
			 * Format: date-time
			 * @description Slip verification date
			 * @example 2023-01-01T00:00:00.000Z
			 */
			slipVerifyAt: string
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
		}
		ForceCompleteWithdrawDto: {
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
		}
		AdminApproveWithdrawDto: {
			/**
			 * @description Manual withdrawal (skip bank API call)
			 * @example false
			 */
			isManual?: boolean
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
		}
		CancelWithdrawTransactionDto: {
			/**
			 * @description Cancellation note/reason
			 * @example Transaction cancelled due to suspicious activity
			 */
			note?: string
		}
		RefundWithdrawTransactionDto: {
			/**
			 * @description Refund note/reason
			 * @example Refunding failed withdrawal to player wallet
			 */
			note?: string
		}
		CreateManualDepositTransactionDto: {
			/**
			 * @description Player phone number
			 * @example 0812345678
			 */
			playerPhone: string
			/**
			 * @description Transaction amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Promotion ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			promotionId?: string
			/**
			 * @description bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankProviderName?: string
			/**
			 * @description Bank account number
			 * @example 1234567890
			 */
			accountNumber?: string
			/**
			 * @description Bank account name
			 * @example John Doe
			 */
			accountName?: string
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
			/**
			 * @description Type of manual deposit (REGULAR = actual deposit, FREE_CREDIT = admin giveaway)
			 * @example REGULAR
			 * @enum {string}
			 */
			manualDepositType?: CreateManualDepositTransactionDtoManualDepositType
		}
		CreateOperatorDepositTransactionDto: {
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			paymentGatewayId: string
			/**
			 * @description Transaction amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankProviderName: string
			/**
			 * @description Bank account number
			 * @example 1234567890
			 */
			accountNumber: string
			/**
			 * @description Bank account name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Phone number
			 * @example 0812345678
			 */
			phoneNumber: string
			/**
			 * @description Deposit channel (QR, Transfer, TrueMoney)
			 * @enum {string}
			 */
			channel?: CreateOperatorDepositTransactionDtoChannel
		}
		CreateOperatorWithdrawTransactionDto: {
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			paymentGatewayId: string
			/**
			 * @description Transaction amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			bankProviderName: string
			/**
			 * @description Bank account number
			 * @example 1234567890
			 */
			accountNumber: string
			/**
			 * @description Bank account name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Phone number
			 * @example 0812345678
			 */
			phoneNumber: string
			/**
			 * @description Withdraw channel (WITHDRAW_BANK, WITHDRAW_TRUE_MONEY)
			 * @enum {string}
			 */
			channel?: CreateOperatorWithdrawTransactionDtoChannel
		}
		CreateManualWithdrawTransactionDto: {
			/**
			 * @description Player phone number
			 * @example 0812345678
			 */
			playerPhone: string
			/**
			 * @description Transaction amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Bank account number
			 * @example 1234567890
			 */
			accountNumber?: string
			/**
			 * @description Bank account name
			 * @example John Doe
			 */
			accountName?: string
			/**
			 * @description Bank provider name
			 * @example SCB
			 */
			bankProviderName?: string
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
		}
		ForceCancelDepositTransactionDto: {
			/**
			 * @description Note
			 * @example Note
			 */
			note?: string
		}
		TrueWalletTransactionLogResponse: {
			/**
			 * @description Log ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			paymentGatewayId: string
			/** @description Payment gateway details */
			paymentGateway: components['schemas']['PaymentGatewayResponse']
			/**
			 * @description Report ID
			 * @example TW-12345678
			 */
			reportId: string
			/**
			 * @description Transaction type
			 * @example DEPOSIT
			 * @enum {string}
			 */
			type: TrueWalletTransactionLogResponseType
			/**
			 * @description Transaction method
			 * @example TRUE_WALLET
			 * @enum {string}
			 */
			method: TrueWalletTransactionLogResponseMethod
			/**
			 * @description Amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Account name
			 * @example John Doe
			 */
			name: string
			/**
			 * @description Phone number
			 * @example 0812345678
			 */
			phoneNumber: string
			/**
			 * @description Transaction date and time
			 * @example 2025-03-04 12:00:00
			 */
			dateTime: string
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			updatedAt: string
		}
		PaginatedTrueWalletTransactionLogsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['TrueWalletTransactionLogResponse'][]
		}
		/**
		 * @description SMS auto log status
		 * @enum {string}
		 */
		SmsAutoLogStatus: SmsAutoLogStatus
		SmsAutoTransactionLogResponse: {
			/**
			 * @description Log ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Payment gateway ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			paymentGatewayId: string
			/** @description Payment gateway details */
			paymentGateway: components['schemas']['PaymentGatewayResponse']
			/**
			 * @description Transaction method
			 * @example SMS_AUTO
			 */
			method: string
			/**
			 * @description Amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description Account number
			 * @example 1234567890
			 */
			accountNumber: string
			status: components['schemas']['SmsAutoLogStatus']
			/** @description Raw SMS message */
			message?: string
			/** @description Linked deposit transaction ID */
			depositTransactionId?: string
			/**
			 * Format: date-time
			 * @description Matched date
			 */
			matchedAt?: string
			/** @description Operator note for rematch/cancel */
			note?: string
			/** @description Operator ID who rematched/cancelled */
			rematchedBy?: string
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2025-03-04T00:00:00.000Z
			 */
			updatedAt: string
			/** @description Previous amount before rematch (if changed) */
			previousAmount?: number
			/** @description Amount change history log */
			amountChangeLog?: Record<string, never>
		}
		PaginatedSmsAutoTransactionLogsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['SmsAutoTransactionLogResponse'][]
		}
		AdminSearchUsersForRematchResultItem: {
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Masked phone number
			 * @example 081****678
			 */
			maskedPhone: string
			/**
			 * @description Player bank account number
			 * @example 1234567890
			 */
			accountNumber: string
			/**
			 * @description Player bank account name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Bank provider
			 * @example SCB
			 */
			bankProvider: string
			/**
			 * @description Number of pending deposit transactions for this player
			 * @example 2
			 */
			pendingDepositCount: number
		}
		AdminSearchUsersForRematchResponse: {
			data: components['schemas']['AdminSearchUsersForRematchResultItem'][]
			/**
			 * @description Total number of matching users
			 * @example 3
			 */
			total: number
		}
		AdminRematchSmsAutoLogRequestDto: {
			/**
			 * @description Deposit transaction ID to link
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			depositTransactionId: string
			/**
			 * @description New amount (if different from deposit amount)
			 * @example 1000
			 */
			newAmount?: number
			/**
			 * @description Reason/note for rematch
			 * @example Adjusted amount per bank slip
			 */
			note?: string
		}
		AdminCancelSmsAutoLogRequestDto: {
			/**
			 * @description Reason for cancellation
			 * @example Duplicate SMS - ignore
			 */
			note: string
		}
		AdminUpdateSmsAutoLogStatusDto: {
			/** @example PROCESSING */
			status: components['schemas']['SmsAutoLogStatus']
		}
		AdminCreateDepositForRematchDto: {
			/**
			 * @description Player ID to create deposit for (from searchUsersForRematch)
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
		}
		AdminCompleteRematchDto: {
			/**
			 * @description Deposit transaction ID to link (optional - if omitted, auto-creates deposit)
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			depositTransactionId?: string
			/**
			 * @description Player ID (required for auto-creating deposit)
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			playerId: string
			/**
			 * @description Final amount for the deposit
			 * @example 1000
			 */
			newAmount: number
			/**
			 * @description Note for the rematch (required if amount differs from original)
			 * @example Adjusted
			 */
			note?: string
		}
		TransactionMethodStatistics: {
			/**
			 * @description Total amount for this method
			 * @example 250000.75
			 */
			totalAmount: number
			/**
			 * @description Total count for this method
			 * @example 150
			 */
			totalCount: number
		}
		DepositStatistics: {
			/** @description Bank deposit statistics */
			bank: components['schemas']['TransactionMethodStatistics']
			/** @description Payment gateway deposit statistics */
			paymentGateway: components['schemas']['TransactionMethodStatistics']
			/** @description True Money deposit statistics */
			trueMoney: components['schemas']['TransactionMethodStatistics']
			/** @description SMS Auto deposit statistics */
			smsAuto: components['schemas']['TransactionMethodStatistics']
			/** @description Manual deposit statistics (excluding free credit) */
			manual: components['schemas']['TransactionMethodStatistics']
		}
		WithdrawStatistics: {
			/** @description Bank withdraw statistics */
			bank: components['schemas']['TransactionMethodStatistics']
			/** @description Payment gateway withdraw statistics */
			paymentGateway: components['schemas']['TransactionMethodStatistics']
			/** @description True Money withdraw statistics */
			trueMoney: components['schemas']['TransactionMethodStatistics']
			/** @description Manual withdraw statistics */
			manual: components['schemas']['TransactionMethodStatistics']
		}
		TransactionStatisticsData: {
			/** @description Deposit statistics by method */
			deposits: components['schemas']['DepositStatistics']
			/** @description Withdraw statistics by method */
			withdraws: components['schemas']['WithdrawStatistics']
		}
		TransactionStatisticsResponse: {
			/** @description Success status */
			success: boolean
			/** @description Transaction statistics data */
			data: components['schemas']['TransactionStatisticsData']
		}
		AdminUpdateDepositStatusDto: {
			/**
			 * @description New deposit status
			 * @example COMPLETED
			 * @enum {string}
			 */
			status: AdminUpdateDepositStatusDtoStatus
			/**
			 * @description Optional note for status update
			 * @example Status updated by admin
			 */
			note?: string
		}
		AdminUpdateWithdrawStatusDto: {
			/**
			 * @description New withdrawal status
			 * @example COMPLETED
			 * @enum {string}
			 */
			status: AdminUpdateWithdrawStatusDtoStatus
			/**
			 * @description Optional note for status update
			 * @example Status updated by admin
			 */
			note?: string
		}
		UploadOperatorDepositSlipDto: {
			/**
			 * @description Public image URL from R2 storage
			 * @example https://r2.example.com/slips/abc123.jpg
			 */
			imageUrl: string
		}
		CreateWithdrawDto: {
			/**
			 * @description The amount of the withdraw
			 * @example 100
			 */
			amount: number
			/**
			 * @description The href back url
			 * @example https://example.com
			 */
			hrefBackUrl: string
		}
		WithdrawTransactionResponse: {
			/**
			 * @description Transaction ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Amount
			 * @example 100.5
			 */
			amount: number
			/** @example PENDING */
			status: components['schemas']['WithdrawStatus']
			/**
			 * @description Player ID
			 * @example 123e4567-e89b-12d3-a456-426614174001
			 */
			playerId: string
			/**
			 * @description Bank ID
			 * @example 123e4567-e89b-12d3-a456-426614174002
			 */
			bankId?: string
			/** @description Timestamp information */
			timestamp: {
				[key: string]: string
			}
			/**
			 * @description Whether this withdrawal requires admin approval
			 * @example false
			 */
			requiresApproval?: boolean
			/**
			 * @description Whether this withdrawal was approved by an admin
			 * @example false
			 */
			isApprovedByAdmin?: boolean
			/**
			 * Format: date-time
			 * @description Created date
			 * @example 2023-01-01T12:00:00Z
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description Updated date
			 * @example 2023-01-01T12:30:00Z
			 */
			updatedAt: string
			/**
			 * @description Amount matched so far in P2P matching
			 * @example 100
			 */
			matchedAmount?: number
			/**
			 * @description Amount refunded back to player (partial match / timeout)
			 * @example 0
			 */
			refundAmount?: number
		}
		WithdrawRankInfoResponse: {
			/**
			 * @description Maximum daily withdrawal amount for the player's rank
			 * @example 10000
			 */
			limitWithdrawCredit: number
			/**
			 * @description Maximum number of withdrawals per day for the player's rank
			 * @example 5
			 */
			limitWithdrawFrequency: number
			/**
			 * @description Current day's withdrawal amount
			 * @example 3000
			 */
			currentDayWithdrawAmount?: number
			/**
			 * @description Current day's withdrawal count
			 * @example 2
			 */
			cumulativeWithdrawFrequency?: number
		}
		WithdrawInfoResponse: {
			/**
			 * @description Minimum withdrawal amount allowed
			 * @example 100
			 */
			minimumWithdrawalAmount: number
			/**
			 * @description Maximum withdrawal amount available for the current day
			 * @example 5000
			 */
			maximumWithdrawalAmount: number
			/**
			 * @description Number of withdrawals left for the current day
			 * @example 3
			 */
			withdrawQuotaLeft: number
			/**
			 * @description Whether withdrawal is currently available for the player
			 * @example true
			 */
			isWithdrawAvailable: boolean
			/** @description Player rank withdrawal limit information */
			rankInfo: components['schemas']['WithdrawRankInfoResponse']
		}
		AdminBlacklistResponse: {
			/**
			 * @description Blacklist ID
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			id: string
			/**
			 * @description Bank Account Number
			 * @example 123e4567
			 */
			accountNumber: string
			/**
			 * @description Bank Account Name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Bank Provider Name
			 * @example SCB
			 */
			bankProviderName: string
			/**
			 * @description Total Report
			 * @example 10
			 */
			totalReport: number
			/**
			 * @description Reasons
			 * @example [
			 *       "Reason 1",
			 *       "Reason 2"
			 *     ]
			 */
			reasons: string[]
			/**
			 * @description Created By
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			createdBy: string
			/**
			 * @description Created at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			createdAt: string
			/**
			 * @description Updated at
			 * @example 2023-01-01T00:00:00.000Z
			 */
			updatedAt: string
		}
		PaginatedBlacklistResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminBlacklistResponse'][]
		}
		CreateBlacklistDto: {
			/**
			 * @description Account Number
			 * @example 123e4567-e89b-12d3-a456-426614174000
			 */
			accountNumber: string
			/**
			 * @description Account Name
			 * @example John Doe
			 */
			accountName: string
			/**
			 * @description Bank Provider Name
			 * @example SCB
			 */
			bankProviderName: string
			/**
			 * @description Phone Number
			 * @example 0812345678
			 */
			phoneNumber: string
			/**
			 * @description Reason
			 * @example Reason
			 */
			reason: string
		}
		ReportBlacklistDto: {
			/**
			 * @description Phone Number
			 * @example 0812345678
			 */
			phoneNumber?: string
			/**
			 * @description Reason
			 * @example Reason
			 */
			reason?: string
		}
		CreateAnnouncementDto: {
			title: string
			content: string
			isActive: boolean
		}
		GetAnnouncementResponse: {
			id: string
			title: string
			content: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AnnouncementModel: {
			id: string
			title: string
			content: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetAnnouncementsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AnnouncementModel'][]
		}
		UpdateAnnouncementDto: {
			title?: string
			content?: string
			isActive?: boolean
		}
		CreateSlideAnnouncementDto: {
			content: string
		}
		GetSlideAnnouncementResponse: {
			id: string
			content: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateSlideAnnouncementDto: {
			content: string
		}
		MinimumWithdrawSettingResponse: {
			walletType: components['schemas']['WalletType']
			minimumAmount: number
			id: string
			minimumWithdrawSettingId: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateMinimumWithdrawSettingDto: {
			/** @example MAIN */
			walletType: components['schemas']['WalletType']
			/** @example 100 */
			minimumAmount: number
		}
		RewardModel: {
			ratio?: number
			creditRatio?: number
			maxCreditAmount?: number
		}
		ReturnLossRewardModel: {
			creditRatio: number
			maxCreditAmount?: number
		}
		InviteFriendTierModel: {
			id: string
			level: number
			rewards: {
				[key: string]: components['schemas']['RewardModel']
			}
			returnLossRewards?: {
				[key: string]: components['schemas']['ReturnLossRewardModel']
			}
			depositCommissionRatio?: number
			depositCommissionMaxAmount?: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		InviteFriendSettingResponse: {
			id: string
			turnoverRound: number
			durationDays?: number
			minimumFirstDepositAmount?: number
			firstDepositCreditType: components['schemas']['CreditType']
			firstDepositCreditAmount?: number
			firstDepositCreditRatio?: number
			firstDepositMaxCreditAmount?: number
			isRequireFirstDepositPromotion: boolean
			commissionTiers: components['schemas']['InviteFriendTierModel'][]
			returnLossMinimumLossAmount?: number
			returnLossCalculateInterval?: components['schemas']['CalculateInterval']
			isReturnLossEnabled: boolean
			isDepositCommissionEnabled: boolean
			isRequireDepositPromotion: boolean
			depositCommissionMinimumAmount?: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		InviteCommissionTierDto: {
			level: number
			rewards: {
				[key: string]: components['schemas']['RewardModel']
			}
			returnLossRewards?: {
				[key: string]: components['schemas']['ReturnLossRewardModel']
			}
			depositCommissionRatio?: number
			depositCommissionMaxAmount?: number
		}
		UpdateInviteFriendSettingDto: {
			turnoverRound?: number
			durationDays?: number
			minimumFirstDepositAmount?: number
			firstDepositCreditType?: components['schemas']['CreditType']
			firstDepositCreditAmount?: number
			firstDepositCreditRatio?: number
			firstDepositMaxCreditAmount?: number
			isRequireFirstDepositPromotion?: boolean
			commissionTiers: components['schemas']['InviteCommissionTierDto'][]
			returnLossMinimumLossAmount?: number
			returnLossCalculateInterval?: components['schemas']['CalculateInterval']
			isReturnLossEnabled?: boolean
			isDepositCommissionEnabled?: boolean
			isRequireDepositPromotion?: boolean
			depositCommissionMinimumAmount?: number
		}
		AdminInviteFriendCommissionHistoryResponse: {
			id: string
			playerId: string
			referredPlayerId: string
			playerPlayLogId?: string
			/** @enum {string} */
			commissionType: AdminInviteFriendCommissionHistoryResponseCommissionType
			/** @enum {string} */
			gameType?: AdminInviteFriendCommissionHistoryResponseGameType
			tier: number
			turnoverAmount: number
			lossAmount: number
			commissionRate: number
			commissionAmount: number
			balanceBefore: number
			balanceAfter: number
			/** Format: date-time */
			cumulatedAt?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			playerPhone: string
			referredPlayerPhone: string
		}
		AdminInviteFriendCommissionHistoryListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminInviteFriendCommissionHistoryResponse'][]
		}
		AdminInviteFriendTierCount: {
			/** @description Tier level (1 = direct referrals, 2+ = indirect) */
			tier: number
			/** @description Number of players at this tier level */
			count: number
		}
		AdminGetInviteFriendTierCountsResponse: {
			/** @description Array of tier counts */
			tierCounts: components['schemas']['AdminInviteFriendTierCount'][]
		}
		ReferralCommissionByGameType: {
			/** @enum {string} */
			gameType: ReferralCommissionByGameTypeGameType
			commissionAmount: number
		}
		ReferralPlayerCommissionData: {
			playerId: string
			/** @description Masked phone number */
			phone: string
			tier: number
			totalSignupCommission: number
			totalFirstDepositCommission: number
			totalTurnoverCommission: number
			totalReturnLossCommission: number
			totalAllCommissions: number
			turnoverCommissionByGameType: components['schemas']['ReferralCommissionByGameType'][]
			returnLossCommissionByGameType: components['schemas']['ReferralCommissionByGameType'][]
			/** Format: date-time */
			createdAt: string
		}
		ProfilePageBannerModel: {
			id: string
			title: string
			image: string
			type: components['schemas']['ProfilePageBannerType']
			link?: string
			gameCode?: string
			gameId?: string
			order: number
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		/** @enum {string} */
		ProfilePageBannerType: ProfilePageBannerType
		CreateProfilePageBannerDto: {
			title: string
			image: string
			type?: components['schemas']['ProfilePageBannerType']
			link?: string
			gameCode?: string
			/** @default true */
			isActive: boolean
		}
		UpdateProfilePageBannerDto: {
			title?: string
			image?: string
			link?: string
			order?: number
			type?: components['schemas']['ProfilePageBannerType']
			gameCode?: string
			isActive?: boolean
		}
		/** @enum {string} */
		CouponType: CouponType
		CreateCouponBatchDto: {
			/**
			 * @description Unique prefix for coupon codes (2-6 uppercase letters/numbers only, e.g., "SALE", "VIP", "NEW2024"). Required for SINGLE type only. Do not send for MULTIPLE type.
			 * @example SALE
			 */
			prefix?: string
			/** @description Promotion ID to associate with coupons (optional - if not provided, must provide creditAmount) */
			promotionId?: string
			/** @description Credit amount for non-promotion coupons (optional - if not provided, must provide promotionId) */
			creditAmount?: number
			/** @description Number of coupons to generate */
			quantity: number
			type: components['schemas']['CouponType']
			/** @description Maximum quota for SINGLE type coupons (how many times the single coupon can be used). Leave empty or null for unlimited usage. */
			maxQuota?: number
			/** @description Batch name for organizing coupons */
			batchName?: string
			/** @description Batch description */
			batchDescription?: string
			/** @description Require player to have connected LINE account to redeem */
			requireConnectedLine?: boolean
			/** @description Custom code for single coupon (only when quantity is 1) */
			customCode?: string
		}
		CouponBatchModel: {
			id: string
			name: string
			description?: string
			/** @description Unique prefix used for generating coupon codes in this batch */
			prefix?: string | null
			promotionId: string
			type: components['schemas']['CouponType']
			totalCoupons: number
			usedCoupons: number
			remainingCoupons: number
			maxQuota?: number | null
			usedQuota: number
			/** Format: date-time */
			expiresAt: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CreateCouponBatchResponse: {
			success: boolean
			message: string
			batch: components['schemas']['CouponBatchModel']
			codesGenerated: number
		}
		UpdateCouponBatchDto: {
			/** @description Updated batch name */
			name?: string
			/** @description Updated batch description */
			description?: string
			/** @description Update maximum quota for SINGLE type coupons. Leave empty or null for unlimited usage. */
			maxQuota?: number | null
			/** @description Update total capacity for MULTIPLE type coupons. Must be at least the used coupon count. */
			totalCoupons?: number
			/** @description Require player to have connected LINE account to redeem */
			requireConnectedLine?: boolean
			/** @description Whether the batch is active */
			isActive?: boolean
		}
		UpdateCouponBatchResponse: {
			success: boolean
			message: string
			batch: components['schemas']['CouponBatchModel']
		}
		GenerateAdditionalCouponsDto: {
			/** @description For MULTIPLE type: Number of additional coupons to generate. For SINGLE type: Additional quota to add. */
			quantity: number
		}
		GenerateAdditionalCouponsResponse: {
			success: boolean
			message: string
			codesGenerated: number
			totalCoupons: number
		}
		CouponBatchWithPromotionModel: {
			id: string
			name: string
			description?: string
			/** @description Unique prefix used for generating coupon codes in this batch */
			prefix?: string | null
			promotionId: string
			type: components['schemas']['CouponType']
			totalCoupons: number
			usedCoupons: number
			remainingCoupons: number
			maxQuota?: number | null
			usedQuota: number
			/** Format: date-time */
			expiresAt: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			promotion: Record<string, never>
		}
		GetCouponBatchesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['CouponBatchWithPromotionModel'][]
		}
		CouponModel: {
			id: string
			code: string
			promotionId: string
			status: string
			type: components['schemas']['CouponType']
			isUsed: boolean
			/** Format: date-time */
			usedAt?: string
			/** Format: date-time */
			expiresAt: string
			batchId?: string
			playerPhone?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetCouponsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['CouponModel'][]
		}
		CouponStatsModel: {
			totalBatches: number
			activeBatches: number
			totalCoupons: number
			activeCoupons: number
			usedCoupons: number
			expiredCoupons: number
		}
		GetCouponStatsResponse: {
			stats: components['schemas']['CouponStatsModel']
		}
		CouponForBrokeNotificationModel: {
			id: string
			code: string
		}
		GetCouponsForBrokeNotificationResponse: {
			data: components['schemas']['CouponForBrokeNotificationModel'][]
		}
		CouponUsageHistoryModel: {
			id: string
			couponId: string
			playerId: string
			playerPhone: string
			/** Format: date-time */
			usedAt: string
			/** Format: date-time */
			createdAt: string
		}
		GetCouponUsageHistoryResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['CouponUsageHistoryModel'][]
		}
		/** @enum {string} */
		ShopItemType: ShopItemType
		/** @enum {string} */
		CurrencyType: CurrencyType
		AdminShopItemPresetDataModel: {
			name: string
			description: string
			rewardType: components['schemas']['ShopItemType']
			amount: number
			price: number
			currencyType: components['schemas']['CurrencyType']
			betAmount?: number
		}
		AdminShopItemPresetModel: {
			id: string
			name: string
			description: string
			data: components['schemas']['AdminShopItemPresetDataModel']
		}
		AdminShopItemPresetListResponse: {
			presets: components['schemas']['AdminShopItemPresetModel'][]
		}
		AdminShopItemResponse: {
			id: string
			name: string
			description?: string
			rewardType: components['schemas']['ShopItemType']
			imageUrl?: string
			amount: number
			price: number
			currencyType: components['schemas']['CurrencyType']
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			presetId?: string
			gameId?: string
			betAmount?: number
		}
		AdminCreateShopItemDto: {
			/** @description Shop item name */
			name: string
			/** @description Shop item description */
			description?: string
			rewardType: components['schemas']['ShopItemType']
			/** @description Item image URL */
			imageUrl?: string
			/** @description Price of the item in diamonds */
			price: number
			/** @description Diamond reward amount for the item */
			amount: number
			currencyType: components['schemas']['CurrencyType']
			/**
			 * @description Whether item is active
			 * @default true
			 */
			isActive: boolean
			/** @description Preset ID for FREE_SPIN reward type (controls RTP) */
			presetId?: string
			/** @description Game ID for FREE_SPIN reward type */
			gameId?: string
			/** @description Bet amount for FREE_SPIN reward type */
			betAmount?: number
		}
		AdminShopItemListResponse: {
			data: components['schemas']['AdminShopItemResponse'][]
			total: number
			skip: number
			take: number
		}
		AdminUpdateShopItemDto: {
			/** @description Shop item name */
			name?: string
			/** @description Shop item description */
			description?: string
			rewardType?: components['schemas']['ShopItemType']
			/** @description Item image URL */
			imageUrl?: string
			/** @description Price of the item in diamonds */
			price?: number
			/** @description Diamond reward amount for the item */
			amount?: number
			currencyType?: components['schemas']['CurrencyType']
			/**
			 * @description Whether item is active
			 * @default true
			 */
			isActive: boolean
			/** @description Preset ID for FREE_SPIN reward type (controls RTP) */
			presetId?: string
			/** @description Game ID for FREE_SPIN reward type */
			gameId?: string
			/** @description Bet amount for FREE_SPIN reward type */
			betAmount?: number
		}
		/** @enum {string} */
		ShopHistoryStatus: ShopHistoryStatus
		AdminShopPurchaseAddressResponse: {
			name: string
			phone: string
			address: string
			province: string
			district: string
			subDistrict: string
			postalCode: string
		}
		AdminShopPurchaseResponse: {
			id: string
			playerId: string
			itemId: string
			amount: number
			status: components['schemas']['ShopHistoryStatus']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			adminNotes?: string
			trackingNumber?: string
			item: components['schemas']['AdminShopItemResponse']
			player: Record<string, never>
			price?: number
			shippingAddress?: components['schemas']['AdminShopPurchaseAddressResponse']
		}
		AdminShopPurchaseListResponse: {
			data: components['schemas']['AdminShopPurchaseResponse'][]
			total: number
			skip: number
			take: number
		}
		AdminProcessPurchaseDto: {
			status: components['schemas']['ShopHistoryStatus']
			/** @description Admin notes for this purchase */
			adminNotes?: string
			/** @description Tracking number for physical items */
			trackingNumber?: string
		}
		EventModel: {
			id: string
			/** @enum {string} */
			type?: EventModelType
			title: string
			bannerUrl?: string
			logoUrl?: string
			shortDescription?: string
			description?: string
			isActive: boolean
			linkUrl?: string
			order: number
			/** @enum {string} */
			status?: EventModelStatus
			/** Format: date-time */
			startDate?: string
			/** Format: date-time */
			endDate?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** @enum {string} */
			periodType?: EventModelPeriodType
			requiredTurnover?: string
			minBetAmount?: string
			rewardAmount?: string
			allowedGameTypes?: string
			allowedGameIds?: string
			allowedProviderIds?: string
			maxRewardsPerPlayer?: number
		}
		GetEventsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['EventModel'][]
		}
		GetEventResponse: {
			id: string
			/** @enum {string} */
			type: GetEventResponseType
			title: string
			bannerUrl?: string
			logoUrl?: string
			shortDescription?: string
			description?: string
			isActive: boolean
			linkUrl?: string
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CreateEventDto: {
			title: string
			bannerUrl?: string
			logoUrl?: string
			shortDescription?: string
			description?: string
			isActive: boolean
			linkUrl?: string
		}
		UpdateEventDto: {
			title?: string
			bannerUrl?: string
			logoUrl?: string
			shortDescription?: string
			description?: string
			isActive?: boolean
			linkUrl?: string
			order?: number
		}
		AdminCreateTurnoverEventDto: {
			/** @example SLOT การท้าประจำวัน */
			title: string
			/** @example เล่นเกมสล็อตยอดรวม 5,000 บาท รับทันที 50 บาท */
			description?: string
			/** @example https://example.com/images/event-banner.jpg */
			bannerUrl?: string
			/** @example 2026-03-13T00:00:00.000Z */
			startDate: string
			/** @example 2026-03-13T23:59:59.999Z */
			endDate: string
			/**
			 * @description Period type for turnover reset
			 * @example DAILY
			 * @enum {string}
			 */
			periodType: AdminCreateTurnoverEventDtoPeriodType
			/**
			 * @description Required turnover amount to get reward
			 * @example 5000
			 */
			requiredTurnover: number
			/**
			 * @description Minimum bet amount per transaction
			 * @example 50
			 */
			minBetAmount: number
			/**
			 * @description Reward amount when turnover is reached
			 * @example 50
			 */
			rewardAmount: number
			/**
			 * @description Comma-separated game type patterns (e.g., "SLOT", "CASINO", "SLOT,CASINO")
			 * @example SLOT
			 */
			allowedGameTypes?: string
			/**
			 * @description Comma-separated game IDs to allow
			 * @example game-uuid-1,game-uuid-2
			 */
			allowedGameIds?: string
			/**
			 * @description Comma-separated provider IDs to allow
			 * @example provider-uuid-1,provider-uuid-2
			 */
			allowedProviderIds?: string
			/**
			 * @description Maximum rewards per player per period (null = unlimited)
			 * @example 1
			 */
			maxRewardsPerPlayer?: number
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		AdminTurnoverEventResponse: {
			id: string
			title: string
			description?: string
			bannerUrl?: string
			/** @enum {string} */
			status: AdminTurnoverEventResponseStatus
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			/** @enum {string} */
			periodType: AdminTurnoverEventResponsePeriodType
			requiredTurnover: string
			minBetAmount: string
			rewardAmount: string
			allowedGameTypes?: string
			allowedGameIds?: string
			allowedProviderIds?: string
			/** @description Array of allowed games with details */
			allowedGames?: Record<string, never>[]
			/** @description Array of allowed providers with details */
			allowedProviders?: Record<string, never>[]
			maxRewardsPerPlayer?: number
			walletCondition?: components['schemas']['WalletConditionResponse']
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			/** @description Total number of claims */
			totalClaims: number
			/** @description Total reward amount distributed */
			totalRewardAmount: string
		}
		AdminTurnoverEventListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminTurnoverEventResponse'][]
		}
		AdminUpdateTurnoverEventDto: {
			/** @example SLOT การท้าประจำวัน */
			title?: string
			/** @example เล่นเกมสล็อตยอดรวม 5,000 บาท รับทันที 50 บาท */
			description?: string
			/** @example https://example.com/images/event-banner.jpg */
			bannerUrl?: string
			/** @example 2026-03-13T00:00:00.000Z */
			startDate?: string
			/** @example 2026-03-13T23:59:59.999Z */
			endDate?: string
			/** @enum {string} */
			periodType?: AdminUpdateTurnoverEventDtoPeriodType
			/** @example 5000 */
			requiredTurnover?: number
			/** @example 50 */
			minBetAmount?: number
			/** @example 50 */
			rewardAmount?: number
			allowedGameTypes?: string
			allowedGameIds?: string
			allowedProviderIds?: string
			maxRewardsPerPlayer?: number
			status?: string
			isActive?: boolean
			walletCondition?: components['schemas']['CreateWalletConditionDto']
		}
		AdminUpdateTurnoverEventStatusDto: {
			/** @enum {string} */
			status: AdminUpdateTurnoverEventStatusDtoStatus
		}
		AdminTurnoverEventRewardResponse: {
			id: string
			playerId: string
			playerPhone: string
			playerUsername?: string
			amount: string
			turnoverAchieved: string
			/** Format: date-time */
			periodStartDate: string
			balanceBefore: string
			balanceAfter: string
			/** Format: date-time */
			createdAt: string
		}
		AdminTurnoverEventRewardListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminTurnoverEventRewardResponse'][]
		}
		/** @enum {string} */
		SmsTransactionStatus: SmsTransactionStatus
		/** @enum {string} */
		MessageTransactionType: MessageTransactionType
		ParentCampaignInfo: {
			id: string
			message: string
			/** Format: date-time */
			scheduleDate?: string | null
			/** Format: date-time */
			sendDate?: string | null
			type: components['schemas']['MessageTransactionType']
		}
		/** @enum {string} */
		IntervalCondition: IntervalCondition
		IntervalMessageInfo: {
			id: string
			message: string
			intervalCondition: components['schemas']['IntervalCondition']
			/** @description Day of week (0-6) or date of month (1-31) */
			intervalValue: number
			/** @description Time to send message (HH:mm format) */
			sendTime: string
			messageTransactionType: components['schemas']['MessageTransactionType']
		}
		PlayerForTransactionModel: {
			id: string
			phone: string
			lineId?: string | null
		}
		SmsTransactionWithCampaign: {
			id: string
			status: components['schemas']['SmsTransactionStatus']
			successCount?: number | null
			creditUsed?: number | null
			/** @description Array of player IDs who received this SMS */
			sentPlayerIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			messageTransaction?: components['schemas']['ParentCampaignInfo']
			autoMessageTransaction?: components['schemas']['ParentCampaignInfo']
			intervalMessageTransaction?: components['schemas']['IntervalMessageInfo']
			/** @description Players who received this SMS */
			players: components['schemas']['PlayerForTransactionModel'][]
		}
		LineTransactionWithCampaign: {
			id: string
			/** @description Array of player IDs who successfully received this LINE message */
			successfulPlayerIds: string[]
			/** @description Array of player IDs who failed to receive this LINE message */
			failedPlayerIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			messageTransaction?: components['schemas']['ParentCampaignInfo']
			autoMessageTransaction?: components['schemas']['ParentCampaignInfo']
			intervalMessageTransaction?: components['schemas']['IntervalMessageInfo']
			/** @description Players who received this LINE message */
			players: components['schemas']['PlayerForTransactionModel'][]
		}
		GetSmsProvidersResponse: {
			id: string
			name: string
			userId: string
			creditAmount: number
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetSmsProviderSendersResponse: {
			id: string
			senderId: string
			senderName: string
			smsProviderId: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetMessageTransactionHistoryDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
		}
		/** @enum {string} */
		MessageGroupCondition: MessageGroupCondition
		/** @enum {string} */
		LineTransactionType: LineTransactionType
		SmsTransactionModel: {
			id: string
			status: components['schemas']['SmsTransactionStatus']
			successCount?: number | null
			creditUsed?: number | null
			/** @description Array of player IDs who received this SMS */
			sentPlayerIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		LineTransactionModel: {
			id: string
			/** @description Array of player IDs who successfully received this LINE message */
			successfulPlayerIds: string[]
			/** @description Array of player IDs who failed to receive this LINE message */
			failedPlayerIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		MessageTransactionModel: {
			id: string
			message: string
			/** Format: date-time */
			scheduleDate?: string | null
			/** Format: date-time */
			sendDate?: string | null
			messageGroupCondition: components['schemas']['MessageGroupCondition']
			minimum?: number | null
			maximum?: number | null
			messageTransactionType: components['schemas']['MessageTransactionType']
			lineTransactionType?: components['schemas']['LineTransactionType']
			flexJson?: Record<string, never> | null
			smsTransaction?: components['schemas']['SmsTransactionModel']
			lineTransaction?: components['schemas']['LineTransactionModel']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetMessageTransactionHistoryResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['MessageTransactionModel'][]
		}
		/**
		 * @description Enum values for frontend usage
		 * @enum {string}
		 */
		MessageConditionSingle: MessageConditionSingle
		/**
		 * @description Condition types enum
		 * @enum {string}
		 */
		MessageConditionType: MessageConditionType
		MessageConditionSingleConfigDto: {
			name: components['schemas']['MessageConditionSingle']
			type: components['schemas']['MessageConditionType']
			/** @description Whether this condition supports date range filtering */
			supportsDateRange: boolean
		}
		MessageConditionSingleResponse: {
			/** @description List of single message conditions configurations */
			conditions: components['schemas']['MessageConditionSingleConfigDto'][]
			enum: components['schemas']['MessageConditionSingle']
			types: components['schemas']['MessageConditionType']
		}
		/**
		 * @description Enum values for frontend usage
		 * @enum {string}
		 */
		MessageConditionAuto: MessageConditionAuto
		MessageConditionAutoConfigDto: {
			name: components['schemas']['MessageConditionAuto']
			type: components['schemas']['MessageConditionType']
			/** @description Whether this condition supports date range filtering */
			supportsDateRange: boolean
		}
		MessageConditionAutoResponse: {
			/** @description List of auto message conditions configurations */
			conditions: components['schemas']['MessageConditionAutoConfigDto'][]
			enum: components['schemas']['MessageConditionAuto']
			types: components['schemas']['MessageConditionType']
		}
		/**
		 * @description Message condition type (use MessageConditionSingle or MessageConditionAuto enum values)
		 * @enum {string}
		 */
		MessageCondition: MessageCondition
		GetPlayerByConditionDto: {
			condition: components['schemas']['MessageCondition']
			/** @description Minimum value for MIN_MAX or SINGLE type conditions */
			minimum?: number
			/** @description Maximum value for MIN_MAX type conditions */
			maximum?: number
			/**
			 * @description Phone numbers array for PHONE_NUMBERS type conditions
			 * @example [
			 *       "0812345678",
			 *       "0823456789"
			 *     ]
			 */
			phoneNumbers?: string[]
			/**
			 * @description Customer tag IDs for CUSTOMER_TAGS condition type
			 * @example [
			 *       "tag-id-1",
			 *       "tag-id-2"
			 *     ]
			 */
			tagIds?: string[]
			/**
			 * Format: date-time
			 * @description Start date for date range filter (only for conditions with supportsDateRange=true)
			 */
			startDate?: string
			/**
			 * Format: date-time
			 * @description End date for date range filter (only for conditions with supportsDateRange=true)
			 */
			endDate?: string
		}
		PlayerForMessagingModel: {
			id: string
			phone: string
			lineId?: string | null
			email?: string | null
			/** Format: date-time */
			createdAt?: string | null
		}
		/** @enum {string} */
		AutoMessageGroupCondition: AutoMessageGroupCondition
		SmsProviderModel: {
			id: string
			name: string
			userId: string
			creditAmount: number
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		SmsProviderSenderModel: {
			id: string
			senderId: string
			senderName: string
			smsProviderId: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AutoSmsTransactionModel: {
			id: string
			smsProviderId: string
			smsProviderSenderId: string
			SmsProvider: components['schemas']['SmsProviderModel']
			smsProviderSender: components['schemas']['SmsProviderSenderModel']
			processedPhoneNumbers: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AutoLineTransactionModel: {
			id: string
			processedLineIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetAutoMessageResponse: {
			id: string
			message: string
			/** Format: date-time */
			scheduleDate?: string | null
			/** Format: date-time */
			sendDate?: string | null
			autoMessageGroupCondition: components['schemas']['AutoMessageGroupCondition']
			minimum?: number | null
			maximum?: number | null
			messageTransactionType: components['schemas']['MessageTransactionType']
			lineTransactionType?: components['schemas']['LineTransactionType']
			flexJson?: Record<string, never> | null
			autoSmsTransaction?: components['schemas']['AutoSmsTransactionModel']
			autoLineTransaction?: components['schemas']['AutoLineTransactionModel']
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateAutoMessageDto: {
			/** @description Message text */
			message?: string
			/** @description Is active */
			isActive?: boolean
		}
		/**
		 * @description Message channels (SMS, LINE, or both)
		 * @enum {string}
		 */
		MessageChannel: MessageChannel
		CreateMessageTransactionDto: {
			senderId: string
			message: string
			/** @description Optional list of player phone numbers. If not provided or empty, players will be queried using playerCondition. For large player groups, omit this field to avoid payload size issues. */
			playerPhoneNumber?: string[]
			/** @description Player condition for grouping. Used to query players when playerPhoneNumber is not provided. */
			playerCondition: components['schemas']['GetPlayerByConditionDto']
			/** Format: date-time */
			scheduleDate: string
			type: components['schemas']['MessageTransactionType']
			/** @example [
			 *       "SMS",
			 *       "LINE"
			 *     ] */
			channels?: components['schemas']['MessageChannel'][]
			/** @description Hot game flex message setting ID (for LINE_HOT_GAME channel) */
			hotGameFlexMessageId?: string
			/**
			 * @description Deposit promotion IDs for promotion cards (for LINE_PROMOTION channel)
			 * @example [
			 *       "promo-id-1",
			 *       "promo-id-2"
			 *     ]
			 */
			promotionIds?: string[]
			/**
			 * @description Enable instant claim mode - generates shared claim link (zero-deposit promotion). Promotion validates customer tags on claim.
			 * @default false
			 */
			enableInstantClaim: boolean
		}
		GetMessageResponse: {
			id: string
			message: string
			/** Format: date-time */
			scheduleDate?: string | null
			/** Format: date-time */
			sendDate?: string | null
			messageGroupCondition: components['schemas']['MessageGroupCondition']
			minimum?: number | null
			maximum?: number | null
			messageTransactionType: components['schemas']['MessageTransactionType']
			lineTransactionType?: components['schemas']['LineTransactionType']
			flexJson?: Record<string, never> | null
			smsTransaction?: components['schemas']['SmsTransactionModel']
			lineTransaction?: components['schemas']['LineTransactionModel']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetChannelTransactionsDto: {
			/** @default 0 */
			skip: number
			/** @default 10 */
			take: number
			channel: components['schemas']['MessageChannel']
			/**
			 * Format: date-time
			 * @description Start date for filtering
			 */
			startDate?: string
			/**
			 * Format: date-time
			 * @description End date for filtering
			 */
			endDate?: string
		}
		GetChannelTransactionsResponse: {
			total: number
			take: number
			skip: number
			/** @description Array of SMS or LINE transactions with campaign info */
			data: (
				| components['schemas']['SmsTransactionWithCampaign']
				| components['schemas']['LineTransactionWithCampaign']
			)[]
		}
		ConversionMetricsByDays: {
			/** @description Conversion rate (percentage) */
			rate: number
			/** @description Number of unique players who converted */
			count: number
			/** @description Total amount (for deposits/withdraws) */
			amount: number
		}
		ConversionRateByDays: {
			day1: components['schemas']['ConversionMetricsByDays']
			day3: components['schemas']['ConversionMetricsByDays']
			day5: components['schemas']['ConversionMetricsByDays']
			day7: components['schemas']['ConversionMetricsByDays']
			day14: components['schemas']['ConversionMetricsByDays']
			day30: components['schemas']['ConversionMetricsByDays']
		}
		CategoryConversionMetrics: {
			/** @description Total recipients in this category */
			newDepositorRecipients: number
			/** @description Converted players count */
			newDepositorCount: number
			/** @description Total deposit amount from conversions */
			newDepositorAmount: number
			newDepositorByDay: components['schemas']['ConversionRateByDays']
			/** @description Total recipients in this category */
			inactive7dRecipients: number
			/** @description Converted players count */
			inactive7dCount: number
			/** @description Total deposit amount from conversions */
			inactive7dAmount: number
			inactive7dByDay: components['schemas']['ConversionRateByDays']
			/** @description Total recipients in this category */
			inactive14dRecipients: number
			/** @description Converted players count */
			inactive14dCount: number
			/** @description Total deposit amount from conversions */
			inactive14dAmount: number
			inactive14dByDay: components['schemas']['ConversionRateByDays']
			/** @description Total recipients in this category */
			inactive30dRecipients: number
			/** @description Converted players count */
			inactive30dCount: number
			/** @description Total deposit amount from conversions */
			inactive30dAmount: number
			inactive30dByDay: components['schemas']['ConversionRateByDays']
			/** @description Total recipients in this category */
			regularUserRecipients: number
			/** @description Converted players count */
			regularUserCount: number
			/** @description Total deposit amount from conversions */
			regularUserAmount: number
			regularUserByDay: components['schemas']['ConversionRateByDays']
		}
		ChannelAnalytics: {
			/** @description Total players targeted for messaging (all) */
			totalRecipients: number
			/** @description Players who successfully received the message (delivered) */
			successfulDeliveries: number
			/** @description Players who failed to receive the message (LINE only) */
			failedDeliveries: number
			/** @description Delivery success rate: successful / total (percentage) */
			deliveryRate: number
			/** @description Total unique players who deposited after receiving the message (all time) */
			totalDepositConversions: number
			/** @description Total unique players who withdrew after receiving the message (all time) */
			totalWithdrawConversions: number
			/** @description Total amount deposited by all converted players (all time) */
			totalDepositAmount: number
			/** @description Total amount withdrawn by all converted players (all time) */
			totalWithdrawAmount: number
			/** @description Conversion rate based on delivered messages: conversions / successful (percentage) */
			depositConversionRate: number
			/** @description Conversion rate based on delivered messages: conversions / successful (percentage) */
			withdrawConversionRate: number
			/** @description Deposit conversion rates and amounts by days */
			depositConversion: components['schemas']['ConversionRateByDays']
			/** @description Withdraw conversion rates and amounts by days */
			withdrawConversion: components['schemas']['ConversionRateByDays']
			depositConversionByCategory: components['schemas']['CategoryConversionMetrics']
		}
		CampaignAnalytics: {
			/** @description Total players targeted for messaging (all) */
			totalRecipients: number
			/** @description Players who successfully received the message (delivered) */
			successfulDeliveries: number
			/** @description Players who failed to receive the message (LINE only) */
			failedDeliveries: number
			/** @description Delivery success rate: successful / total (percentage) */
			deliveryRate: number
			/** @description Total unique players who deposited after receiving the message (all time) */
			totalDepositConversions: number
			/** @description Total unique players who withdrew after receiving the message (all time) */
			totalWithdrawConversions: number
			/** @description Total amount deposited by all converted players (all time) */
			totalDepositAmount: number
			/** @description Total amount withdrawn by all converted players (all time) */
			totalWithdrawAmount: number
			/** @description Conversion rate based on delivered messages: conversions / successful (percentage) */
			depositConversionRate: number
			/** @description Conversion rate based on delivered messages: conversions / successful (percentage) */
			withdrawConversionRate: number
			/** @description Deposit conversion rates and amounts by days */
			depositConversion: components['schemas']['ConversionRateByDays']
			/** @description Withdraw conversion rates and amounts by days */
			withdrawConversion: components['schemas']['ConversionRateByDays']
			depositConversionByCategory: components['schemas']['CategoryConversionMetrics']
			/** @description Campaign/Transaction ID */
			transactionId: string
			/** @description Message content */
			message: string
			/**
			 * @description Message type (IMMEDIATE, AUTO, SCHEDULED, INTERVAL)
			 * @enum {string}
			 */
			messageType: CampaignAnalyticsMessageType
			/**
			 * @description LINE message type: TEXT or FLEX_HOT_GAME (only for LINE messages)
			 * @enum {string|null}
			 */
			lineTransactionType?: CampaignAnalyticsLineTransactionType
			channel: components['schemas']['MessageChannel']
			/**
			 * Format: date-time
			 * @description When message was sent
			 */
			sentAt: string
		}
		MessagingAnalyticsResponse: {
			/** @description Overall analytics (SMS + LINE combined) */
			overall?: components['schemas']['ChannelAnalytics']
			/** @description Overall SMS analytics */
			smsOverall?: components['schemas']['ChannelAnalytics']
			/** @description Overall LINE analytics */
			lineOverall?: components['schemas']['ChannelAnalytics']
			/** @description Per-campaign breakdown for SMS */
			smsCampaigns: components['schemas']['CampaignAnalytics'][]
			/** @description Per-campaign breakdown for LINE */
			lineCampaigns: components['schemas']['CampaignAnalytics'][]
		}
		OpensByDayWindowResponse: {
			/** @description Opens within 1 day */
			day1: number
			/** @description Opens within 3 days */
			day3: number
			/** @description Opens within 7 days */
			day7: number
			/** @description Opens within 14 days */
			day14: number
			/** @description Opens within 30 days */
			day30: number
		}
		FlexMessageAnalyticsOverall: {
			/** @description Total recipients across all flex messages */
			totalRecipients: number
			/** @description Total unique openers across all flex messages */
			totalUniqueOpeners: number
			/** @description Total opens (including repeats) across all flex messages */
			totalOpens: number
			/** @description Total unique players who played across all flex messages */
			totalUniquePlayers: number
			/** @description Total plays across all flex messages */
			totalPlays: number
			/** @description Average open rate across all flex messages (totalUniqueOpeners / totalRecipients * 100) */
			avgOpenRate?: number
			/** @description Average play rate across all flex messages (totalUniquePlayers / totalUniqueOpeners * 100) */
			avgPlayRate?: number
			/** @description Average hours to open across all flex messages */
			avgHoursToOpen?: number
			/** @description Aggregated opens by day window */
			opensByDayWindow: components['schemas']['OpensByDayWindowResponse']
			/** @description Aggregated breakdown by wallet type */
			walletTypeBreakdown: Record<string, never>
			/** @description Aggregated breakdown by balance range */
			balanceRangeBreakdown: Record<string, never>
			/** @description Aggregated breakdown by game */
			gameBreakdown: Record<string, never>
			/** @description Number of flex messages included in this data */
			flexMessageCount: number
		}
		FlexMessageAnalyticsResponse: {
			/** @description Analytics record ID */
			id: string
			/** @description Hot game flex message ID */
			hotGameFlexMessageId: string
			/** @description Flex message name */
			flexMessageName: string
			/** @description Total recipients of the flex message */
			totalRecipients: number
			/** @description Unique players who opened the flex message */
			uniqueOpeners: number
			/** @description Total opens including repeat opens */
			totalOpens: number
			/** @description Unique players who actually played after opening */
			uniquePlayers: number
			/** @description Total play events from flex message opens */
			totalPlays: number
			/** @description Open rate (uniqueOpeners / totalRecipients) */
			openRate?: number
			/** @description Play rate (uniquePlayers / uniqueOpeners) */
			playRate?: number
			/** @description Average hours from message sent to first open */
			avgHoursToOpen?: number
			/** @description Opens by day window (cumulative) */
			opensByDayWindow: components['schemas']['OpensByDayWindowResponse']
			/** @description Breakdown by wallet type */
			walletTypeBreakdown: Record<string, never>
			/** @description Breakdown by balance range */
			balanceRangeBreakdown: Record<string, never>
			/** @description Breakdown by game */
			gameBreakdown: Record<string, never>
			/**
			 * Format: date-time
			 * @description Last time analytics were calculated
			 */
			lastCalculatedAt: string
			/**
			 * Format: date-time
			 * @description When the record was created
			 */
			createdAt: string
			/**
			 * Format: date-time
			 * @description When the record was last updated
			 */
			updatedAt: string
		}
		FlexMessageAnalyticsListResponse: {
			/** @description Aggregated stats across all flex messages */
			overall?: components['schemas']['FlexMessageAnalyticsOverall']
			data: components['schemas']['FlexMessageAnalyticsResponse'][]
		}
		RecalculateFlexMessageAnalyticsDto: {
			/** @description Specific hot game flex message ID to recalculate. If not provided, recalculates all. */
			hotGameFlexMessageId?: string
		}
		FlexMessageAnalyticsRecalculateResponse: {
			/** @description Number of flex messages successfully recalculated */
			successCount: number
			/** @description Number of flex messages that failed to recalculate */
			errorCount: number
		}
		CreateIntervalMessageDto: {
			/** @description Message text */
			message: string
			/**
			 * @description Interval condition (DAY_OF_WEEK or DATE_OF_MONTH)
			 * @enum {string}
			 */
			intervalCondition: CreateIntervalMessageDtoIntervalCondition
			/** @description Interval value (0-6 for day of week, 1-31 for date of month) */
			intervalValue: number
			/**
			 * @description Send time in HH:MM format (Bangkok timezone)
			 * @example 09:00
			 */
			sendTime?: string
			messageGroupCondition: components['schemas']['MessageGroupCondition']
			/** @description Minimum value for conditions that require range */
			minimum?: number
			/** @description Maximum value for conditions that require range */
			maximum?: number
			/**
			 * @description Allow resending to same recipients on recurring intervals
			 * @default false
			 */
			allowResend: boolean
			channels: components['schemas']['MessageChannel'][]
			/** @description SMS provider sender ID (required if SMS channel is selected) */
			senderId?: string
			/** @description Hot game flex message setting ID (for LINE_HOT_GAME channel) */
			hotGameFlexMessageId?: string
		}
		IntervalSmsTransactionModel: {
			id: string
			smsProviderId: string
			smsProviderSenderId: string
			processedPhoneNumbers: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		IntervalLineTransactionModel: {
			id: string
			processedLineIds: string[]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		IntervalMessageTransactionModel: {
			id: string
			message: string
			intervalCondition: components['schemas']['IntervalCondition']
			intervalValue: number
			sendTime?: string | null
			messageGroupCondition: components['schemas']['MessageGroupCondition']
			minimum?: number | null
			maximum?: number | null
			allowResend: boolean
			/** Format: date-time */
			lastSentDate?: string | null
			messageTransactionType: components['schemas']['MessageTransactionType']
			lineTransactionType?: components['schemas']['LineTransactionType']
			flexJson?: Record<string, never> | null
			intervalSmsTransaction?:
				| components['schemas']['IntervalSmsTransactionModel']
				| null
			intervalLineTransaction?:
				| components['schemas']['IntervalLineTransactionModel']
				| null
			isActive: boolean
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetIntervalMessagesResponse: {
			data: components['schemas']['IntervalMessageTransactionModel'][]
			total: number
		}
		UpdateIntervalMessageDto: {
			/** @description Message text */
			message?: string
			/** @description Is active */
			isActive?: boolean
		}
		BrokeNotificationModel: {
			id: string
			title: string
			content?: string
			imageUrl?: string
			link?: string
			linkText?: string
			/** @enum {string} */
			type: BrokeNotificationModelType
			order: number
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		BrokeNotificationListResponse: {
			data: components['schemas']['BrokeNotificationModel'][]
		}
		BrokeNotificationStatsModel: {
			notificationId: string
			title: string
			order: number
			totalViews: number
			uniquePlayers: number
		}
		BrokeNotificationStatsResponse: {
			data: components['schemas']['BrokeNotificationStatsModel'][]
		}
		BrokeNotificationResponse: {
			notification: components['schemas']['BrokeNotificationModel'] | null
			/** @description Broke event number (deprecated - not used, frontend handles with session) */
			brokeEventNumber: number
			/** @description Whether there are more notifications configured */
			hasMoreNotifications: boolean
			/** @description Message explaining why notification was not shown */
			message: string | null
		}
		CreateBrokeNotificationDto: {
			/** @description Notification title */
			title: string
			/** @description Notification content */
			content?: string
			/** @description Image URL */
			imageUrl?: string
			/** @description Link to navigate to (e.g., /return-loss, /commission) */
			link?: string
			/** @description Text for the link button */
			linkText?: string
			/**
			 * @description Type of event this notification is for
			 * @enum {string}
			 */
			type: CreateBrokeNotificationDtoType
			/** @description Display order (determines when notification is shown) */
			order: number
			/** @description Deposit promotion ID (required if type is DEPOSIT_PROMOTION) */
			depositPromotionId?: string
			/** @description Shop item ID (required if type is SHOP) */
			shopItemId?: string
			/** @description Coupon code (required if type is COUPON) */
			couponCode?: string
			/**
			 * @description Whether notification is active
			 * @default true
			 */
			isActive: boolean
		}
		UpdateBrokeNotificationDto: {
			/** @description Notification title */
			title?: string
			/** @description Notification content (can be null for image-only) */
			content?: string
			/** @description Image URL */
			imageUrl?: string
			/** @description Link to navigate to */
			link?: string
			/** @description Text for the link button */
			linkText?: string
			/**
			 * @description Type of event
			 * @enum {string}
			 */
			type?: UpdateBrokeNotificationDtoType
			/** @description Display order */
			order?: number
			/** @description Deposit promotion ID */
			depositPromotionId?: string
			/** @description Shop item ID */
			shopItemId?: string
			/** @description Coupon code */
			couponCode?: string
			/** @description Whether notification is active */
			isActive?: boolean
		}
		CreateBrokeFlexMessageItemDto: {
			/**
			 * @description Type of bonus/promotion item
			 * @enum {string}
			 */
			type: CreateBrokeFlexMessageItemDtoType
			/** @description Display order in the list */
			order: number
			/**
			 * @description How to check if player is eligible
			 * @enum {string}
			 */
			eligibilityType: CreateBrokeFlexMessageItemDtoEligibilityType
			/** @description Minimum value required for eligibility (e.g., balance >= 100) */
			minValue?: number
			/** @description Display name shown to player */
			displayName: string
			/**
			 * @description Icon emoji
			 * @default 🎁
			 */
			icon: string
			/** @description Short description */
			description?: string
			/** @description Custom message for this item */
			message?: string
			/** @description Image URL for this item */
			imageUrl?: string
			/** @description Promotion ID (for DEPOSIT_PROMOTION type) */
			promotionId?: string
			/** @description Coupon code (for COUPON type) */
			couponCode?: string
			/** @description Action URL (for CUSTOM_LINK type) */
			actionUrl?: string
			/**
			 * @description Enable/disable this item
			 * @default true
			 */
			enabled: boolean
		}
		CreateBrokeFlexMessageStageDto: {
			/**
			 * @description Minutes to wait after trigger before sending this stage
			 * @example 0
			 */
			minutesAfterTrigger: number
			/** @description Message text for this stage */
			message: string
			/**
			 * @description Maximum number of items to show in this stage
			 * @default 3
			 */
			maxItemsToShow: number
			/** @description Display order of this stage */
			order: number
			/** @description Items to show in this stage */
			items: components['schemas']['CreateBrokeFlexMessageItemDto'][]
		}
		CreateBrokeFlexMessageCampaignDto: {
			/**
			 * @description Campaign name for easy identification
			 * @example VIP Recovery Campaign
			 */
			name?: string
			/** @description Progressive stages for this campaign */
			stages: components['schemas']['CreateBrokeFlexMessageStageDto'][]
			/**
			 * @description Activate campaign immediately
			 * @default true
			 */
			isActive: boolean
		}
		AdminBrokeFlexMessageItemModel: {
			id: string
			/** @enum {string} */
			type: AdminBrokeFlexMessageItemModelType
			order: number
			/** @enum {string} */
			eligibilityType: AdminBrokeFlexMessageItemModelEligibilityType
			minValue?: number
			displayName: string
			icon: string
			description?: string
			message?: string
			imageUrl?: string
			promotionId?: string
			couponCode?: string
			actionUrl?: string
			enabled: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminBrokeFlexMessageStageModel: {
			id: string
			minutesAfterTrigger: number
			message: string
			order: number
			maxItemsToShow: number
			items: components['schemas']['AdminBrokeFlexMessageItemModel'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminBrokeFlexMessageSettingsModel: {
			id: string
			stages: components['schemas']['AdminBrokeFlexMessageStageModel'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminBrokeFlexMessageCampaignModel: {
			id: string
			name?: string
			autoMessageGroupCondition: string
			minimum?: number
			isActive: boolean
			isMultiStage: boolean
			brokeNotificationSettings?: components['schemas']['AdminBrokeFlexMessageSettingsModel']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminBrokeFlexMessageCampaignResponse: {
			success: boolean
			data: components['schemas']['AdminBrokeFlexMessageCampaignModel']
		}
		AdminBrokeFlexMessageCampaignListResponse: {
			success: boolean
			data: components['schemas']['AdminBrokeFlexMessageCampaignModel'][]
			total: number
		}
		UpdateBrokeFlexMessageStageDto: {
			/**
			 * @description Minutes to wait after trigger before sending this stage
			 * @example 0
			 */
			minutesAfterTrigger: number
			/** @description Message text for this stage */
			message: string
			/**
			 * @description Maximum number of items to show in this stage
			 * @default 3
			 */
			maxItemsToShow: number
			/** @description Display order of this stage */
			order: number
			/** @description Items to show in this stage */
			items: components['schemas']['CreateBrokeFlexMessageItemDto'][]
		}
		UpdateBrokeFlexMessageCampaignDto: {
			/**
			 * @description Campaign name for easy identification
			 * @example VIP Recovery Campaign
			 */
			name?: string
			/** @description Progressive stages for this campaign */
			stages?: components['schemas']['UpdateBrokeFlexMessageStageDto'][]
			/** @description Activate/deactivate campaign */
			isActive?: boolean
		}
		PresetInfoResponse: {
			/** @enum {string} */
			preset: PresetInfoResponsePreset
			name: string
			description: string
			defaultMaxItems: number
			requiredFields: string[]
			optionalFields: string[]
		}
		PresetsListResponse: {
			success: boolean
			data: components['schemas']['PresetInfoResponse'][]
		}
		CreateFromPresetDto: {
			/**
			 * @description Campaign name for easy identification
			 * @example Weekend Broke Campaign
			 */
			name?: string
			/**
			 * @description Preset template to use
			 * @example SIMPLE_PROMOTION
			 * @enum {string}
			 */
			preset: CreateFromPresetDtoPreset
			/**
			 * @description Promotion IDs to include
			 * @example [
			 *       "promo-id-1",
			 *       "promo-id-2"
			 *     ]
			 */
			promotionIds?: string[]
			/**
			 * @description Coupon codes to include
			 * @example [
			 *       "VIP100",
			 *       "NEWBIE50"
			 *     ]
			 */
			couponCodes?: string[]
			/**
			 * @description Include return loss wallet bonus
			 * @default false
			 */
			includeReturnLoss: boolean
			/**
			 * @description Include commission wallet bonus
			 * @default false
			 */
			includeCommission: boolean
			/**
			 * @description Include invite friend wallet bonus
			 * @default false
			 */
			includeInviteFriend: boolean
			/**
			 * @description Message text to display
			 * @example หมดเครดิตแล้วหรอ? เติมเลยรับโบนัส!
			 */
			message: string
			/**
			 * @description Activate campaign immediately
			 * @default true
			 */
			isActive: boolean
		}
		AddStageDto: {
			/**
			 * @description Minutes to wait after trigger before sending this stage
			 * @example 30
			 */
			minutesAfter: number
			/**
			 * @description Message text for this stage
			 * @example ยังไม่ฝากอีกเหรอ? โปรใหญ่มาแล้ว!
			 */
			message: string
			/** @description Promotion IDs to include in this stage */
			promotionIds?: string[]
			/** @description Coupon codes to include in this stage */
			couponCodes?: string[]
			/**
			 * @description Include return loss wallet bonus
			 * @default false
			 */
			includeReturnLoss: boolean
			/**
			 * @description Include commission wallet bonus
			 * @default false
			 */
			includeCommission: boolean
			/**
			 * @description Include invite friend wallet bonus
			 * @default false
			 */
			includeInviteFriend: boolean
			/**
			 * @description Maximum items to show per player
			 * @default 3
			 */
			maxItemsToShow: number
		}
		AttachDomainDto: {
			/** @description The domain to attach (e.g., "foo.example.com") */
			domain: string
		}
		AttachDomainResponse: {
			success: boolean
			message: string
		}
		DetachDomainDto: {
			/** @description The domain to detach (e.g., "foo.example.com") */
			domain: string
		}
		DetachDomainResponse: {
			success: boolean
			message: string
		}
		GetDomainsResponse: {
			clientDomain: string
			domains: string[]
		}
		InvalidateCacheDto: {
			/** @description The type of cache to invalidate (e.g., "image", "video") */
			path: string
		}
		InvalidateCacheResponse: {
			success: boolean
			message: string
		}
		HotGameFlexMessageGameModel: {
			id: string
			messageId: string
			gameId?: string
			preset?: string
			/** @enum {string} */
			gameType?: HotGameFlexMessageGameModelGameType
			gameTypes: HotGameFlexMessageGameModelGameTypes[]
			isRandomized: boolean
			winProbability?: number
			freeSpinChance?: number
			maxMultiplier?: number
			bonusAmount?: number
			includedProviderIds: string[]
			excludedProviderIds: string[]
			includedGameIds: string[]
			excludedGameIds: string[]
			includedPresets: string[]
			excludedPresets: string[]
			winProbabilityMin?: number
			winProbabilityMax?: number
			freeSpinChanceMin?: number
			freeSpinChanceMax?: number
			maxMultiplierMin?: number
			maxMultiplierMax?: number
			bonusAmountMin?: number
			bonusAmountMax?: number
			order: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		HotGameFlexMessageModel: {
			id: string
			name: string
			description?: string
			isActive: boolean
			games: components['schemas']['HotGameFlexMessageGameModel'][]
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		CreateHotGameFlexMessageResponse: {
			success: boolean
			data: components['schemas']['HotGameFlexMessageModel']
		}
		GetHotGameFlexMessageResponse: {
			success: boolean
			data: components['schemas']['HotGameFlexMessageModel']
		}
		GetHotGameFlexMessagesResponse: {
			success: boolean
			data: {
				items?: components['schemas']['HotGameFlexMessageModel'][]
				total?: number
				page?: number
				pageSize?: number
				totalPages?: number
			}
		}
		UpdateHotGameFlexMessageResponse: {
			success: boolean
			data: components['schemas']['HotGameFlexMessageModel']
		}
		DeleteHotGameFlexMessageResponse: {
			success: boolean
			message: string
		}
		HotGameSlotDataDto: {
			/** @description Win probability (0-100) */
			winProbability: number
			/** @description Free spin chance (0-100) */
			freeSpinChance: number
			/** @description Max multiplier */
			maxMultiplier: number
		}
		HotGameNonSlotDataDto: {
			/** @description Bonus amount */
			bonusAmount: number
		}
		SlotDataRangeDto: {
			/** @description Min win probability (0-100) */
			winProbabilityMin: number
			/** @description Max win probability (0-100) */
			winProbabilityMax: number
			/** @description Min free spin chance (0-100) */
			freeSpinChanceMin: number
			/** @description Max free spin chance (0-100) */
			freeSpinChanceMax: number
			/** @description Min max multiplier */
			maxMultiplierMin: number
			/** @description Max max multiplier */
			maxMultiplierMax: number
		}
		NonSlotDataRangeDto: {
			/** @description Min bonus amount */
			bonusAmountMin: number
			/** @description Max bonus amount */
			bonusAmountMax: number
		}
		FlexMessagePresetGameItemModel: {
			isRandomized: boolean
			order: number
			/** @enum {string} */
			gameType?: FlexMessagePresetGameItemModelGameType
			gameTypes?: FlexMessagePresetGameItemModelGameTypes[]
			providerNames?: string[]
			slotData?: components['schemas']['HotGameSlotDataDto']
			nonSlotData?: components['schemas']['HotGameNonSlotDataDto']
			slotDataRange?: components['schemas']['SlotDataRangeDto']
			nonSlotDataRange?: components['schemas']['NonSlotDataRangeDto']
		}
		FlexMessagePresetModel: {
			id: string
			name: string
			description: string
			games: components['schemas']['FlexMessagePresetGameItemModel'][]
		}
		FlexMessagePresetListResponse: {
			data: components['schemas']['FlexMessagePresetModel'][]
		}
		DuplicateFlexMessagePresetResponse: {
			success: boolean
			data: components['schemas']['HotGameFlexMessageModel']
		}
		ProviderFilterDto: {
			/** @description Provider IDs to include (mutually exclusive with excluded) */
			includedProviderIds?: string[]
			/** @description Provider IDs to exclude (mutually exclusive with included) */
			excludedProviderIds?: string[]
		}
		GameFilterDto: {
			/** @description Game IDs to include (mutually exclusive with excluded) */
			includedGameIds?: string[]
			/** @description Game IDs to exclude (mutually exclusive with included) */
			excludedGameIds?: string[]
		}
		PresetFilterDto: {
			/** @description Presets to include (mutually exclusive with excluded) */
			includedPresets?: string[]
			/** @description Presets to exclude (mutually exclusive with included) */
			excludedPresets?: string[]
		}
		HotGameItemDto: {
			/**
			 * @description Whether this item uses randomization
			 * @default false
			 */
			isRandomized: boolean
			/** @description Game ID (required when isRandomized = false) */
			gameId?: string
			/** @description Optional winning probability preset ID (for fixed items) */
			preset?: string
			/** @description Fixed slot data (required when isRandomized = false and gameType = SLOT) */
			slotData?: components['schemas']['HotGameSlotDataDto']
			/** @description Fixed non-slot data (required when isRandomized = false and gameType != SLOT) */
			nonSlotData?: components['schemas']['HotGameNonSlotDataDto']
			/** @description Provider filter for randomization */
			providerFilter?: components['schemas']['ProviderFilterDto']
			/** @description Game filter for randomization */
			gameFilter?: components['schemas']['GameFilterDto']
			/** @description Preset filter for randomization */
			presetFilter?: components['schemas']['PresetFilterDto']
			/** @description Slot data range for randomization (required when isRandomized = true and gameTypes includes SLOT) */
			slotDataRange?: components['schemas']['SlotDataRangeDto']
			/** @description Non-slot data range for randomization (required when isRandomized = true and gameTypes includes any non-SLOT type) */
			nonSlotDataRange?: components['schemas']['NonSlotDataRangeDto']
			gameType?: components['schemas']['GameType']
			gameTypes?: components['schemas']['GameType'][]
			/** @description Display order in carousel */
			order?: number
		}
		CreateHotGameFlexMessageDto: {
			/** @description Hot game setting name for admin reference */
			name: string
			/** @description Optional description */
			description?: string
			/** @description Games in this hot game setting (max 10) */
			games: components['schemas']['HotGameItemDto'][]
		}
		UpdateHotGameFlexMessageDto: {
			/** @description Hot game setting name */
			name?: string
			/** @description Description */
			description?: string
			/** @description Games in this hot game setting (max 10) */
			games?: components['schemas']['HotGameItemDto'][]
			/** @description Active status */
			isActive?: boolean
		}
		RangeResponse: {
			/**
			 * @description Lookback window in minutes
			 * @example 60
			 */
			minutes: number
			/**
			 * @description Metric granularity in seconds
			 * @example 300
			 */
			periodSeconds: number
		}
		DataPoint: {
			/**
			 * @description Timestamp in ISO format
			 * @example 2024-01-01T00:00:00Z
			 */
			timestamp: string
			/**
			 * @description Metric value
			 * @example 45.5
			 */
			value: Record<string, never> | null
		}
		CpuMetricsResponse: {
			/**
			 * @description Average CPU utilization percentage
			 * @example 45.5
			 */
			average: Record<string, never> | null
			/**
			 * @description Maximum CPU utilization percentage
			 * @example 85.2
			 */
			max: Record<string, never> | null
			/**
			 * @description Number of data points
			 * @example 12
			 */
			datapoints: number
			/** @description Time-series data points */
			timeSeries: components['schemas']['DataPoint'][]
		}
		MemoryMetricsResponse: {
			/**
			 * @description Average memory utilization percentage
			 * @example 60.3
			 */
			average: Record<string, never> | null
			/**
			 * @description Maximum memory utilization percentage
			 * @example 90.1
			 */
			max: Record<string, never> | null
			/**
			 * @description Number of data points
			 * @example 12
			 */
			datapoints: number
			/** @description Time-series data points */
			timeSeries: components['schemas']['DataPoint'][]
		}
		TasksResponse: {
			/**
			 * @description Desired number of tasks
			 * @example 3
			 */
			desired: number
			/**
			 * @description Running number of tasks
			 * @example 3
			 */
			running: number
			/**
			 * @description Pending number of tasks
			 * @example 0
			 */
			pending: number
		}
		TaskMetric: {
			/**
			 * @description Task display name (masked)
			 * @example PROJECT-1
			 */
			taskName: string
			/**
			 * @description Task ID (for querying detailed metrics)
			 * @example 7ea043e26f5245749009578c36f47b97
			 */
			taskId: string
			/**
			 * @description Task CPU utilization percentage
			 * @example 45.5
			 */
			cpu: Record<string, never> | null
			/**
			 * @description Task memory utilization percentage
			 * @example 60.3
			 */
			memory: Record<string, never> | null
			/**
			 * @description Task last status
			 * @example RUNNING
			 */
			lastStatus: string
			/**
			 * @description Task health status
			 * @example HEALTHY
			 */
			healthStatus: Record<string, never> | null
		}
		GetEcsServiceCpuMemResponse: {
			/** @description Time range configuration */
			range: components['schemas']['RangeResponse']
			/** @description CPU metrics */
			cpu: components['schemas']['CpuMetricsResponse']
			/** @description Memory metrics */
			memory: components['schemas']['MemoryMetricsResponse']
			/** @description Database CPU metrics */
			databaseCpu: components['schemas']['CpuMetricsResponse']
			/** @description Task counts */
			tasks: components['schemas']['TasksResponse']
			/** @description Per-task metrics */
			taskMetrics: components['schemas']['TaskMetric'][]
		}
		GetTaskMetricsResponse: {
			/**
			 * @description Task display name
			 * @example PROJECT-1
			 */
			taskName: string
			/** @description Time range configuration */
			range: components['schemas']['RangeResponse']
			/** @description CPU time-series data */
			cpu: components['schemas']['DataPoint'][]
			/** @description Memory time-series data */
			memory: components['schemas']['DataPoint'][]
		}
		LineStickerModel: {
			/** @description Sticker ID (internal) */
			id: string
			/** @description LINE package ID */
			packageId: string
			/** @description LINE sticker ID */
			stickerId: string
			/** @description URL to sticker image */
			stickerUrl: string
			/**
			 * Format: date-time
			 * @description Created timestamp
			 */
			createdAt: string
		}
		LineStickerPackageModel: {
			/** @description Package ID (internal) */
			id: string
			/** @description LINE package ID */
			packageId: string
			/** @description Package display name */
			name: string
			/** @description Whether the package is active */
			isActive: boolean
			/** @description Stickers in this package */
			stickers?: components['schemas']['LineStickerModel'][]
			/**
			 * Format: date-time
			 * @description Created timestamp
			 */
			createdAt: string
		}
		GetLineStickerPackagesResponse: {
			data: components['schemas']['LineStickerPackageModel'][]
		}
		GetLineStickerPackageResponse: {
			data: components['schemas']['LineStickerPackageModel']
		}
		GetLineStickersResponse: {
			data: components['schemas']['LineStickerModel'][]
		}
		/**
		 * @description Type of LINE auto message log
		 * @enum {string}
		 */
		LineAutoMessageLogType: LineAutoMessageLogType
		AdminLineAutoMessageLogModel: {
			id: string
			logType: components['schemas']['LineAutoMessageLogType']
			/** @description Array of message text previews */
			message: string[]
			xLineRequestId?: string
			totalTargeted: number
			successCount: number
			failedCount: number
			skippedCount: number
			operatorId?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminGetLineMessageLogsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminLineAutoMessageLogModel'][]
		}
		AdminLineMessageLogMessageModel: {
			id: string
			chatRoomId: string
			direction: components['schemas']['ChatMessageDirection']
			messageType: components['schemas']['ChatMessageType']
			text?: string
			stickerPackageId?: string
			stickerId?: string
			imageOriginalUrl?: string
			imagePreviewUrl?: string
			videoOriginalUrl?: string
			videoPreviewUrl?: string
			flexAltText?: string
			flexContents?: Record<string, never>
			/** Format: date-time */
			createdAt: string
		}
		AdminGetLineMessageLogMessagesResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['AdminLineMessageLogMessageModel'][]
		}
		AdminGetLineMessageLogGroupedResponse: {
			messages: components['schemas']['AdminLineMessageLogMessageModel'][]
			totalMessages: number
			totalChatRooms: number
			chatRoomIds: string[]
		}
		AdminAssetsResponse: {
			id: string
			withdrawSoundUrl?: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		UpdateAdminAssetsDto: {
			withdrawSoundUrl?: string | null
		}
		AdminOtpProviderResponse: {
			id: string
			name: string
			otpKey: string
			otpSecret: string
			isActive: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		AdminCreateOtpProviderDto: {
			/**
			 * @description OTP provider name
			 * @example ThaiBulkSMS Production
			 */
			name: string
			/**
			 * @description OTP API Key
			 * @example 1828939416034155
			 */
			otpKey: string
			/**
			 * @description OTP API Secret
			 * @example 391e6c38df5c2a550d03f6af152f961a
			 */
			otpSecret: string
		}
		AdminUpdateOtpProviderDto: {
			/**
			 * @description OTP provider name
			 * @example ThaiBulkSMS Production
			 */
			name?: string
			/**
			 * @description OTP API Key
			 * @example 1828939416034155
			 */
			otpKey?: string
			/**
			 * @description OTP API Secret
			 * @example 391e6c38df5c2a550d03f6af152f961a
			 */
			otpSecret?: string
			/** @description Is provider active */
			isActive?: boolean
		}
		GenerateUploadFileUrlDto: {
			fileExtension: string
		}
		GetPresignedUrlResponse: {
			presignedUrl: string
			fileUrl: string
		}
		InvalidateImageCacheDto: {
			imageUrl: string
		}
		InvalidateImageCacheResponse: {
			success: boolean
			message?: string
		}
		UploadFileResponse: {
			success: boolean
			fileUrl: string
			message?: string
		}
		GenerateFaviconsResponse: {
			favicon16: string
			favicon32: string
			appleIcon: string
			faviconIco: string
		}
		UploadCustomCssDto: {
			/** @description CSS content as string */
			cssContent: string
		}
		/**
		 * @description The provider type of the transaction
		 * @enum {string}
		 */
		BankTransactionMethod: BankTransactionMethod
		/** @enum {string} */
		BankTransactionType: BankTransactionType
		/**
		 * @description The status of the transaction
		 * @enum {string}
		 */
		BankTransactionStatus: BankTransactionStatus
		UpdateTransactionsDto: {
			/**
			 * @description The transaction id
			 * @example 1234567890
			 */
			id?: string
			/** @example BANK */
			method: components['schemas']['BankTransactionMethod']
			/** @example DEPOSIT */
			type: components['schemas']['BankTransactionType']
			status: components['schemas']['BankTransactionStatus']
			/**
			 * @description The process by bank id
			 * @example 1234567890
			 */
			processByBankId?: string
			/**
			 * @description The transfer amount
			 * @example 1000
			 */
			amount: number
			/**
			 * @description The error message
			 * @example The transfer failed
			 */
			errorMessage?: string
			/**
			 * @description The blockchain transaction hash (for CRYPTO_INVOICE type)
			 * @example 0x1234567890abcdef...
			 */
			txHash?: string
			/** @description Amount matched so far (for P2P progressive updates) */
			matchedAmount?: number
			/** @description Amount refunded (for P2P partial match / timeout) */
			refundAmount?: number
			/** @description Bank-generated notification id (for SMS_AUTO linking) */
			notificationId?: string
		}
		BulkCreateTransactionsDto: {
			/** @description The transactions */
			transactions: components['schemas']['UpdateTransactionsDto'][]
		}
		/**
		 * @description The status of the transaction
		 * @enum {string}
		 */
		TransferStatus: TransferStatus
		PaymentGatewayErrors: {
			/**
			 * @description The error message
			 * @example The transfer failed
			 */
			paymentGatewayId: string
			/**
			 * @description The error message
			 * @example The transfer failed
			 */
			errorMessage?: string
			/** @description Bank-generated notification id (for SMS_AUTO linking) */
			notificationId?: string
		}
		UpdateTransferTransactionDto: {
			/**
			 * @description The transaction id
			 * @example 1234567890
			 */
			transactionId: string
			/** @example COMPLETED */
			status: components['schemas']['TransferStatus']
			/**
			 * @description The transfer amount
			 * @example 1000
			 */
			transferAmount: number
			/**
			 * @description The error message
			 * @example The transfer failed
			 */
			errorMessage?: string
			/**
			 * @description The is error
			 * @example true
			 */
			isError: boolean
			/** @description The payment gateway errors */
			paymentGatewayErrors: components['schemas']['PaymentGatewayErrors'][]
		}
		UpdateStatusTransactionDto: {
			/**
			 * @description The bank id
			 * @example 1234567890
			 */
			bankIdList: string[]
			/**
			 * @description The status of the bank
			 * @example true
			 */
			isHealthy: boolean
		}
		NotifyTrueWalletTransactionLogToAutoServerRequestDto: {
			paymentGatewayId: string
			reportId: string
			type: components['schemas']['BankTransactionType']
			method: components['schemas']['TransactionMethod']
			amount: number
			name: string
			phoneNumber: string
			dateTime: string
		}
		BulkNotifyTrueWalletTransactionLogDto: {
			/** @description The transactions */
			transactions: components['schemas']['NotifyTrueWalletTransactionLogToAutoServerRequestDto'][]
		}
		NotifySMSAutoTransactionLogToAutoServerRequestDto: {
			paymentGatewayId: string
			method: components['schemas']['TransactionMethod']
			amount: number
			accountNumber: string
			message?: string
			notificationId?: string
		}
		BulkNotifySMSAutoTransactionLogDto: {
			/** @description The transactions */
			transactions: components['schemas']['NotifySMSAutoTransactionLogToAutoServerRequestDto'][]
		}
		MaintenanceNotifyItemDto: {
			bankProviderName: string
			depositMaintenanceStartAt?: Record<string, never>
			depositMaintenanceEndAt?: Record<string, never>
			withdrawMaintenanceStartAt?: Record<string, never>
			withdrawMaintenanceEndAt?: Record<string, never>
		}
		MaintenanceNotifyDto: {
			/** @description Maintenance status per provider */
			maintenances: components['schemas']['MaintenanceNotifyItemDto'][]
		}
		MaintenanceStartedItemDto: {
			bankProviderName: string
			/** @enum {string} */
			type: MaintenanceStartedItemDtoType
			startAt: string
			endAt?: Record<string, never>
		}
		MaintenanceStartedDto: {
			/** @description Maintenances that just started */
			maintenances: components['schemas']['MaintenanceStartedItemDto'][]
		}
		MaintenanceEndedItemDto: {
			bankProviderName: string
			/** @enum {string} */
			type: MaintenanceEndedItemDtoType
		}
		MaintenanceEndedDto: {
			/** @description Maintenances that just ended */
			maintenances: components['schemas']['MaintenanceEndedItemDto'][]
		}
		MinimumWithdrawSettingModel: {
			id: string
			minimumWithdrawForWalletType: string[]
		}
		GeneralSettingModelPlayer: {
			id: string
			isOtpEnabled: boolean
			isRegisterEnabled: boolean
			/** @description When true, players may skip adding a bank account at registration */
			isSkipBankEnabled: boolean
			displayAllPromotion: boolean
			minimumDepositAmount: number
			minimumWithdrawalAmount: number
			minimumWithdrawSetting: components['schemas']['MinimumWithdrawSettingModel']
			minimumEasyClearTurnover: number
			lineUrl: string
			telegramUrl: string
			gameTypeSettings: components['schemas']['GameTypeSettingModel'][]
			initType: components['schemas']['InitType']
			carouselItemSize: components['schemas']['CarouselItemSize']
			/**
			 * @description Quick deposit button amounts
			 * @example [
			 *       10,
			 *       20,
			 *       50,
			 *       100,
			 *       500
			 *     ]
			 */
			quickDepositButtons: number[]
			hideClearTurnoverButton: boolean
			/** @description When true, player sees deposit channel choice (QR, Transfer, etc.) on deposit */
			enableDepositChannelChoice: boolean
			/** @description Theme mode: dark or light */
			themeMode: string
			/** @description Show gradient drop shadow effects in player frontend (default: true) */
			showDropShadow: boolean
			/**
			 * @description Custom Google Fonts family name (e.g., "Kanit", "Noto Sans Thai"). Null means use default font.
			 * @example Kanit
			 */
			fontFamily?: string
			/**
			 * @description Computed Google Fonts CSS URL from fontFamily. Null if no custom font set.
			 * @example https://fonts.googleapis.com/css2?family=Kanit:wght@400;500;600;700&display=swap
			 */
			fontUrl?: string
		}
		PlayerModel: {
			id: string
			username?: string | null
			email?: string | null
			phone: string
			lineId?: string | null
			/** Format: date-time */
			lineIdLinkedAt?: string | null
			isNewUser: boolean
			isFirstDeposit: boolean
			isBanned: boolean
			banReason?: string
			channel?: components['schemas']['ChannelModel'] | null
			referralCode: string
			isPartner?: boolean | null
			isDemoAccount: boolean
			needsDepositToContinue: boolean
			isBankSkipped: boolean
			diamondAmount: number
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			bank: components['schemas']['BankModel']
			rank: components['schemas']['RankModel']
			gameStatistics?: components['schemas']['PlayerGameStatisticsModel']
		}
		UpdatePlayerPasswordDto: {
			password: string
		}
		RankSnapshotModel: {
			id: string
			name: string
			order: number
		}
		RewardItemModel: {
			kind: string
			amount?: number
			labelTh: string
		}
		RankEventSnapshotModel: {
			fromRank: components['schemas']['RankSnapshotModel']
			toRank: components['schemas']['RankSnapshotModel']
			rewards: components['schemas']['RewardItemModel'][]
		}
		PlayerPopupDisplayModel: {
			shouldDisplayRankUp: boolean
			rankUpAt?: Record<string, never> | null
			rankUpSnapshot?: components['schemas']['RankEventSnapshotModel']
			shouldDisplayRankDown: boolean
			rankDownAt?: Record<string, never> | null
			rankDownSnapshot?: components['schemas']['RankEventSnapshotModel']
		}
		UpdatePopupDisplayDto: {
			shouldDisplayRankUp: boolean
			shouldDisplayRankDown: boolean
		}
		ConnectLineIdDto: {
			/** @description LINE ID to connect to player account */
			lineId: string
		}
		PlayerDiamondHistoryResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['DiamondTransactionResponse'][]
		}
		PlayerNotificationModel: {
			id: string
			title: string
			content: string
			imageUrl?: string | null
			link?: string | null
			isRead: boolean
			/** Format: date-time */
			readAt?: string | null
			isDeleted: boolean
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		GetPlayerNotificationsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerNotificationModel'][]
		}
		LuckyWheelEventModel: {
			/** @description Number of spins available */
			quota: number
			/** @description Whether player has lucky wheel quota available */
			hasQuota: boolean
			/** @description Lucky wheel setting name */
			settingName: Record<string, never> | null
		}
		DailyCheckInRewardModel: {
			/**
			 * @description Type of reward
			 * @enum {string}
			 */
			rewardType: DailyCheckInRewardModelRewardType
			/** @description Amount of reward */
			amount: number
		}
		DailyCheckInEventModel: {
			/** @description Whether player has checked in today */
			hasCheckedInToday: boolean
			/** @description Current day (next day to check in) */
			currentDay: number
			/** @description Missing deposit amount to check in */
			missingDeposit: number
			/** @description Missing turnover amount to check in */
			missingTurnover: number
			/** @description Whether player can check in now */
			canCheckIn: boolean
			/** @description Reward that player will receive if they check in today */
			todayReward: components['schemas']['DailyCheckInRewardModel'] | null
		}
		ReturnLossEventModel: {
			/** @description Whether player can receive return loss */
			canReceive: boolean
			/** @description Return loss amount that can be claimed this period */
			amount: number
			/** @description Total loss amount for this period */
			totalLoss: number
			/** @description Current return loss wallet balance */
			walletBalance: number
			/** @description Whether player can transfer from return loss wallet to main/promotion wallet */
			canTransfer: boolean
		}
		CommissionEventModel: {
			/** @description Whether player has commission available */
			hasCommission: boolean
			/** @description Total commission amount available */
			amount: number
			/** @description Commission wallet balance */
			walletBalance: number
			/** @description Whether player can transfer from commission wallet to main/promotion wallet */
			canTransfer: boolean
		}
		PlayerEventsResponse: {
			/** @description Whether to show notification badge (true if any event requires player attention) */
			shouldShowNotification: boolean
			/** @description Lucky wheel event information */
			luckyWheel: components['schemas']['LuckyWheelEventModel']
			/** @description Daily check-in event information */
			dailyCheckIn: components['schemas']['DailyCheckInEventModel']
			/** @description Return loss event information */
			returnLoss: components['schemas']['ReturnLossEventModel']
			/** @description Commission event information */
			commission: components['schemas']['CommissionEventModel']
		}
		PromotionsResponse: {
			/** @description List of available promotions */
			promotions: components['schemas']['PromotionResponse'][]
		}
		AddPlayerBankDto: {
			/** @description Bank provider code */
			bankProvider: string
			/** @description Bank account number */
			accountNumber: string
			/** @description Account holder name (firstName lastName) */
			accountName: string
		}
		PlayerSlideAnnouncementResponse: {
			id: string
			content: string
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
		}
		PaymentRecordSnapshotSummaryModel: {
			playerCount: number
			totalDepositAmount: number
			totalDepositBonusAmount: number
			totalWithdraw: number
			totalLoss: number
			totalPartnerShare: number
		}
		PlayerPaymentRecordModel: {
			id: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			amount: number
			note?: string
			snapshotSummary: components['schemas']['PaymentRecordSnapshotSummaryModel']
			/** Format: date-time */
			createdAt: string
		}
		GetPlayerPaymentRecordsResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerPaymentRecordModel'][]
		}
		RedeemCouponDto: {
			/**
			 * @description Coupon code to redeem
			 * @example CP1A2B3C4D
			 */
			couponCode: string
		}
		CouponRedemptionResponse: {
			/**
			 * @description Whether the coupon redemption was successful
			 * @example true
			 */
			success: boolean
			/**
			 * @description Redemption result message
			 * @example Coupon redeemed successfully
			 */
			message: string
			/**
			 * @description Bonus amount received from the coupon
			 * @example 100
			 */
			bonusAmount: number
			/**
			 * @description Turnover requirement for the bonus
			 * @example 500
			 */
			turnoverRequired: number
			/** @description Promotion details (only for promotion coupons) */
			promotion?: Record<string, never>
			/**
			 * @description Current wallet balance after redemption
			 * @example 150
			 */
			walletBalance: number
		}
		PlayerShopItemResponse: {
			id: string
			name: string
			description?: string
			rewardType: components['schemas']['ShopItemType']
			imageUrl?: string
			price: number
			amount: number
			currencyType: components['schemas']['CurrencyType']
			/** Format: date-time */
			createdAt: string
			/** @description Game ID for FREE_SPIN reward type */
			gameId?: string
			/** @description Preset ID for FREE_SPIN reward type */
			presetId?: string
			/** @description Bet amount for FREE_SPIN reward type */
			betAmount?: number
		}
		PlayerShopItemListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerShopItemResponse'][]
		}
		ShippingAddressDto: {
			/** @description Recipient name */
			name: string
			/** @description Recipient phone number */
			phone: string
			/** @description Shipping address */
			address: string
			/** @description Province */
			province: string
			/** @description District */
			district: string
			/** @description Sub-district */
			subDistrict: string
			/** @description Postal code */
			postalCode: string
		}
		PurchaseShopItemDto: {
			/** @description Shipping address for physical items */
			shippingAddress?: components['schemas']['ShippingAddressDto']
			/** @description URL to return to after game (for FREE_SPIN) */
			hrefBackUrl?: string
			/**
			 * @description Desktop mode (for FREE_SPIN)
			 * @default true
			 */
			isDesktop: boolean
		}
		PlayerShopPurchaseResponse: {
			id: string
			itemId: string
			amount: number
			status: components['schemas']['ShopHistoryStatus']
			/** Format: date-time */
			createdAt: string
			/** Format: date-time */
			updatedAt: string
			item: components['schemas']['PlayerShopItemResponse']
			/** @description Free spin game URL (only for FREE_SPIN items) */
			freeSpinUrl?: string
		}
		PlayerShopPurchaseListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerShopPurchaseResponse'][]
		}
		PlayerTurnoverEventResponse: {
			id: string
			title: string
			description?: string
			bannerUrl?: string
			/** @enum {string} */
			status: PlayerTurnoverEventResponseStatus
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			/** @enum {string} */
			periodType: PlayerTurnoverEventResponsePeriodType
			requiredTurnover: string
			minBetAmount: string
			rewardAmount: string
			allowedGameTypes?: string
			allowedGameIds?: string
			allowedProviderIds?: string
			/** @description Array of allowed games */
			allowedGames?: Record<string, never>[]
			/** @description Array of allowed providers */
			allowedProviders?: Record<string, never>[]
			maxRewardsPerPlayer?: number
			walletCondition?: components['schemas']['WalletConditionResponse']
			/** @description Player current turnover for this event */
			currentTurnover: string
			/** @description Number of claims by player */
			claimCount: number
			/** @description Progress percentage (0-100) */
			progressPercentage: number
			/** @description Whether player has reached the goal */
			hasReachedGoal: boolean
			/** @description Can player claim reward now */
			canClaimReward: boolean
		}
		PlayerTurnoverEventListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerTurnoverEventResponse'][]
		}
		PlayerTournamentPrizeResponse: {
			rank: number
			prizeAmount: string
		}
		PlayerTournamentResponse: {
			id: string
			name: string
			description?: string
			bannerImage?: string
			status: string
			/** Format: date-time */
			startDate: string
			/** Format: date-time */
			endDate: string
			minTurnover?: string
			minDeposit?: string
			minBetAmount: string
			maxTransactionDay: number
			allowedGameTypes: string
			allowedGameIds?: string
			allowedProviderIds?: string
			allowedGames?: components['schemas']['AllowedGameResponse'][]
			allowedProviders?: components['schemas']['AllowedProviderResponse'][]
			pointSystemConfig?: components['schemas']['PointSystemConfigResponse']
			prizes: components['schemas']['PlayerTournamentPrizeResponse'][]
			playerCount?: number
			isPlayerJoined?: boolean
			playerQualified?: boolean
		}
		PlayerTournamentListResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerTournamentResponse'][]
		}
		PlayerTournamentLeaderboardEntryResponse: {
			rank: number
			playerUsername?: string
			playerPhone: string
			totalPoints: number
			totalWins: number
			currentStreak: number
			longestStreak: number
			totalBetAmount: string
			isCurrentPlayer: boolean
		}
		PlayerTournamentLeaderboardResponse: {
			total: number
			take: number
			skip: number
			data: components['schemas']['PlayerTournamentLeaderboardEntryResponse'][]
			currentPlayerRanking?: components['schemas']['PlayerTournamentLeaderboardEntryResponse']
		}
		PlayerTournamentStatsResponse: {
			totalPoints: number
			totalWins: number
			currentStreak: number
			longestStreak: number
			totalBetAmount: string
			totalTransactions: number
			currentRank: number
		}
		BackfillReturnLossDto: {
			/**
			 * @description Date to backfill return loss for (YYYY-MM-DD format)
			 * @example 2025-11-09
			 */
			date: string
		}
		BackfillReturnLossRangeDto: {
			/**
			 * @description First date to backfill daily histories for (YYYY-MM-DD)
			 * @example 2025-11-01
			 */
			startDate: string
			/**
			 * @description Last date to backfill daily histories for (YYYY-MM-DD)
			 * @example 2025-11-12
			 */
			endDate: string
		}
		BackfillReturnLossPayoutDto: {
			/**
			 * @description Payout interval to backfill
			 * @example WEEKLY
			 * @enum {string}
			 */
			interval: BackfillReturnLossPayoutDtoInterval
			/**
			 * @description Final business date included in the payout period. Weekly should be Saturday; monthly should be the last day of the month.
			 * @example 2025-11-15
			 */
			periodEndDate: string
		}
		RegisterDto: {
			phone: string
			password: string
			bankProvider: string
			accountName: string
			accountNumber: string
			channelCode?: string
			lineId: string
		}
		RegisterResponse: {
			playerId: string
		}
		PoliUpdatePlayerDto: {
			phone: string
			password: string
			bankProvider: string
			accountName: string
			accountNumber: string
			channelId?: string
			lineId: string
		}
		UpdatePlayerResponse: {
			playerId: string
		}
		CheckBalanceDto: {
			playerId: string
		}
		InitSessionDto: {
			playerId: string
		}
		PoliInitSessionResponse: {
			token: string
		}
		GeneralSettingResponse: {
			id: string
			isOtpEnabled: boolean
			isRegisterEnabled: boolean
			displayAllPromotion: boolean
			minimumDepositAmount: number
			minimumWithdrawalAmount: number
			minimumEasyClearTurnover: number
			lineUrl: string
			telegramUrl: string
			initType: string
			carouselItemSize: string
			quickDepositButtons: number[]
			hideClearTurnoverButton: boolean
			/**
			 * @description Custom Google Fonts family name (e.g., "Kanit", "Noto Sans Thai")
			 * @example Kanit
			 */
			fontFamily?: string
		}
		DepositDto: {
			playerId: string
			amount: number
		}
		DepositResponse: {
			method: components['schemas']['TransactionMethod']
			qrCodeUrl?: string
			bank?: components['schemas']['BankResponse']
			txId: string
			status: components['schemas']['DepositStatus']
			/** Format: date-time */
			expiredAt: string
			amount: number
		}
		GetDepositStatusDto: {
			playerId: string
			txId: string
		}
		GetDepositStatusResponse: {
			method: components['schemas']['TransactionMethod']
			qrCodeUrl?: string
			bank?: components['schemas']['BankResponse']
			txId: string
			status: components['schemas']['DepositStatus']
			/** Format: date-time */
			expiredAt: string
			amount: number
		}
		CancelDepositDto: {
			playerId: string
			txId: string
		}
		CancelDepositResponse: {
			method: components['schemas']['TransactionMethod']
			qrCodeUrl?: string
			bank?: components['schemas']['BankResponse']
			txId: string
			status: components['schemas']['DepositStatus']
			/** Format: date-time */
			expiredAt: string
			amount: number
		}
		WithdrawDto: {
			playerId: string
			amount: number
		}
		WithdrawResponse: {
			txId: string
			status: components['schemas']['WithdrawStatus']
			amount: number
		}
		WithdrawListResponse: {
			data: components['schemas']['WithdrawResponse'][]
		}
		GetWithdrawStatusDto: {
			playerId: string
			txId: string
		}
		GetWithdrawStatusResponse: {
			txId: string
			status: components['schemas']['WithdrawStatus']
			amount: number
		}
		CancelWithdrawDto: {
			playerId: string
			txId: string
		}
		CancelWithdrawResponse: {
			txId: string
			status: components['schemas']['WithdrawStatus']
			amount: number
		}
		ManualCompleteDepositDto: {
			/** @description Transaction ID */
			txId: string
			/**
			 * @description Amount to complete
			 * @example 1000
			 */
			amount: number
			/** @description Note/reason for manual completion */
			note?: string
			/** @description username of the operator */
			username: string
		}
		ManualCompleteDepositResponse: {
			message: string
		}
	}
	responses: never
	parameters: never
	requestBodies: never
	headers: never
	pathItems: never
}
export type $defs = Record<string, never>
export interface operations {
	AppController_health: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AppController_testCache: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AppController_testGetCache: {
		parameters: {
			query?: never
			header?: never
			path: {
				key: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AuthController_login: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LoginDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid credentials */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AuthController_loginOperator: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LoginDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid credentials */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AuthController_loginAdmin: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LoginDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginResponse']
				}
			}
		}
	}
	AdminController_getMe: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminResponse']
				}
			}
			/** @description Admin not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_updateMe: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAdminDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Admin not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_findOperator: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_getOperators: {
		parameters: {
			query: {
				skip: number
				take: number
				username?: string
				isActive?: boolean
				userGroupId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorsResponse']
				}
			}
		}
	}
	AdminController_createOperator: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateOperatorDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_updateOperator: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateOperatorDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_deleteOperator: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Operator deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminController_getLoginHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				operatorId?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorLoginHistoriesResponse']
				}
			}
		}
	}
	OperatorController_getMe: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_updateMe: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateMeOperatorDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_getOperators: {
		parameters: {
			query: {
				skip: number
				take: number
				username?: string
				isActive?: boolean
				userGroupId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorsResponse']
				}
			}
		}
	}
	OperatorController_getOperatorById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_createOperator: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateOperatorDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_updateOperator: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateOperatorDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_removeOperator: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Operator deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_getLoginHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				operatorId?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorLoginHistoriesResponse']
				}
			}
		}
	}
	OperatorController_getEventLog: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by operator name */
				operatorName?: string
				tagEvent?: unknown
				status?: components['schemas']['OperatorEventHistoryStatus']
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetOperatorEventLogsResponse']
				}
			}
		}
	}
	OperatorController_generateTotp: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetTotpSecretResponse']
				}
			}
			/** @description TOTP already enabled */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_enableTotp: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['EnableTotpDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid TOTP code or TOTP already enabled */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_disableTotp: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['DisableTotpDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid TOTP code or TOTP not enabled */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_resetTotp: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ResetTotpDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid password */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Operator not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_registerFCMToken: {
		parameters: {
			query?: never
			header: {
				'user-agent': string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RegisterFCMTokenDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RegisterFCMTokenResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_deleteFCMToken: {
		parameters: {
			query?: never
			header?: never
			path: {
				token: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Token deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	OperatorController_getFCMTokens: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['FCMTokenResponse'][]
				}
			}
		}
	}
	PartnerController_createPartner: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePartnerDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnerResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getPartners: {
		parameters: {
			query: {
				skip: number
				take: number
				nickname?: string
				isActive?: boolean
				id?: string
				createdByPlayerId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnersResponse']
				}
			}
		}
	}
	PartnerController_getPartnerById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnerResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_updatePartner: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePartnerDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnerResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getPartnerPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Start date for filtering players (createdAt >= startDate) and transactions
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date for filtering transactions (createdAt <= endDate)
				 * @example 2024-12-31
				 */
				endDate?: string
				/** @description Search by phone number */
				phone?: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetPartnerPlayersResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getPartnerPlayersSummary: {
		parameters: {
			query?: {
				/**
				 * @description Start date for filtering players (createdAt >= startDate) and transactions
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date for filtering transactions (createdAt <= endDate)
				 * @example 2024-12-31
				 */
				endDate?: string
				/** @description Search by phone number */
				phone?: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetPartnerPlayersSummaryResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_exportPartnerPlayersCsv: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminExportPartnerPlayersCsvDto']
			}
		}
		responses: {
			/** @description CSV or ZIP file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_addCredit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AddPartnerCreditDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AddPartnerCreditResponse']
				}
			}
			/** @description Bad request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner or player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getPaymentRecords: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnerPaymentRecordsResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_createPaymentRecord: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePartnerPaymentRecordDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CreatePartnerPaymentRecordResponse']
				}
			}
			/** @description Bad request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getPaymentRecordById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
				recordId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PartnerPaymentRecordModel']
				}
			}
			/** @description Payment record not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_togglePartnerActive: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['TogglePartnerActiveDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TogglePartnerActiveResponse']
				}
			}
			/** @description Partner is deleted */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getAdminAnalyticsDailyTransactions: {
		parameters: {
			query?: {
				/**
				 * @description Number of days to retrieve (default: 7). Ignored if startDate and endDate are provided.
				 * @example 7
				 */
				days?: number
				/**
				 * @description Start date (YYYY-MM-DD). When provided together with endDate, overrides days.
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD). When provided together with startDate, overrides days.
				 * @example 2024-01-31
				 */
				endDate?: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDailyTransactionsResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_getAdminAnalyticsInvitationSummary: {
		parameters: {
			query?: {
				/**
				 * @description Number of days to retrieve (default: 7). Ignored if startDate and endDate are provided.
				 * @example 7
				 */
				days?: number
				/**
				 * @description Start date (YYYY-MM-DD). When provided together with endDate, overrides days.
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD). When provided together with startDate, overrides days.
				 * @example 2024-01-31
				 */
				endDate?: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInvitationSummaryResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerController_deletePartner: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DeletePartnerResponse']
				}
			}
			/** @description Partner already deleted */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_createChannel: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateChannelDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetChannelResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_getChannels: {
		parameters: {
			query: {
				skip: number
				take: number
				name?: string
				isActive?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetChannelsResponse']
				}
			}
		}
	}
	ChannelController_getChannelById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetChannelResponse']
				}
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_updateChannel: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateChannelDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetChannelsResponse']
				}
			}
		}
	}
	ChannelController_deleteChannel: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Channel deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_getChannelTransactionCumulative: {
		parameters: {
			query: {
				/** @description Start date for the cumulative calculation */
				startDate: string
				/** @description End date for the cumulative calculation */
				endDate: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns cumulative transaction data for all players in the channel */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChannelTransactionCumulativeResponse']
				}
			}
			/** @description Invalid date format or date range */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_getChannelCohortAnalytics: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns deposit/withdraw/profit cohort data for the channel across all-time and day-after-activation buckets */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChannelCohortAnalyticsResponse']
				}
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChannelController_getChannelPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Search by phone or username */
				search?: string
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns paginated players with all-time deposit/withdraw/turnover stats and channel averages */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChannelPlayerListResponse']
				}
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	UserGroupController_createUserGroup: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateUserGroupDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetUserGroupResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	UserGroupController_getUserGroups: {
		parameters: {
			query: {
				skip: number
				take: number
				name?: string
				withOperatorCount?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetUserGroupsResponse']
				}
			}
		}
	}
	UserGroupController_getUserGroupById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetUserGroupResponse']
				}
			}
		}
	}
	UserGroupController_updateUserGroup: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateUserGroupDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetUserGroupResponse']
				}
			}
		}
	}
	UserGroupController_deleteUserGroup: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	UserGroupController_getAllPermissions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of all permissions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAllPermissionsResponse']
				}
			}
		}
	}
	PlayerController_createPlayer: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePlayerDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_toggleDemoAccount: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDemoAccountDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				search?: string
				ipAddress?: string
				isBanned?: boolean
				referringPartnerId?: string
				rankId?: string
				/** @description Filter by channel name */
				channelName?: string
				orderByCreatedAt?: components['schemas']['SortOrder']
				/** @description Sort by main wallet balance */
				sortByMainWalletBalance?: components['schemas']['SortOrder']
				sortByPromotionWalletBalance?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersResponse']
				}
			}
		}
	}
	PlayerController_exportPlayersCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayersCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerByIdWithEventRewardsModel']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerFullPhone: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerFullPhoneResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_updatePlayer: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePlayerDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_deletePlayer: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getLoginHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerLoginHistoriesResponse']
				}
			}
		}
	}
	PlayerController_getBannedPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBannedPlayersResponse']
				}
			}
		}
	}
	PlayerController_getInactivePlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				/**
				 * @description Filter players inactive since this date
				 * @example 2024-01-01T00:00:00.000Z
				 */
				inactiveSince?: string
				totalDepositAmountSort?: components['schemas']['SortOrder']
				lastDepositAtSort?: components['schemas']['SortOrder']
				totalDepositTimeSort?: components['schemas']['SortOrder']
				totalWithdrawAmountSort?: components['schemas']['SortOrder']
				totalWithdrawTimeSort?: components['schemas']['SortOrder']
				lastLoginSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInactivePlayersResponse']
				}
			}
		}
	}
	PlayerController_clearPlayerLockout: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ClearPlayerLockoutDto']
			}
		}
		responses: {
			/** @description Lockout cleared successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Unauthorized */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Forbidden - Insufficient permissions */
			403: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerClearTurnoverHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				playerId: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerClearTurnoverHistoryResponse']
				}
			}
		}
	}
	PlayerController_exportPlayerClearTurnoverHistoryCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerClearTurnoverHistoryCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Player ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				playerId: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedTransactionResponseWithPromotion']
				}
			}
		}
	}
	PlayerController_exportPlayerTransactionsCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerTransactionsCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerPlaylog: {
		parameters: {
			query: {
				skip: number
				take: number
				sessionId?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerPlaylogResponse']
				}
			}
		}
	}
	PlayerController_exportPlayerPlaylogCsv: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerPlaylogCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_reinitPlaylog: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminReinitPlaylogDto']
			}
		}
		responses: {
			/** @description Game session re-initialized successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getReferredPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				startDate?: string
				endDate?: string
				/** @description Optional player ID to calculate commissions for (useful for viewing referral tree from head perspective) */
				commissionForPlayer?: string
			}
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetReferredPlayersResponse']
				}
			}
		}
	}
	PlayerController_exportReferredPlayersCsv: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetReferredPlayersCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayerCumulative: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerCumulativeResponse']
				}
			}
		}
	}
	PlayerController_getPlayerCommission: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminPlayerCommissionResponse']
				}
			}
		}
	}
	PlayerController_getPlayerReturnLoss: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminPlayerReturnLossResponse']
				}
			}
		}
	}
	PlayerController_getPlayerDiamondHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter start date (ISO string) */
				startDate?: string
				/** @description Filter end date (ISO string) */
				endDate?: string
				orderByCreatedAt?: components['schemas']['SortOrder']
			}
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminPlayerDiamondHistoryResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getActivePlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				search?: string
				ipAddress?: string
				isBanned?: boolean
				referringPartnerId?: string
				rankId?: string
				/** @description Filter by channel name */
				channelName?: string
				orderByCreatedAt?: components['schemas']['SortOrder']
				/** @description Sort by main wallet balance */
				sortByMainWalletBalance?: components['schemas']['SortOrder']
				sortByPromotionWalletBalance?: components['schemas']['SortOrder']
				startDate?: string
				endDate?: string
				betAmountSort?: components['schemas']['SortOrder']
				depositAmountSort?: components['schemas']['SortOrder']
				withdrawAmountSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetActivePlayersResponse']
				}
			}
		}
	}
	PlayerController_getPlayersWithDepositPromotion: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithDepositPromotionResponse']
				}
			}
		}
	}
	PlayerController_exportPlayersWithDepositPromotionCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayersWithDepositPromotionCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayersWithDeposits: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				depositAmountSort?: components['schemas']['SortOrder']
				depositTimeSort?: components['schemas']['SortOrder']
				/** @description Exclude deposits with amount 0 (free credits) */
				excludeFreeCredit?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithDepositsResponse']
				}
			}
		}
	}
	PlayerController_exportPlayersWithDepositsCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayersWithDepositsCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayersWithDepositsWithoutPromotion: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				depositAmountSort?: components['schemas']['SortOrder']
				depositTimeSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithDepositsWithoutPromotionResponse']
				}
			}
		}
	}
	PlayerController_getPlayerActivityLog: {
		parameters: {
			query: {
				skip: number
				take: number
				playerId?: string
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerActivityLogBodyDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerActivityLogResponse']
				}
			}
		}
	}
	PlayerController_exportPlayerActivityLogCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerActivityLogCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_clearPlayerTurnover: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ClearPlayerTurnoverDto']
			}
		}
		responses: {
			/** @description Turnover cleared successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearPlayerTurnoverResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_updateMainWalletBalance: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateMainWalletDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateMainWalletResponse']
				}
			}
		}
	}
	PlayerController_clearMainWalletTurnover: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ClearPlayerTurnoverDto']
			}
		}
		responses: {
			/** @description Main wallet turnover cleared successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearPlayerTurnoverResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPlayersWithWithdraws: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				withdrawAmountSort?: components['schemas']['SortOrder']
				withdrawTimeSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithWithdrawsResponse']
				}
			}
		}
	}
	PlayerController_getPlayersWithLuckyWheelReceive: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				luckyWheelAmountSort?: components['schemas']['SortOrder']
				luckyWheelTimeSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithLuckyWheelReceiveResponse']
				}
			}
		}
	}
	PlayerController_getPlayersWithReturnLossReceive: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				returnLossAmountSort?: components['schemas']['SortOrder']
				returnLossTimeSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithReturnLossReceiveResponse']
				}
			}
		}
	}
	PlayerController_getPlayersWithDailyCheckInReceive: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				isBanned?: boolean
				startDate?: string
				endDate?: string
				dailyCheckInAmountSort?: components['schemas']['SortOrder']
				dailyCheckInTimeSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersWithDailyCheckInReceiveResponse']
				}
			}
		}
	}
	PlayerController_getPlayerDataList: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				startDate?: string
				endDate?: string
				totalDepositAmountSort?: components['schemas']['SortOrder']
				totalWithdrawAmountSort?: components['schemas']['SortOrder']
				totalProfitSort?: components['schemas']['SortOrder']
				totalWinlossSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerDataListResponse']
				}
			}
		}
	}
	PlayerController_exportPlayerDataListCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerDataListCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getRegisteredPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				ipAddress?: string
				/** @description Filter by channel name */
				channelName?: string
				startDate?: string
				endDate?: string
				channelId?: string
				rankId?: string
				orderByCreatedAt?: components['schemas']['SortOrder']
				orderByTotalDepositAmount?: components['schemas']['SortOrder']
				/** @description Filter only players with at least one deposit */
				hasDeposit?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetRegisteredPlayersResponse']
				}
			}
		}
	}
	PlayerController_getPlayerProviderStats: {
		parameters: {
			query: {
				/**
				 * @description Player ID
				 * @example player-uuid
				 */
				playerId: string
				/**
				 * @description Start date (YYYY-MM-DD or ISO date string). Defaults to 2000-01-01 if not provided
				 * @example 2025-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD or ISO date string). Defaults to today if not provided
				 * @example 2025-01-31
				 */
				endDate?: string
				/**
				 * @description Filter by specific provider (optional)
				 * @example pghard
				 */
				provider?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerProviderStatsResponse']
				}
			}
		}
	}
	PlayerAuthController_login: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['PlayerLoginDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerLoginResponseDto']
				}
			}
			/** @description Invalid credentials */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_loginWithLine: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LineLoginDto']
			}
		}
		responses: {
			/** @description Successfully logged in with LINE */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerLoginResponseDto']
				}
			}
			/** @description LINE ID not linked or invalid token */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_checkPhone: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': {
					/**
					 * @description Phone number to check
					 * @example 1234567890
					 */
					phone: string
				}
			}
		}
		responses: {
			/** @description Returns true if phone exists, false otherwise */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': boolean
				}
			}
		}
	}
	PlayerAuthController_checkBank: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CheckBankExistsDto']
			}
		}
		responses: {
			/** @description Bank account is available */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bank account already exists */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_registerPlayer: {
		parameters: {
			query?: never
			header: {
				'user-agent': string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RegisterPlayerDto']
			}
		}
		responses: {
			/** @description Player successfully registered */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerRegisterResponseDto']
				}
			}
			/** @description Invalid referral code */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_registerDemoAccount: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Demo account successfully registered */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerRegisterResponseDto']
				}
			}
			/** @description Demo channel not found */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_checkChannel: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Channel information retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						/** @description Whether the channel is for guest/demo accounts */
						isGuest?: boolean
						/** @description Whether the channel is active */
						isActive?: boolean
						/** @description Channel name */
						name?: string
					}
				}
			}
			/** @description Channel not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_updateDemoToReal: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDemoToRealDto']
			}
		}
		responses: {
			/** @description Demo account updated to real account */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerRegisterResponseDto']
				}
			}
		}
	}
	PlayerAuthController_sendLoginSmsOtp: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendSmsOtpDto']
			}
		}
		responses: {
			/** @description SMS OTP sent successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SendLoginSmsOtpResponseDto']
				}
			}
		}
	}
	PlayerAuthController_verifyLoginSmsOtp: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['VerifySmsOtpDto']
			}
		}
		responses: {
			/** @description SMS OTP verified successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['VerifyLoginSmsOtpResponseDto']
				}
			}
		}
	}
	PlayerAuthController_forgotPassword: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ForgotPasswordDto']
			}
		}
		responses: {
			/** @description Forgot password successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerAuthController_resetPassword: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ResetPasswordDto']
			}
		}
		responses: {
			/** @description Reset password successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ThaibulkController_sendSms: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendSmsDto']
			}
		}
		responses: {
			/** @description SMS sent successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ThaibulkController_sendSmsOtp: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendSmsOtpDto']
			}
		}
		responses: {
			/** @description OTP sent successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SendSmsOtpResponse']
				}
			}
		}
	}
	ThaibulkController_verifySmsOtp: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['VerifySmsOtpDto']
			}
		}
		responses: {
			/** @description OTP verified successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['VerifySmsOtpResponse']
				}
			}
		}
	}
	LineController_sendMessage: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendLineMessageDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LineController_getUserProfile: {
		parameters: {
			query?: never
			header?: never
			path: {
				userId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LineController_handleWebhook: {
		parameters: {
			query?: never
			header: {
				'x-line-signature': string
			}
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatController_getChatRooms: {
		parameters: {
			query?: {
				/** @description Start cursor (message ID or timestamp) */
				start?: string
				/** @description End cursor */
				end?: string
				/** @description Number of items to fetch */
				limit?: number
				status?: components['schemas']['ChatRoomStatus']
				/** @description Filter by read status (omit to get both read and unread) */
				isRead?: boolean
				/** @description Filter by assigned to current operator */
				assignedToMe?: boolean
				/** @description Filter rooms that need attention (unread AND no assignee) */
				needsAttention?: boolean
				/** @description Filter by tag IDs */
				tagIds?: string[]
				/** @description Filter to show only users with no tags (true) or any users (false/omit) */
				noTags?: boolean
				/** @description Search by display name, LINE user ID, player phone number, or player ID */
				search?: string
				/** @description Filter by player LINE connection status. true = connected, false = not connected yet */
				hasLineId?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomListResponse']
				}
			}
		}
	}
	ChatController_getUnreadCount: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UnreadCountResponse']
				}
			}
		}
	}
	ChatController_getClosedRooms: {
		parameters: {
			query?: {
				/** @description Start cursor (message ID or timestamp) */
				start?: string
				/** @description End cursor */
				end?: string
				/** @description Number of items to fetch */
				limit?: number
				status?: components['schemas']['ChatRoomStatus']
				/** @description Filter by read status (omit to get both read and unread) */
				isRead?: boolean
				/** @description Filter by assigned to current operator */
				assignedToMe?: boolean
				/** @description Filter rooms that need attention (unread AND no assignee) */
				needsAttention?: boolean
				/** @description Filter by tag IDs */
				tagIds?: string[]
				/** @description Filter to show only users with no tags (true) or any users (false/omit) */
				noTags?: boolean
				/** @description Search by display name, LINE user ID, player phone number, or player ID */
				search?: string
				/** @description Filter by player LINE connection status. true = connected, false = not connected yet */
				hasLineId?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomListResponse']
				}
			}
		}
	}
	ChatController_getBannedRooms: {
		parameters: {
			query?: {
				/** @description Start cursor (message ID or timestamp) */
				start?: string
				/** @description End cursor */
				end?: string
				/** @description Number of items to fetch */
				limit?: number
				status?: components['schemas']['ChatRoomStatus']
				/** @description Filter by read status (omit to get both read and unread) */
				isRead?: boolean
				/** @description Filter by assigned to current operator */
				assignedToMe?: boolean
				/** @description Filter rooms that need attention (unread AND no assignee) */
				needsAttention?: boolean
				/** @description Filter by tag IDs */
				tagIds?: string[]
				/** @description Filter to show only users with no tags (true) or any users (false/omit) */
				noTags?: boolean
				/** @description Search by display name, LINE user ID, player phone number, or player ID */
				search?: string
				/** @description Filter by player LINE connection status. true = connected, false = not connected yet */
				hasLineId?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomListResponse']
				}
			}
		}
	}
	ChatController_getChatRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_getChatMessages: {
		parameters: {
			query?: {
				/** @description Start cursor (message ID or timestamp) */
				start?: string
				/** @description End cursor */
				end?: string
				/** @description Number of items to fetch */
				limit?: number
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatMessageListResponse']
				}
			}
		}
	}
	ChatController_sendMessage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendChatMessageDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SendMessageResponse']
				}
			}
		}
	}
	ChatController_sendMultipleMessages: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SendMultipleMessagesDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SendMultipleMessagesResponse']
				}
			}
		}
	}
	ChatController_markAsRead: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['MarkAsReadDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						readCount?: number
					}
				}
			}
		}
	}
	ChatController_searchMessages: {
		parameters: {
			query: {
				/** @description Start cursor (message ID or timestamp) */
				start?: string
				/** @description End cursor */
				end?: string
				/** @description Number of items to fetch */
				limit?: number
				/** @description Search query text */
				query: string
				/** @description Filter by specific room ID (omit to search all rooms) */
				roomId?: string
				/** @description Filter by message direction */
				direction?: PathsApiAdminChatSearchGetParametersQueryDirection
				/** @description Filter by date range start (ISO string) */
				dateFrom?: string
				/** @description Filter by date range end (ISO string) */
				dateTo?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SearchChatMessagesResponse']
				}
			}
		}
	}
	ChatController_pinRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['PinChatRoomDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_banRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BanChatRoomDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_updateRoomStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateChatRoomStatusDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_pinMessage: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
				messageId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['PinMessageDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatMessageResponse']
				}
			}
		}
	}
	ChatController_getPinnedMessages: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatMessageResponse'][]
				}
			}
		}
	}
	ChatController_claimRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_releaseRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_assignRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AssignChatRoomDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_getTags: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CustomerTagResponse'][]
				}
			}
		}
	}
	ChatController_createTag: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateCustomerTagDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CustomerTagResponse']
				}
			}
		}
	}
	ChatController_updateTag: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateCustomerTagDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CustomerTagResponse']
				}
			}
		}
	}
	ChatController_deleteTag: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SuccessResponse']
				}
			}
		}
	}
	ChatController_addTagsToRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AddTagsToRoomDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_removeTagFromRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
				tagId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_linkPlayerToRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LinkPlayerToRoomDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_unlinkPlayerFromRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_connectLine: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatRoomResponse']
				}
			}
		}
	}
	ChatController_getPlayerChatStats: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerChatStatsResponse']
				}
			}
			/** @description Chat room not found or no linked player */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatController_getChatNotes: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatNoteListResponse']
				}
			}
		}
	}
	ChatController_createChatNote: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateChatNoteDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatNoteResponse']
				}
			}
		}
	}
	ChatController_updateChatNote: {
		parameters: {
			query?: never
			header?: never
			path: {
				noteId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateChatNoteDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatNoteResponse']
				}
			}
		}
	}
	ChatController_deleteChatNote: {
		parameters: {
			query?: never
			header?: never
			path: {
				noteId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SuccessResponse']
				}
			}
		}
	}
	ChatController_getQuickResponses: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['QuickResponseResponse'][]
				}
			}
		}
	}
	ChatController_createQuickResponse: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateQuickResponseDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['QuickResponseResponse']
				}
			}
		}
	}
	ChatController_updateQuickResponse: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateQuickResponseDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['QuickResponseResponse']
				}
			}
		}
	}
	ChatController_deleteQuickResponse: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SuccessResponse']
				}
			}
		}
	}
	ChatController_getSettings: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatSettingsResponse']
				}
			}
		}
	}
	ChatController_updateSettings: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateChatSettingsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatSettingsResponse']
				}
			}
		}
	}
	ChatController_getQuota: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatAnalyticsResponse']
				}
			}
		}
	}
	ChatController_getAnalytics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatAnalyticsResponse']
				}
			}
		}
	}
	ChatController_generateMediaUploadUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateChatMediaUploadUrlDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatMediaUploadUrlResponse']
				}
			}
		}
	}
	ChatController_broadcastMessages: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BroadcastMessagesDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BroadcastResponse']
				}
			}
		}
	}
	ChatSseController_stream: {
		parameters: {
			query?: {
				/**
				 * @description JWT auth token (alternative to Authorization header for browser EventSource)
				 * @example eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...
				 */
				token?: unknown
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description SSE stream of chat events */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'text/event-stream':
						| components['schemas']['ChatNewMessageSseEvent']
						| components['schemas']['ChatRoomUpdatedSseEvent']
						| components['schemas']['ChatRoomListChangedSseEvent']
						| components['schemas']['ChatTagUpdatedSseEvent']
						| components['schemas']['ChatAssigneeUpdatedSseEvent']
						| components['schemas']['ChatMessageReadSseEvent']
						| components['schemas']['ChatPingSseEvent']
						| components['schemas']['WithdrawPendingSseEvent']
				}
			}
		}
	}
	ChatSseController_subscribeToRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SuccessResponse']
				}
			}
		}
	}
	ChatSseController_unsubscribeFromRoom: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SuccessResponse']
				}
			}
		}
	}
	ChatAiDraftController_getSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AiSettingFullResponse']
				}
			}
		}
	}
	ChatAiDraftController_updateSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAiSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatAiDraftController_updatePromptCases: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAiPromptCasesDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatAiDraftController_getLatestDraft: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AiDraftResponse']
				}
			}
		}
	}
	ChatAiDraftController_getRoomAdminTasks: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTaskResponse'][]
				}
			}
		}
	}
	ChatAiDraftController_markAdminTaskDone: {
		parameters: {
			query?: never
			header?: never
			path: {
				taskId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTaskResponse']
				}
			}
		}
	}
	ChatAiDraftController_dismissAdminTask: {
		parameters: {
			query?: never
			header?: never
			path: {
				taskId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTaskResponse']
				}
			}
		}
	}
	ChatAiDraftController_reopenAdminTask: {
		parameters: {
			query?: never
			header?: never
			path: {
				taskId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTaskResponse']
				}
			}
		}
	}
	ChatAiDraftController_markUsed: {
		parameters: {
			query?: never
			header?: never
			path: {
				draftId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAiDraftBody']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatAiDraftController_markEdited: {
		parameters: {
			query?: never
			header?: never
			path: {
				draftId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAiDraftBody']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatAiDraftController_markIgnored: {
		parameters: {
			query?: never
			header?: never
			path: {
				draftId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAiDraftBody']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ChatAiDraftController_updateChatAiMode: {
		parameters: {
			query?: never
			header?: never
			path: {
				roomId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateChatAiModeDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChatAiModeResponse']
				}
			}
		}
	}
	DepositController_createDeposit: {
		parameters: {
			query?: never
			header: {
				'user-agent': string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDepositDto']
			}
		}
		responses: {
			/** @description The deposit has been successfully created. */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositTransactionResponse']
				}
			}
		}
	}
	DepositController_getPendingDepositTransactions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The pending deposit transactions have been successfully retrieved. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositTransactionResponse']
				}
			}
		}
	}
	DepositController_confirmDeposit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The deposit has been successfully confirmed. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositTransactionResponse']
				}
			}
		}
	}
	DepositController_cancelDeposit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The deposit has been successfully cancelled. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositTransactionResponse']
				}
			}
		}
	}
	DepositController_getDepositInfo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns minimum deposit amount and available promotions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MinimumDepositResponse']
				}
			}
		}
	}
	DepositController_getAvailableChannels: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns available deposit channels. True Wallet users get forceChannel instead. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AvailableChannelsResponse']
				}
			}
		}
	}
	DepositController_getAvailableAmounts: {
		parameters: {
			query: {
				channel: string
				amount: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns available P2P deposit amounts for the given channel */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositController_getDepositStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns deposit availability status */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionAvailabilityResponse']
				}
			}
		}
	}
	DepositController_getSlipPresignUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetSlipPresignDto']
			}
		}
		responses: {
			/** @description Presigned upload URL and final file URL */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SlipPresignResponse']
				}
			}
		}
	}
	DepositController_uploadSlip: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UploadSlipDto']
			}
		}
		responses: {
			/** @description Slip processed */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UploadSlipResponse']
				}
			}
		}
	}
	DepositController_uploadVerifySlip: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UploadSlipDto']
			}
		}
		responses: {
			/** @description Slip processed */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UploadSlipResponse']
				}
			}
		}
	}
	DepositController_uploadAutosslip: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UploadSlipDto']
			}
		}
		responses: {
			/** @description Slip processed */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UploadSlipResponse']
				}
			}
		}
	}
	DepositController_proxyQrImage: {
		parameters: {
			query: {
				url: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositController_getDepositTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				transactionId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The deposit transaction has been successfully retrieved. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositTransactionResponse']
				}
			}
		}
	}
	DepositController_claimPromotion: {
		parameters: {
			query: {
				p: string
			}
			header?: never
			path: {
				token: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Promotion claimed successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositController_claimPromotionTest: {
		parameters: {
			query?: never
			header?: never
			path: {
				token: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Promotion claimed successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WalletController_getBalance: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns player active wallet balance information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WalletBalanceResponse']
				}
			}
		}
	}
	WalletController_getBalanceByType: {
		parameters: {
			query?: never
			header?: never
			path: {
				walletType: unknown
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns player wallet balance information by type */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WalletBalanceResponse']
				}
			}
		}
	}
	WalletController_transferToMain: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns the transferred amount, previous promotion balance, conditions, and main wallet info */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WalletTransferResponse']
				}
			}
			/** @description Bad request if transfer is not possible or wallet not found */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WalletController_clearPromotionWallet: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ClearTurnoverWalletDto']
			}
		}
		responses: {
			/** @description Returns the cleared promotion wallet information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearTurnoverWalletResponse']
				}
			}
			/** @description Bad request if player not found or wallet not found */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WalletController_easyClearTurnover: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns the cleared promotion wallet information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearTurnoverWalletResponse']
				}
			}
			/** @description Bad request if balance exceeds minimum threshold or wallet not found */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WalletController_transferToActiveWallet: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['TransferToActiveWalletDto']
			}
		}
		responses: {
			/** @description Returns the transferred promotion wallet information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						message?: string
					}
				}
			}
			/** @description Bad request if transfer is not possible or wallet not found */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WalletController_getTransferHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				startDate?: string
				endDate?: string
			}
			header?: never
			path: {
				walletId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Wallet not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_getPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresetsResponse']
				}
			}
			/** @description Failed to get presets */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_findAll: {
		parameters: {
			query: {
				skip: number
				take: number
				name?: string
				orderByCreatedAt?: string
				isForPlayer?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositPromotionsResponse']
				}
			}
		}
	}
	DepositPromotionController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDepositPromotionDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositPromotionResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_getPromotionsForBrokeNotification: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDepositPromotionsForBrokeNotificationResponse']
				}
			}
		}
	}
	DepositPromotionController_getDepositPromotionPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositPromotionPresetListResponse']
				}
			}
		}
	}
	DepositPromotionController_applyDepositPromotionPreset: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ApplyDepositPromotionPresetDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ApplyDepositPromotionPresetResponse']
				}
			}
		}
	}
	DepositPromotionController_findById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositPromotionResponse']
				}
			}
			/** @description Deposit promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_delete: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Deposit promotion deleted */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Deposit promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDepositPromotionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositPromotionResponse']
				}
			}
			/** @description Deposit promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DepositPromotionController_getPromotionNamesForSelector: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionSelectorListResponse']
				}
			}
		}
	}
	DepositPromotionController_getPromotionNamesForSelectorChannel: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionSelectorListResponse']
				}
			}
		}
	}
	DepositPromotionController_getPromotionNamesForSelectorCoupon: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionSelectorListResponse']
				}
			}
		}
	}
	NotificationController_createNotification: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateNotificationDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ConversionController_trackConversion: {
		parameters: {
			query?: never
			header: {
				'user-agent': string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateConversionDto']
			}
		}
		responses: {
			/** @description Conversion event tracked successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LuckyWheelController_getImagePresets: {
		parameters: {
			query?: {
				type?: components['schemas']['LuckyWheelPresetType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminLuckyWheelImagePresetsResponse']
				}
			}
		}
	}
	LuckyWheelController_findOnce: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LuckyWheelSettingResponse']
				}
			}
			/** @description Lucky wheel setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LuckyWheelController_update: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateLuckyWheelSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LuckyWheelSettingResponse']
				}
			}
			/** @description Lucky wheel setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LuckyWheelController_testSpinWheel: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LuckyWheelSpinResponse']
				}
			}
		}
	}
	PaymentGatewayController_getAvailableChannels: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Which channels have at least one active bank account */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PaymentGatewayController_getChannelCounts: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Counts for QR, Transfer, True Money, withdraw bank channels; includes active withdrawal account for QR/Transfer */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayChannelCountsResponse']
				}
			}
		}
	}
	PaymentGatewayController_getPaymentGateways: {
		parameters: {
			query: {
				skip: number
				take: number
				channel: unknown
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Payment gateways retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedPaymentGatewayResponse']
				}
			}
		}
	}
	PaymentGatewayController_updatePaymentGateway: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePaymentGatewayRequest']
			}
		}
		responses: {
			/** @description Payment gateway updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayResponse']
				}
			}
		}
	}
	PaymentGatewayController_createPaymentGateway: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePaymentGatewayRequest']
			}
		}
		responses: {
			/** @description Payment gateway created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayResponse']
				}
			}
		}
	}
	PaymentGatewayController_getPaymentGatewayProvider: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Payment gateway providers retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayProviderModel'][]
				}
			}
		}
	}
	PaymentGatewayController_getPaymentGatewayConstraints: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Constraints retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayConstraintsResponse']
				}
			}
		}
	}
	PaymentGatewayController_getMaintenances: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Active maintenances (currently in effect) */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProviderMaintenanceListResponse']
				}
			}
		}
	}
	PaymentGatewayController_createMaintenance: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateMaintenanceRequest']
			}
		}
		responses: {
			/** @description Maintenance created */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CreateMaintenanceResponse']
				}
			}
		}
	}
	PaymentGatewayController_getMaintenancesAll: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description All non-rejected maintenances */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProviderMaintenanceListResponse']
				}
			}
		}
	}
	PaymentGatewayController_rejectMaintenance: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Maintenance rejected */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PaymentGatewayController_getPaymentGatewayAnalytics: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2024-12-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayAnalyticsResponse']
				}
			}
		}
	}
	PaymentGatewayController_getPaymentGateway: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Payment gateway retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaymentGatewayResponse']
				}
			}
		}
	}
	PaymentGatewayController_deletePaymentGateway: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Payment gateway deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PaymentGatewayController_syncPaymentGateways: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Payment gateways synced successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TelegramNotifyController_getTelegramNotifySetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns telegram notify settings */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TelegramNotifySettingResponse']
				}
			}
		}
	}
	TelegramNotifyController_updateTelegramNotifySetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateTelegramNotifySettingDto']
			}
		}
		responses: {
			/** @description Returns updated telegram notify settings */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TelegramNotifySettingResponse']
				}
			}
		}
	}
	PlayerTagController_getAllTags: {
		parameters: {
			query?: {
				/**
				 * @description Filter by tag name (partial match)
				 * @example VIP
				 */
				search?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTagResponse'][]
				}
			}
		}
	}
	PlayerTagController_createTag: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePlayerTagDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTagResponse']
				}
			}
		}
	}
	PlayerTagController_getTagStatistics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TagStatisticsResponse']
				}
			}
		}
	}
	PlayerTagController_getTagById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTagResponse']
				}
			}
		}
	}
	PlayerTagController_deleteTag: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						success?: boolean
					}
				}
			}
		}
	}
	PlayerTagController_updateTag: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePlayerTagDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTagResponse']
				}
			}
		}
	}
	PlayerTagController_getPlayersByTags: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by tag ID */
				tagId?: string
				/**
				 * @description Search by phone or email
				 * @example 0812345678
				 */
				search?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayersByTagResponse']
				}
			}
		}
	}
	PlayerTagController_assignTagsToPlayers: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AssignTagsToPlayersDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						assignedCount?: number
					}
				}
			}
		}
	}
	PlayerTagController_removeTagsFromPlayers: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RemoveTagsFromPlayersDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						removedCount?: number
					}
				}
			}
		}
	}
	PlayerTagController_recheckAllPlayers: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						processedTags?: number
						totalPlayersTagged?: number
					}
				}
			}
		}
	}
	TrackingController_trackSingle: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['TrackSingleDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TrackingResponse']
				}
			}
		}
	}
	TrackingController_trackBatch: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['TrackBatchDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TrackingResponse']
				}
			}
		}
	}
	PlayerCommissionController_getCommissionByPlayerId: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns commission configuration and current month totals */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerCommissionResponse']
				}
			}
		}
	}
	CommissionCashbackController_findAll: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CommissionCashbacksResponse']
				}
			}
		}
	}
	CommissionCashbackController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateCommissionCashbackDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CommissionCashbackResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CommissionCashbackController_findById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CommissionCashbackResponse']
				}
			}
			/** @description Commission cashback promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CommissionCashbackController_delete: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Commission cashback promotion deleted */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Commission cashback promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CommissionCashbackController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateCommissionCashbackDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CommissionCashbackResponse']
				}
			}
			/** @description Commission cashback promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CommissionCashbackController_getCommissionCashbackNamesForSelector: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CommissionCashbackSelectorListResponse']
				}
			}
		}
	}
	PlayerDailyCheckInController_getCheckInData: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInResponse']
				}
			}
		}
	}
	PlayerDailyCheckInController_getDailyCheckInById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInResponse']
				}
			}
		}
	}
	PlayerDailyCheckInController_checkIn: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CheckInDto']
			}
		}
		responses: {
			/** @description Player check-in successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CheckInResponse']
				}
			}
			/** @description Check-in ID not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DailyCheckInController_findAll: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInSettingsResponse']
				}
			}
			/** @description Daily check-in setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DailyCheckInController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDailyCheckInSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInSettingResponse']
				}
			}
			/** @description Daily check-in setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DailyCheckInController_findById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInSettingResponse']
				}
			}
			/** @description Daily check-in setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DailyCheckInController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDailyCheckInSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInSettingResponse']
				}
			}
			/** @description Daily check-in setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DailyCheckInController_getDailyCheckInNamesForSelector: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DailyCheckInSelectorListResponse']
				}
			}
		}
	}
	GameController_initSession: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['LaunchGameDto']
			}
		}
		responses: {
			/** @description Game session initialized successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InitGameSessionResponse']
				}
			}
		}
	}
	GameController_getGameList: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetGameListDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameListResponse']
				}
			}
		}
	}
	GameController_getGameProviderList: {
		parameters: {
			query?: {
				displayName?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerGameProviderListResponse']
				}
			}
		}
	}
	GameController_getProvidersByGameType: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Game type
				 * @example SLOT
				 */
				gameType: components['schemas']['GameType']
				displayName?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameProviderWithBannerListResponse']
				}
			}
		}
	}
	GameController_getRecentGames: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameListResponse']
				}
			}
		}
	}
	GameController_getPlayerGameTypeList: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameTypeListResponse']
				}
			}
		}
	}
	GameController_getDynamicSectionList: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerDynamicSectionListResponse']
				}
			}
		}
	}
	RankController_getRankInfo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankInfoResponse'][]
				}
			}
		}
	}
	RankController_promoteRank: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromoteRankResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_getRankExperience: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankExperienceResponse']
				}
			}
		}
	}
	RankController_getRankExperienceRate: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankExperienceRateResponse']
				}
			}
		}
	}
	RankController_getPendingFreeSpins: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PendingFreeSpinResponse'][]
				}
			}
		}
	}
	RankController_claimFreeSpin: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ClaimFreeSpinDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClaimFreeSpinResponse']
				}
			}
			/** @description Free spin not found or already claimed */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SettingsController_getLoginAnnouncements: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	SettingsController_createLoginAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateLoginAnnouncementDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	SettingsController_getLoginAnnouncementById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	SettingsController_deleteLoginAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	SettingsController_updateLoginAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateLoginAnnouncementDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	SettingsController_getGeneralSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GeneralSettingModel']
				}
			}
		}
	}
	SettingsController_updateGeneralSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGeneralSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GeneralSettingModel']
				}
			}
		}
	}
	SettingsController_getThemePresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ThemePresetListResponse']
				}
			}
		}
	}
	SettingsController_applyThemePreset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ApplyThemePresetDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GeneralSettingModel']
				}
			}
		}
	}
	SettingsController_getGameTypeSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameTypeSettingResponse']
				}
			}
		}
	}
	SettingsController_updateGameTypeSetting: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGameTypeSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameTypeSettingResponse']
				}
			}
		}
	}
	SettingsController_getDynamicSections: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicSectionResponse']
				}
			}
		}
	}
	SettingsController_createDynamicSection: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDynamicSectionDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicSectionModel']
				}
			}
		}
	}
	SettingsController_getDynamicSectionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicSectionModel']
				}
			}
		}
	}
	SettingsController_deleteDynamicSection: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicSectionModel']
				}
			}
		}
	}
	SettingsController_updateDynamicSection: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDynamicSectionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicSectionModel']
				}
			}
		}
	}
	SettingsController_updateDynamicSectionOrder: {
		parameters: {
			query?: never
			header?: never
			path: {
				dynamicPageSectionId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDynamicSectionOrderDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SettingsController_getDynamicPages: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageResponse']
				}
			}
		}
	}
	SettingsController_createDynamicPage: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateDynamicPageDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageModel']
				}
			}
		}
	}
	SettingsController_getDynamicPageById: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageModel']
				}
			}
		}
	}
	SettingsController_deleteDynamicPage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageModel']
				}
			}
		}
	}
	SettingsController_updateDynamicPage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateDynamicPageDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageModel']
				}
			}
		}
	}
	SettingsController_addSectionToPage: {
		parameters: {
			query?: never
			header?: never
			path: {
				pageId: string
				sectionId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SettingsController_removeSectionFromPage: {
		parameters: {
			query?: never
			header?: never
			path: {
				dynamicPageSectionId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SettingsController_getDynamicPagePresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPagePresetListResponse']
				}
			}
		}
	}
	SettingsController_duplicateDynamicPagePreset: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DynamicPageModel']
				}
			}
		}
	}
	SettingsController_getMainWalletSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns main wallet setting */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MainWalletSettingResponse']
				}
			}
		}
	}
	SettingsController_updateMainWalletSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateMainWalletSettingDto']
			}
		}
		responses: {
			/** @description Returns updated main wallet setting */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MainWalletSettingResponse']
				}
			}
		}
	}
	SettingsController_getDepositStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionTypeStatusResponse']
				}
			}
		}
	}
	SettingsController_getDepositSchedules: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleListResponse']
				}
			}
		}
	}
	SettingsController_createDepositSchedule: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateTransactionScheduleDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_getDepositScheduleById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_deleteDepositSchedule: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_updateDepositSchedule: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateTransactionScheduleDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_setDepositTemporaryDisable: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SetTemporaryDisableDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SetTemporaryDisableResponse']
				}
			}
		}
	}
	SettingsController_clearDepositTemporaryDisable: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearTemporaryDisableResponse']
				}
			}
		}
	}
	SettingsController_getWithdrawStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionTypeStatusResponse']
				}
			}
		}
	}
	SettingsController_getWithdrawSchedules: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleListResponse']
				}
			}
		}
	}
	SettingsController_createWithdrawSchedule: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateTransactionScheduleDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_getWithdrawScheduleById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_deleteWithdrawSchedule: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_updateWithdrawSchedule: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateTransactionScheduleDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionScheduleResponse']
				}
			}
		}
	}
	SettingsController_setWithdrawTemporaryDisable: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SetTemporaryDisableDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SetTemporaryDisableResponse']
				}
			}
		}
	}
	SettingsController_clearWithdrawTemporaryDisable: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ClearTemporaryDisableResponse']
				}
			}
		}
	}
	InviteFriendAnalyticsController_handleNewReferralLinkClick: {
		parameters: {
			query?: never
			header?: never
			path: {
				referralCode: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Referral code not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_getPlayerInviteFriendAnalyticsCumulative: {
		parameters: {
			query: {
				startDate?: string
				endDate: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInviteFriendAnalyticsCumulativeResponse']
				}
			}
			/** @description Bad Request - Invalid date range or format */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_getInviteFriendTiers: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInviteFriendTiersResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_getInviteFriendWalletTransferHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WalletTransferHistoryResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_calculateInviteFriendReturnLoss: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InviteFriendReturnLossResponseDto']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_getInviteFriendReturnLossInfo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InviteFriendReturnLossInfoResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendAnalyticsController_getInviteFriendTierCounts: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInviteFriendTierCountsResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_handleNewReferralLinkClick: {
		parameters: {
			query?: never
			header?: never
			path: {
				referralCode: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Referral code not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_getPartnerAnalyticsCumulative: {
		parameters: {
			query: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-01-31
				 */
				endDate: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPartnerAnalyticsCumulativeResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_getReferredPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetReferredPlayersResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_getMonthlyPlayers: {
		parameters: {
			query: {
				/**
				 * @description Month in YYYY-MM format
				 * @example 2024-01
				 */
				month: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetMonthlyPlayersResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_getDailyTransactions: {
		parameters: {
			query?: {
				/**
				 * @description Number of days to retrieve (default: 7). Ignored if startDate and endDate are provided.
				 * @example 7
				 */
				days?: number
				/**
				 * @description Start date (YYYY-MM-DD). When provided together with endDate, overrides days.
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD). When provided together with startDate, overrides days.
				 * @example 2024-01-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDailyTransactionsResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PartnerAnalyticsController_getInvitationSummary: {
		parameters: {
			query?: {
				/**
				 * @description Number of days to retrieve (default: 7). Ignored if startDate and endDate are provided.
				 * @example 7
				 */
				days?: number
				/**
				 * @description Start date (YYYY-MM-DD). When provided together with endDate, overrides days.
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD). When provided together with startDate, overrides days.
				 * @example 2024-01-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetInvitationSummaryResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerLuckyWheelController_getWheelInfoByRank: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Get wheel info by rank */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LuckyWheelResponse']
				}
			}
		}
	}
	PlayerLuckyWheelController_spinWheel: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['SpinWheelDto']
			}
		}
		responses: {
			/** @description Spin wheel */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LuckyWheelSpinResponse']
				}
			}
		}
	}
	ReturnLossController_calculate: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossResponseDto']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ReturnLossController_info: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_getTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns paginated transactions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedTransactionResponse']
				}
			}
		}
	}
	PlayHistoryController_getPlayHistory: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns player play history with pagination */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayHistoryController_getPlayHistorySessions: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns play history grouped by promotion session with games */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayHistorySessionsResponse']
				}
			}
		}
	}
	PlayHistoryController_reinitSession: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ReinitSessionDto']
			}
		}
		responses: {
			/** @description Game session re-initialized successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReinitSessionResponse']
				}
			}
		}
	}
	RankController_getRankExperienceSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns the rank experience setting */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankExperienceSettingModel']
				}
			}
		}
	}
	RankController_updateRankExperienceSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateRankExperienceSettingDto']
			}
		}
		responses: {
			/** @description Returns the updated rank experience setting */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankExperienceSettingModel']
				}
			}
		}
	}
	RankController_getRanks: {
		parameters: {
			query: {
				skip: number
				take: number
				name?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetRanksResponse']
				}
			}
		}
	}
	RankController_createRank: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateRankDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetRankResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_getRankNames: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RankNameModel'][]
				}
			}
		}
	}
	RankController_getRankById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetRankResponse']
				}
			}
			/** @description Rank not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_deleteRank: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Rank deleted successfully with player auto-placement */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DeleteRankResponse']
				}
			}
			/** @description Bad Request - Cannot delete the only remaining rank or no valid target rank */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Rank not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_updateRank: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateRankDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetRankResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Rank not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_updateRankOrder: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateRankOrderDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	RankController_updateRankUpRewards: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateRankUpRewardsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminRankUpRewardResponse'][]
				}
			}
			/** @description Rank not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ReturnLossController_findAll: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossesResponse']
				}
			}
		}
	}
	ReturnLossController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateReturnLossDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ReturnLossController_getReturnLossNamesForSelector: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossSelectorListResponse']
				}
			}
		}
	}
	ReturnLossController_getDailyPlayerReturnLoss: {
		parameters: {
			query?: {
				phone?: string
				startDate?: string
				endDate?: string
				minimumAmount?: number
				skip?: number
				take?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminDailyPlayerReturnLossListResponse']
				}
			}
		}
	}
	ReturnLossController_getReturnLossHistory: {
		parameters: {
			query?: {
				phone?: string
				startDate?: string
				endDate?: string
				minimumAmount?: number
				skip?: number
				take?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminReturnLossHistoryListResponse']
				}
			}
		}
	}
	ReturnLossController_findById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossResponse']
				}
			}
			/** @description Return loss promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ReturnLossController_delete: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Return loss promotion deleted */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Return loss promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ReturnLossController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateReturnLossDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ReturnLossResponse']
				}
			}
			/** @description Return loss promotion not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CarouselController_getAllCarousels: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCarouselItemsResponse']
				}
			}
		}
	}
	CarouselController_createItem: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateCarouselItemDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CarouselItemModel']
				}
			}
		}
	}
	CarouselController_deleteItem: {
		parameters: {
			query?: never
			header?: never
			path: {
				itemId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CarouselItemModel']
				}
			}
		}
	}
	CarouselController_updateItem: {
		parameters: {
			query?: never
			header?: never
			path: {
				itemId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateCarouselItemDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CarouselItemModel']
				}
			}
		}
	}
	AnalyticsController_getChannelAnalytics: {
		parameters: {
			query?: {
				/**
				 * @description Start date to filter channels by activateAt (YYYY-MM-DD)
				 * @example 2025-01-01
				 */
				startDate?: string
				/**
				 * @description End date to filter channels by activateAt (YYYY-MM-DD)
				 * @example 2025-12-31
				 */
				endDate?: string
				/**
				 * @description Search channels by name
				 * @example Facebook
				 */
				name?: string
				/** @description Days after activation to analyze (e.g. 1,7,30,60,90,120) */
				dateRanges?: string[]
				/**
				 * @description Skip
				 * @example 0
				 */
				skip?: number
				/**
				 * @description Take
				 * @example 10
				 */
				take?: number
				/**
				 * @description Filter channels by active status
				 * @example true
				 */
				isActiveChannel?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ChannelAnalyticsListResponse']
				}
			}
		}
	}
	AnalyticsController_getOverallAnalyticsCumulative: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-01-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OverallAnalyticsCumulativeResponse']
				}
			}
		}
	}
	AnalyticsController_getOverallAnalyticsAggregate: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-01-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OverallAnalyticsAggregateResponse']
				}
			}
		}
	}
	AnalyticsController_getOverallAnalytics: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-01-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OverallAnalyticsResponse']
				}
			}
		}
	}
	AnalyticsController_exportOverallAnalyticsCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetOverallAnalyticsCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnalyticsController_getDepositWithdrawGraph: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDepositWithdrawGraphResponse']
				}
			}
		}
	}
	AnalyticsController_getPlayerDepositWithdrawGraph: {
		parameters: {
			query: {
				/**
				 * @description Player ID to get graph for
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				playerId: string
				/**
				 * @description Start date for graph data
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date for graph data
				 * @example 2023-12-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerDepositWithdrawGraphResponse']
				}
			}
		}
	}
	AnalyticsController_getTransactionSummary: {
		parameters: {
			query?: {
				/**
				 * @description Start date for transaction summary
				 * @example 2025-05-31T16:34:04.148Z
				 */
				startDate?: string
				/**
				 * @description End date for transaction summary
				 * @example 2025-05-31T16:34:04.148Z
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionSummaryResponse']
				}
			}
		}
	}
	AnalyticsController_exportTransactionSummaryCsv: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetTransactionSummaryCsvDto']
			}
		}
		responses: {
			/** @description CSV file download */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnalyticsController_getPromotionAnalytics: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-12-31
				 */
				endDate?: string
				/**
				 * @description Skip
				 * @example 0
				 */
				skip?: number
				/**
				 * @description Take
				 * @example 10
				 */
				take?: number
				/**
				 * @description Search promotions by name
				 * @example Welcome Bonus
				 */
				searchQuery?: string
				/**
				 * @description Filter promotions for players
				 * @example true
				 */
				isForPlayer?: boolean
				/**
				 * @description Filter coupon promotions
				 * @example false
				 */
				isCoupon?: boolean
				/**
				 * @description Filter guest-only promotions
				 * @example false
				 */
				isForGuestOnly?: boolean
				/** @description Sort by total deposit amount */
				totalDepositAmountSort?: components['schemas']['SortOrder']
				/** @description Sort by total transfer amount */
				totalTransferAmountSort?: components['schemas']['SortOrder']
				/** @description Sort by player count */
				playerCountSort?: components['schemas']['SortOrder']
				/** @description Sort by total receive time */
				totalReceiveTimeSort?: components['schemas']['SortOrder']
				/** @description Sort by balance after turnover finish */
				balanceAfterTurnoverFinishSort?: components['schemas']['SortOrder']
				/** @description Sort by player turnover amount after clear turnover */
				playerTurnoverAmountAfterClearTurnoverSort?: components['schemas']['SortOrder']
				/** @description Sort by total time finish turnover */
				totalTimeFinishTurnoverSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionAnalyticsListResponse']
				}
			}
		}
	}
	AnalyticsController_getPromotionDetail: {
		parameters: {
			query: {
				/** @description Promotion ID */
				promotionId: string
				/** @description Start date (YYYY-MM-DD) */
				startDate?: string
				/** @description End date (YYYY-MM-DD) */
				endDate?: string
				/**
				 * @description Skip
				 * @example 0
				 */
				skip?: number
				/**
				 * @description Take
				 * @example 10
				 */
				take?: number
				/** @description Optional search by player phone */
				phone?: string
				/** @description Sort by total receive time */
				totalReceiveTimeSort?: components['schemas']['SortOrder']
				/** @description Sort by total deposit amount */
				totalDepositAmountSort?: components['schemas']['SortOrder']
				/** @description Sort by total transfer amount */
				totalTransferAmountSort?: components['schemas']['SortOrder']
				/** @description Sort by balance after turnover finish */
				balanceAfterTurnoverFinishSort?: components['schemas']['SortOrder']
				/** @description Sort by player turnover amount after clear turnover */
				playerTurnoverAmountAfterClearTurnoverSort?: components['schemas']['SortOrder']
				/** @description Sort by total time finish turnover */
				totalTimeFinishTurnoverSort?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionDetailAnalyticsListResponse']
				}
			}
		}
	}
	AnalyticsController_getTTFBDistribution: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
				bucketSize?: components['schemas']['BucketSize']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TTFBDistributionResponse']
				}
			}
		}
	}
	AnalyticsController_getTTFDDistribution: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
				bucketSize?: components['schemas']['BucketSize']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TTFDDistributionResponse']
				}
			}
		}
	}
	AnalyticsController_getCohortRetention: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
				cohortType?: components['schemas']['CohortType']
				retentionDays?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CohortRetentionResponse']
				}
			}
		}
	}
	AnalyticsController_getStickinessTrend: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
				windowType?: components['schemas']['CohortType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['StickinessTrendResponse']
				}
			}
		}
	}
	AnalyticsController_getPlayerLifecycle: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerLifecycleResponse']
				}
			}
		}
	}
	AnalyticsController_getPlayLogs: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-12-31
				 */
				endDate?: string
				/**
				 * @description Player phone number
				 * @example 0812345678
				 */
				phone?: string
				/**
				 * @description Provider
				 * @example PG
				 */
				provider?: string
				/**
				 * @description Skip
				 * @example 0
				 */
				skip?: number
				/**
				 * @description Take
				 * @example 10
				 */
				take?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminPlayLogsListResponse']
				}
			}
		}
	}
	AnalyticsController_getOnlineUsersStats: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns the total count of currently online/active users */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OnlineUsersStatsResponse']
				}
			}
		}
	}
	AnalyticsController_getLineAnalytics: {
		parameters: {
			query?: {
				/**
				 * @description Date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				date?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns comprehensive LINE analytics including quota, consumption, and message statistics by type */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LineAnalyticsResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Service Unavailable */
			503: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnalyticsController_getActiveUsersMetrics: {
		parameters: {
			query?: {
				/**
				 * @description Start date for metrics query
				 * @example 2024-01-01T00:00:00.000Z
				 */
				startDate?: string
				/**
				 * @description End date for metrics query
				 * @example 2024-01-31T23:59:59.999Z
				 */
				endDate?: string
				/**
				 * @description Aggregation interval: 30min (raw), hourly, daily
				 * @example 30min
				 */
				interval?: string
				/**
				 * @description Comparison period start date (optional)
				 * @example 2023-12-01T00:00:00.000Z
				 */
				compareStart?: string
				/**
				 * @description Comparison period end date (optional)
				 * @example 2023-12-31T23:59:59.999Z
				 */
				compareEnd?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns time-series data of active user counts with support for 30min/hourly/daily aggregation and optional comparison */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ActiveUsersMetricsResponse']
				}
			}
		}
	}
	AnalyticsController_getActiveUsersSummary: {
		parameters: {
			query?: {
				/**
				 * @description Start date for metrics query
				 * @example 2024-01-01T00:00:00.000Z
				 */
				startDate?: string
				/**
				 * @description End date for metrics query
				 * @example 2024-01-31T23:59:59.999Z
				 */
				endDate?: string
				/**
				 * @description Aggregation interval: 30min (raw), hourly, daily
				 * @example 30min
				 */
				interval?: string
				/**
				 * @description Comparison period start date (optional)
				 * @example 2023-12-01T00:00:00.000Z
				 */
				compareStart?: string
				/**
				 * @description Comparison period end date (optional)
				 * @example 2023-12-31T23:59:59.999Z
				 */
				compareEnd?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns comprehensive summary with hourly pattern and day of week pattern */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ActiveUsersSummaryResponse']
				}
			}
		}
	}
	AnalyticsController_getPlayerGameStats: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player game statistics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnalyticsController_getAllPlayersGameStats: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2025-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2025-01-31
				 */
				endDate?: string
				/**
				 * @description Filter by specific game ID
				 * @example game-uuid
				 */
				gameId?: string
				/**
				 * @description Filter by specific provider
				 * @example pghard
				 */
				provider?: string
				/** @description Sort by field */
				sortBy?: PathsApiAdminAnalyticsAllPlayersGameStatsGetParametersQuerySortBy
				sortOrder?: PathsApiAdminAnalyticsAllPlayersGameStatsGetParametersQuerySortOrder
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description All players game statistics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetAllPlayersGameStatsResponse']
				}
			}
		}
	}
	GameController_getGameListForAdmin: {
		parameters: {
			query: {
				skip: number
				take: number
				name?: string
				type?: components['schemas']['GameType']
				isActive?: boolean
				isPopular?: boolean
				isNew?: boolean
				providerName?: string
				displayName?: string
				/** @description Include hard provider games (PGHARD, JILIHARD, JOKERHARD, etc.) */
				includeHardProviders?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_getGameProviderListForAdmin: {
		parameters: {
			query: {
				skip: number
				take: number
				providerName?: string
				displayName?: string
				gameType?: components['schemas']['GameType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameAdminProviderListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_updateGame: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGameListDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Game not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_getGameTypeList: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameTypeListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_updateGameType: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGameTypeDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameTypeListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Game type not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_syncGames: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Games synced successfully */
			204: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_updateGameProvider: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGameProviderDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameProviderModel']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Game provider not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_updateGameProviderGameType: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateGameProviderGameTypeDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateGameProviderGameTypeResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_getAdminProvidersByGameType: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Game type
				 * @example SLOT
				 */
				gameType: components['schemas']['GameType']
				displayName?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GameProviderWithBannerListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_batchSetProviderPreset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BatchSetProviderPresetDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BatchSetPresetResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	GameController_batchSetGamePreset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BatchSetGamePresetDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BatchSetPresetResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ExternalCallbackController_checkBalance: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CheckBalanceRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CheckBalanceResponse']
				}
			}
		}
	}
	ExternalCallbackController_updateBalance: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateBalanceRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateBalanceResponse']
				}
			}
		}
	}
	ExternalCallbackController_getGeneralSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalGeneralSettingResponse']
				}
			}
		}
	}
	ExternalCallbackController_updateGeneralSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateExternalGeneralSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalGeneralSettingResponse']
				}
			}
		}
	}
	ExternalCallbackController_getBillingDetails: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetExternalBillingDetailsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalBillingDetailsResponse']
				}
			}
		}
	}
	ExternalCallbackController_getCryptoInvoices: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetExternalCryptoInvoicesDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalPaginatedCryptoInvoicesResponse']
				}
			}
		}
	}
	ExternalCallbackController_getPromotions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPromotionsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalPromotionsResponse']
				}
			}
		}
	}
	ExternalCallbackController_updatePromotionChargeRate: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePromotionChargeRateDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalPromotionResponse']
				}
			}
		}
	}
	ExternalCallbackController_createMonthlyFeeInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateMonthlyFeeInvoiceDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalCryptoInvoiceResponse']
				}
			}
		}
	}
	ExternalCallbackController_createCompanyCommissionInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateCompanyCommissionInvoiceDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalCryptoInvoiceResponse']
				}
			}
		}
	}
	ExternalCallbackController_updateCryptoInvoiceStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateCryptoInvoiceStatusDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalCryptoInvoiceResponse']
				}
			}
		}
	}
	ExternalCallbackController_createManualInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateManualCryptoInvoiceExternalDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ExternalCryptoInvoiceResponse']
				}
			}
		}
	}
	CryptoDepositController_checkOverdueInvoices: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Overdue invoice check result */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CryptoDepositController_getCryptoInvoices: {
		parameters: {
			query: {
				skip: number
				take: number
				txId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedCryptoInvoicesResponse']
				}
			}
		}
	}
	CryptoDepositController_getBillingDetails: {
		parameters: {
			query: {
				/**
				 * @description Billing month in YYYY-MM format
				 * @example 2025-11
				 */
				billingMonth: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BillingDetailsResponse']
				}
			}
		}
	}
	CryptoDepositController_getCryptoInvoiceById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CryptoInvoiceResponse']
				}
			}
		}
	}
	CryptoDepositController_createManualInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateManualCryptoInvoiceDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CryptoInvoiceResponse']
				}
			}
		}
	}
	CryptoDepositController_createPrepaymentInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreatePrepaymentInvoiceDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CryptoInvoiceResponse']
				}
			}
		}
	}
	CryptoDepositController_generatePayment: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GeneratePaymentRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CryptoInvoiceResponse']
				}
			}
		}
	}
	CryptoDepositController_payCryptoInvoice: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ConfirmCryptoInvoiceRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CryptoInvoiceResponse']
				}
			}
		}
	}
	TournamentController_getPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament presets retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TournamentController_createTournamentFromPreset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateTournamentFromPresetDto']
			}
		}
		responses: {
			/** @description Tournament created from preset successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	TournamentController_getTournaments: {
		parameters: {
			query: {
				skip: number
				take: number
				search?: string
				status?: PathsApiAdminTournamentsGetParametersQueryStatus
				isActive?: boolean
				sortBy?: PathsApiAdminTournamentsGetParametersQuerySortBy
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournaments retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentListResponse']
				}
			}
		}
	}
	TournamentController_createTournament: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateTournamentDto']
			}
		}
		responses: {
			/** @description Tournament created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	TournamentController_getTournamentById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	TournamentController_deleteTournament: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TournamentController_updateTournament: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateTournamentDto']
			}
		}
		responses: {
			/** @description Tournament updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	TournamentController_updateTournamentStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateTournamentStatusDto']
			}
		}
		responses: {
			/** @description Tournament status updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	TournamentController_getTournamentPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				search?: string
				status?: PathsApiAdminTournamentsIdPlayersGetParametersQueryStatus
				sortBy?: PathsApiAdminTournamentsIdPlayersGetParametersQuerySortBy
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament players retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentPlayerListResponse']
				}
			}
		}
	}
	TournamentController_manualJoinTournament: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminManualJoinTournamentDto']
			}
		}
		responses: {
			/** @description Player added to tournament successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentPlayerResponse']
				}
			}
		}
	}
	TournamentController_finalizeTournament: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament finalized successfully, prizes distributed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTournamentResponse']
				}
			}
		}
	}
	BankAccountController_createBankAccount: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateBankAccountDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankAccountController_getBankAccounts: {
		parameters: {
			query: {
				skip: number
				take: number
				bankProvider?: string
				bankAccountType?: components['schemas']['BankAccountType']
				isActive?: boolean
				accountName?: string
				accountNumber?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountsResponse']
				}
			}
		}
	}
	BankAccountController_getBankAccountById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountResponse']
				}
			}
			/** @description Bank account not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankAccountController_updateBankAccount: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateBankAccountDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountsResponse']
				}
			}
		}
	}
	BankAccountController_deleteBankAccount: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountsResponse']
				}
			}
		}
	}
	BankAccountController_getAdminBankProviders: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of bank providers */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BankProviderResponse'][]
				}
			}
		}
	}
	BankAccountController_createWithdrawTransaction: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateWithdrawTransactionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetBankAccountsResponse']
				}
			}
		}
	}
	BankTransactionController_getDepositTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Player ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				playerId?: string
				/**
				 * @description Search by txId, player phone, bank account number, or bank account name
				 * @example 0812345678
				 */
				search?: string
				/**
				 * @description Payment Gateway ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				paymentGatewayId?: string
				/** @description Transaction processor */
				processor?: components['schemas']['TransactionProcessor']
				/**
				 * @description Transaction status
				 * @example [
				 *       "PENDING",
				 *       "COMPLETED"
				 *     ]
				 */
				status?: components['schemas']['DepositStatus'][]
				/** @description Sort by deposit amount */
				sortByAmount?: components['schemas']['SortOrder']
				/** @description Sort by created date */
				sortByCreatedAt: components['schemas']['SortOrder']
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of deposit transactions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedDepositTransactionsResponse']
				}
			}
		}
	}
	BankTransactionController_getOperatorDepositTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Transaction ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				txId?: string
				/**
				 * @description Transaction status
				 * @example [
				 *       "PENDING",
				 *       "COMPLETED"
				 *     ]
				 */
				status?: components['schemas']['DepositStatus'][]
				/** @description Sort by deposit amount */
				sortByAmount?: components['schemas']['SortOrder']
				/** @description Sort by created date */
				sortByCreatedAt: components['schemas']['SortOrder']
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of operator deposit transactions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedOperatorDepositTransactionsResponse']
				}
			}
		}
	}
	BankTransactionController_createOperatorDeposit: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateOperatorDepositTransactionDto']
			}
		}
		responses: {
			/** @description The deposit transaction has been successfully created */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_getOperatorDepositTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a single operator deposit transaction */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OperatorDepositTransactionResponse']
				}
			}
		}
	}
	BankTransactionController_getWithdrawalTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Player ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				playerId?: string
				/**
				 * @description Search by txId, player phone, bank account number, or bank account name
				 * @example 0812345678
				 */
				search?: string
				/**
				 * @description Payment Gateway ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				paymentGatewayId?: string
				/** @description Transaction processor */
				processor?: components['schemas']['TransactionProcessor']
				/**
				 * @description Transaction status
				 * @example [
				 *       "PENDING",
				 *       "COMPLETED"
				 *     ]
				 */
				status?: components['schemas']['WithdrawStatus'][]
				/** @description Sort by withdraw amount */
				sortByAmount?: components['schemas']['SortOrder']
				/** @description Sort by created date */
				sortByCreatedAt: components['schemas']['SortOrder']
				/**
				 * @description Start date
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date
				 * @example 2023-01-01
				 */
				endDate?: string
				/** @description Filter by player account type (BANK or TRUE_MONEY) */
				playerBankType?: components['schemas']['PlayerBankType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of withdrawal transactions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedWithdrawTransactionsResponse']
				}
			}
		}
	}
	BankTransactionController_createWithdraw: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateWithdrawTransactionDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully created */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_getOperatorWithdrawalTransactions: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Transaction ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				txId?: string
				/**
				 * @description Transaction status
				 * @example [
				 *       "PENDING",
				 *       "COMPLETED"
				 *     ]
				 */
				status?: components['schemas']['WithdrawStatus'][]
				/** @description Sort by withdraw amount */
				sortByAmount?: components['schemas']['SortOrder']
				/** @description Sort by created date */
				sortByCreatedAt: components['schemas']['SortOrder']
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of operator deposit transactions */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedOperatorDepositTransactionsResponse']
				}
			}
		}
	}
	BankTransactionController_createOperatorWithdrawal: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateOperatorWithdrawTransactionDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully created */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_getOperatorWithdrawalTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a single operator deposit transaction */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['OperatorWithdrawalTransactionResponse']
				}
			}
		}
	}
	BankTransactionController_getTrueMoneyDeposits: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-12-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TrueMoneyDepositsResponse']
				}
			}
		}
	}
	BankTransactionController_getDepositTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a single deposit transaction */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminDepositTransactionResponse']
				}
			}
		}
	}
	BankTransactionController_getWithdrawalTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a single withdrawal transaction */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminWithdrawTransactionResponse']
				}
			}
		}
	}
	BankTransactionController_forceCompleteDeposit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ForceCompleteDepositDto']
			}
		}
		responses: {
			/** @description The deposit transaction has been successfully completed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_manualBankWithdraw: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The withdrawal transaction has been successfully processed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminDepositTransactionResponse']
				}
			}
		}
	}
	BankTransactionController_forceCompleteWithdraw: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ForceCompleteWithdrawDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully completed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_approveWithdraw: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminApproveWithdrawDto']
			}
		}
		responses: {
			/** @description The withdrawal approval has been executed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_retryWithdraw: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The withdrawal retry has been executed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_cancelWithdrawBank: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CancelWithdrawTransactionDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully cancelled */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_refundWithdraw: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RefundWithdrawTransactionDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully refunded to player wallet */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Transaction is currently being processed or already refunded */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Transaction not found or cannot be refunded (only FAILED or EXPIRED) */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_createManualDeposit: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateManualDepositTransactionDto']
			}
		}
		responses: {
			/** @description The deposit transaction has been successfully created */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_createManualWithdraw: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateManualWithdrawTransactionDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction has been successfully created */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_forceCancelDeposit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ForceCancelDepositTransactionDto']
			}
		}
		responses: {
			/** @description The deposit transaction has been successfully canceled */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_getTrueWalletTransactionLogs: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Payment gateway ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				paymentGatewayId?: string
				/**
				 * @description Phone number
				 * @example 0812345678
				 */
				phoneNumber?: string
				/**
				 * @description Amount
				 * @example 100
				 */
				amount?: number
				/**
				 * @description Start date for filtering
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date for filtering
				 * @example 2024-12-31
				 */
				endDate?: string
				/**
				 * @description Sort by created date
				 * @example desc
				 */
				sortByCreatedAt?: PathsApiAdminBankTransactionsTrueWalletLogsGetParametersQuerySortByCreatedAt
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of True Wallet transaction logs */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedTrueWalletTransactionLogsResponse']
				}
			}
		}
	}
	BankTransactionController_searchPlayersForRematch: {
		parameters: {
			query: {
				q: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Matching players */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_checkPlayerTurnover: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns turnover status for the player */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_getSmsAutoTransactionLogs: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Payment gateway ID
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				paymentGatewayId?: string
				/**
				 * @description Account number
				 * @example 1234567890
				 */
				accountNumber?: string
				/**
				 * @description Amount
				 * @example 100
				 */
				amount?: number
				/**
				 * @description Start date for filtering
				 * @example 2024-01-01
				 */
				startDate?: string
				/**
				 * @description End date for filtering
				 * @example 2024-12-31
				 */
				endDate?: string
				/**
				 * @description Sort by created date
				 * @example desc
				 */
				sortByCreatedAt?: PathsApiAdminBankTransactionsSmsAutoLogsGetParametersQuerySortByCreatedAt
				/** @description Filter by SMS auto log status */
				status?: components['schemas']['SmsAutoLogStatus'][]
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of SMS Auto transaction logs */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedSmsAutoTransactionLogsResponse']
				}
			}
		}
	}
	BankTransactionController_searchUsersForRematch: {
		parameters: {
			query: {
				/**
				 * @description SMS auto log ID to resolve account number and amount from
				 * @example 123e4567-e89b-12d3-a456-426614174000
				 */
				smsLogId: string
				/**
				 * @description Account number to search (optional, for backward compat / direct use)
				 * @example 1234567890
				 */
				accountNumber?: string
				/**
				 * @description Bank provider name filter
				 * @example SCB
				 */
				bankProviderName?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminSearchUsersForRematchResponse']
				}
			}
		}
	}
	BankTransactionController_rematchSmsAutoLog: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminRematchSmsAutoLogRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SmsAutoTransactionLogResponse']
				}
			}
		}
	}
	BankTransactionController_cancelSmsAutoLog: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCancelSmsAutoLogRequestDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SmsAutoTransactionLogResponse']
				}
			}
		}
	}
	BankTransactionController_updateSmsAutoLogStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateSmsAutoLogStatusDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SmsAutoTransactionLogResponse']
				}
			}
		}
	}
	BankTransactionController_createSmsAutoLogDeposit: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateDepositForRematchDto']
			}
		}
		responses: {
			/** @description Deposit created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						depositTransactionId?: string
						amount?: number
						status?: string
					}
				}
			}
		}
	}
	BankTransactionController_completeRematchSmsAutoLog: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCompleteRematchDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['SmsAutoTransactionLogResponse']
				}
			}
		}
	}
	BankTransactionController_getTransactionStatistics: {
		parameters: {
			query?: {
				/**
				 * @description Start date (YYYY-MM-DD)
				 * @example 2023-01-01
				 */
				startDate?: string
				/**
				 * @description End date (YYYY-MM-DD)
				 * @example 2023-12-31
				 */
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionStatisticsResponse']
				}
			}
		}
	}
	BankTransactionController_updateDepositStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateDepositStatusDto']
			}
		}
		responses: {
			/** @description The deposit transaction status has been updated */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Deposit transaction not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_updateWithdrawStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateWithdrawStatusDto']
			}
		}
		responses: {
			/** @description The withdrawal transaction status has been updated */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Withdrawal transaction not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankTransactionController_uploadOperatorDepositSlip: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UploadOperatorDepositSlipDto']
			}
		}
		responses: {
			/** @description Slip uploaded and processed */
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	WithdrawController_createWithdraw: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateWithdrawDto']
			}
		}
		responses: {
			/** @description The withdraw has been successfully created. */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WithdrawTransactionResponse']
				}
			}
		}
	}
	WithdrawController_getPendingWithdrawTransaction: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The withdraw transactions have been successfully retrieved. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WithdrawTransactionResponse'][]
				}
			}
		}
	}
	WithdrawController_getWithdrawInfo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns withdrawal limits and availability information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WithdrawInfoResponse']
				}
			}
		}
	}
	WithdrawController_getWithdrawStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns withdrawal availability status */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['TransactionAvailabilityResponse']
				}
			}
		}
	}
	WithdrawController_getWithdrawTransactionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				transactionId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The withdraw transaction has been successfully retrieved. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WithdrawTransactionResponse']
				}
			}
		}
	}
	BlacklistController_getBlacklists: {
		parameters: {
			query: {
				skip: number
				take: number
				/**
				 * @description Account Name / Account Number
				 * @example John Doe / 1234567890
				 */
				account?: string
				/**
				 * @description Bank Provider Name
				 * @example SCB
				 */
				bankProviderName?: string
				/**
				 * @description Phone Number
				 * @example 0812345678
				 */
				phoneNumber?: string
				/**
				 * @description Phone Number
				 * @example 0812345678
				 */
				reason?: string
				/** @description Sort by created date */
				sortByCreatedAt: components['schemas']['SortOrder']
				startDate?: string
				endDate?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of blacklists */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PaginatedBlacklistResponse']
				}
			}
		}
	}
	BlacklistController_reportBlacklist: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateBlacklistDto']
			}
		}
		responses: {
			/** @description The blacklist has been successfully reported */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BlacklistController_removeBlacklist: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description The blacklist has been successfully removed */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BlacklistController_updateBlacklist: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ReportBlacklistDto']
			}
		}
		responses: {
			/** @description The blacklist has been successfully reported */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnnouncementController_createAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateAnnouncementDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAnnouncementResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnnouncementController_getAnnouncements: {
		parameters: {
			query: {
				skip: number
				take: number
				title?: string
				content?: string
				isActive?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAnnouncementsResponse']
				}
			}
		}
	}
	AnnouncementController_getAnnouncementById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAnnouncementResponse']
				}
			}
			/** @description Announcement not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AnnouncementController_updateAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAnnouncementDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAnnouncementResponse']
				}
			}
		}
	}
	AnnouncementController_deleteAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAnnouncementResponse']
				}
			}
		}
	}
	SlideAnnouncementController_getSlideAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetSlideAnnouncementResponse']
				}
			}
		}
	}
	SlideAnnouncementController_createSlideAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateSlideAnnouncementDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetSlideAnnouncementResponse']
				}
			}
		}
	}
	SlideAnnouncementController_deleteSlideAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Slide announcement deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SlideAnnouncementController_updateSlideAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateSlideAnnouncementDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetSlideAnnouncementResponse']
				}
			}
		}
	}
	MinimumWithdrawController_get: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MinimumWithdrawSettingResponse']
				}
			}
			/** @description Minimum withdraw setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MinimumWithdrawController_update: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateMinimumWithdrawSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MinimumWithdrawSettingResponse']
				}
			}
			/** @description Minimum withdraw setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendController_getSettings: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InviteFriendSettingResponse']
				}
			}
			/** @description Invite friend setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendController_update: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateInviteFriendSettingDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InviteFriendSettingResponse']
				}
			}
			/** @description Invite friend setting not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendController_getCommissionHistory: {
		parameters: {
			query?: {
				phone?: string
				startDate?: string
				endDate?: string
				minimumAmount?: number
				/** @description Filter by a specific commission type */
				commissionType?: PathsApiAdminInviteFriendCommissionHistoryGetParametersQueryCommissionType
				skip?: number
				take?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminInviteFriendCommissionHistoryListResponse']
				}
			}
		}
	}
	InviteFriendController_getInviteFriendTierCounts: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Success */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetInviteFriendTierCountsResponse']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	InviteFriendController_getPlayerReferredPlayers: {
		parameters: {
			query: {
				skip: number
				take: number
				phone?: string
				startDate?: string
				endDate?: string
				/** @description Optional player ID to calculate commissions for (useful for viewing referral tree from head perspective) */
				commissionForPlayer?: string
			}
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetReferredPlayersResponse']
				}
			}
		}
	}
	ProfilePageBannerController_getAllProfilePageBanners: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	ProfilePageBannerController_createProfilePageBanner: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateProfilePageBannerDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	ProfilePageBannerController_getProfilePageBannerById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	ProfilePageBannerController_deleteProfilePageBanner: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	ProfilePageBannerController_updateProfilePageBanner: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateProfilePageBannerDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	CouponController_getCouponBatches: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by promotion ID */
				promotionId?: string
				/** @description Filter by active status */
				isActive?: boolean
				/** @description Search by batch name */
				name?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of coupon batches */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCouponBatchesResponse']
				}
			}
		}
	}
	CouponController_createCouponBatch: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateCouponBatchDto']
			}
		}
		responses: {
			/** @description Coupon batch created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CreateCouponBatchResponse']
				}
			}
		}
	}
	CouponController_deleteBatch: {
		parameters: {
			query?: never
			header?: never
			path: {
				batchId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Batch and coupons deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CouponController_updateCouponBatch: {
		parameters: {
			query?: never
			header?: never
			path: {
				batchId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateCouponBatchDto']
			}
		}
		responses: {
			/** @description Batch updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateCouponBatchResponse']
				}
			}
		}
	}
	CouponController_generateAdditionalCoupons: {
		parameters: {
			query?: never
			header?: never
			path: {
				batchId: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateAdditionalCouponsDto']
			}
		}
		responses: {
			/** @description Additional coupons generated or quota increased successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GenerateAdditionalCouponsResponse']
				}
			}
		}
	}
	CouponController_getCoupons: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by batch ID */
				batchId?: string
				/** @description Filter by promotion ID */
				promotionId?: string
				/** @description Filter by coupon status */
				status?: string
				/** @description Search by coupon code */
				code?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of coupons */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCouponsResponse']
				}
			}
		}
	}
	CouponController_getCouponStats: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Coupon statistics */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCouponStatsResponse']
				}
			}
		}
	}
	CouponController_getCouponsForBrokeNotification: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of SINGLE type coupons */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCouponsForBrokeNotificationResponse']
				}
			}
		}
	}
	CouponController_getCouponUsageHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Coupon ID to get usage history for (SINGLE type only) */
				couponId?: string
			}
			header?: never
			path: {
				couponId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Coupon usage history */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetCouponUsageHistoryResponse']
				}
			}
		}
	}
	ShopController_getShopItemPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop item presets retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemPresetListResponse']
				}
			}
		}
	}
	ShopController_applyShopItemPreset: {
		parameters: {
			query?: never
			header?: never
			path: {
				presetId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop item created from preset successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemResponse']
				}
			}
		}
	}
	ShopController_getShopItems: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by name */
				name?: string
				/** @description Filter by currency type */
				currencyType?: components['schemas']['CurrencyType']
				/** @description Filter by reward type */
				rewardType?: components['schemas']['ShopItemType']
				/** @description Filter by active status */
				isActive?: boolean
				/** @description Filter by preset ID */
				presetId?: string
				/** @description Filter by game ID */
				gameId?: string
				/** @description Filter by bet amount */
				betAmount?: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop items retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemListResponse']
				}
			}
		}
	}
	ShopController_createShopItem: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateShopItemDto']
			}
		}
		responses: {
			/** @description Shop item created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemResponse']
				}
			}
		}
	}
	ShopController_getShopItemById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop item retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemResponse']
				}
			}
		}
	}
	ShopController_deleteShopItem: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop item deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	ShopController_updateShopItem: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateShopItemDto']
			}
		}
		responses: {
			/** @description Shop item updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopItemResponse']
				}
			}
		}
	}
	ShopController_getShopPurchases: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by player phone */
				playerPhone?: string
				/** @description Filter by reward type */
				rewardType?: unknown
				/** @description Filter by purchase status */
				status?: components['schemas']['ShopHistoryStatus']
				/** @description Filter by currency type */
				currencyType?: components['schemas']['CurrencyType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Shop purchases retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopPurchaseListResponse']
				}
			}
		}
	}
	ShopController_getPurchaseById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Purchase retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopPurchaseResponse']
				}
			}
		}
	}
	ShopController_processPurchase: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminProcessPurchaseDto']
			}
		}
		responses: {
			/** @description Purchase processed successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminShopPurchaseResponse']
				}
			}
		}
	}
	EventController_getAllEvents: {
		parameters: {
			query: {
				skip: number
				take: number
				title?: string
				isActive?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetEventsResponse']
				}
			}
		}
	}
	EventController_createEvent: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateEventDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['EventModel']
				}
			}
		}
	}
	EventController_getEventById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetEventResponse']
				}
			}
		}
	}
	EventController_deleteEvent: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['EventModel']
				}
			}
		}
	}
	EventController_updateEvent: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateEventDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['EventModel']
				}
			}
		}
	}
	TurnoverEventController_getTurnoverEvents: {
		parameters: {
			query: {
				skip: number
				take: number
				search?: string
				status?: PathsApiAdminTurnoverEventsGetParametersQueryStatus
				isActive?: boolean
				sortBy?: PathsApiAdminTurnoverEventsGetParametersQuerySortBy
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Turnover events retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventListResponse']
				}
			}
		}
	}
	TurnoverEventController_createTurnoverEvent: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateTurnoverEventDto']
			}
		}
		responses: {
			/** @description Turnover event created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventResponse']
				}
			}
		}
	}
	TurnoverEventController_getTurnoverEventById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Turnover event retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventResponse']
				}
			}
		}
	}
	TurnoverEventController_deleteTurnoverEvent: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Turnover event deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TurnoverEventController_updateTurnoverEvent: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateTurnoverEventDto']
			}
		}
		responses: {
			/** @description Turnover event updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventResponse']
				}
			}
		}
	}
	TurnoverEventController_updateTurnoverEventStatus: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateTurnoverEventStatusDto']
			}
		}
		responses: {
			/** @description Turnover event status updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventResponse']
				}
			}
		}
	}
	TurnoverEventController_getEventClaims: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Search by player phone or username */
				search?: string
				sortBy?: PathsApiAdminTurnoverEventsIdClaimsGetParametersQuerySortBy
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Event claims retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminTurnoverEventRewardListResponse']
				}
			}
		}
	}
	MessageController_getSmsProviders: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetSmsProvidersResponse'][]
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getSmsProviderSenders: {
		parameters: {
			query?: never
			header?: never
			path: {
				providerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetSmsProviderSendersResponse'][]
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getMessageTransactionHistory: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetMessageTransactionHistoryDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetMessageTransactionHistoryResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getConditions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MessageConditionSingleResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getConditionsAuto: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MessageConditionAutoResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_groupPlayerByCondition: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetPlayerByConditionDto']
			}
		}
		responses: {
			/** @description Array of player objects with messaging info */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerForMessagingModel'][]
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getAllAutoMessages: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAutoMessageResponse'][]
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getAutoMessage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAutoMessageResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_updateAutoMessage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAutoMessageDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateAutoMessageDto']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_removeAutoMessage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Successfully deleted */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_createMessageTransaction: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateMessageTransactionDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetMessageResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_createAutoMessageTransaction: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateMessageTransactionDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetAutoMessageResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getChannelTransactions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetChannelTransactionsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetChannelTransactionsResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getMessagingAnalytics: {
		parameters: {
			query?: {
				startDate?: string
				endDate?: string
				/** @description Filter by channel (SMS or LINE). If not provided, returns both. */
				channel?: PathsApiAdminMessageAnalyticsGetParametersQueryChannel
				/** @description Filter by message type. If not provided, combines all types. */
				messageType?: PathsApiAdminMessageAnalyticsGetParametersQueryMessageType
				/** @description Specific transaction ID for campaign-level analytics */
				transactionId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['MessagingAnalyticsResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getFlexMessageAnalytics: {
		parameters: {
			query?: {
				/** @description Filter by specific hot game flex message ID */
				hotGameFlexMessageId?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['FlexMessageAnalyticsListResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getFlexMessageAnalyticsDetail: {
		parameters: {
			query?: never
			header?: never
			path: {
				hotGameFlexMessageId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['FlexMessageAnalyticsResponse']
				}
			}
			/** @description Not Found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_recalculateFlexMessageAnalytics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RecalculateFlexMessageAnalyticsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['FlexMessageAnalyticsRecalculateResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_buildPromotionFlex: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Flex message built successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': {
						flexJson?: Record<string, never>
						lineTransactionType?: string
					}
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getPromotionFlexAnalytics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Analytics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MessageController_getPromotionFlexAnalyticsDetail: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Analytics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	IntervalMessageController_findAll: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetIntervalMessagesResponse']
				}
			}
		}
	}
	IntervalMessageController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateIntervalMessageDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['IntervalMessageTransactionModel']
				}
			}
		}
	}
	IntervalMessageController_getIntervalConditions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	IntervalMessageController_findOne: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['IntervalMessageTransactionModel']
				}
			}
		}
	}
	IntervalMessageController_remove: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	IntervalMessageController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateIntervalMessageDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['IntervalMessageTransactionModel']
				}
			}
		}
	}
	AdminBrokeNotificationController_getAllNotifications: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationListResponse']
				}
			}
		}
	}
	AdminBrokeNotificationController_createNotification: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateBrokeNotificationDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationResponse']
				}
			}
		}
	}
	AdminBrokeNotificationController_getNotificationStats: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationStatsResponse']
				}
			}
		}
	}
	AdminBrokeNotificationController_getNotificationById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationResponse']
				}
			}
		}
	}
	AdminBrokeNotificationController_deleteNotification: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationResponse']
				}
			}
		}
	}
	AdminBrokeNotificationController_updateNotification: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateBrokeNotificationDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_getCampaigns: {
		parameters: {
			query?: {
				/** @description Filter by active status */
				isActive?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Campaigns retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignListResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_createCampaign: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateBrokeFlexMessageCampaignDto']
			}
		}
		responses: {
			/** @description Campaign created successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_getCampaign: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Campaign retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_updateCampaign: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateBrokeFlexMessageCampaignDto']
			}
		}
		responses: {
			/** @description Campaign updated successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_deleteCampaign: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Campaign deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BrokeFlexMessageController_previewCampaignStage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
				stageId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Preview sent successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BrokeFlexMessageController_getPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Presets retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PresetsListResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_createFromPreset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateFromPresetDto']
			}
		}
		responses: {
			/** @description Campaign created successfully from preset */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_addStage: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AddStageDto']
			}
		}
		responses: {
			/** @description Stage added successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminBrokeFlexMessageCampaignResponse']
				}
			}
		}
	}
	BrokeFlexMessageController_getAllAnalytics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Analytics overview retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BrokeFlexMessageController_getAnalytics: {
		parameters: {
			query?: never
			header?: never
			path: {
				campaignId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Analytics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DomainController_attachDomain: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AttachDomainDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AttachDomainResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Unauthorized */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Agent not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Internal Server Error */
			500: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DomainController_detachDomain: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['DetachDomainDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DetachDomainResponse']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Unauthorized */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Agent or domain not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Internal Server Error */
			500: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DomainController_getDomains: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDomainsResponse']
				}
			}
			/** @description Unauthorized */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Agent not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	DomainController_invalidateCache: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['InvalidateCacheDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InvalidateCacheResponse']
				}
			}
			/** @description Unauthorized */
			401: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Agent not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	HotGameFlexMessageController_findAll: {
		parameters: {
			query?: {
				/** @description Page number */
				page?: number
				/** @description Items per page */
				pageSize?: number
				/** @description Filter by active status */
				isActive?: boolean
				/** @description Search by name */
				search?: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetHotGameFlexMessagesResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_create: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CreateHotGameFlexMessageDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CreateHotGameFlexMessageResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_getPresets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['FlexMessagePresetListResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_duplicatePreset: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DuplicateFlexMessagePresetResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_findOne: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetHotGameFlexMessageResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_delete: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DeleteHotGameFlexMessageResponse']
				}
			}
		}
	}
	HotGameFlexMessageController_update: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateHotGameFlexMessageDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdateHotGameFlexMessageResponse']
				}
			}
		}
	}
	SessionController_kickAll: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description All sessions cleared */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SessionController_kickPlayer: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player session cleared */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SessionController_reinitPlayer: {
		parameters: {
			query?: never
			header?: never
			path: {
				playerId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player session reinitialized */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	SessionController_reinitAll: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description All active sessions reinitialized */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MetricsController_getEcsServiceCpuMem: {
		parameters: {
			query: {
				/**
				 * @description Lookback window in minutes (1-1440)
				 * @example 60
				 */
				minutes: number
				/**
				 * @description Metric granularity in seconds (60-3600)
				 * @example 300
				 */
				periodSeconds: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns CPU and memory metrics for the specified ECS service */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetEcsServiceCpuMemResponse']
				}
			}
			/** @description Invalid input parameters */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	MetricsController_getTaskMetrics: {
		parameters: {
			query: {
				/**
				 * @description Task ID (32 hex characters)
				 * @example 7ea043e26f5245749009578c36f47b97
				 */
				taskId: string
				/**
				 * @description Lookback window in minutes (1-1440)
				 * @example 60
				 */
				minutes: number
				/**
				 * @description Metric granularity in seconds (60-3600)
				 * @example 300
				 */
				periodSeconds: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns CPU and memory time-series data for a specific task */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetTaskMetricsResponse']
				}
			}
			/** @description Invalid input parameters */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	LineStickerController_getAllPackages: {
		parameters: {
			query?: {
				/** @description Include stickers in response */
				includeStickers?: boolean
				/** @description Only return active packages */
				activeOnly?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetLineStickerPackagesResponse']
				}
			}
		}
	}
	LineStickerController_getPackageById: {
		parameters: {
			query?: never
			header?: never
			path: {
				/** @description Package ID (internal) */
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetLineStickerPackageResponse']
				}
			}
		}
	}
	LineStickerController_getStickersForPackage: {
		parameters: {
			query?: never
			header?: never
			path: {
				/** @description Package ID (internal) */
				packageId: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetLineStickersResponse']
				}
			}
		}
	}
	LineMessageLogController_getLineMessageLogs: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by start date (ISO string) */
				startDate?: string
				/** @description Filter by end date (ISO string) */
				endDate?: string
				/** @description Filter by log type */
				logType?: components['schemas']['LineAutoMessageLogType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetLineMessageLogsResponse']
				}
			}
		}
	}
	LineMessageLogController_getLineMessageLogById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminLineAutoMessageLogModel']
				}
			}
		}
	}
	LineMessageLogController_getLineMessageLogMessages: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetLineMessageLogMessagesResponse']
				}
			}
		}
	}
	LineMessageLogController_getLineMessageLogGrouped: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminGetLineMessageLogGroupedResponse']
				}
			}
		}
	}
	AdminAssetsController_getAdminAssets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminAssetsResponse']
				}
			}
		}
	}
	AdminAssetsController_updateAdminAssets: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateAdminAssetsDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminAssetsResponse']
				}
			}
		}
	}
	OtpProviderController_getAllProviders: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Get all OTP providers */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminOtpProviderResponse'][]
				}
			}
		}
	}
	OtpProviderController_createProvider: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminCreateOtpProviderDto']
			}
		}
		responses: {
			/** @description Create new OTP provider */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminOtpProviderResponse']
				}
			}
		}
	}
	OtpProviderController_getActiveProvider: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Get active OTP provider */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminOtpProviderResponse']
				}
			}
		}
	}
	OtpProviderController_getProviderById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Get OTP provider by ID */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminOtpProviderResponse']
				}
			}
		}
	}
	OtpProviderController_updateProvider: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AdminUpdateOtpProviderDto']
			}
		}
		responses: {
			/** @description Update OTP provider */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['AdminOtpProviderResponse']
				}
			}
		}
	}
	OtpProviderController_deleteProvider: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Delete OTP provider */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminQuotaController_purchaseQuota: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Quota purchased successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminQuotaController_getCurrentQuota: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns current quota details */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AdminQuotaController_getPurchaseHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				startDate: string
				endDate: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns purchase history with pagination */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AgentQuotaCryptoController_buyQuotaCrypto: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns wallet address and transaction details */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	AgentQuotaCryptoController_confirmQuotaCrypto: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Confirms the crypto payment */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	FileController_getCarouselUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getPromotionUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getRankBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getRankFrameUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getReturnLossUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getCommissionCashbackUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getGamePageBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getAnnouncementBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getBrokeNotificationUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getProfilePageBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getGameImageUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getProviderBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getProviderLogoUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getLuckyWheelImageUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getLuckyWheelArrowImageUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getShopItemImageUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getEventBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getEventLogoUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_getTournamentBannerUploadFileUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_invalidateImageCache: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['InvalidateImageCacheDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['InvalidateImageCacheResponse']
				}
			}
		}
	}
	FileController_uploadLogo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'multipart/form-data': {
					/** Format: binary */
					file?: string
				}
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UploadFileResponse']
				}
			}
		}
	}
	FileController_uploadFavicon: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'multipart/form-data': {
					/** Format: binary */
					file?: string
				}
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GenerateFaviconsResponse']
				}
			}
		}
	}
	FileController_getWithdrawSoundUploadUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	FileController_uploadCustomCss: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UploadCustomCssDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UploadFileResponse']
				}
			}
		}
	}
	FileController_getSlipPresignUrl: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GenerateUploadFileUrlDto']
			}
		}
		responses: {
			default: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPresignedUrlResponse']
				}
			}
		}
	}
	TransactionController_bulkUpdateTransactions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BulkCreateTransactionsDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_updateTransferTransaction: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateTransferTransactionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_bulkUpdateBankHealthStatus: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdateStatusTransactionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_bulkNotifyTrueWalletTransactionLog: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BulkNotifyTrueWalletTransactionLogDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_bulkNotifySMSAutoTransactionLog: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BulkNotifySMSAutoTransactionLogDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_markSmsAutoMatchFailed: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_maintenanceNotify: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['MaintenanceNotifyDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_maintenanceStarted: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['MaintenanceStartedDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	TransactionController_maintenanceEnded: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['MaintenanceEndedDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerPageController_getGeneralSetting: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Return general settings */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GeneralSettingModelPlayer']
				}
			}
		}
	}
	PlayerPageController_getCarouselItems: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CarouselItemModel'][]
				}
			}
		}
	}
	PlayerPageController_getManifest: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Return PWA manifest */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getMe: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerModel']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_updatePassword: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePlayerPasswordDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_registerFCMToken: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RegisterFCMTokenDto']
			}
		}
		responses: {
			/** @description FCM token registered successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Invalid token */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_unregisterFCMToken: {
		parameters: {
			query?: never
			header?: never
			path: {
				token: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description FCM token(s) removed successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getPopupDisplay: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerPopupDisplayModel']
				}
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_updatePopupDisplay: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['UpdatePopupDisplayDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerPopupDisplayModel']
				}
			}
			/** @description Bad Request */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_connectLineId: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ConnectLineIdDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerModel']
				}
			}
			/** @description Invalid LINE ID or already connected */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Player not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerController_getDiamondHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter start date (ISO string) */
				startDate?: string
				/** @description Filter end date (ISO string) */
				endDate?: string
				orderByCreatedAt?: components['schemas']['SortOrder']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerDiamondHistoryResponse']
				}
			}
		}
	}
	PlayerNotificationController_getNotifications: {
		parameters: {
			query: {
				skip: number
				take: number
				isRead?: boolean
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player notifications retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerNotificationsResponse']
				}
			}
		}
	}
	PlayerNotificationController_markAsRead: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Notification marked as read successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerNotificationModel']
				}
			}
		}
	}
	PlayerNotificationController_markAllAsRead: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description All notifications marked as read successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerNotificationModel'][]
				}
			}
		}
	}
	PlayerNotificationController_getUnreadCount: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Unread notifications count retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': number
				}
			}
		}
	}
	PlayerNotificationController_deleteNotification: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Notification deleted successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerNotificationModel']
				}
			}
		}
	}
	PlayerNotificationController_getPlayerEvents: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player events retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerEventsResponse']
				}
			}
		}
	}
	PromotionController_getApplicablePromotions: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns a list of promotions applicable for the current player */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionsResponse']
				}
			}
		}
	}
	PromotionController_getPromotionById: {
		parameters: {
			query?: never
			header?: never
			path: {
				/** @description Promotion ID */
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns promotion details with eligibility information */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PromotionResponse']
				}
			}
			/** @description Promotion not found or not active */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	BankController_getPlayerBankProviders: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description List of bank providers */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BankProviderResponse'][]
				}
			}
		}
	}
	BankController_addPlayerBank: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['AddPlayerBankDto']
			}
		}
		responses: {
			/** @description Bank account added successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
			/** @description Bank already set or validation error */
			400: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerProfilePageBannerController_getAllProfilePageBanners: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	PlayerProfilePageBannerController_getProfilePageBannerById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ProfilePageBannerModel']
				}
			}
		}
	}
	PlayerLoginAnnouncementController_getPlayerLoginAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player login announcement retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['LoginAnnouncementResponse']
				}
			}
		}
	}
	PlayerSlideAnnouncementController_getPlayerSlideAnnouncement: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Player slide announcement retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerSlideAnnouncementResponse']
				}
			}
		}
	}
	PartnerController_getPartnerInfo: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PartnerModel']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerPartnerController_getPaymentRecords: {
		parameters: {
			query: {
				skip: number
				take: number
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetPlayerPaymentRecordsResponse']
				}
			}
			/** @description Partner not found */
			404: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CouponController_redeemCoupon: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RedeemCouponDto']
			}
		}
		responses: {
			/** @description Coupon has been successfully redeemed. */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CouponRedemptionResponse']
				}
			}
		}
	}
	ShopController_getPlayerShopItems: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by currency type */
				currencyType?: components['schemas']['CurrencyType']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Diamond shop items retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerShopItemListResponse']
				}
			}
		}
	}
	ShopController_purchaseShopItem: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['PurchaseShopItemDto']
			}
		}
		responses: {
			/** @description Item purchased successfully */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerShopPurchaseResponse']
				}
			}
		}
	}
	ShopController_getPlayerPurchaseHistory: {
		parameters: {
			query: {
				skip: number
				take: number
				/** @description Filter by purchase status */
				status?: components['schemas']['ShopHistoryStatus']
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Purchase history retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerShopPurchaseListResponse']
				}
			}
		}
	}
	EventController_getActiveEvents: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['EventModel'][]
				}
			}
		}
	}
	BrokeNotificationController_checkBrokeNotification: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Returns notification if eligible, null otherwise */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BrokeNotificationResponse']
				}
			}
		}
	}
	PlayerTurnoverEventController_getTurnoverEvents: {
		parameters: {
			query: {
				skip: number
				take: number
				status?: PathsApiPlayerTurnoverEventsGetParametersQueryStatus
				sortBy?: PathsApiPlayerTurnoverEventsGetParametersQuerySortBy
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Turnover events retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTurnoverEventListResponse']
				}
			}
		}
	}
	PlayerTurnoverEventController_getTurnoverEventById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Turnover event retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTurnoverEventResponse']
				}
			}
		}
	}
	PlayerTurnoverEventController_claimReward: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Reward claimed successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PlayerTournamentController_getTournaments: {
		parameters: {
			query: {
				skip: number
				take: number
				status?: PathsApiPlayerTournamentsGetParametersQueryStatus
				sortBy?: PathsApiPlayerTournamentsGetParametersQuerySortBy
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournaments retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTournamentListResponse']
				}
			}
		}
	}
	PlayerTournamentController_getTournamentById: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Tournament retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTournamentResponse']
				}
			}
		}
	}
	PlayerTournamentController_joinTournament: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Successfully joined tournament */
			201: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTournamentResponse']
				}
			}
		}
	}
	PlayerTournamentController_getTournamentLeaderboard: {
		parameters: {
			query: {
				skip: number
				take: number
				sortBy?: PathsApiPlayerTournamentsIdLeaderboardGetParametersQuerySortBy
			}
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Leaderboard retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTournamentLeaderboardResponse']
				}
			}
		}
	}
	PlayerTournamentController_getPlayerTournamentStats: {
		parameters: {
			query?: never
			header?: never
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody?: never
		responses: {
			/** @description Statistics retrieved successfully */
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PlayerTournamentStatsResponse']
				}
			}
		}
	}
	CronJobController_backfillReturnLoss: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BackfillReturnLossDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_backfillReturnLossRange: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BackfillReturnLossRangeDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_backfillReturnLossPayout: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BackfillReturnLossPayoutDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_backfillInviteFriendReturnLossPayout: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['BackfillReturnLossPayoutDto']
			}
		}
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_backfillMessageAnalytics: {
		parameters: {
			query: {
				startDate: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_calculateMessageAnalytics: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_backfillBrokeFlexAnalytics: {
		parameters: {
			query: {
				campaignId: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_calculateBrokeFlexAnalytics: {
		parameters: {
			query: {
				campaignId: string
			}
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	CronJobController_runDemoReset: {
		parameters: {
			query?: never
			header?: never
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			201: {
				headers: {
					[name: string]: unknown
				}
				content?: never
			}
		}
	}
	PoliExternalCallbackController_register: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['RegisterDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['RegisterResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_updatePlayer: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path: {
				id: string
			}
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['PoliUpdatePlayerDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['UpdatePlayerResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_getBankProvider: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['BankProviderResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_checkBalance: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CheckBalanceDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CheckBalanceResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_initSession: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['InitSessionDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['PoliInitSessionResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_getGeneralSetting: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody?: never
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GeneralSettingResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_deposit: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['DepositDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['DepositResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_getDepositStatus: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetDepositStatusDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetDepositStatusResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_cancelDeposit: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CancelDepositDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CancelDepositResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_withdraw: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['WithdrawDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['WithdrawListResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_getWithdrawStatus: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['GetWithdrawStatusDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['GetWithdrawStatusResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_cancelWithdraw: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['CancelWithdrawDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['CancelWithdrawResponse']
				}
			}
		}
	}
	PoliExternalCallbackController_manualCompleteDeposit: {
		parameters: {
			query?: never
			header?: {
				/** @description API Key for authentication */
				'x-api-key'?: string
			}
			path?: never
			cookie?: never
		}
		requestBody: {
			content: {
				'application/json': components['schemas']['ManualCompleteDepositDto']
			}
		}
		responses: {
			200: {
				headers: {
					[name: string]: unknown
				}
				content: {
					'application/json': components['schemas']['ManualCompleteDepositResponse']
				}
			}
		}
	}
}
export enum PathsApiAdminChatSearchGetParametersQueryDirection {
	INCOMING = 'INCOMING',
	OUTGOING = 'OUTGOING',
}
export enum PathsApiAdminAnalyticsAllPlayersGameStatsGetParametersQuerySortBy {
	totalPlayCount = 'totalPlayCount',
	totalProfit = 'totalProfit',
	totalTurnover = 'totalTurnover',
	lastPlayAt = 'lastPlayAt',
}
export enum PathsApiAdminAnalyticsAllPlayersGameStatsGetParametersQuerySortOrder {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminTournamentsGetParametersQueryStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum PathsApiAdminTournamentsGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminTournamentsIdPlayersGetParametersQueryStatus {
	PENDING = 'PENDING',
	QUALIFIED = 'QUALIFIED',
	ACTIVE = 'ACTIVE',
	DISQUALIFIED = 'DISQUALIFIED',
	COMPLETED = 'COMPLETED',
}
export enum PathsApiAdminTournamentsIdPlayersGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminBankTransactionsTrueWalletLogsGetParametersQuerySortByCreatedAt {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminBankTransactionsSmsAutoLogsGetParametersQuerySortByCreatedAt {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminInviteFriendCommissionHistoryGetParametersQueryCommissionType {
	TURNOVER = 'TURNOVER',
	SIGNUP = 'SIGNUP',
	FIRST_DEPOSIT = 'FIRST_DEPOSIT',
	RETURN_LOSS = 'RETURN_LOSS',
	DEPOSIT = 'DEPOSIT',
}
export enum PathsApiAdminTurnoverEventsGetParametersQueryStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum PathsApiAdminTurnoverEventsGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminTurnoverEventsIdClaimsGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiAdminMessageAnalyticsGetParametersQueryChannel {
	SMS = 'SMS',
	LINE = 'LINE',
	LINE_HOT_GAME = 'LINE_HOT_GAME',
	LINE_PROMOTION = 'LINE_PROMOTION',
}
export enum PathsApiAdminMessageAnalyticsGetParametersQueryMessageType {
	SCHEDULED = 'SCHEDULED',
	IMMEDIATE = 'IMMEDIATE',
	AUTO = 'AUTO',
	INTERVAL = 'INTERVAL',
}
export enum PathsApiPlayerTurnoverEventsGetParametersQueryStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum PathsApiPlayerTurnoverEventsGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiPlayerTournamentsGetParametersQueryStatus {
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
}
export enum PathsApiPlayerTournamentsGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum PathsApiPlayerTournamentsIdLeaderboardGetParametersQuerySortBy {
	asc = 'asc',
	desc = 'desc',
}
export enum SubType {
	OPERATOR = 'OPERATOR',
	PARTNER = 'PARTNER',
	ADMIN = 'ADMIN',
}
export enum OperatorGroupPermission {
	MANAGE_OPERATOR = 'MANAGE_OPERATOR',
	MANAGE_PLAYER = 'MANAGE_PLAYER',
	WEB_SETTING = 'WEB_SETTING',
	MANAGE_RANK = 'MANAGE_RANK',
	MANAGE_INVITE = 'MANAGE_INVITE',
	MANAGE_LUCKY_WHEEL = 'MANAGE_LUCKY_WHEEL',
	MANAGE_DAILY_CHECK_IN = 'MANAGE_DAILY_CHECK_IN',
	MANAGE_COMMISSION_CASHBACK = 'MANAGE_COMMISSION_CASHBACK',
	MANAGE_DEPOSIT_PROMOTION = 'MANAGE_DEPOSIT_PROMOTION',
	MANAGE_RETURN_LOSS = 'MANAGE_RETURN_LOSS',
	MANAGE_MARKETING = 'MANAGE_MARKETING',
	MANAGE_CHANNEL_ANALYTICS = 'MANAGE_CHANNEL_ANALYTICS',
	MANAGE_ANNOUNCEMENT = 'MANAGE_ANNOUNCEMENT',
	MANAGE_SMS = 'MANAGE_SMS',
	MANAGE_BANK_ACCOUNT = 'MANAGE_BANK_ACCOUNT',
	MANAGE_NOTIFICATION = 'MANAGE_NOTIFICATION',
	MANAGE_BANK_TRANSACTION = 'MANAGE_BANK_TRANSACTION',
	MANAGE_BLACKLIST = 'MANAGE_BLACKLIST',
	MANAGE_GAME = 'MANAGE_GAME',
	MANAGE_COUPON = 'MANAGE_COUPON',
	MANAGE_SHOP = 'MANAGE_SHOP',
	MANAGE_DOMAIN = 'MANAGE_DOMAIN',
	MANAGE_SERVER_METRICS = 'MANAGE_SERVER_METRICS',
	MANAGE_CHAT = 'MANAGE_CHAT',
	MANAGE_PLAYER_TAGS = 'MANAGE_PLAYER_TAGS',
	MANAGE_TOURNAMENT = 'MANAGE_TOURNAMENT',
	VIEW_FULL_PHONE = 'VIEW_FULL_PHONE',
}
export enum OperatorEventHistoryStatus {
	IMPORTANT = 'IMPORTANT',
	NORMAL = 'NORMAL',
}
export enum OperatorLogEvent {
	CREATE = 'CREATE',
	UPDATE = 'UPDATE',
	DELETE = 'DELETE',
	LOGIN = 'LOGIN',
}
export enum TagEvent {
	MANAGE_OPERATOR = 'MANAGE_OPERATOR',
	MANAGE_OPERATOR_GROUP = 'MANAGE_OPERATOR_GROUP',
	MANAGE_BANK = 'MANAGE_BANK',
	MANAGE_PLAYER = 'MANAGE_PLAYER',
	MANAGE_PROMOTION = 'MANAGE_PROMOTION',
	MANAGE_SHOP = 'MANAGE_SHOP',
	MANAGE_CHANNEL = 'MANAGE_CHANNEL',
	MANAGE_INVITE_FRIEND = 'MANAGE_INVITE_FRIEND',
	MANAGE_PARTNER = 'MANAGE_PARTNER',
	MANAGE_PAYMENT_GATEWAY = 'MANAGE_PAYMENT_GATEWAY',
	MANAGE_COMMISSION = 'MANAGE_COMMISSION',
	MANAGE_RETURN_LOSS = 'MANAGE_RETURN_LOSS',
	MANAGE_LUCKY_WHEEL = 'MANAGE_LUCKY_WHEEL',
	MANAGE_DAILY_CHECK_IN = 'MANAGE_DAILY_CHECK_IN',
	MANAGE_COUPON = 'MANAGE_COUPON',
	MANAGE_RANK = 'MANAGE_RANK',
	MANAGE_GENERAL_SETTING = 'MANAGE_GENERAL_SETTING',
	MANAGE_BANNER_SLIDE = 'MANAGE_BANNER_SLIDE',
	MANGE_BROKE_NOTIFICATION = 'MANGE_BROKE_NOTIFICATION',
	MANAGE_LOGIN_ANNOUNCEMENT = 'MANAGE_LOGIN_ANNOUNCEMENT',
	MANAGE_SLIDE_ANNOUNCEMENT = 'MANAGE_SLIDE_ANNOUNCEMENT',
	MANAGE_DYNAMIC_PAGE = 'MANAGE_DYNAMIC_PAGE',
	MANAGE_PROFILE_PAGE_BANNER = 'MANAGE_PROFILE_PAGE_BANNER',
	MANAGE_GAME = 'MANAGE_GAME',
	MANAGE_MESSAGING = 'MANAGE_MESSAGING',
	MANAGE_CHAT = 'MANAGE_CHAT',
	VIEW_FULL_PHONE = 'VIEW_FULL_PHONE',
}
export enum AdminRankUpRewardResponseType {
	CREDIT = 'CREDIT',
	DIAMOND = 'DIAMOND',
	LUCKY_WHEEL_QUOTA = 'LUCKY_WHEEL_QUOTA',
	FREE_SPIN = 'FREE_SPIN',
}
export enum WalletType {
	MAIN = 'MAIN',
	PROMOTION = 'PROMOTION',
	INVITE_FRIEND = 'INVITE_FRIEND',
	RETURN_LOSS = 'RETURN_LOSS',
	COMMISSION = 'COMMISSION',
	WHEEL = 'WHEEL',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	PARTNER = 'PARTNER',
}
export enum PlayerGameTypeStatsModelGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum PlayerGameStatsModelGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum SortOrder {
	asc = 'asc',
	desc = 'desc',
}
export enum ChatPlatform {
	LINE = 'LINE',
}
export enum TransactionType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAW = 'WITHDRAW',
}
export enum DepositStatus {
	CREATED = 'CREATED',
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	MANUAL_COMPLETED = 'MANUAL_COMPLETED',
	PAYMENT_GATEWAY_FAILED = 'PAYMENT_GATEWAY_FAILED',
	FAILED = 'FAILED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
}
export enum TransactionProcessor {
	AUTO = 'AUTO',
	MANUAL = 'MANUAL',
}
export enum PlayerPlayLogStatus {
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
	PENDING = 'PENDING',
	DUPLICATE = 'DUPLICATE',
}
export enum GameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum CalculateInterval {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
}
export enum PlayerDiamondHistoryType {
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	RANK_UP = 'RANK_UP',
	DEPOSIT = 'DEPOSIT',
}
export enum PlayerActivityLogType {
	RANK_CHANGE = 'RANK_CHANGE',
	RANK_PROMOTION = 'RANK_PROMOTION',
	RANK_DEMOTION = 'RANK_DEMOTION',
	LOCKOUT = 'LOCKOUT',
	CLEAR_LOCKOUT = 'CLEAR_LOCKOUT',
	UPDATE_BANK_BY_ADMIN = 'UPDATE_BANK_BY_ADMIN',
	UPDATE_WALLET_BY_ADMIN = 'UPDATE_WALLET_BY_ADMIN',
	UPDATE_BANK = 'UPDATE_BANK',
	LUCKY_WHEEL_PLAY = 'LUCKY_WHEEL_PLAY',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LOGIN = 'LOGIN',
	PROMOTION_REDEEM = 'PROMOTION_REDEEM',
	RETURN_LOSS = 'RETURN_LOSS',
	WALLET_TRANSFER = 'WALLET_TRANSFER',
	DEPOSIT = 'DEPOSIT',
	WITHDRAW = 'WITHDRAW',
	CLEAR_TURNOVER = 'CLEAR_TURNOVER',
	COMMISSION_CASHBACK = 'COMMISSION_CASHBACK',
}
export enum SendSmsDtoForce {
	standard = 'standard',
	premium = 'premium',
}
export enum ChatRoomStatus {
	CLOSED = 'CLOSED',
	INBOX = 'INBOX',
	FOLLOW_UP = 'FOLLOW_UP',
	RESOLVED = 'RESOLVED',
}
export enum ChatResponseType {
	OPERATOR = 'OPERATOR',
	CUSTOMER_TAG = 'CUSTOMER_TAG',
	PLAYER = 'PLAYER',
	REPLY_TO_MESSAGE = 'REPLY_TO_MESSAGE',
	CHAT_MESSAGE = 'CHAT_MESSAGE',
	CHAT_ROOM = 'CHAT_ROOM',
	CHAT_NOTE = 'CHAT_NOTE',
	CHAT_ROOM_LIST = 'CHAT_ROOM_LIST',
	CHAT_MESSAGE_LIST = 'CHAT_MESSAGE_LIST',
	CHAT_NOTE_LIST = 'CHAT_NOTE_LIST',
	QUICK_RESPONSE = 'QUICK_RESPONSE',
	CHAT_AUTO_REPLY_RULE = 'CHAT_AUTO_REPLY_RULE',
	CHAT_SETTINGS = 'CHAT_SETTINGS',
	CHAT_QUOTA = 'CHAT_QUOTA',
	CHAT_ANALYTICS = 'CHAT_ANALYTICS',
	SUCCESS = 'SUCCESS',
	SEND_MESSAGE = 'SEND_MESSAGE',
	CHAT_MEDIA_UPLOAD_URL = 'CHAT_MEDIA_UPLOAD_URL',
	SEARCH_CHAT_MESSAGE_RESULT = 'SEARCH_CHAT_MESSAGE_RESULT',
	SEARCH_CHAT_MESSAGES = 'SEARCH_CHAT_MESSAGES',
	CURSOR_PAGINATION_META = 'CURSOR_PAGINATION_META',
}
export enum ChatMessageDirection {
	INCOMING = 'INCOMING',
	OUTGOING = 'OUTGOING',
}
export enum ChatMessageType {
	TEXT = 'TEXT',
	STICKER = 'STICKER',
	IMAGE = 'IMAGE',
	VIDEO = 'VIDEO',
	AUDIO = 'AUDIO',
	FILE = 'FILE',
	LOCATION = 'LOCATION',
	FLEX = 'FLEX',
	TEMPLATE = 'TEMPLATE',
	SYSTEM = 'SYSTEM',
}
export enum AiAnswerMode {
	ASSIS = 'ASSIS',
	AUTO = 'AUTO',
	OFF = 'OFF',
}
export enum GenerateChatMediaUploadUrlDtoMediaType {
	image = 'image',
	video = 'video',
	audio = 'audio',
	file = 'file',
}
export enum ChatNewMessageSseEventEvent {
	chat_new_message = 'chat:new_message',
}
export enum ChatRoomUpdatedSseEventEvent {
	chat_room_updated = 'chat:room_updated',
}
export enum ChatRoomListChangedSsePayloadLastMessageType {
	TEXT = 'TEXT',
	STICKER = 'STICKER',
	IMAGE = 'IMAGE',
	VIDEO = 'VIDEO',
	AUDIO = 'AUDIO',
	FILE = 'FILE',
	LOCATION = 'LOCATION',
	FLEX = 'FLEX',
	TEMPLATE = 'TEMPLATE',
	SYSTEM = 'SYSTEM',
}
export enum ChatRoomListChangedSsePayloadLastMessageDirection {
	INCOMING = 'INCOMING',
	OUTGOING = 'OUTGOING',
}
export enum ChatRoomListChangedSsePayloadReason {
	new_message = 'new_message',
	read = 'read',
	assigned = 'assigned',
	released = 'released',
	tag_changed = 'tag_changed',
	status_changed = 'status_changed',
}
export enum ChatRoomListChangedSseEventEvent {
	chat_room_list_changed = 'chat:room_list_changed',
}
export enum ChatTagUpdatedSsePayloadAction {
	added = 'added',
	removed = 'removed',
}
export enum ChatTagUpdatedSseEventEvent {
	chat_tag_updated = 'chat:tag_updated',
}
export enum ChatAssigneeUpdatedSseEventEvent {
	chat_assignee_updated = 'chat:assignee_updated',
}
export enum ChatMessageReadSseEventEvent {
	chat_message_read = 'chat:message_read',
}
export enum ChatMessageConfirmedSseEventEvent {
	chat_message_confirmed = 'chat:message_confirmed',
}
export enum ChatMessagePinnedSseEventEvent {
	chat_message_pinned = 'chat:message_pinned',
}
export enum ChatRoomPinnedSseEventEvent {
	chat_room_pinned = 'chat:room_pinned',
}
export enum ChatRoomBannedSseEventEvent {
	chat_room_banned = 'chat:room_banned',
}
export enum ChatPingSseEventEvent {
	ping = 'ping',
}
export enum ChatBroadcastSentSseEventEvent {
	chat_broadcast_sent = 'chat:broadcast_sent',
}
export enum WithdrawPendingSseEventEvent {
	withdraw_pending = 'withdraw:pending',
}
export enum ChatAiDraftSsePayloadAction {
	suggest = 'suggest',
	escalate = 'escalate',
	drop = 'drop',
}
export enum AiPromptCaseKey {
	deposit_help = 'deposit_help',
	withdraw_help = 'withdraw_help',
	balance_check = 'balance_check',
	bank_info_request = 'bank_info_request',
	promotion_inquiry = 'promotion_inquiry',
	commission_inquiry = 'commission_inquiry',
	returnloss_inquiry = 'returnloss_inquiry',
	lucky_wheel_inquiry = 'lucky_wheel_inquiry',
	daily_checkin_inquiry = 'daily_checkin_inquiry',
	game_issue = 'game_issue',
	login_password = 'login_password',
	account_change = 'account_change',
	complaint = 'complaint',
	chitchat_greeting = 'chitchat_greeting',
	sticker_reaction = 'sticker_reaction',
	sticker_end_conversation = 'sticker_end_conversation',
	spam_irrelevant = 'spam_irrelevant',
	other_unclear = 'other_unclear',
}
export enum AdminTaskResponseStatus {
	pending = 'pending',
	done = 'done',
	dismissed = 'dismissed',
}
export enum CreateDepositDtoChannel {
	QR = 'QR',
	TRANSFER = 'TRANSFER',
	TRUE_MONEY = 'TRUE_MONEY',
	CRYPTO = 'CRYPTO',
	WITHDRAW_BANK = 'WITHDRAW_BANK',
	WITHDRAW_TRUE_MONEY = 'WITHDRAW_TRUE_MONEY',
	VERIFY_SLIP = 'VERIFY_SLIP',
	P2P = 'P2P',
}
export enum TransactionMethod {
	PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
	TRUE_WALLET = 'TRUE_WALLET',
	BANK = 'BANK',
	SMS_AUTO = 'SMS_AUTO',
	VERIFY_SLIP = 'VERIFY_SLIP',
	AUTOSSLIP = 'AUTOSSLIP',
}
export enum ValidateMethod {
	SMS = 'SMS',
	LINE = 'LINE',
	BANK_API = 'BANK_API',
	BANK_APP = 'BANK_APP',
}
export enum ManualDepositType {
	REGULAR = 'REGULAR',
	FREE_CREDIT = 'FREE_CREDIT',
}
export enum CreditType {
	FIXED = 'FIXED',
	RATIO = 'RATIO',
}
export enum TransactionAvailabilityResponseReason {
	TEMPORARY_DISABLED = 'TEMPORARY_DISABLED',
	SCHEDULED_MAINTENANCE = 'SCHEDULED_MAINTENANCE',
}
export enum NewUserConstraintModelConstraintType {
	NEW_USER = 'NEW_USER',
}
export enum FirstDepositConstraintModelConstraintType {
	FIRST_DEPOSIT = 'FIRST_DEPOSIT',
}
export enum FirstTimeOfDayConstraintModelConstraintType {
	FIRST_TIME_OF_DAY = 'FIRST_TIME_OF_DAY',
}
export enum ComparisonOperator {
	GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
	GREATER_THAN = 'GREATER_THAN',
}
export enum DepositAmountConstraintModelConstraintType {
	DEPOSIT_AMOUNT = 'DEPOSIT_AMOUNT',
}
export enum DayOfWeekConstraintModelConstraintType {
	DAY_OF_WEEK = 'DAY_OF_WEEK',
}
export enum DepositHistoryPeriod {
	TODAY = 'TODAY',
	MONTH = 'MONTH',
}
export enum DepositHistoryAmountConstraintModelConstraintType {
	DEPOSIT_HISTORY_AMOUNT = 'DEPOSIT_HISTORY_AMOUNT',
}
export enum CreateDepositPromotionPresetConfigDtoThresholdType {
	FIXED = 'FIXED',
	MULTIPLIER = 'MULTIPLIER',
}
export enum DepositPromotionPresetConfigModelThresholdType {
	FIXED = 'FIXED',
	MULTIPLIER = 'MULTIPLIER',
}
export enum FacebookStandardEvents {
	AddPaymentInfo = 'AddPaymentInfo',
	AddToCart = 'AddToCart',
	AddToWishlist = 'AddToWishlist',
	InitiateCheckout = 'InitiateCheckout',
	Purchase = 'Purchase',
	CompleteRegistration = 'CompleteRegistration',
	Contact = 'Contact',
	Lead = 'Lead',
	Schedule = 'Schedule',
	StartTrial = 'StartTrial',
	SubmitApplication = 'SubmitApplication',
	Subscribe = 'Subscribe',
	PageView = 'PageView',
	ViewContent = 'ViewContent',
	Search = 'Search',
	CustomizeProduct = 'CustomizeProduct',
	Donate = 'Donate',
	FindLocation = 'FindLocation',
}
export enum CustomerSegmentation {
	first_party_user_data = 'first_party_user_data',
	third_party_user_data = 'third_party_user_data',
	both_first_and_third_party_user_data = 'both_first_and_third_party_user_data',
}
export enum LuckyWheelPresetType {
	wheel = 'wheel',
	arrow = 'arrow',
}
export enum LuckyWheelConstraintType {
	TURNOVER = 'TURNOVER',
	LOSS = 'LOSS',
	DEPOSIT_WITH_BONUS = 'DEPOSIT_WITH_BONUS',
}
export enum LuckyWheelRewardType {
	CREDIT = 'CREDIT',
	DIAMOND = 'DIAMOND',
	FREE_SPIN = 'FREE_SPIN',
}
export enum WalletConditionPresetConfigModelThresholdType {
	FIXED = 'FIXED',
	MULTIPLIER = 'MULTIPLIER',
}
export enum ProviderMaintenanceItemResponseType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAWAL = 'WITHDRAWAL',
}
export enum CreatePaymentGatewayRequestChannels {
	QR = 'QR',
	TRANSFER = 'TRANSFER',
	TRUE_MONEY = 'TRUE_MONEY',
	CRYPTO = 'CRYPTO',
	WITHDRAW_BANK = 'WITHDRAW_BANK',
	WITHDRAW_TRUE_MONEY = 'WITHDRAW_TRUE_MONEY',
	VERIFY_SLIP = 'VERIFY_SLIP',
	P2P = 'P2P',
}
export enum UpdatePaymentGatewayRequestChannels {
	QR = 'QR',
	TRANSFER = 'TRANSFER',
	TRUE_MONEY = 'TRUE_MONEY',
	CRYPTO = 'CRYPTO',
	WITHDRAW_BANK = 'WITHDRAW_BANK',
	WITHDRAW_TRUE_MONEY = 'WITHDRAW_TRUE_MONEY',
	VERIFY_SLIP = 'VERIFY_SLIP',
	P2P = 'P2P',
}
export enum TrackSingleDtoEvent_source {
	client = 'client',
	server = 'server',
}
export enum TrackSingleDtoDevice_type {
	mobile = 'mobile',
	desktop = 'desktop',
}
export enum TrackingEventDtoEvent_source {
	client = 'client',
	server = 'server',
}
export enum TrackingEventDtoDevice_type {
	mobile = 'mobile',
	desktop = 'desktop',
}
export enum CheckInRewardType {
	CREDIT = 'CREDIT',
	WHEEL = 'WHEEL',
	DIAMOND = 'DIAMOND',
	FREE_SPIN = 'FREE_SPIN',
}
export enum InitType {
	IFRAME = 'IFRAME',
	EXTERNAL = 'EXTERNAL',
}
export enum GameRenderType {
	URL = 'URL',
	HTML = 'HTML',
}
export enum DynamicSectionType {
	GAME_LIST = 'GAME_LIST',
	LOTTO_ANNOUNCEMENT = 'LOTTO_ANNOUNCEMENT',
	LEADERBOARD = 'LEADERBOARD',
	GAME_SUGGESTION = 'GAME_SUGGESTION',
	FOOTBALL_MATCHES = 'FOOTBALL_MATCHES',
}
export enum CarouselItemSize {
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
	LARGE = 'LARGE',
}
export enum GameListSectionType {
	NEW = 'NEW',
	POPULAR = 'POPULAR',
	CUSTOM = 'CUSTOM',
}
export enum LeaderboardSectionType {
	TOP_WINNERS = 'TOP_WINNERS',
	DEPOSIT_AMOUNT = 'DEPOSIT_AMOUNT',
	WITHDRAWAL_AMOUNT = 'WITHDRAWAL_AMOUNT',
}
export enum LeaderboardUIType {
	HORIZONTAL = 'HORIZONTAL',
	VERTICAL = 'VERTICAL',
}
export enum AdminRankUpRewardLineDtoType {
	CREDIT = 'CREDIT',
	DIAMOND = 'DIAMOND',
	LUCKY_WHEEL_QUOTA = 'LUCKY_WHEEL_QUOTA',
	FREE_SPIN = 'FREE_SPIN',
}
export enum PromotionAnalyticsItemResponseChargeType {
	NORMAL = 'NORMAL',
	FREE_CREDIT = 'FREE_CREDIT',
}
export enum BucketSize {
	minute = 'minute',
	hour = 'hour',
	day = 'day',
}
export enum CohortType {
	daily = 'daily',
	weekly = 'weekly',
	monthly = 'monthly',
}
export enum StatusCode {
	Value0 = 0,
	Value1 = 1,
	Value2 = 2,
	Value3 = 3,
	Value4 = 4,
	Value5 = 5,
	Value6 = 6,
	Value7 = 7,
}
export enum UpdateBalanceStatus {
	success = 'success',
	failed = 'failed',
}
export enum GetExternalCryptoInvoicesDtoStatus {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
}
export enum GetExternalCryptoInvoicesDtoInvoiceType {
	MONTHLY_FEE = 'MONTHLY_FEE',
	COMPANY_COMMISSION = 'COMPANY_COMMISSION',
	MANUAL = 'MANUAL',
}
export enum CryptoInvoiceStatus {
	CREATED = 'CREATED',
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	MANUAL = 'MANUAL',
	FAILED = 'FAILED',
	PROCESSING = 'PROCESSING',
	EXPIRED = 'EXPIRED',
	CANCELED = 'CANCELED',
}
export enum CryptoInvoiceType {
	MONTHLY_FEE = 'MONTHLY_FEE',
	COMPANY_COMMISSION = 'COMPANY_COMMISSION',
	MANUAL = 'MANUAL',
	PREPAYMENT = 'PREPAYMENT',
}
export enum GetPromotionsDtoChargeType {
	NORMAL = 'NORMAL',
	FREE_CREDIT = 'FREE_CREDIT',
}
export enum UpdateCryptoInvoiceStatusDtoStatus {
	PENDING = 'PENDING',
	COMPLETED = 'COMPLETED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
}
export enum AdminCreateTournamentFromPresetDtoPreset {
	MINI = 'MINI',
	SMALL = 'SMALL',
	MEDIUM = 'MEDIUM',
	BIG = 'BIG',
}
export enum AdminUpdateTournamentStatusDtoStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum BankAccountType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAWAL = 'WITHDRAWAL',
	DEPOSIT_WITHDRAWAL = 'DEPOSIT_WITHDRAWAL',
	TRANSFER = 'TRANSFER',
}
export enum CreateWithdrawTransactionDtoType {
	auto = 'auto',
	manual = 'manual',
}
export enum WithdrawStatus {
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
	REFUNDED = 'REFUNDED',
}
export enum PlayerBankType {
	BANK = 'BANK',
	TRUE_MONEY = 'TRUE_MONEY',
}
export enum CreateManualDepositTransactionDtoManualDepositType {
	REGULAR = 'REGULAR',
	FREE_CREDIT = 'FREE_CREDIT',
}
export enum CreateOperatorDepositTransactionDtoChannel {
	QR = 'QR',
	TRANSFER = 'TRANSFER',
	TRUE_MONEY = 'TRUE_MONEY',
}
export enum CreateOperatorWithdrawTransactionDtoChannel {
	WITHDRAW_BANK = 'WITHDRAW_BANK',
	WITHDRAW_TRUE_MONEY = 'WITHDRAW_TRUE_MONEY',
}
export enum TrueWalletTransactionLogResponseType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAW = 'WITHDRAW',
	TRANSFER = 'TRANSFER',
	CRYPTO_INVOICE = 'CRYPTO_INVOICE',
}
export enum TrueWalletTransactionLogResponseMethod {
	PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
	TRUE_WALLET = 'TRUE_WALLET',
	BANK = 'BANK',
	SMS_AUTO = 'SMS_AUTO',
	VERIFY_SLIP = 'VERIFY_SLIP',
	AUTOSSLIP = 'AUTOSSLIP',
}
export enum SmsAutoLogStatus {
	UNMATCHED = 'UNMATCHED',
	PROCESSING = 'PROCESSING',
	REMATCHED = 'REMATCHED',
	CANCELLED = 'CANCELLED',
	AUTO_MATCHED = 'AUTO_MATCHED',
}
export enum AdminUpdateDepositStatusDtoStatus {
	CREATED = 'CREATED',
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	MANUAL_COMPLETED = 'MANUAL_COMPLETED',
	PAYMENT_GATEWAY_FAILED = 'PAYMENT_GATEWAY_FAILED',
	FAILED = 'FAILED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
}
export enum AdminUpdateWithdrawStatusDtoStatus {
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
	CANCELED = 'CANCELED',
	EXPIRED = 'EXPIRED',
	REFUNDED = 'REFUNDED',
}
export enum AdminInviteFriendCommissionHistoryResponseCommissionType {
	TURNOVER = 'TURNOVER',
	SIGNUP = 'SIGNUP',
	FIRST_DEPOSIT = 'FIRST_DEPOSIT',
	RETURN_LOSS = 'RETURN_LOSS',
	DEPOSIT = 'DEPOSIT',
}
export enum AdminInviteFriendCommissionHistoryResponseGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum ReferralCommissionByGameTypeGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum ProfilePageBannerType {
	GAME = 'GAME',
	LINK = 'LINK',
}
export enum CouponType {
	SINGLE = 'SINGLE',
	MULTIPLE = 'MULTIPLE',
}
export enum ShopItemType {
	CREDIT = 'CREDIT',
	FREE_SPIN = 'FREE_SPIN',
	ITEM = 'ITEM',
}
export enum CurrencyType {
	CREDIT = 'CREDIT',
	DIAMOND = 'DIAMOND',
}
export enum ShopHistoryStatus {
	PENDING = 'PENDING',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
}
export enum EventModelType {
	CUSTOM = 'CUSTOM',
	TURNOVER = 'TURNOVER',
	BATTLE_PASS = 'BATTLE_PASS',
}
export enum EventModelStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum EventModelPeriodType {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	CUSTOM = 'CUSTOM',
}
export enum GetEventResponseType {
	CUSTOM = 'CUSTOM',
	TURNOVER = 'TURNOVER',
	BATTLE_PASS = 'BATTLE_PASS',
}
export enum AdminCreateTurnoverEventDtoPeriodType {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	CUSTOM = 'CUSTOM',
}
export enum AdminTurnoverEventResponseStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum AdminTurnoverEventResponsePeriodType {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	CUSTOM = 'CUSTOM',
}
export enum AdminUpdateTurnoverEventDtoPeriodType {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	CUSTOM = 'CUSTOM',
}
export enum AdminUpdateTurnoverEventStatusDtoStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum SmsTransactionStatus {
	PENDING = 'PENDING',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
}
export enum MessageTransactionType {
	SCHEDULED = 'SCHEDULED',
	IMMEDIATE = 'IMMEDIATE',
	AUTO = 'AUTO',
	INTERVAL = 'INTERVAL',
}
export enum IntervalCondition {
	DAY_OF_WEEK = 'DAY_OF_WEEK',
	DATE_OF_MONTH = 'DATE_OF_MONTH',
}
export enum MessageGroupCondition {
	REGISTER_DAYS = 'REGISTER_DAYS',
	DEPOSIT_RANGE = 'DEPOSIT_RANGE',
	INACTIVE_DAYS_SINGLE_MESSAGE = 'INACTIVE_DAYS_SINGLE_MESSAGE',
	ALL_MEMBERS = 'ALL_MEMBERS',
	ALL_MEMBERS_NEVER_DEPOSIT = 'ALL_MEMBERS_NEVER_DEPOSIT',
	ALL_MEMBERS_TOTAL_DEPOSIT = 'ALL_MEMBERS_TOTAL_DEPOSIT',
	ALL_MEMBERS_SINGLE_DEPOSIT = 'ALL_MEMBERS_SINGLE_DEPOSIT',
	ALL_MEMBERS_TOTAL_TURNOVER = 'ALL_MEMBERS_TOTAL_TURNOVER',
	ALL_MEMBERS_TOTAL_LOSS = 'ALL_MEMBERS_TOTAL_LOSS',
	ALL_MEMBERS_TOTAL_PROFIT = 'ALL_MEMBERS_TOTAL_PROFIT',
	PENDING_INVITE_FRIEND_BALANCE = 'PENDING_INVITE_FRIEND_BALANCE',
	PENDING_RETURN_LOSS_BALANCE = 'PENDING_RETURN_LOSS_BALANCE',
	PENDING_COMMISSION_BALANCE = 'PENDING_COMMISSION_BALANCE',
	PENDING_DAILY_CHECK_IN_BALANCE = 'PENDING_DAILY_CHECK_IN_BALANCE',
	PENDING_LUCKY_WHEEL_BALANCE = 'PENDING_LUCKY_WHEEL_BALANCE',
	LINE_LINKED_DAYS = 'LINE_LINKED_DAYS',
	SPECIFIC_PHONE_NUMBERS = 'SPECIFIC_PHONE_NUMBERS',
}
export enum LineTransactionType {
	TEXT = 'TEXT',
	FLEX_HOT_GAME = 'FLEX_HOT_GAME',
	FLEX_PROMOTION = 'FLEX_PROMOTION',
}
export enum MessageConditionSingle {
	REGISTER_DAYS = 'REGISTER_DAYS',
	REGISTER_DAYS_NEVER_DEPOSIT = 'REGISTER_DAYS_NEVER_DEPOSIT',
	INACTIVE_DAYS_SINGLE_MESSAGE = 'INACTIVE_DAYS_SINGLE_MESSAGE',
	DEPOSIT_RANGE = 'DEPOSIT_RANGE',
	ALL_MEMBERS = 'ALL_MEMBERS',
	ALL_MEMBERS_NEVER_DEPOSIT = 'ALL_MEMBERS_NEVER_DEPOSIT',
	ALL_MEMBERS_TOTAL_DEPOSIT = 'ALL_MEMBERS_TOTAL_DEPOSIT',
	ALL_MEMBERS_SINGLE_DEPOSIT = 'ALL_MEMBERS_SINGLE_DEPOSIT',
	ALL_MEMBERS_TOTAL_TURNOVER = 'ALL_MEMBERS_TOTAL_TURNOVER',
	ALL_MEMBERS_TOTAL_LOSS = 'ALL_MEMBERS_TOTAL_LOSS',
	PENDING_INVITE_FRIEND_BALANCE = 'PENDING_INVITE_FRIEND_BALANCE',
	PENDING_RETURN_LOSS_BALANCE = 'PENDING_RETURN_LOSS_BALANCE',
	PENDING_COMMISSION_BALANCE = 'PENDING_COMMISSION_BALANCE',
	PENDING_DAILY_CHECK_IN_BALANCE = 'PENDING_DAILY_CHECK_IN_BALANCE',
	PENDING_LUCKY_WHEEL_BALANCE = 'PENDING_LUCKY_WHEEL_BALANCE',
	LINE_LINKED_DAYS = 'LINE_LINKED_DAYS',
	SPECIFIC_PHONE_NUMBERS = 'SPECIFIC_PHONE_NUMBERS',
	CUSTOMER_TAGS = 'CUSTOMER_TAGS',
}
export enum MessageConditionType {
	SINGLE = 'SINGLE',
	MIN_MAX = 'MIN_MAX',
	NONE = 'NONE',
	PHONE_NUMBERS = 'PHONE_NUMBERS',
}
export enum MessageConditionAuto {
	NO_DEPOSIT_AFTER_REGISTER_MINUTES = 'NO_DEPOSIT_AFTER_REGISTER_MINUTES',
	REGISTER_MINUTES = 'REGISTER_MINUTES',
	LINE_CONNECTED_NO_DEPOSIT_MINUTES = 'LINE_CONNECTED_NO_DEPOSIT_MINUTES',
	INACTIVE_DAYS_AUTO_MESSAGE = 'INACTIVE_DAYS_AUTO_MESSAGE',
	BALANCE_DEPLETED_NO_DEPOSIT = 'BALANCE_DEPLETED_NO_DEPOSIT',
	CONSECUTIVE_PLAY_DAYS_GT_X = 'CONSECUTIVE_PLAY_DAYS_GT_X',
}
export enum MessageCondition {
	REGISTER_DAYS = 'REGISTER_DAYS',
	REGISTER_DAYS_NEVER_DEPOSIT = 'REGISTER_DAYS_NEVER_DEPOSIT',
	INACTIVE_DAYS_SINGLE_MESSAGE = 'INACTIVE_DAYS_SINGLE_MESSAGE',
	DEPOSIT_RANGE = 'DEPOSIT_RANGE',
	ALL_MEMBERS = 'ALL_MEMBERS',
	ALL_MEMBERS_NEVER_DEPOSIT = 'ALL_MEMBERS_NEVER_DEPOSIT',
	ALL_MEMBERS_TOTAL_DEPOSIT = 'ALL_MEMBERS_TOTAL_DEPOSIT',
	ALL_MEMBERS_SINGLE_DEPOSIT = 'ALL_MEMBERS_SINGLE_DEPOSIT',
	ALL_MEMBERS_TOTAL_TURNOVER = 'ALL_MEMBERS_TOTAL_TURNOVER',
	ALL_MEMBERS_TOTAL_LOSS = 'ALL_MEMBERS_TOTAL_LOSS',
	PENDING_INVITE_FRIEND_BALANCE = 'PENDING_INVITE_FRIEND_BALANCE',
	PENDING_RETURN_LOSS_BALANCE = 'PENDING_RETURN_LOSS_BALANCE',
	PENDING_COMMISSION_BALANCE = 'PENDING_COMMISSION_BALANCE',
	PENDING_DAILY_CHECK_IN_BALANCE = 'PENDING_DAILY_CHECK_IN_BALANCE',
	PENDING_LUCKY_WHEEL_BALANCE = 'PENDING_LUCKY_WHEEL_BALANCE',
	LINE_LINKED_DAYS = 'LINE_LINKED_DAYS',
	SPECIFIC_PHONE_NUMBERS = 'SPECIFIC_PHONE_NUMBERS',
	CUSTOMER_TAGS = 'CUSTOMER_TAGS',
	NO_DEPOSIT_AFTER_REGISTER_MINUTES = 'NO_DEPOSIT_AFTER_REGISTER_MINUTES',
	REGISTER_MINUTES = 'REGISTER_MINUTES',
	LINE_CONNECTED_NO_DEPOSIT_MINUTES = 'LINE_CONNECTED_NO_DEPOSIT_MINUTES',
	INACTIVE_DAYS_AUTO_MESSAGE = 'INACTIVE_DAYS_AUTO_MESSAGE',
	BALANCE_DEPLETED_NO_DEPOSIT = 'BALANCE_DEPLETED_NO_DEPOSIT',
	CONSECUTIVE_PLAY_DAYS_GT_X = 'CONSECUTIVE_PLAY_DAYS_GT_X',
}
export enum AutoMessageGroupCondition {
	NO_DEPOSIT_AFTER_REGISTER_MINUTES = 'NO_DEPOSIT_AFTER_REGISTER_MINUTES',
	REGISTER_MINUTES = 'REGISTER_MINUTES',
	LINE_CONNECTED_NO_DEPOSIT_MINUTES = 'LINE_CONNECTED_NO_DEPOSIT_MINUTES',
	INACTIVE_DAYS = 'INACTIVE_DAYS',
	INACTIVE_DAYS_AUTO_MESSAGE = 'INACTIVE_DAYS_AUTO_MESSAGE',
	BALANCE_DEPLETED_NO_DEPOSIT = 'BALANCE_DEPLETED_NO_DEPOSIT',
	CONSECUTIVE_PLAY_DAYS_GT_X = 'CONSECUTIVE_PLAY_DAYS_GT_X',
}
export enum MessageChannel {
	SMS = 'SMS',
	LINE = 'LINE',
	LINE_HOT_GAME = 'LINE_HOT_GAME',
	LINE_PROMOTION = 'LINE_PROMOTION',
}
export enum CampaignAnalyticsMessageType {
	SCHEDULED = 'SCHEDULED',
	IMMEDIATE = 'IMMEDIATE',
	AUTO = 'AUTO',
	INTERVAL = 'INTERVAL',
}
export enum CampaignAnalyticsLineTransactionType {
	TEXT = 'TEXT',
	FLEX_HOT_GAME = 'FLEX_HOT_GAME',
	FLEX_PROMOTION = 'FLEX_PROMOTION',
}
export enum CreateIntervalMessageDtoIntervalCondition {
	DAY_OF_WEEK = 'DAY_OF_WEEK',
	DATE_OF_MONTH = 'DATE_OF_MONTH',
}
export enum BrokeNotificationModelType {
	RETURN_LOSS = 'RETURN_LOSS',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	COMMISSION_CASHBACK = 'COMMISSION_CASHBACK',
	SHOP = 'SHOP',
	DEPOSIT_PROMOTION = 'DEPOSIT_PROMOTION',
	COUPON = 'COUPON',
	GO_DEPOSIT = 'GO_DEPOSIT',
}
export enum CreateBrokeNotificationDtoType {
	RETURN_LOSS = 'RETURN_LOSS',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	COMMISSION_CASHBACK = 'COMMISSION_CASHBACK',
	SHOP = 'SHOP',
	DEPOSIT_PROMOTION = 'DEPOSIT_PROMOTION',
	COUPON = 'COUPON',
	GO_DEPOSIT = 'GO_DEPOSIT',
}
export enum UpdateBrokeNotificationDtoType {
	RETURN_LOSS = 'RETURN_LOSS',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	COMMISSION_CASHBACK = 'COMMISSION_CASHBACK',
	SHOP = 'SHOP',
	DEPOSIT_PROMOTION = 'DEPOSIT_PROMOTION',
	COUPON = 'COUPON',
	GO_DEPOSIT = 'GO_DEPOSIT',
}
export enum CreateBrokeFlexMessageItemDtoType {
	RETURN_LOSS = 'RETURN_LOSS',
	COMMISSION = 'COMMISSION',
	INVITE_FRIEND = 'INVITE_FRIEND',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	COUPON = 'COUPON',
	DEPOSIT_PROMOTION = 'DEPOSIT_PROMOTION',
	CUSTOM_LINK = 'CUSTOM_LINK',
}
export enum CreateBrokeFlexMessageItemDtoEligibilityType {
	BALANCE = 'BALANCE',
	QUOTA = 'QUOTA',
	COUNT = 'COUNT',
	AVAILABLE = 'AVAILABLE',
	ALWAYS = 'ALWAYS',
}
export enum AdminBrokeFlexMessageItemModelType {
	RETURN_LOSS = 'RETURN_LOSS',
	COMMISSION = 'COMMISSION',
	INVITE_FRIEND = 'INVITE_FRIEND',
	DAILY_CHECK_IN = 'DAILY_CHECK_IN',
	LUCKY_WHEEL = 'LUCKY_WHEEL',
	COUPON = 'COUPON',
	DEPOSIT_PROMOTION = 'DEPOSIT_PROMOTION',
	CUSTOM_LINK = 'CUSTOM_LINK',
}
export enum AdminBrokeFlexMessageItemModelEligibilityType {
	BALANCE = 'BALANCE',
	QUOTA = 'QUOTA',
	COUNT = 'COUNT',
	AVAILABLE = 'AVAILABLE',
	ALWAYS = 'ALWAYS',
}
export enum PresetInfoResponsePreset {
	SIMPLE_PROMOTION = 'SIMPLE_PROMOTION',
	THREE_PROMOTIONS = 'THREE_PROMOTIONS',
	PROMOTION_WITH_BONUSES = 'PROMOTION_WITH_BONUSES',
	COUPON_BLAST = 'COUPON_BLAST',
	ALL_IN_RECOVERY = 'ALL_IN_RECOVERY',
}
export enum CreateFromPresetDtoPreset {
	SIMPLE_PROMOTION = 'SIMPLE_PROMOTION',
	THREE_PROMOTIONS = 'THREE_PROMOTIONS',
	PROMOTION_WITH_BONUSES = 'PROMOTION_WITH_BONUSES',
	COUPON_BLAST = 'COUPON_BLAST',
	ALL_IN_RECOVERY = 'ALL_IN_RECOVERY',
}
export enum HotGameFlexMessageGameModelGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum HotGameFlexMessageGameModelGameTypes {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum FlexMessagePresetGameItemModelGameType {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum FlexMessagePresetGameItemModelGameTypes {
	SLOT = 'SLOT',
	CASINO = 'CASINO',
	LOTTO = 'LOTTO',
	SPORT = 'SPORT',
	FISHING = 'FISHING',
}
export enum LineAutoMessageLogType {
	BROADCAST = 'BROADCAST',
	AUTO_REPLY = 'AUTO_REPLY',
	GREETING = 'GREETING',
}
export enum BankTransactionMethod {
	BANK = 'BANK',
	SMS_AUTO = 'SMS_AUTO',
	PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
	TRUE_WALLET = 'TRUE_WALLET',
	MANUAL = 'MANUAL',
	CRYPTO = 'CRYPTO',
	VERIFY_SLIP = 'VERIFY_SLIP',
	AUTOSSLIP = 'AUTOSSLIP',
}
export enum BankTransactionType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAW = 'WITHDRAW',
	TRANSFER = 'TRANSFER',
	CRYPTO_INVOICE = 'CRYPTO_INVOICE',
}
export enum BankTransactionStatus {
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
	EXPIRED = 'EXPIRED',
	PENDING = 'PENDING',
}
export enum TransferStatus {
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED',
}
export enum MaintenanceStartedItemDtoType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAWAL = 'WITHDRAWAL',
}
export enum MaintenanceEndedItemDtoType {
	DEPOSIT = 'DEPOSIT',
	WITHDRAWAL = 'WITHDRAWAL',
}
export enum DailyCheckInRewardModelRewardType {
	CREDIT = 'CREDIT',
	WHEEL = 'WHEEL',
	DIAMOND = 'DIAMOND',
}
export enum PlayerTurnoverEventResponseStatus {
	DRAFT = 'DRAFT',
	ACTIVE = 'ACTIVE',
	ENDED = 'ENDED',
	CANCELLED = 'CANCELLED',
}
export enum PlayerTurnoverEventResponsePeriodType {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	CUSTOM = 'CUSTOM',
}
export enum BackfillReturnLossPayoutDtoInterval {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
}
